export var Core;
(function (Core) {
    /**
     * Adds a boarding pass to specified order, by barcode.
     *
     * @export
     * @class AddBoardingPassToOrder
     * @implements {EvaService}
     */
    class AddBoardingPassToOrder {
        name = 'Core:AddBoardingPassToOrder';
        path = '/message/AddBoardingPassToOrder';
        request;
        response;
    }
    Core.AddBoardingPassToOrder = AddBoardingPassToOrder;
    /**
     * The normal `AddProductToOrder` cannot be used for adding a Product with type `BundleProduct` to an order. Instead, `AddBundleProductToOrder` must be
used. In addition to the `BundleProductID`, this service accepts an optional `LineSelection`, which represents the bundle's configuration in terms of
which products you've chosen.

The `LineSelection` data structure contains a `SelectedProductID`, which must refer to a ProductID that is a valid option for this bundle, according
to what `GetBundleProductDetails` returns.

If no `LineSelection` is provided then the default products of the bundle are added to the Order.
     *
     * @export
     * @class AddBundleProductToOrder
     * @implements {EvaService}
     */
    class AddBundleProductToOrder {
        name = 'Core:AddBundleProductToOrder';
        path = '/message/AddBundleProductToOrder';
        request;
        response;
    }
    Core.AddBundleProductToOrder = AddBundleProductToOrder;
    /**
     * A specific implementation for `AddProductToOrder` for GiftCards. Adds a new order line for a digital GiftCard to specified order, where
`OrderID` identifies the order for the customer and `Amount` is the desired amount to create a GiftCard for.

Optionally supply a `DetailsUrl` pointing to the website you want the buyer of the GiftCard to land to see/manage the order.

Additionally, the `DisplayOptions` property need to be supplied, this contains a bunch of default options to personalize the giftcard.
It is also possible to provide some Metadata. We won't do any processing on DisplayOptions.

Except: DetailsUrl will be changed to include the `OrderID` in the URL as well as a `token` that can be used to access a few services.
     *
     * @export
     * @class AddDigitalGiftCardToOrder
     * @implements {EvaService}
     */
    class AddDigitalGiftCardToOrder {
        name = 'Core:AddDigitalGiftCardToOrder';
        path = '/message/AddDigitalGiftCardToOrder';
        request;
        response;
    }
    Core.AddDigitalGiftCardToOrder = AddDigitalGiftCardToOrder;
    /**
     * Add a discount coupon to an order
     *
     * @export
     * @class AddDiscountCouponToOrder
     * @implements {EvaService}
     */
    class AddDiscountCouponToOrder {
        name = 'Core:AddDiscountCouponToOrder';
        path = '/message/AddDiscountCouponToOrder';
        request;
        response;
    }
    Core.AddDiscountCouponToOrder = AddDiscountCouponToOrder;
    /**
     * Add a Discount to an Order

- To add a Coupon discount, specify the `CouponCode`.
- To add a Manual discount, specify the `DiscountID` and the `DiscountAmount`. Optionally a `Reason` can be added.
     *
     * @export
     * @class AddDiscountToOrder
     * @implements {EvaService}
     */
    class AddDiscountToOrder {
        name = 'Core:AddDiscountToOrder';
        path = '/message/AddDiscountToOrder';
        request;
        response;
    }
    Core.AddDiscountToOrder = AddDiscountToOrder;
    /**
     * Adds a label to specified full stock count.
     *
     * @export
     * @class AddLabelToFullStockCount
     * @implements {EvaService}
     */
    class AddLabelToFullStockCount {
        name = 'Core:AddLabelToFullStockCount';
        path = '/message/AddLabelToFullStockCount';
        request;
        response;
    }
    Core.AddLabelToFullStockCount = AddLabelToFullStockCount;
    /**
     * Add a loyalty Discount to an order
     *
     * @export
     * @class AddLoyaltyDiscountToOrder
     * @implements {EvaService}
     */
    class AddLoyaltyDiscountToOrder {
        name = 'Core:AddLoyaltyDiscountToOrder';
        path = '/message/AddLoyaltyDiscountToOrder';
        request;
        response;
    }
    Core.AddLoyaltyDiscountToOrder = AddLoyaltyDiscountToOrder;
    /**
     * Add a manual Discount to an order
     *
     * @export
     * @class AddManualDiscountToOrder
     * @implements {EvaService}
     */
    class AddManualDiscountToOrder {
        name = 'Core:AddManualDiscountToOrder';
        path = '/message/AddManualDiscountToOrder';
        request;
        response;
    }
    Core.AddManualDiscountToOrder = AddManualDiscountToOrder;
    /**
     * Adds a product count result to specified Full Stock Count label. User task must be active and assigned to the current user.
     *
     * @export
     * @class AddProductToFullStockCountLabel
     * @implements {EvaService}
     */
    class AddProductToFullStockCountLabel {
        name = 'Core:AddProductToFullStockCountLabel';
        path = '/message/AddProductToFullStockCountLabel';
        request;
        response;
    }
    Core.AddProductToFullStockCountLabel = AddProductToFullStockCountLabel;
    /**
     * Add a Product to an Order

A product can be defined by `ProductID` or `Barcode`.
If the product is unstackable (e.g. gift cards, same product added with different serial numbers), new orderlines are created.
     *
     * @export
     * @class AddProductToOrder
     * @implements {EvaService}
     */
    class AddProductToOrder {
        name = 'Core:AddProductToOrder';
        path = '/message/AddProductToOrder';
        request;
        response;
    }
    Core.AddProductToOrder = AddProductToOrder;
    /**
     * Add product(s) to an anonymous wishlist.
     *
     * @export
     * @class AddProductsToAnonymousWishlist
     * @implements {EvaService}
     */
    class AddProductsToAnonymousWishlist {
        name = 'Core:AddProductsToAnonymousWishlist';
        path = '/message/AddProductsToAnonymousWishlist';
        request;
        response;
    }
    Core.AddProductsToAnonymousWishlist = AddProductsToAnonymousWishlist;
    /**
     * Add product(s) to the user wishlist.
     *
     * @export
     * @class AddProductsToUserWishlist
     * @implements {EvaService}
     */
    class AddProductsToUserWishlist {
        name = 'Core:AddProductsToUserWishlist';
        path = '/message/AddProductsToUserWishlist';
        request;
        response;
    }
    Core.AddProductsToUserWishlist = AddProductsToUserWishlist;
    /**
     * Add lines to an existing purchase order

It is required to supply an OrderID and at least one line with a ProductID and a Quantity. All other line properties are optional.
It's not allowed to create multiple lines with the same product on the same stocklabel.
     *
     * @export
     * @class AddPurchaseOrderLines
     * @implements {EvaService}
     */
    class AddPurchaseOrderLines {
        name = 'Core:AddPurchaseOrderLines';
        path = '/message/AddPurchaseOrderLines';
        request;
        response;
    }
    Core.AddPurchaseOrderLines = AddPurchaseOrderLines;
    /**
     * Adds a service product to an order.
     *
     * @export
     * @class AddServiceProductToOrder
     * @implements {EvaService}
     */
    class AddServiceProductToOrder {
        name = 'Core:AddServiceProductToOrder';
        path = '/message/AddServiceProductToOrder';
        request;
        response;
    }
    Core.AddServiceProductToOrder = AddServiceProductToOrder;
    /**
     * Add a tracking code to the ReturnToSupplier task shipment.
If tracking code is already present, it will be overwritten.
     *
     * @export
     * @class AddTrackingCodeToReturnToSupplierShipment
     * @implements {EvaService}
     */
    class AddTrackingCodeToReturnToSupplierShipment {
        name = 'Core:AddTrackingCodeToReturnToSupplierShipment';
        path = '/message/AddTrackingCodeToReturnToSupplierShipment';
        request;
        response;
    }
    Core.AddTrackingCodeToReturnToSupplierShipment = AddTrackingCodeToReturnToSupplierShipment;
    /**
     * Add user borrowed products to order. When no quantity is given, all borrowed products with the given product ID are added to the order.
     *
     * @export
     * @class AddUserBorrowedProductToOrder
     * @implements {EvaService}
     */
    class AddUserBorrowedProductToOrder {
        name = 'Core:AddUserBorrowedProductToOrder';
        path = '/message/AddUserBorrowedProductToOrder';
        request;
        response;
    }
    Core.AddUserBorrowedProductToOrder = AddUserBorrowedProductToOrder;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class AddUserToGroup
     * @implements {EvaService}
     */
    class AddUserToGroup {
        name = 'Core:AddUserToGroup';
        path = '/message/AddUserToGroup';
        request;
        response;
    }
    Core.AddUserToGroup = AddUserToGroup;
    /**
     * Book a set of Adjustments to modify stock.

An Adjustment should have a `ProductID` to identify the product, an `OrganizationUnitID` to identify the stock keeping organization, a `StockLabelID` (see `GetEnumValues` with type `StockLabel`),
a `StockMutationReasonID` (see `GetEnumValues` with type `StockMutationReasons`) and of course a `Quantity` to actually book.

Supply a `BackendSystemID` on the request and `BackendID`'s on the Adjustments to make the request idempotent (optional). When one adjustment in your request fails, all of them will fail. Duplicate
keys will not be processed again and yield a warning (but thus will not block!).

Optionally supports a `Remark` for each Adjustment.

When specifying a `SerialNumber`, please note the `Quantity` of this adjustment then should either be -1 or 1!
     *
     * @export
     * @class AdjustStock
     * @implements {EvaService}
     */
    class AdjustStock {
        name = 'Core:AdjustStock';
        path = '/message/AdjustStock';
        request;
        response;
    }
    Core.AdjustStock = AdjustStock;
    /**
     * This service is used to apply a selection of products to the provided `BundleProductOrderLineID`.
The `BundleProductOrderLineID` field refers to the ID of an `OrderLine` on the provided `Order` that has a `BundleProduct` Product on it.
The `LineSelection` field is a list that couples a `SelectedProductID` to a `ProductBundleLineID` and is identical to how it's used in `AddBundleProductToOrder`.
     *
     * @export
     * @class ApplyBundleProductSelection
     * @implements {EvaService}
     */
    class ApplyBundleProductSelection {
        name = 'Core:ApplyBundleProductSelection';
        path = '/message/ApplyBundleProductSelection';
        request;
        response;
    }
    Core.ApplyBundleProductSelection = ApplyBundleProductSelection;
    /**
     * Will apply and return the estimated tax for specified order. Its effect is persistent through all subsequent calls for this orders' amounts.
     *
     * @export
     * @class ApplySalesTaxEstimateForOrder
     * @implements {EvaService}
     */
    class ApplySalesTaxEstimateForOrder {
        name = 'Core:ApplySalesTaxEstimateForOrder';
        path = '/message/ApplySalesTaxEstimateForOrder';
        request;
        response;
    }
    Core.ApplySalesTaxEstimateForOrder = ApplySalesTaxEstimateForOrder;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ApplyScriptEdits
     * @implements {EvaService}
     */
    class ApplyScriptEdits {
        name = 'Core:ApplyScriptEdits';
        path = '/message/ApplyScriptEdits';
        request;
        response;
    }
    Core.ApplyScriptEdits = ApplyScriptEdits;
    /**
     * Approve a non-confirmed payment transaction capture
     *
     * @export
     * @class ApproveCapture
     * @implements {EvaService}
     */
    class ApproveCapture {
        name = 'Core:ApproveCapture';
        path = '/message/ApproveCapture';
        request;
        response;
    }
    Core.ApproveCapture = ApproveCapture;
    /**
     * Approve a non-confirmed payment transaction
     *
     * @export
     * @class ApprovePayment
     * @implements {EvaService}
     */
    class ApprovePayment {
        name = 'Core:ApprovePayment';
        path = '/message/ApprovePayment';
        request;
        response;
    }
    Core.ApprovePayment = ApprovePayment;
    /**
     * Archive an organization unit.
NOTE: Only do this when it is no longer in use. While this action is reversible, settings and other configurations previously in place may be lost.
     *
     * @export
     * @class ArchiveOrganizationUnit
     * @implements {EvaService}
     */
    class ArchiveOrganizationUnit {
        name = 'Core:ArchiveOrganizationUnit';
        path = '/message/ArchiveOrganizationUnit';
        request;
        response;
    }
    Core.ArchiveOrganizationUnit = ArchiveOrganizationUnit;
    /**
     * Attach addresses to specified order(s), requiring either `OrderID` or `OrderIDs`.
     *
     * @export
     * @class AttachAddressToOrder
     * @implements {EvaService}
     */
    class AttachAddressToOrder {
        name = 'Core:AttachAddressToOrder';
        path = '/message/AttachAddressToOrder';
        request;
        response;
    }
    Core.AttachAddressToOrder = AttachAddressToOrder;
    /**
     * If the wishlist is created by anonymous, but the user logs in afterwards, this service can be used to attach the anonymous wishlist to the logged in user.
The service requires a unique name.
     *
     * @export
     * @class AttachAnonymousWishlistToUser
     * @implements {EvaService}
     */
    class AttachAnonymousWishlistToUser {
        name = 'Core:AttachAnonymousWishlistToUser';
        path = '/message/AttachAnonymousWishlistToUser';
        request;
        response;
    }
    Core.AttachAnonymousWishlistToUser = AttachAnonymousWishlistToUser;
    /**
     * Attaches a blob to an invoice, either by `BlobID` or `BlobUrl`.
     *
     * @export
     * @class AttachBlobToInvoice
     * @implements {EvaService}
     */
    class AttachBlobToInvoice {
        name = 'Core:AttachBlobToInvoice';
        path = '/message/AttachBlobToInvoice';
        request;
        response;
    }
    Core.AttachBlobToInvoice = AttachBlobToInvoice;
    /**
     * Attaches given blob to an order, either by `BlobID` or `BlobUrl`.
     *
     * @export
     * @class AttachBlobToOrder
     * @implements {EvaService}
     */
    class AttachBlobToOrder {
        name = 'Core:AttachBlobToOrder';
        path = '/message/AttachBlobToOrder';
        request;
        response;
    }
    Core.AttachBlobToOrder = AttachBlobToOrder;
    /**
     * Attaches a consumer company to an order. Optionally, provide a user ID to associate with it.
     *
     * @export
     * @class AttachConsumerCompanyToOrder
     * @implements {EvaService}
     */
    class AttachConsumerCompanyToOrder {
        name = 'Core:AttachConsumerCompanyToOrder';
        path = '/message/AttachConsumerCompanyToOrder';
        request;
        response;
    }
    Core.AttachConsumerCompanyToOrder = AttachConsumerCompanyToOrder;
    /**
     * Attach a Customer to an Order. When no UserID is provided the current user will be attached. If the selected User has addresses, these will also be assigned to the Order.
     *
     * @export
     * @class AttachCustomerToOrder
     * @implements {EvaService}
     */
    class AttachCustomerToOrder {
        name = 'Core:AttachCustomerToOrder';
        path = '/message/AttachCustomerToOrder';
        request;
        response;
    }
    Core.AttachCustomerToOrder = AttachCustomerToOrder;
    /**
     * Attach an identification document to an order. This will replace any existing identification document attached to the order.
     *
     * @export
     * @class AttachIdentificationToOrder
     * @implements {EvaService}
     */
    class AttachIdentificationToOrder {
        name = 'Core:AttachIdentificationToOrder';
        path = '/message/AttachIdentificationToOrder';
        request;
        response;
    }
    Core.AttachIdentificationToOrder = AttachIdentificationToOrder;
    /**
     * Attaches an OpeningHoursTemplate to the given OrganizationUnitSets.
When `OverrideIfOpeningHoursTypeAlreadyAttached` is set to true, the service detaches the template of the same type before attaching the new template.
When `OverrideIfOpeningHoursTypeAlreadyAttached` is set to false, the service will fail if one of the given OrganizationUnitSets is already attached to a OpeningHoursTemplate of the same Type.
     *
     * @export
     * @class AttachOpeningHoursTemplateToOrganizationUnitSets
     * @implements {EvaService}
     */
    class AttachOpeningHoursTemplateToOrganizationUnitSets {
        name = 'Core:AttachOpeningHoursTemplateToOrganizationUnitSets';
        path = '/message/AttachOpeningHoursTemplateToOrganizationUnitSets';
        request;
        response;
    }
    Core.AttachOpeningHoursTemplateToOrganizationUnitSets = AttachOpeningHoursTemplateToOrganizationUnitSets;
    /**
     * Attaches an user to a consumer company.
     *
     * @export
     * @class AttachUserToConsumerCompany
     * @implements {EvaService}
     */
    class AttachUserToConsumerCompany {
        name = 'Core:AttachUserToConsumerCompany';
        path = '/message/AttachUserToConsumerCompany';
        request;
        response;
    }
    Core.AttachUserToConsumerCompany = AttachUserToConsumerCompany;
    /**
     * Automatically places, ships and receives an interbranch order between 2 organization units.
     *
     * @export
     * @class AutoTransferInterbranchOrder
     * @implements {EvaService}
     */
    class AutoTransferInterbranchOrder {
        name = 'Core:AutoTransferInterbranchOrder';
        path = '/message/AutoTransferInterbranchOrder';
        request;
        response;
    }
    Core.AutoTransferInterbranchOrder = AutoTransferInterbranchOrder;
    /**
     * Service for retrieving a list of suggested addresses
     *
     * @export
     * @class AutocompleteAddress
     * @implements {EvaService}
     */
    class AutocompleteAddress {
        name = 'Core:AutocompleteAddress';
        path = '/message/AutocompleteAddress';
        request;
        response;
    }
    Core.AutocompleteAddress = AutocompleteAddress;
    /**
     * Attempts to autocomplete the order by:

- Cancelling the lines that can still be cancelled
- Invoicing the lines that've been (partially) shipped
- Optionally creating a payment to bring the open amount to 0

:bikini: __The actions this service performs are irreverisble__

*With great power comes great responsibility*
-Uncle Ben
     *
     * @export
     * @class AutocompleteOrder
     * @implements {EvaService}
     */
    class AutocompleteOrder {
        name = 'Core:AutocompleteOrder';
        path = '/message/AutocompleteOrder';
        request;
        response;
    }
    Core.AutocompleteOrder = AutocompleteOrder;
    /**
     * Generate a barcode image.

The `Format` is one of;

- QR = 0
- EAN = 1
- Code39 = 2
- Code128 = 3

:lock: This is the safer variant to our `/barcode` endpoint, because the data moves _inside_ the POST body instead of through GET query params
:bulb: You can use the returned `Data` in combination with `MimeType` to render the image directly, for example;

```
  <img src='data:{MimeType};base64,{Data}' />
```
     *
     * @export
     * @class Barcode
     * @implements {EvaService}
     */
    class Barcode {
        name = 'Core:Barcode';
        path = '/message/Barcode';
        request;
        response;
    }
    Core.Barcode = Barcode;
    /**
     * Books the given invoice by its `ID`.

Booking an invoice has the side effect of creating a payment on the order for the amount of the invoice.
     *
     * @export
     * @class BookInvoice
     * @implements {EvaService}
     */
    class BookInvoice {
        name = 'Core:BookInvoice';
        path = '/message/BookInvoice';
        request;
        response;
    }
    Core.BookInvoice = BookInvoice;
    /**
     * Updates some of the non-unique the OrganizationUnit's settings. This service can be used to only update a subset of the settings of the OrganizationUnit by providing only the fields you want to update.
If a field is not part of the request message (or has value `undefined`) then the setting is not updated. If the field is present but has a value of `null` then it's assumed you want to unset the setting.

The targeted OrganizationUnits can be identified by providing `OrganizationUnitIDs` or an `OrganizationUnitSetID`.

All OrganizationUnits will be updated, if one of them fails, no changes will be persisted.
     *
     * @export
     * @class BulkUpdateOrganizationUnitSettings
     * @implements {EvaService}
     */
    class BulkUpdateOrganizationUnitSettings {
        name = 'Core:BulkUpdateOrganizationUnitSettings';
        path = '/message/BulkUpdateOrganizationUnitSettings';
        request;
        response;
    }
    Core.BulkUpdateOrganizationUnitSettings = BulkUpdateOrganizationUnitSettings;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CanProcessInitialCycleCount
     * @implements {EvaService}
     */
    class CanProcessInitialCycleCount {
        name = 'Core:CanProcessInitialCycleCount';
        path = '/message/CanProcessInitialCycleCount';
        request;
        response;
    }
    Core.CanProcessInitialCycleCount = CanProcessInitialCycleCount;
    /**
     * Cancel the pending cash PaymentTransactions on the Order to remove the AML checks.
     *
     * @export
     * @class CancelAMLChecksOnOrder
     * @implements {EvaService}
     */
    class CancelAMLChecksOnOrder {
        name = 'Core:CancelAMLChecksOnOrder';
        path = '/message/CancelAMLChecksOnOrder';
        request;
        response;
    }
    Core.CancelAMLChecksOnOrder = CancelAMLChecksOnOrder;
    /**
     * Cancel a discount order line.

When the discount of the given line is a coupon triggerd discount, the coupon will be removed from the order.
When the discount of the given line is a manual discount, the manual discount will be cancelled.
When the discount of the given line is an automatic discount, the discount will be disabled on the order. To re-enable it you must call the 'EnableDisabledDiscountOnOrder' service. You can check which discount are disabled on an order by calling 'ListDisabledDiscountsOnOrder'
     *
     * @export
     * @class CancelDiscountOrderLine
     * @implements {EvaService}
     */
    class CancelDiscountOrderLine {
        name = 'Core:CancelDiscountOrderLine';
        path = '/message/CancelDiscountOrderLine';
        request;
        response;
    }
    Core.CancelDiscountOrderLine = CancelDiscountOrderLine;
    /**
     * Cancel a full stock count, cancelling all related labels and their results.
     *
     * @export
     * @class CancelFullStockCount
     * @implements {EvaService}
     */
    class CancelFullStockCount {
        name = 'Core:CancelFullStockCount';
        path = '/message/CancelFullStockCount';
        request;
        response;
    }
    Core.CancelFullStockCount = CancelFullStockCount;
    /**
     * Cancel a specific Full Stock Count label.
     *
     * @export
     * @class CancelFullStockCountLabel
     * @implements {EvaService}
     */
    class CancelFullStockCountLabel {
        name = 'Core:CancelFullStockCountLabel';
        path = '/message/CancelFullStockCountLabel';
        request;
        response;
    }
    Core.CancelFullStockCountLabel = CancelFullStockCountLabel;
    /**
     * Cancel a complete order or a subset of lines.

The order can be identified by an OrderID or by BackendID + BackendSystemID, the lines can be identified by an OrderLineID or by BackendID.

The result will tell you if it was successful.
     *
     * @export
     * @class CancelOrder
     * @implements {EvaService}
     */
    class CancelOrder {
        name = 'Core:CancelOrder';
        path = '/message/CancelOrder';
        request;
        response;
    }
    Core.CancelOrder = CancelOrder;
    /**
     * Cancels the OrderFulfillmentLines for the given OrderID and provided OrderLineIDs.
It will cancel all not already cancelled OrderFulfillmentLines for the orderlines.
This will cause them to be re-routed and possible be fulfilled through another supplier or method.
     *
     * @export
     * @class CancelOrderLineFulfillments
     * @implements {EvaService}
     */
    class CancelOrderLineFulfillments {
        name = 'Core:CancelOrderLineFulfillments';
        path = '/message/CancelOrderLineFulfillments';
        request;
        response;
    }
    Core.CancelOrderLineFulfillments = CancelOrderLineFulfillments;
    /**
     * Cancels a non-confirmed payment transaction
     *
     * @export
     * @class CancelPayment
     * @implements {EvaService}
     */
    class CancelPayment {
        name = 'Core:CancelPayment';
        path = '/message/CancelPayment';
        request;
        response;
    }
    Core.CancelPayment = CancelPayment;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CancelSecondChanceProductRegistration
     * @implements {EvaService}
     */
    class CancelSecondChanceProductRegistration {
        name = 'Core:CancelSecondChanceProductRegistration';
        path = '/message/CancelSecondChanceProductRegistration';
        request;
        response;
    }
    Core.CancelSecondChanceProductRegistration = CancelSecondChanceProductRegistration;
    /**
     * Cancels shipments without receipt of goods, also removing stock in transit.
     *
     * @export
     * @class CancelShipments
     * @implements {EvaService}
     */
    class CancelShipments {
        name = 'Core:CancelShipments';
        path = '/message/CancelShipments';
        request;
        response;
    }
    Core.CancelShipments = CancelShipments;
    /**
     * Sends a capture request to the PSP for the given PaymentTransaction with the given amount.
     *
     * @export
     * @class CapturePayment
     * @implements {EvaService}
     */
    class CapturePayment {
        name = 'Core:CapturePayment';
        path = '/message/CapturePayment';
        request;
        response;
    }
    Core.CapturePayment = CapturePayment;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CaptureShipment
     * @implements {EvaService}
     */
    class CaptureShipment {
        name = 'Core:CaptureShipment';
        path = '/message/CaptureShipment';
        request;
        response;
    }
    Core.CaptureShipment = CaptureShipment;
    /**
     * Checks a balance of given card, where `Handler` or `Barcode` determines the giftcard provider to consult.
     *
     * @export
     * @class CardBalanceCheck
     * @implements {EvaService}
     */
    class CardBalanceCheck {
        name = 'Core:CardBalanceCheck';
        path = '/message/CardBalanceCheck';
        request;
        response;
    }
    Core.CardBalanceCheck = CardBalanceCheck;
    /**
     * Update some OrderLines to a state so that they can be carried out in a store

If the products should be ordered from a supplier first, the `OrderTheLinesFromASupplier` property should be true.

When no OrderLineIDs are provided all eligable lines in the Order are updated
     *
     * @export
     * @class ChangeOrderLinesToCarryOut
     * @implements {EvaService}
     */
    class ChangeOrderLinesToCarryOut {
        name = 'Core:ChangeOrderLinesToCarryOut';
        path = '/message/ChangeOrderLinesToCarryOut';
        request;
        response;
    }
    Core.ChangeOrderLinesToCarryOut = ChangeOrderLinesToCarryOut;
    /**
     * Update some OrderLines to a state so that they can be delivered to the ShippingAddress on the order

When no OrderLineIDs are provided all eligable lines in the Order are updated
     *
     * @export
     * @class ChangeOrderLinesToDelivery
     * @implements {EvaService}
     */
    class ChangeOrderLinesToDelivery {
        name = 'Core:ChangeOrderLinesToDelivery';
        path = '/message/ChangeOrderLinesToDelivery';
        request;
        response;
    }
    Core.ChangeOrderLinesToDelivery = ChangeOrderLinesToDelivery;
    /**
     * Update some OrderLines to a state so that they can be pickup up in a store by the customer attached to the order

If no PickupOrganizationUnit was choses yet, it should be provided in the `PickupOrganizationUnitID` property.

When no OrderLineIDs are provided all eligable lines in the Order are updated
     *
     * @export
     * @class ChangeOrderLinesToPickup
     * @implements {EvaService}
     */
    class ChangeOrderLinesToPickup {
        name = 'Core:ChangeOrderLinesToPickup';
        path = '/message/ChangeOrderLinesToPickup';
        request;
        response;
    }
    Core.ChangeOrderLinesToPickup = ChangeOrderLinesToPickup;
    /**
     * Change the password of a user.

When invalid, the service will return a 400 BAD REQUEST;

- SecurityPolicy:UserOrPasswordInvalid
- SecurityPolicy:TooShort
- SecurityPolicy:TooLong
- SecurityPolicy.NewPasswordIsRequired
- SecurityPolicy.Pwned
- General
     *
     * @export
     * @class ChangeUserPassword
     * @implements {EvaService}
     */
    class ChangeUserPassword {
        name = 'Core:ChangeUserPassword';
        path = '/message/ChangeUserPassword';
        request;
        response;
    }
    Core.ChangeUserPassword = ChangeUserPassword;
    /**
     * Checks if the given EmailAddress is available to create an account for.

When creating Employee accounts, the `AsEmployee` property should be set to true.
     *
     * @export
     * @class CheckEmailAddressAvailability
     * @implements {EvaService}
     */
    class CheckEmailAddressAvailability {
        name = 'Core:CheckEmailAddressAvailability';
        path = '/message/CheckEmailAddressAvailability';
        request;
        response;
    }
    Core.CheckEmailAddressAvailability = CheckEmailAddressAvailability;
    /**
     * Checks if a magic login was confirmed already.
     *
     * @export
     * @class CheckMagicLink
     * @implements {EvaService}
     */
    class CheckMagicLink {
        name = 'Core:CheckMagicLink';
        path = '/message/CheckMagicLink';
        request;
        response;
    }
    Core.CheckMagicLink = CheckMagicLink;
    /**
     * Checks if the given Nickname is available to create an account for.

When creating Employee accounts, the `AsEmployee` property should be set to true.
     *
     * @export
     * @class CheckNicknameAvailability
     * @implements {EvaService}
     */
    class CheckNicknameAvailability {
        name = 'Core:CheckNicknameAvailability';
        path = '/message/CheckNicknameAvailability';
        request;
        response;
    }
    Core.CheckNicknameAvailability = CheckNicknameAvailability;
    /**
     * Check if the order has fraudulent shipping or billing addresses
     *
     * @export
     * @class CheckOrderAddressFraud
     * @implements {EvaService}
     */
    class CheckOrderAddressFraud {
        name = 'Core:CheckOrderAddressFraud';
        path = '/message/CheckOrderAddressFraud';
        request;
        response;
    }
    Core.CheckOrderAddressFraud = CheckOrderAddressFraud;
    /**
     * Check if order BackendID exists
     *
     * @export
     * @class CheckOrderBackendIDExists
     * @implements {EvaService}
     */
    class CheckOrderBackendIDExists {
        name = 'Core:CheckOrderBackendIDExists';
        path = '/message/CheckOrderBackendIDExists';
        request;
        response;
    }
    Core.CheckOrderBackendIDExists = CheckOrderBackendIDExists;
    /**
     * Check if shipment BackendID exists
     *
     * @export
     * @class CheckShipmentBackendIDExists
     * @implements {EvaService}
     */
    class CheckShipmentBackendIDExists {
        name = 'Core:CheckShipmentBackendIDExists';
        path = '/message/CheckShipmentBackendIDExists';
        request;
        response;
    }
    Core.CheckShipmentBackendIDExists = CheckShipmentBackendIDExists;
    /**
     * Closes the financial period for your current OrganizationUnit.
     *
     * @export
     * @class CloseFinancialPeriod
     * @implements {EvaService}
     */
    class CloseFinancialPeriod {
        name = 'Core:CloseFinancialPeriod';
        path = '/message/CloseFinancialPeriod';
        request;
        response;
    }
    Core.CloseFinancialPeriod = CloseFinancialPeriod;
    /**
     * This service allows you to manually commit the stock for the given OrderLineIDs.
The response contains whether or not the commitment was successful, per OrderLine.

Commitment can be unsucessful for two reasons:

- No commitment is necessary. This is because it's an OrderLine that can't be committed, for example one without a stock product, or because the order type doesn't allow commitments.
- Insufficient stock. This service only allows creating a commitment when there's sufficient available stock. Use the MoveCommitments or UncommitOrderLines services to create available stock.
     *
     * @export
     * @class CommitOrderLines
     * @implements {EvaService}
     */
    class CommitOrderLines {
        name = 'Core:CommitOrderLines';
        path = '/message/CommitOrderLines';
        request;
        response;
    }
    Core.CommitOrderLines = CommitOrderLines;
    /**
     * Completes the closing of a cash journal, making the device once again unavailable for cash transactions until a new journal is opened.

This service expects a list of coins and notes, which summed up must equal the given `TotalAmount`.

If the `TotalAmount` is different from what was expected (returned as `ExpectedClosingAmount` in `StartCloseCashJournal` ) then this deviation
must be corrected and provided through a list of corrections in the `Corrections` field.

For cash journals that either do not use or ignore cash journals, most properties will automatically be set to the expected amounts. Should you
want to enforce validation, regardless, specify the `ForceValidation` as `true`.

Pending cash deposits need to be accounted for as well - supply their `ID`s as `PendingCashDeposits`. Do not add the `Amount` of cash deposits
to the `TotalAmount`, as the user cannot usually verify the cash deposit content.
     *
     * @export
     * @class CompleteCloseCashJournal
     * @implements {EvaService}
     */
    class CompleteCloseCashJournal {
        name = 'Core:CompleteCloseCashJournal';
        path = '/message/CompleteCloseCashJournal';
        request;
        response;
    }
    Core.CompleteCloseCashJournal = CompleteCloseCashJournal;
    /**
     * Completes a ConsolidatedPickTask task.
     *
     * @export
     * @class CompleteConsolidatedPickTask
     * @implements {EvaService}
     */
    class CompleteConsolidatedPickTask {
        name = 'Core:CompleteConsolidatedPickTask';
        path = '/message/CompleteConsolidatedPickTask';
        request;
        response;
    }
    Core.CompleteConsolidatedPickTask = CompleteConsolidatedPickTask;
    /**
     * Completes a ConsolidatedZonePickTask
     *
     * @export
     * @class CompleteConsolidatedZonePickTask
     * @implements {EvaService}
     */
    class CompleteConsolidatedZonePickTask {
        name = 'Core:CompleteConsolidatedZonePickTask';
        path = '/message/CompleteConsolidatedZonePickTask';
        request;
        response;
    }
    Core.CompleteConsolidatedZonePickTask = CompleteConsolidatedZonePickTask;
    /**
     * Completes a custom usertask
     *
     * @export
     * @class CompleteCustomUserTask
     * @implements {EvaService}
     */
    class CompleteCustomUserTask {
        name = 'Core:CompleteCustomUserTask';
        path = '/message/CompleteCustomUserTask';
        request;
        response;
    }
    Core.CompleteCustomUserTask = CompleteCustomUserTask;
    /**
     * Completes a full stock count task. User task must be active and assigned to the current user.
     *
     * @export
     * @class CompleteFullStockCount
     * @implements {EvaService}
     */
    class CompleteFullStockCount {
        name = 'Core:CompleteFullStockCount';
        path = '/message/CompleteFullStockCount';
        request;
        response;
    }
    Core.CompleteFullStockCount = CompleteFullStockCount;
    /**
     * Completes a Full Stock Count label task. User task must be active and assigned to the current user.
     *
     * @export
     * @class CompleteFullStockCountLabel
     * @implements {EvaService}
     */
    class CompleteFullStockCountLabel {
        name = 'Core:CompleteFullStockCountLabel';
        path = '/message/CompleteFullStockCountLabel';
        request;
        response;
    }
    Core.CompleteFullStockCountLabel = CompleteFullStockCountLabel;
    /**
     * Complete multiple print SFS tasks.
     *
     * @export
     * @class CompleteMultipleShipFromStoreTasks
     * @implements {EvaService}
     */
    class CompleteMultipleShipFromStoreTasks {
        name = 'Core:CompleteMultipleShipFromStoreTasks';
        path = '/message/CompleteMultipleShipFromStoreTasks';
        request;
        response;
    }
    Core.CompleteMultipleShipFromStoreTasks = CompleteMultipleShipFromStoreTasks;
    /**
     * Completes the opening of a cash journal. After this service has been called, it's possible to make cash transactions on this device.

This service expects a list of the coins and notes that were counted.

When the opening amount is different from last period's closing amount, it's required that a correction is provided for this difference
in `OpeningDeviationCorrection`. This simply consists of a description and an amount.

For cash journals that either do not use or ignore cash journals, most properties will automatically be set to the expected amounts. Should you
want to enforce validation, regardless, specify the `ForceValidation` as `true`.

Pending cash deposits need to be accounted for as well - supply their `ID`s as `PendingCashDeposits`. Do not add the `Amount` of cash deposits
to the `TotalAmount`, as the user cannot usually verify the cash deposit content.
     *
     * @export
     * @class CompleteOpenCashJournal
     * @implements {EvaService}
     */
    class CompleteOpenCashJournal {
        name = 'Core:CompleteOpenCashJournal';
        path = '/message/CompleteOpenCashJournal';
        request;
        response;
    }
    Core.CompleteOpenCashJournal = CompleteOpenCashJournal;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CompletePrintPriceLabelTask
     * @implements {EvaService}
     */
    class CompletePrintPriceLabelTask {
        name = 'Core:CompletePrintPriceLabelTask';
        path = '/message/CompletePrintPriceLabelTask';
        request;
        response;
    }
    Core.CompletePrintPriceLabelTask = CompletePrintPriceLabelTask;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CompletePrintTask
     * @implements {EvaService}
     */
    class CompletePrintTask {
        name = 'Core:CompletePrintTask';
        path = '/message/CompletePrintTask';
        request;
        response;
    }
    Core.CompletePrintTask = CompletePrintTask;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CompleteReservationCleanup
     * @implements {EvaService}
     */
    class CompleteReservationCleanup {
        name = 'Core:CompleteReservationCleanup';
        path = '/message/CompleteReservationCleanup';
        request;
        response;
    }
    Core.CompleteReservationCleanup = CompleteReservationCleanup;
    /**
     * Complete a ReservationPickupTask task
     *
     * @export
     * @class CompleteReservationPickupTask
     * @implements {EvaService}
     */
    class CompleteReservationPickupTask {
        name = 'Core:CompleteReservationPickupTask';
        path = '/message/CompleteReservationPickupTask';
        request;
        response;
    }
    Core.CompleteReservationPickupTask = CompleteReservationPickupTask;
    /**
     * Completes the ReturnToSupplier task.

When CompleteReturnToSupplierTask is called and there are no lines on the task shipment, the shipment will be removed.
     *
     * @export
     * @class CompleteReturnToSupplierTask
     * @implements {EvaService}
     */
    class CompleteReturnToSupplierTask {
        name = 'Core:CompleteReturnToSupplierTask';
        path = '/message/CompleteReturnToSupplierTask';
        request;
        response;
    }
    Core.CompleteReturnToSupplierTask = CompleteReturnToSupplierTask;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CompleteSecondChanceProductRegistration
     * @implements {EvaService}
     */
    class CompleteSecondChanceProductRegistration {
        name = 'Core:CompleteSecondChanceProductRegistration';
        path = '/message/CompleteSecondChanceProductRegistration';
        request;
        response;
    }
    Core.CompleteSecondChanceProductRegistration = CompleteSecondChanceProductRegistration;
    /**
     * Completes the ShipFromOrder task, indicating that the shipment of the order has taken place.

The order will be shipped and the shop stock will be moved to Transit.
     *
     * @export
     * @class CompleteShipFromStoreTask
     * @implements {EvaService}
     */
    class CompleteShipFromStoreTask {
        name = 'Core:CompleteShipFromStoreTask';
        path = '/message/CompleteShipFromStoreTask';
        request;
        response;
    }
    Core.CompleteShipFromStoreTask = CompleteShipFromStoreTask;
    /**
     * Completes a Stock Movement Follow Up task, using the `WorkSet` returned by the `StartStockMovementFollowUp` service.
     *
     * @export
     * @class CompleteStockMovementFollowUp
     * @implements {EvaService}
     */
    class CompleteStockMovementFollowUp {
        name = 'Core:CompleteStockMovementFollowUp';
        path = '/message/CompleteStockMovementFollowUp';
        request;
        response;
    }
    Core.CompleteStockMovementFollowUp = CompleteStockMovementFollowUp;
    /**
     * Completes a Stock Replenishment task, using the UserTaskIDs from the `WorkSet` returned by the `StartStockReplenishment` service.
     *
     * @export
     * @class CompleteStockReplenishment
     * @implements {EvaService}
     */
    class CompleteStockReplenishment {
        name = 'Core:CompleteStockReplenishment';
        path = '/message/CompleteStockReplenishment';
        request;
        response;
    }
    Core.CompleteStockReplenishment = CompleteStockReplenishment;
    /**
     * Complete a StockReservation task that has been started with the StartStockReservation(2) service

The service should be called with a line for each orderline that should be reserved. It is not required anymore to send a line for each item on a line.

Provide each line with an OrderLineID and a QuantityTo(Cancel/Reserve/Order).
     *
     * @export
     * @class CompleteStockReservationTask
     * @implements {EvaService}
     */
    class CompleteStockReservationTask {
        name = 'Core:CompleteStockReservationTask';
        path = '/message/CompleteStockReservationTask';
        request;
        response;
    }
    Core.CompleteStockReservationTask = CompleteStockReservationTask;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CompleteZonedCycleCountPreCount
     * @implements {EvaService}
     */
    class CompleteZonedCycleCountPreCount {
        name = 'Core:CompleteZonedCycleCountPreCount';
        path = '/message/CompleteZonedCycleCountPreCount';
        request;
        response;
    }
    Core.CompleteZonedCycleCountPreCount = CompleteZonedCycleCountPreCount;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CompleteZonedCycleCounts
     * @implements {EvaService}
     */
    class CompleteZonedCycleCounts {
        name = 'Core:CompleteZonedCycleCounts';
        path = '/message/CompleteZonedCycleCounts';
        request;
        response;
    }
    Core.CompleteZonedCycleCounts = CompleteZonedCycleCounts;
    /**
     * Confirms a magic login by `ManualCode`.
     *
     * @export
     * @class ConfirmMagicLink
     * @implements {EvaService}
     */
    class ConfirmMagicLink {
        name = 'Core:ConfirmMagicLink';
        path = '/message/ConfirmMagicLink';
        request;
        response;
    }
    Core.ConfirmMagicLink = ConfirmMagicLink;
    /**
     * Confirms that specified Purchase Order will be delivered, identified by the `OrderID` parameter.

Optionally use the `BackendID` parameter to set the BackendID on the Purchase Order.
     *
     * @export
     * @class ConfirmPurchaseOrder
     * @implements {EvaService}
     */
    class ConfirmPurchaseOrder {
        name = 'Core:ConfirmPurchaseOrder';
        path = '/message/ConfirmPurchaseOrder';
        request;
        response;
    }
    Core.ConfirmPurchaseOrder = ConfirmPurchaseOrder;
    /**
     * Confirm a Subscription with a Token

The service returns the status of the subscription
     *
     * @export
     * @class ConfirmSubscription
     * @implements {EvaService}
     */
    class ConfirmSubscription {
        name = 'Core:ConfirmSubscription';
        path = '/message/ConfirmSubscription';
        request;
        response;
    }
    Core.ConfirmSubscription = ConfirmSubscription;
    /**
     * Confirms an email address validation by entering the code that was sent through `ValidateUserEmailAddress`.
     *
     * @export
     * @class ConfirmUserEmailAddressValidation
     * @implements {EvaService}
     */
    class ConfirmUserEmailAddressValidation {
        name = 'Core:ConfirmUserEmailAddressValidation';
        path = '/message/ConfirmUserEmailAddressValidation';
        request;
        response;
    }
    Core.ConfirmUserEmailAddressValidation = ConfirmUserEmailAddressValidation;
    /**
     * Copies EntityTranslations from one entity to another. Replaces any existing translations of the target entity.
     *
     * @export
     * @class CopyEntityTranslations
     * @implements {EvaService}
     */
    class CopyEntityTranslations {
        name = 'Core:CopyEntityTranslations';
        path = '/message/CopyEntityTranslations';
        request;
        response;
    }
    Core.CopyEntityTranslations = CopyEntityTranslations;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CountProductForInitialCycleCount
     * @implements {EvaService}
     */
    class CountProductForInitialCycleCount {
        name = 'Core:CountProductForInitialCycleCount';
        path = '/message/CountProductForInitialCycleCount';
        request;
        response;
    }
    Core.CountProductForInitialCycleCount = CountProductForInitialCycleCount;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CountStockLabelForZonedCycleCount
     * @implements {EvaService}
     */
    class CountStockLabelForZonedCycleCount {
        name = 'Core:CountStockLabelForZonedCycleCount';
        path = '/message/CountStockLabelForZonedCycleCount';
        request;
        response;
    }
    Core.CountStockLabelForZonedCycleCount = CountStockLabelForZonedCycleCount;
    /**
     * Create a new Address in the AddressBook of an User
     *
     * @export
     * @class CreateAddressBookItem
     * @implements {EvaService}
     */
    class CreateAddressBookItem {
        name = 'Core:CreateAddressBookItem';
        path = '/message/CreateAddressBookItem';
        request;
        response;
    }
    Core.CreateAddressBookItem = CreateAddressBookItem;
    /**
     * Create an anonymous token for specified `OrganizationUnitID` and `LanguageID`. The response is your new token, or a current one if it already existed.
     *
     * @export
     * @class CreateAnonymousToken
     * @implements {EvaService}
     */
    class CreateAnonymousToken {
        name = 'Core:CreateAnonymousToken';
        path = '/message/CreateAnonymousToken';
        request;
        response;
    }
    Core.CreateAnonymousToken = CreateAnonymousToken;
    /**
     * Create an anonymous wishlist.
     *
     * @export
     * @class CreateAnonymousWishlist
     * @implements {EvaService}
     */
    class CreateAnonymousWishlist {
        name = 'Core:CreateAnonymousWishlist';
        path = '/message/CreateAnonymousWishlist';
        request;
        response;
    }
    Core.CreateAnonymousWishlist = CreateAnonymousWishlist;
    /**
     * Creates an API key for specified user
     *
     * @export
     * @class CreateApiKey
     * @implements {EvaService}
     */
    class CreateApiKey {
        name = 'Core:CreateApiKey';
        path = '/message/CreateApiKey';
        request;
        response;
    }
    Core.CreateApiKey = CreateApiKey;
    /**
     * Creates a API user
     *
     * @export
     * @class CreateApiUser
     * @implements {EvaService}
     */
    class CreateApiUser {
        name = 'Core:CreateApiUser';
        path = '/message/CreateApiUser';
        request;
        response;
    }
    Core.CreateApiUser = CreateApiUser;
    /**
     * Create app rule
     *
     * @export
     * @class CreateAppRule
     * @implements {EvaService}
     */
    class CreateAppRule {
        name = 'Core:CreateAppRule';
        path = '/message/CreateAppRule';
        request;
        response;
    }
    Core.CreateAppRule = CreateAppRule;
    /**
     * Creates a new AuditChainConfiguration, which allows you to configure the starting number of a sequence and its prefix.
Creating a configuration for an audit chain that already exists does not apply this configuration. A new chain would need to be created by incrementing the Auditing:Version setting.
     *
     * @export
     * @class CreateAuditChainConfiguration
     * @implements {EvaService}
     */
    class CreateAuditChainConfiguration {
        name = 'Core:CreateAuditChainConfiguration';
        path = '/message/CreateAuditChainConfiguration';
        request;
        response;
    }
    Core.CreateAuditChainConfiguration = CreateAuditChainConfiguration;
    /**
     * Create a cash correction reason
     *
     * @export
     * @class CreateCashCorrectionReason
     * @implements {EvaService}
     */
    class CreateCashCorrectionReason {
        name = 'Core:CreateCashCorrectionReason';
        path = '/message/CreateCashCorrectionReason';
        request;
        response;
    }
    Core.CreateCashCorrectionReason = CreateCashCorrectionReason;
    /**
     * Creates a cash deposit for the provided device, currency and payment type.

When not explicitly delaying the drop-off, it will be booked to the current active cash journal and financial period.
     *
     * @export
     * @class CreateCashDeposit
     * @implements {EvaService}
     */
    class CreateCashDeposit {
        name = 'Core:CreateCashDeposit';
        path = '/message/CreateCashDeposit';
        request;
        response;
    }
    Core.CreateCashDeposit = CreateCashDeposit;
    /**
     * Creates a cash expense.

This service expects:
- `DeviceID`, which is the cash device the money was used from.
- `TypeID` which is one of the available expense types.
- An `Amount`, which is the amount of cash that was taken from or added to the device.
The amount should always be positive, but the semantics of the amount depends on the AmountType of the ExpenseType:
if ExpenseType.AmountType = Expense, then the amount is booked as an expense, if it's Income then it's booked as income. Either way, it should be a positive number.
- A `TaxCodeID`, which refers to one of the available tax codes.
- A `Description`, which is the reason for this expense (for example: 'lunch').
- A `BlobID`, which contains an image of the receipt.
- A `SignatureBlobID`, which contains an image of the signature
     *
     * @export
     * @class CreateCashExpense
     * @implements {EvaService}
     */
    class CreateCashExpense {
        name = 'Core:CreateCashExpense';
        path = '/message/CreateCashExpense';
        request;
        response;
    }
    Core.CreateCashExpense = CreateCashExpense;
    /**
     * Create and attach a new company to an User

Only Name is required.
     *
     * @export
     * @class CreateCompanyForUser
     * @implements {EvaService}
     */
    class CreateCompanyForUser {
        name = 'Core:CreateCompanyForUser';
        path = '/message/CreateCompanyForUser';
        request;
        response;
    }
    Core.CreateCompanyForUser = CreateCompanyForUser;
    /**
     * Creates consolidated pick task
     *
     * @export
     * @class CreateConsolidatedPickTask
     * @implements {EvaService}
     */
    class CreateConsolidatedPickTask {
        name = 'Core:CreateConsolidatedPickTask';
        path = '/message/CreateConsolidatedPickTask';
        request;
        response;
    }
    Core.CreateConsolidatedPickTask = CreateConsolidatedPickTask;
    /**
     * Creates consolidated pick task
     *
     * @export
     * @class CreateConsolidatedPickTask_Async
     * @implements {EvaService}
     */
    class CreateConsolidatedPickTask_Async {
        name = 'Core:CreateConsolidatedPickTask_Async';
        path = '/async-message/CreateConsolidatedPickTask';
        request;
        response;
    }
    Core.CreateConsolidatedPickTask_Async = CreateConsolidatedPickTask_Async;
    /**
     * Creates consolidated pick task
     *
     * @export
     * @class CreateConsolidatedPickTask_AsyncResult
     * @implements {EvaService}
     */
    class CreateConsolidatedPickTask_AsyncResult {
        name = 'Core:CreateConsolidatedPickTask_AsyncResult';
        path = '/async-result/CreateConsolidatedPickTask';
        request;
        response;
    }
    Core.CreateConsolidatedPickTask_AsyncResult = CreateConsolidatedPickTask_AsyncResult;
    /**
     * Creates a new company associated with the consumer type
     *
     * @export
     * @class CreateConsumerCompany
     * @implements {EvaService}
     */
    class CreateConsumerCompany {
        name = 'Core:CreateConsumerCompany';
        path = '/message/CreateConsumerCompany';
        request;
        response;
    }
    Core.CreateConsumerCompany = CreateConsumerCompany;
    /**
     * Creates a custom order status which can be set on an order
     *
     * @export
     * @class CreateCustomOrderStatus
     * @implements {EvaService}
     */
    class CreateCustomOrderStatus {
        name = 'Core:CreateCustomOrderStatus';
        path = '/message/CreateCustomOrderStatus';
        request;
        response;
    }
    Core.CreateCustomOrderStatus = CreateCustomOrderStatus;
    /**
     * Creates a new custom usertask
     *
     * @export
     * @class CreateCustomUserTask
     * @implements {EvaService}
     */
    class CreateCustomUserTask {
        name = 'Core:CreateCustomUserTask';
        path = '/message/CreateCustomUserTask';
        request;
        response;
    }
    Core.CreateCustomUserTask = CreateCustomUserTask;
    /**
     * Creates a new template for custom user tasks
     *
     * @export
     * @class CreateCustomUserTaskTemplate
     * @implements {EvaService}
     */
    class CreateCustomUserTaskTemplate {
        name = 'Core:CreateCustomUserTaskTemplate';
        path = '/message/CreateCustomUserTaskTemplate';
        request;
        response;
    }
    Core.CreateCustomUserTaskTemplate = CreateCustomUserTaskTemplate;
    /**
     * Creates a new custom usertask type.
     *
     * @export
     * @class CreateCustomUserTaskType
     * @implements {EvaService}
     */
    class CreateCustomUserTaskType {
        name = 'Core:CreateCustomUserTaskType';
        path = '/message/CreateCustomUserTaskType';
        request;
        response;
    }
    Core.CreateCustomUserTaskType = CreateCustomUserTaskType;
    /**
     * Creates a customer.

This is allowed when you are an employee, or by anonymous if the CustomerCanRegister (default true) is enabled.

Be sure to handle errors for registering, which could be (amongst others);

  * InvalidEmailAddress
  * EmailAddressInUse
  * NicknameInUse
  * FiscalIDInUse
     *
     * @export
     * @class CreateCustomer
     * @implements {EvaService}
     */
    class CreateCustomer {
        name = 'Core:CreateCustomer';
        path = '/message/CreateCustomer';
        request;
        response;
    }
    Core.CreateCustomer = CreateCustomer;
    /**
     * Create a return order from an existing sales order (`OrderID`).

When a `TargetOrderID` has been specified, newly created lines are added to that specific order. When omitted, the lines are either added to the
existing, original order (in case that is still permitted) or a new order is created automatically.

Returns information on the (newly created?) return order.
     *
     * @export
     * @class CreateCustomerReturn
     * @implements {EvaService}
     */
    class CreateCustomerReturn {
        name = 'Core:CreateCustomerReturn';
        path = '/message/CreateCustomerReturn';
        request;
        response;
    }
    Core.CreateCustomerReturn = CreateCustomerReturn;
    /**
     * Creates a return order for a set of products for which there is no original order in EVA.
     *
     * @export
     * @class CreateCustomerReturnWithoutOrder
     * @implements {EvaService}
     */
    class CreateCustomerReturnWithoutOrder {
        name = 'Core:CreateCustomerReturnWithoutOrder';
        path = '/message/CreateCustomerReturnWithoutOrder';
        request;
        response;
    }
    Core.CreateCustomerReturnWithoutOrder = CreateCustomerReturnWithoutOrder;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CreateCycleCountZone
     * @implements {EvaService}
     */
    class CreateCycleCountZone {
        name = 'Core:CreateCycleCountZone';
        path = '/message/CreateCycleCountZone';
        request;
        response;
    }
    Core.CreateCycleCountZone = CreateCycleCountZone;
    /**
     * Creates a new CycleCountZoneGroup.
     *
     * @export
     * @class CreateCycleCountZoneGroup
     * @implements {EvaService}
     */
    class CreateCycleCountZoneGroup {
        name = 'Core:CreateCycleCountZoneGroup';
        path = '/message/CreateCycleCountZoneGroup';
        request;
        response;
    }
    Core.CreateCycleCountZoneGroup = CreateCycleCountZoneGroup;
    /**
     * Creates a blob intended for app diagnostics - will log the user context to determine user, organization unit and user agent.
     *
     * @export
     * @class CreateDiagnosticsBlob
     * @implements {EvaService}
     */
    class CreateDiagnosticsBlob {
        name = 'Core:CreateDiagnosticsBlob';
        path = '/message/CreateDiagnosticsBlob';
        request;
        response;
    }
    Core.CreateDiagnosticsBlob = CreateDiagnosticsBlob;
    /**
     * Create event export configurations (HTTPS only).

Event Export Configurations allow you to configure specific endpoints (webhooks) for EventTargets and EventTypes.

- Not setting EventTarget & EventType will configure the endpoint for all targets and types
- Set AuthenticationHeaderType and AuthenticationHeaderValue if you want to configure some sort of authentication
- Make sure to catch & store the `SecretKey1` and `SecretKey2`, as there will be no other way of retrieving them after this service call!
     *
     * @export
     * @class CreateEventExportConfiguration
     * @implements {EvaService}
     */
    class CreateEventExportConfiguration {
        name = 'Core:CreateEventExportConfiguration';
        path = '/message/CreateEventExportConfiguration';
        request;
        response;
    }
    Core.CreateEventExportConfiguration = CreateEventExportConfiguration;
    /**
     * Create a new Flight object
     *
     * @export
     * @class CreateFlight
     * @implements {EvaService}
     */
    class CreateFlight {
        name = 'Core:CreateFlight';
        path = '/message/CreateFlight';
        request;
        response;
    }
    Core.CreateFlight = CreateFlight;
    /**
     * Initiate the Full Stock Count process for the current store. **Prevents basic store functionalities once started.**
     *
     * @export
     * @class CreateFullStockCount
     * @implements {EvaService}
     */
    class CreateFullStockCount {
        name = 'Core:CreateFullStockCount';
        path = '/message/CreateFullStockCount';
        request;
        response;
    }
    Core.CreateFullStockCount = CreateFullStockCount;
    /**
     * Create a return that is returned in the store. This will handle the return in the original OU and move stock to the current OU. For now, this only supports orders sold from a webshop.
     *
     * @export
     * @class CreateInStoreReturn
     * @implements {EvaService}
     */
    class CreateInStoreReturn {
        name = 'Core:CreateInStoreReturn';
        path = '/message/CreateInStoreReturn';
        request;
        response;
    }
    Core.CreateInStoreReturn = CreateInStoreReturn;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CreateInitialCycleCount
     * @implements {EvaService}
     */
    class CreateInitialCycleCount {
        name = 'Core:CreateInitialCycleCount';
        path = '/message/CreateInitialCycleCount';
        request;
        response;
    }
    Core.CreateInitialCycleCount = CreateInitialCycleCount;
    /**
     * Convert the given `Order` to a InterbranchOrder.
     *
     * @export
     * @class CreateInterbranchOrder
     * @implements {EvaService}
     */
    class CreateInterbranchOrder {
        name = 'Core:CreateInterbranchOrder';
        path = '/message/CreateInterbranchOrder';
        request;
        response;
    }
    Core.CreateInterbranchOrder = CreateInterbranchOrder;
    /**
     * Creates a new invoice for the given `OrganizationUnitID` (the one who writes the invoice)
and the `SupplierOrganizationUnitID` (the one who receives good/services).

- `InvoiceDate` is the date on which the invoice was created.
- `InvoiceNumber` is the unique number for the invoice.
- `Blobs` can contain PDF's or other media that can for example be a copy of the invoice
- `OriginalTotalAmount` is the amount that is expected on the invoice. E.g. this can differ from the amount that is computed based on the invoice lines
- `Type` indicates if this is an invoice for a sales or purchase orders
     *
     * @export
     * @class CreateInvoice
     * @implements {EvaService}
     */
    class CreateInvoice {
        name = 'Core:CreateInvoice';
        path = '/message/CreateInvoice';
        request;
        response;
    }
    Core.CreateInvoice = CreateInvoice;
    /**
     * Create an InvoiceAdditionalAmount
     *
     * @export
     * @class CreateInvoiceAdditionalAmount
     * @implements {EvaService}
     */
    class CreateInvoiceAdditionalAmount {
        name = 'Core:CreateInvoiceAdditionalAmount';
        path = '/message/CreateInvoiceAdditionalAmount';
        request;
        response;
    }
    Core.CreateInvoiceAdditionalAmount = CreateInvoiceAdditionalAmount;
    /**
     * Create a InvoiceAdditionalAmountType
     *
     * @export
     * @class CreateInvoiceAdditionalAmountType
     * @implements {EvaService}
     */
    class CreateInvoiceAdditionalAmountType {
        name = 'Core:CreateInvoiceAdditionalAmountType';
        path = '/message/CreateInvoiceAdditionalAmountType';
        request;
        response;
    }
    Core.CreateInvoiceAdditionalAmountType = CreateInvoiceAdditionalAmountType;
    /**
     * Create an InvoiceDispute
     *
     * @export
     * @class CreateInvoiceDispute
     * @implements {EvaService}
     */
    class CreateInvoiceDispute {
        name = 'Core:CreateInvoiceDispute';
        path = '/message/CreateInvoiceDispute';
        request;
        response;
    }
    Core.CreateInvoiceDispute = CreateInvoiceDispute;
    /**
     * Create a InvoiceDisputeReason
     *
     * @export
     * @class CreateInvoiceDisputeReason
     * @implements {EvaService}
     */
    class CreateInvoiceDisputeReason {
        name = 'Core:CreateInvoiceDisputeReason';
        path = '/message/CreateInvoiceDisputeReason';
        request;
        response;
    }
    Core.CreateInvoiceDisputeReason = CreateInvoiceDisputeReason;
    /**
     * Create an InvoiceDisputeResolveAction
     *
     * @export
     * @class CreateInvoiceDisputeResolveAction
     * @implements {EvaService}
     */
    class CreateInvoiceDisputeResolveAction {
        name = 'Core:CreateInvoiceDisputeResolveAction';
        path = '/message/CreateInvoiceDisputeResolveAction';
        request;
        response;
    }
    Core.CreateInvoiceDisputeResolveAction = CreateInvoiceDisputeResolveAction;
    /**
     * Creates lines on the given invoice (`InvoiceID`).

It is required to supply an OrderLine or a ShipmentLine. All other properties are optional and will be copied from the shipment-/order- line.
     *
     * @export
     * @class CreateInvoiceLines
     * @implements {EvaService}
     */
    class CreateInvoiceLines {
        name = 'Core:CreateInvoiceLines';
        path = '/message/CreateInvoiceLines';
        request;
        response;
    }
    Core.CreateInvoiceLines = CreateInvoiceLines;
    /**
     * Allocates a payment transaction to either a specific invoice, or to all open invoices sequentially.
     *
     * @export
     * @class CreateInvoicePayment
     * @implements {EvaService}
     */
    class CreateInvoicePayment {
        name = 'Core:CreateInvoicePayment';
        path = '/message/CreateInvoicePayment';
        request;
        response;
    }
    Core.CreateInvoicePayment = CreateInvoicePayment;
    /**
     * Create a correction on an already invoiced line.

This can be used to refund a partial amount on a completed OrderLine, in cases where the product should still be returnable.

Specify either `OrderLineID` and `CorrectionAmount`, or `Lines`.

- If the product is not returnable anymore, a return without retake should be created
- This will result in a new line that will be invoiced immediately and shipped by default (AutoProcess.Ship is the default variant).
- If the shipping isn't desired, use AutoProcess.None;
- If a refund is desired, use AutoProcess.ShipAndRefund.
     *
     * @export
     * @class CreateInvoicedOrderLineCorrection
     * @implements {EvaService}
     */
    class CreateInvoicedOrderLineCorrection {
        name = 'Core:CreateInvoicedOrderLineCorrection';
        path = '/message/CreateInvoicedOrderLineCorrection';
        request;
        response;
    }
    Core.CreateInvoicedOrderLineCorrection = CreateInvoicedOrderLineCorrection;
    /**
     * Create invoices for an Order. Optionally specify the specific lines with quantities.
     *
     * @export
     * @class CreateInvoicesForOrder
     * @implements {EvaService}
     */
    class CreateInvoicesForOrder {
        name = 'Core:CreateInvoicesForOrder';
        path = '/message/CreateInvoicesForOrder';
        request;
        response;
    }
    Core.CreateInvoicesForOrder = CreateInvoicesForOrder;
    /**
     * Creates an order with a manually issued invoice. This will insert a committed Invoice with a custom sequencing number and additional
`InvoiceManualData`. It will be fully paid with a custom payment type.

The specified Order will be paid, placed, shipped and completed, but without any additional side effects like stock ledgers or commitments.
     *
     * @export
     * @class CreateManualInvoice
     * @implements {EvaService}
     */
    class CreateManualInvoice {
        name = 'Core:CreateManualInvoice';
        path = '/message/CreateManualInvoice';
        request;
        response;
    }
    Core.CreateManualInvoice = CreateManualInvoice;
    /**
     * Create a new manual tax exemption reason.
     *
     * @export
     * @class CreateManualTaxExemptionReason
     * @implements {EvaService}
     */
    class CreateManualTaxExemptionReason {
        name = 'Core:CreateManualTaxExemptionReason';
        path = '/message/CreateManualTaxExemptionReason';
        request;
        response;
    }
    Core.CreateManualTaxExemptionReason = CreateManualTaxExemptionReason;
    /**
     * Converts an order to an offer
     *
     * @export
     * @class CreateOfferFromOrder
     * @implements {EvaService}
     */
    class CreateOfferFromOrder {
        name = 'Core:CreateOfferFromOrder';
        path = '/message/CreateOfferFromOrder';
        request;
        response;
    }
    Core.CreateOfferFromOrder = CreateOfferFromOrder;
    /**
     * Create a new OpeningHoursTemplate
     *
     * @export
     * @class CreateOpeningHoursTemplate
     * @implements {EvaService}
     */
    class CreateOpeningHoursTemplate {
        name = 'Core:CreateOpeningHoursTemplate';
        path = '/message/CreateOpeningHoursTemplate';
        request;
        response;
    }
    Core.CreateOpeningHoursTemplate = CreateOpeningHoursTemplate;
    /**
     * Provides a mapping between an organization unit and a company based on a country. This mapping is used in scenarios for where delivery orders are
in play. E.g endless aisle (delivery order from a store) and an online order from a website for example.

To comply with regulations, these invoices that are generated require the tax registration number from the company that will be delivering the goods
with its specific registration from the country that the goods are send to.

If a mapping already exists for given `OrganizationUnitID` and `CountryID`, the `CompanyID` will be updated and `AlreadyExisted` in the response will be `true`.
     *
     * @export
     * @class CreateOrUpdateInvoiceCompanyMapping
     * @implements {EvaService}
     */
    class CreateOrUpdateInvoiceCompanyMapping {
        name = 'Core:CreateOrUpdateInvoiceCompanyMapping';
        path = '/message/CreateOrUpdateInvoiceCompanyMapping';
        request;
        response;
    }
    Core.CreateOrUpdateInvoiceCompanyMapping = CreateOrUpdateInvoiceCompanyMapping;
    /**
     * Create a new Order of the given Type
     *
     * @export
     * @class CreateOrder
     * @implements {EvaService}
     */
    class CreateOrder {
        name = 'Core:CreateOrder';
        path = '/message/CreateOrder';
        request;
        response;
    }
    Core.CreateOrder = CreateOrder;
    /**
     * Creates and sets an app token on specified order, to allow accessing it from an anonymous context. The order may not have a Customer attached.
     *
     * @export
     * @class CreateOrderAppToken
     * @implements {EvaService}
     */
    class CreateOrderAppToken {
        name = 'Core:CreateOrderAppToken';
        path = '/message/CreateOrderAppToken';
        request;
        response;
    }
    Core.CreateOrderAppToken = CreateOrderAppToken;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CreateOrderCustomStatus
     * @implements {EvaService}
     */
    class CreateOrderCustomStatus {
        name = 'Core:CreateOrderCustomStatus';
        path = '/message/CreateOrderCustomStatus';
        request;
        response;
    }
    Core.CreateOrderCustomStatus = CreateOrderCustomStatus;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CreateOrderCustomType
     * @implements {EvaService}
     */
    class CreateOrderCustomType {
        name = 'Core:CreateOrderCustomType';
        path = '/message/CreateOrderCustomType';
        request;
        response;
    }
    Core.CreateOrderCustomType = CreateOrderCustomType;
    /**
     * Create an Order from an Offer specified by `OrderID`.
     *
     * @export
     * @class CreateOrderFromOffer
     * @implements {EvaService}
     */
    class CreateOrderFromOffer {
        name = 'Core:CreateOrderFromOffer';
        path = '/message/CreateOrderFromOffer';
        request;
        response;
    }
    Core.CreateOrderFromOffer = CreateOrderFromOffer;
    /**
     * Create a new order ledger of the given type
     *
     * @export
     * @class CreateOrderLedger
     * @implements {EvaService}
     */
    class CreateOrderLedger {
        name = 'Core:CreateOrderLedger';
        path = '/message/CreateOrderLedger';
        request;
        response;
    }
    Core.CreateOrderLedger = CreateOrderLedger;
    /**
     * Create a price correction on the order line, specified by `OrderID` and `OrderLineID`. Provide the new `UnitPrice` this order line should have, and include
a property `IncludingTax` to indicate if you mean IN or EX taxes.
     *
     * @export
     * @class CreateOrderLineUnitPriceCorrection
     * @implements {EvaService}
     */
    class CreateOrderLineUnitPriceCorrection {
        name = 'Core:CreateOrderLineUnitPriceCorrection';
        path = '/message/CreateOrderLineUnitPriceCorrection';
        request;
        response;
    }
    Core.CreateOrderLineUnitPriceCorrection = CreateOrderLineUnitPriceCorrection;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CreateOrderLink
     * @implements {EvaService}
     */
    class CreateOrderLink {
        name = 'Core:CreateOrderLink';
        path = '/message/CreateOrderLink';
        request;
        response;
    }
    Core.CreateOrderLink = CreateOrderLink;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CreateOrderLinkType
     * @implements {EvaService}
     */
    class CreateOrderLinkType {
        name = 'Core:CreateOrderLinkType';
        path = '/message/CreateOrderLinkType';
        request;
        response;
    }
    Core.CreateOrderLinkType = CreateOrderLinkType;
    /**
     * Create a new order verification reason.
     *
     * @export
     * @class CreateOrderVerificationReason
     * @implements {EvaService}
     */
    class CreateOrderVerificationReason {
        name = 'Core:CreateOrderVerificationReason';
        path = '/message/CreateOrderVerificationReason';
        request;
        response;
    }
    Core.CreateOrderVerificationReason = CreateOrderVerificationReason;
    /**
     * Create a new OrganizationUnit
     *
     * @export
     * @class CreateOrganizationUnit
     * @implements {EvaService}
     */
    class CreateOrganizationUnit {
        name = 'Core:CreateOrganizationUnit';
        path = '/message/CreateOrganizationUnit';
        request;
        response;
    }
    Core.CreateOrganizationUnit = CreateOrganizationUnit;
    /**
     * Service for creating a `OrganizationUnitSupplier`
     *
     * @export
     * @class CreateOrganizationUnitSupplier
     * @implements {EvaService}
     */
    class CreateOrganizationUnitSupplier {
        name = 'Core:CreateOrganizationUnitSupplier';
        path = '/message/CreateOrganizationUnitSupplier';
        request;
        response;
    }
    Core.CreateOrganizationUnitSupplier = CreateOrganizationUnitSupplier;
    /**
     * After having called `GetPasskeyChallenge` to obtain a challenge and some information from the server, and after pushing that through WebAuthn using `navigator.credentials.create`,
you extract information from the generated credential and send it back to the server for storage.

1. The `Challenge` matching the one originally provided through `GetPasskeyChallenge`
2. The `PublicKey` generated (base64 encoded)
3. The `AuthenticatorData` generated (base64 encoded)

The creation will succeed if the `Challenge` matches the one we created for you and all the data checks out, after which you can use your new key to log in!

When you want to log in, simply call `Login` using `CustomAuthenticatorType` set to "Passkey" and it will reply with a challenge and some information inside the
`CustomAuthenticateResponseData` property, which you can push through WebAuthn using `navigator.credentials.get` to sign that challenge with your private key. Exact the information
from the generated credential and call `Login` again with the same `CustomAuthenticatorType`, but this time include `CustomAuthenticateData` with an object of type
`PasskeyAuthenticateMessage` containing;

- The `ID` as the "rawId" of the used credential (base64 encoded)
- The `Signature` that was created to sign the challenge (base64 encoded)
- The `ClientData` to include some client information (base64 encoded json)
- The `AuthenticatorData` to include some authenticator data (base64 encoded)

If this all checks out, you're logged in! As with every `Login`, be sure to specify user types and organization units of your preference.
     *
     * @export
     * @class CreatePasskey
     * @implements {EvaService}
     */
    class CreatePasskey {
        name = 'Core:CreatePasskey';
        path = '/message/CreatePasskey';
        request;
        response;
    }
    Core.CreatePasskey = CreatePasskey;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CreatePayment
     * @implements {EvaService}
     */
    class CreatePayment {
        name = 'Core:CreatePayment';
        path = '/message/CreatePayment';
        request;
        response;
    }
    Core.CreatePayment = CreatePayment;
    /**
     * Create a new paymenttransaction ledger of the given type. Only custom types are allowed
     *
     * @export
     * @class CreatePaymentTransactionLedger
     * @implements {EvaService}
     */
    class CreatePaymentTransactionLedger {
        name = 'Core:CreatePaymentTransactionLedger';
        path = '/message/CreatePaymentTransactionLedger';
        request;
        response;
    }
    Core.CreatePaymentTransactionLedger = CreatePaymentTransactionLedger;
    /**
     * Creates a new Print Price Label task with specified products, or append these to existing tasks when applicable.
     *
     * @export
     * @class CreatePrintPriceLabelTask
     * @implements {EvaService}
     */
    class CreatePrintPriceLabelTask {
        name = 'Core:CreatePrintPriceLabelTask';
        path = '/message/CreatePrintPriceLabelTask';
        request;
        response;
    }
    Core.CreatePrintPriceLabelTask = CreatePrintPriceLabelTask;
    /**
     * Create a UserTask in specified organization unit to print a specific `BlobID` or `BlobUrl`.
     *
     * @export
     * @class CreatePrintTask
     * @implements {EvaService}
     */
    class CreatePrintTask {
        name = 'Core:CreatePrintTask';
        path = '/message/CreatePrintTask';
        request;
        response;
    }
    Core.CreatePrintTask = CreatePrintTask;
    /**
     * This service creates a ProductBundle for the given BundleProductID.

The request body object contains three parameters:

- BackendID: Optional. Can be filled in with the identifier of this bundle by which it is known in another system.
- BundleProductID: Required. This should refer to an EVA product with type `BundleProduct`.
- Type: Required. This specifies the type of bundle: discount or configurable. The type can not be changed after the bundle has been created.
- Lines: Optional. These specify the `ProductBundle`'s lines. If left empty or null at creation, these can be filled in by calling `UpdateProductBundle`. When specified, a line consists of the following:
    - BackendID: Optional. If the bundle exists in another system, this can refer to it.
    - Options: A list of available options for this line from which can be chosen. Only contains a ProductID for now, which may refer to a normal sellable product, a product with Type `ConfigurableProduct` or a `BundleProduct` (which would create bundles of bundles).
    - DefaultProductID: Optional, but required if there are multiple options or if the line option is a Configurable product. The DefaultProductID cannot be a `ConfigurableProduct` or a `BundleProduct`.
    - IsRequired: Is this line an optional part of the bundle or not?
    - IsPromptSuppressed: Should the FE suppress the modal that allows the user to select a matching bundle for the scanned product
     *
     * @export
     * @class CreateProductBundle
     * @implements {EvaService}
     */
    class CreateProductBundle {
        name = 'Core:CreateProductBundle';
        path = '/message/CreateProductBundle';
        request;
        response;
    }
    Core.CreateProductBundle = CreateProductBundle;
    /**
     * Create a new structure of products.
     *
     * @export
     * @class CreateProductStructure
     * @implements {EvaService}
     */
    class CreateProductStructure {
        name = 'Core:CreateProductStructure';
        path = '/message/CreateProductStructure';
        request;
        response;
    }
    Core.CreateProductStructure = CreateProductStructure;
    /**
     * Creates a new ProductZone.
     *
     * @export
     * @class CreateProductZone
     * @implements {EvaService}
     */
    class CreateProductZone {
        name = 'Core:CreateProductZone';
        path = '/message/CreateProductZone';
        request;
        response;
    }
    Core.CreateProductZone = CreateProductZone;
    /**
     * Creates a new ProductZoneGroup.
     *
     * @export
     * @class CreateProductZoneGroup
     * @implements {EvaService}
     */
    class CreateProductZoneGroup {
        name = 'Core:CreateProductZoneGroup';
        path = '/message/CreateProductZoneGroup';
        request;
        response;
    }
    Core.CreateProductZoneGroup = CreateProductZoneGroup;
    /**
     * Creates a Purchase Order for supplied `OrganizationUnitID`, from optional `SupplierID`.

Use the `BackendID` to indicate the supplier order reference.
     *
     * @export
     * @class CreatePurchaseOrder
     * @implements {EvaService}
     */
    class CreatePurchaseOrder {
        name = 'Core:CreatePurchaseOrder';
        path = '/message/CreatePurchaseOrder';
        request;
        response;
    }
    Core.CreatePurchaseOrder = CreatePurchaseOrder;
    /**
     * Create a price correction on the purchase order line.
     *
     * @export
     * @class CreatePurchaseOrderLineUnitPriceCorrection
     * @implements {EvaService}
     */
    class CreatePurchaseOrderLineUnitPriceCorrection {
        name = 'Core:CreatePurchaseOrderLineUnitPriceCorrection';
        path = '/message/CreatePurchaseOrderLineUnitPriceCorrection';
        request;
        response;
    }
    Core.CreatePurchaseOrderLineUnitPriceCorrection = CreatePurchaseOrderLineUnitPriceCorrection;
    /**
     * Service for creating a `QuickBuy`
     *
     * @export
     * @class CreateQuickBuy
     * @implements {EvaService}
     */
    class CreateQuickBuy {
        name = 'Core:CreateQuickBuy';
        path = '/message/CreateQuickBuy';
        request;
        response;
    }
    Core.CreateQuickBuy = CreateQuickBuy;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CreateRecurringTask
     * @implements {EvaService}
     */
    class CreateRecurringTask {
        name = 'Core:CreateRecurringTask';
        path = '/message/CreateRecurringTask';
        request;
        response;
    }
    Core.CreateRecurringTask = CreateRecurringTask;
    /**
     * Create a refund

With this service a refund can be done based on an existing PaymentTransaction, or without it for an Order.

It is required to specify a transaction or to specify the PaymentType to use.

When no Amount is specified the open amount of the order will be used.
     *
     * @export
     * @class CreateRefund
     * @implements {EvaService}
     */
    class CreateRefund {
        name = 'Core:CreateRefund';
        path = '/message/CreateRefund';
        request;
        response;
    }
    Core.CreateRefund = CreateRefund;
    /**
     * Create a repair
     *
     * @export
     * @class CreateRepair
     * @implements {EvaService}
     */
    class CreateRepair {
        name = 'Core:CreateRepair';
        path = '/message/CreateRepair';
        request;
        response;
    }
    Core.CreateRepair = CreateRepair;
    /**
     * Creates a new interaction associated with a specific repair
     *
     * @export
     * @class CreateRepairInteraction
     * @implements {EvaService}
     */
    class CreateRepairInteraction {
        name = 'Core:CreateRepairInteraction';
        path = '/message/CreateRepairInteraction';
        request;
        response;
    }
    Core.CreateRepairInteraction = CreateRepairInteraction;
    /**
     * Convert the given `Order` to a ReturnToSupplierOrder. Existing none-product lines will be cancelled.
     *
     * @export
     * @class CreateReturnToSupplierOrder
     * @implements {EvaService}
     */
    class CreateReturnToSupplierOrder {
        name = 'Core:CreateReturnToSupplierOrder';
        path = '/message/CreateReturnToSupplierOrder';
        request;
        response;
    }
    Core.CreateReturnToSupplierOrder = CreateReturnToSupplierOrder;
    /**
     * Create a new ReturnToSupplierRequest

A ReturnToSupplierRequest is used to generate ReturnToSupplier orders for Shops

- Name: For identification of the request (required)
- OrganizationUnitSetID: The organizationunits (filtered on Type = Shop) that will get a RTS (required)
- ProductSearchTemplateID: Only products matching this template will be added to the orders, if supplied (optional)
- RecallPercentage: Percentage of the current stock to recall. Value should be between 0.00 and 1.00. (required)
- Filters, CountryID, LanguageID: Instead of a productsearchtemplate, products can also be defined by providing a manual filter (all optional)
     *
     * @export
     * @class CreateReturnToSupplierRequest
     * @implements {EvaService}
     */
    class CreateReturnToSupplierRequest {
        name = 'Core:CreateReturnToSupplierRequest';
        path = '/message/CreateReturnToSupplierRequest';
        request;
        response;
    }
    Core.CreateReturnToSupplierRequest = CreateReturnToSupplierRequest;
    /**
     * Creates a new script.
     *
     * @export
     * @class CreateScript
     * @implements {EvaService}
     */
    class CreateScript {
        name = 'Core:CreateScript';
        path = '/message/CreateScript';
        request;
        response;
    }
    Core.CreateScript = CreateScript;
    /**
     * Create a new Serial Number
     *
     * @export
     * @class CreateSerialNumber
     * @implements {EvaService}
     */
    class CreateSerialNumber {
        name = 'Core:CreateSerialNumber';
        path = '/message/CreateSerialNumber';
        request;
        response;
    }
    Core.CreateSerialNumber = CreateSerialNumber;
    /**
     * Creates a new entity for Serial Number Configuration, defining a set of requirements where linked products should adhere to.
     *
     * @export
     * @class CreateSerialNumberConfiguration
     * @implements {EvaService}
     */
    class CreateSerialNumberConfiguration {
        name = 'Core:CreateSerialNumberConfiguration';
        path = '/message/CreateSerialNumberConfiguration';
        request;
        response;
    }
    Core.CreateSerialNumberConfiguration = CreateSerialNumberConfiguration;
    /**
     * Associate a product with a Serial Number Configuration, or re-associate with this Serial Number Configuration in case it was previously assigned to another.
     *
     * @export
     * @class CreateSerialNumberProduct
     * @implements {EvaService}
     */
    class CreateSerialNumberProduct {
        name = 'Core:CreateSerialNumberProduct';
        path = '/message/CreateSerialNumberProduct';
        request;
        response;
    }
    Core.CreateSerialNumberProduct = CreateSerialNumberProduct;
    /**
     * Create a new shipment

It is required to specify an Order. This can be done with `OrderID` or by sending `OrderBackendID` and `OrderBackendSystemID`.

To create a pending Shipment, set `IsPending` to true. A pending shipment has to be shipped with the ShipShipment service.
     *
     * @export
     * @class CreateShipment
     * @implements {EvaService}
     */
    class CreateShipment {
        name = 'Core:CreateShipment';
        path = '/message/CreateShipment';
        request;
        response;
    }
    Core.CreateShipment = CreateShipment;
    /**
     * Create a new shipment identifier.
     *
     * @export
     * @class CreateShipmentIdentifier
     * @implements {EvaService}
     */
    class CreateShipmentIdentifier {
        name = 'Core:CreateShipmentIdentifier';
        path = '/message/CreateShipmentIdentifier';
        request;
        response;
    }
    Core.CreateShipmentIdentifier = CreateShipmentIdentifier;
    /**
     * Creates a shipment receipt with `Lines` for specified `ShipmentID`.

* `CompletesShipment` / `Lines.CompletesShipmentLine` will close the shipment (line) for futher receipts
* `Lines.QuantityReceived` is the delta quantity received in this receipt, so not the new total quantity received
* `StockLabelID` is the target StockLabel for the received stock - overrides the StockLabel of the purchase order line
     *
     * @export
     * @class CreateShipmentReceipt
     * @implements {EvaService}
     */
    class CreateShipmentReceipt {
        name = 'Core:CreateShipmentReceipt';
        path = '/message/CreateShipmentReceipt';
        request;
        response;
    }
    Core.CreateShipmentReceipt = CreateShipmentReceipt;
    /**
     * Creates a stock mutation for the given organization unit and product. Note that this service supports creating delta's as well as modifying in absolute quantities based on the `Delta` property.'
     *
     * @export
     * @class CreateStockMutations
     * @implements {EvaService}
     */
    class CreateStockMutations {
        name = 'Core:CreateStockMutations';
        path = '/message/CreateStockMutations';
        request;
        response;
    }
    Core.CreateStockMutations = CreateStockMutations;
    /**
     * Creates a StockNotification for a product and organization, for specified EmailAddress - will return its ID.
     *
     * @export
     * @class CreateStockNotification
     * @implements {EvaService}
     */
    class CreateStockNotification {
        name = 'Core:CreateStockNotification';
        path = '/message/CreateStockNotification';
        request;
        response;
    }
    Core.CreateStockNotification = CreateStockNotification;
    /**
     * Creates a StockNotification for a product and organization (or current when null), for the current user - will return its ID.
     *
     * @export
     * @class CreateStockNotificationForCurrentUser
     * @implements {EvaService}
     */
    class CreateStockNotificationForCurrentUser {
        name = 'Core:CreateStockNotificationForCurrentUser';
        path = '/message/CreateStockNotificationForCurrentUser';
        request;
        response;
    }
    Core.CreateStockNotificationForCurrentUser = CreateStockNotificationForCurrentUser;
    /**
     * Creates a new Stock Replenishment task.
     *
     * @export
     * @class CreateStockReplenishmentTask
     * @implements {EvaService}
     */
    class CreateStockReplenishmentTask {
        name = 'Core:CreateStockReplenishmentTask';
        path = '/message/CreateStockReplenishmentTask';
        request;
        response;
    }
    Core.CreateStockReplenishmentTask = CreateStockReplenishmentTask;
    /**
     * Creates new Stock Replenishment tasks in bulk, with `DetailedProducts` being an array of products details.
     *
     * @export
     * @class CreateStockReplenishmentTasks
     * @implements {EvaService}
     */
    class CreateStockReplenishmentTasks {
        name = 'Core:CreateStockReplenishmentTasks';
        path = '/message/CreateStockReplenishmentTasks';
        request;
        response;
    }
    Core.CreateStockReplenishmentTasks = CreateStockReplenishmentTasks;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CreateTaxCode
     * @implements {EvaService}
     */
    class CreateTaxCode {
        name = 'Core:CreateTaxCode';
        path = '/message/CreateTaxCode';
        request;
        response;
    }
    Core.CreateTaxCode = CreateTaxCode;
    /**
     * Create a new TaxCodeMapping. Only one mapping per TaxCode & TaxProvider is allowed.
     *
     * @export
     * @class CreateTaxCodeMapping
     * @implements {EvaService}
     */
    class CreateTaxCodeMapping {
        name = 'Core:CreateTaxCodeMapping';
        path = '/message/CreateTaxCodeMapping';
        request;
        response;
    }
    Core.CreateTaxCodeMapping = CreateTaxCodeMapping;
    /**
     * Create a new TaxProvider
     *
     * @export
     * @class CreateTaxProvider
     * @implements {EvaService}
     */
    class CreateTaxProvider {
        name = 'Core:CreateTaxProvider';
        path = '/message/CreateTaxProvider';
        request;
        response;
    }
    Core.CreateTaxProvider = CreateTaxProvider;
    /**
     * Creates a tax rate.

* `CountryID` is a foreign key to the Countries table, which uses the ISO 3166-2 standard as ID
* `CountrySubdivisionID` is a foreign key to the CountrySubdivisions table, which uses the ISO 3166-2 standard as ID
* `TaxCodeID` is a foreign key to the TaxCodes table, which can be listed using the `ListTaxCodes` service

Percentages are a human readable formatted result of a fraction - applications use a `Rate` instead as an actual result of fraction to maintain
precision and integrity. If you wish to set a 21% tax percentage, that means a 1.21 tax rate. Setting a rate of 1.00 implies a 0% tax percentage,
and setting to 2.00 would mean a rediculous 100% tax percentage, doubling prices. You can probably tell that a `Rate` of 2.00 here is much more
readable than a 100% increase, but hey; nobody's forcing you to stick to percentages. At least - we're not!

Oh, and you can set a tax rate of 0.00, which would mean it will be fully sponsored by the government and will be free to purchase. The services
block anything lower than 0.00 and higher than 2.00 for sanity reasons. Will recap when governments gone mad.

:key: The combination of `CountryID`, `CountrySubdivision` and `TaxCodeID` is unique and will be enforced by EVA.

:point_right: `StartDate` and `EndDate` are optional, and can be used to transition from one rate to a next when it changes. Both these dates
are inclusive, meaning you'd want to set the `EndDate` of the expiring tax rate to 2018-12-31 and the `StartDate` of the new tax rate to
2019-01-01 (for example).
     *
     * @export
     * @class CreateTaxRate
     * @implements {EvaService}
     */
    class CreateTaxRate {
        name = 'Core:CreateTaxRate';
        path = '/message/CreateTaxRate';
        request;
        response;
    }
    Core.CreateTaxRate = CreateTaxRate;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CreateUserAssociation
     * @implements {EvaService}
     */
    class CreateUserAssociation {
        name = 'Core:CreateUserAssociation';
        path = '/message/CreateUserAssociation';
        request;
        response;
    }
    Core.CreateUserAssociation = CreateUserAssociation;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CreateUserAssociationType
     * @implements {EvaService}
     */
    class CreateUserAssociationType {
        name = 'Core:CreateUserAssociationType';
        path = '/message/CreateUserAssociationType';
        request;
        response;
    }
    Core.CreateUserAssociationType = CreateUserAssociationType;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CreateUserGroup
     * @implements {EvaService}
     */
    class CreateUserGroup {
        name = 'Core:CreateUserGroup';
        path = '/message/CreateUserGroup';
        request;
        response;
    }
    Core.CreateUserGroup = CreateUserGroup;
    /**
     * Creates a UserInteraction. A UserInteraction logs an interaction between an employee and a customer, for example the fact the customer was called.

UserID is optional but only if OrderID is also provided and the given Order is attached to a customer. If so then the UserInteraction is attached to the Order.Customer.
     *
     * @export
     * @class CreateUserInteraction
     * @implements {EvaService}
     */
    class CreateUserInteraction {
        name = 'Core:CreateUserInteraction';
        path = '/message/CreateUserInteraction';
        request;
        response;
    }
    Core.CreateUserInteraction = CreateUserInteraction;
    /**
     * Creates a UserPhoneNumber for the current user, or the UserID specified if you're allowed to do so.
     *
     * @export
     * @class CreateUserPhoneNumber
     * @implements {EvaService}
     */
    class CreateUserPhoneNumber {
        name = 'Core:CreateUserPhoneNumber';
        path = '/message/CreateUserPhoneNumber';
        request;
        response;
    }
    Core.CreateUserPhoneNumber = CreateUserPhoneNumber;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CreateUserTaskNotCompletedReason
     * @implements {EvaService}
     */
    class CreateUserTaskNotCompletedReason {
        name = 'Core:CreateUserTaskNotCompletedReason';
        path = '/message/CreateUserTaskNotCompletedReason';
        request;
        response;
    }
    Core.CreateUserTaskNotCompletedReason = CreateUserTaskNotCompletedReason;
    /**
     * Creates a new User Task Priority.
     *
     * @export
     * @class CreateUserTaskPriority
     * @implements {EvaService}
     */
    class CreateUserTaskPriority {
        name = 'Core:CreateUserTaskPriority';
        path = '/message/CreateUserTaskPriority';
        request;
        response;
    }
    Core.CreateUserTaskPriority = CreateUserTaskPriority;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CreateUserTaskTypeOrganizationUnitSet
     * @implements {EvaService}
     */
    class CreateUserTaskTypeOrganizationUnitSet {
        name = 'Core:CreateUserTaskTypeOrganizationUnitSet';
        path = '/message/CreateUserTaskTypeOrganizationUnitSet';
        request;
        response;
    }
    Core.CreateUserTaskTypeOrganizationUnitSet = CreateUserTaskTypeOrganizationUnitSet;
    /**
     * Creates a user wishlist.
     *
     * @export
     * @class CreateUserWishlist
     * @implements {EvaService}
     */
    class CreateUserWishlist {
        name = 'Core:CreateUserWishlist';
        path = '/message/CreateUserWishlist';
        request;
        response;
    }
    Core.CreateUserWishlist = CreateUserWishlist;
    /**
     * Creates one cycle count for the requested Product and Organization Unit (with origin Manual)
     *
     * @export
     * @class CreateZonedCycleCount
     * @implements {EvaService}
     */
    class CreateZonedCycleCount {
        name = 'Core:CreateZonedCycleCount';
        path = '/message/CreateZonedCycleCount';
        request;
        response;
    }
    Core.CreateZonedCycleCount = CreateZonedCycleCount;
    /**
     * Creates a Zoned Cycle Count Schedule.

It is required to specify either a set `Date`, or a `CycleCountIntervalInDays`.
     *
     * @export
     * @class CreateZonedCycleCountSchedule
     * @implements {EvaService}
     */
    class CreateZonedCycleCountSchedule {
        name = 'Core:CreateZonedCycleCountSchedule';
        path = '/message/CreateZonedCycleCountSchedule';
        request;
        response;
    }
    Core.CreateZonedCycleCountSchedule = CreateZonedCycleCountSchedule;
    /**
     * Creates cycle counts for all requested combinations of Products and Organization Units (with origin Manual). Use this service through the async service endpoints.
     *
     * @export
     * @class CreateZonedCycleCounts
     * @implements {EvaService}
     */
    class CreateZonedCycleCounts {
        name = 'Core:CreateZonedCycleCounts';
        path = '/message/CreateZonedCycleCounts';
        request;
        response;
    }
    Core.CreateZonedCycleCounts = CreateZonedCycleCounts;
    /**
     * Creates cycle counts for all requested combinations of (type Stock) Products and Organization Units that match specified filters (with origin Manual). Use this service through the async service endpoints.
     *
     * @export
     * @class CreateZonedCycleCountsByQuery
     * @implements {EvaService}
     */
    class CreateZonedCycleCountsByQuery {
        name = 'Core:CreateZonedCycleCountsByQuery';
        path = '/message/CreateZonedCycleCountsByQuery';
        request;
        response;
    }
    Core.CreateZonedCycleCountsByQuery = CreateZonedCycleCountsByQuery;
    /**
     * Creates cycle counts for all requested combinations of (type Stock) Products and Organization Units that match specified filters (with origin Manual). Use this service through the async service endpoints.
     *
     * @export
     * @class CreateZonedCycleCountsByQuery_Async
     * @implements {EvaService}
     */
    class CreateZonedCycleCountsByQuery_Async {
        name = 'Core:CreateZonedCycleCountsByQuery_Async';
        path = '/async-message/CreateZonedCycleCountsByQuery';
        request;
        response;
    }
    Core.CreateZonedCycleCountsByQuery_Async = CreateZonedCycleCountsByQuery_Async;
    /**
     * Creates cycle counts for all requested combinations of (type Stock) Products and Organization Units that match specified filters (with origin Manual). Use this service through the async service endpoints.
     *
     * @export
     * @class CreateZonedCycleCountsByQuery_AsyncResult
     * @implements {EvaService}
     */
    class CreateZonedCycleCountsByQuery_AsyncResult {
        name = 'Core:CreateZonedCycleCountsByQuery_AsyncResult';
        path = '/async-result/CreateZonedCycleCountsByQuery';
        request;
        response;
    }
    Core.CreateZonedCycleCountsByQuery_AsyncResult = CreateZonedCycleCountsByQuery_AsyncResult;
    /**
     * Creates cycle counts for all requested combinations of Products and Organization Units (with origin Manual). Use this service through the async service endpoints.
     *
     * @export
     * @class CreateZonedCycleCounts_Async
     * @implements {EvaService}
     */
    class CreateZonedCycleCounts_Async {
        name = 'Core:CreateZonedCycleCounts_Async';
        path = '/async-message/CreateZonedCycleCounts';
        request;
        response;
    }
    Core.CreateZonedCycleCounts_Async = CreateZonedCycleCounts_Async;
    /**
     * Creates cycle counts for all requested combinations of Products and Organization Units (with origin Manual). Use this service through the async service endpoints.
     *
     * @export
     * @class CreateZonedCycleCounts_AsyncResult
     * @implements {EvaService}
     */
    class CreateZonedCycleCounts_AsyncResult {
        name = 'Core:CreateZonedCycleCounts_AsyncResult';
        path = '/async-result/CreateZonedCycleCounts';
        request;
        response;
    }
    Core.CreateZonedCycleCounts_AsyncResult = CreateZonedCycleCounts_AsyncResult;
    /**
     * Service for customers to add a blob to a case.
     *
     * @export
     * @class CustomerAddBlobToCase
     * @implements {EvaService}
     */
    class CustomerAddBlobToCase {
        name = 'Core:CustomerAddBlobToCase';
        path = '/message/CustomerAddBlobToCase';
        request;
        response;
    }
    Core.CustomerAddBlobToCase = CustomerAddBlobToCase;
    /**
     * Service for customers to add a blob to a case interacion.
     *
     * @export
     * @class CustomerAddBlobToCaseInteraction
     * @implements {EvaService}
     */
    class CustomerAddBlobToCaseInteraction {
        name = 'Core:CustomerAddBlobToCaseInteraction';
        path = '/message/CustomerAddBlobToCaseInteraction';
        request;
        response;
    }
    Core.CustomerAddBlobToCaseInteraction = CustomerAddBlobToCaseInteraction;
    /**
     * Service for customers to create a new case.
     *
     * @export
     * @class CustomerCreateCase
     * @implements {EvaService}
     */
    class CustomerCreateCase {
        name = 'Core:CustomerCreateCase';
        path = '/message/CustomerCreateCase';
        request;
        response;
    }
    Core.CustomerCreateCase = CustomerCreateCase;
    /**
     * Service for customers to create a case
     *
     * @export
     * @class CustomerCreateCaseInteraction
     * @implements {EvaService}
     */
    class CustomerCreateCaseInteraction {
        name = 'Core:CustomerCreateCaseInteraction';
        path = '/message/CustomerCreateCaseInteraction';
        request;
        response;
    }
    Core.CustomerCreateCaseInteraction = CustomerCreateCaseInteraction;
    /**
     * Service for customers to delete a case interaction
     *
     * @export
     * @class CustomerDeleteCaseInteraction
     * @implements {EvaService}
     */
    class CustomerDeleteCaseInteraction {
        name = 'Core:CustomerDeleteCaseInteraction';
        path = '/message/CustomerDeleteCaseInteraction';
        request;
        response;
    }
    Core.CustomerDeleteCaseInteraction = CustomerDeleteCaseInteraction;
    /**
     * Service for customers to get a case by its ID.
     *
     * @export
     * @class CustomerGetCaseByID
     * @implements {EvaService}
     */
    class CustomerGetCaseByID {
        name = 'Core:CustomerGetCaseByID';
        path = '/message/CustomerGetCaseByID';
        request;
        response;
    }
    Core.CustomerGetCaseByID = CustomerGetCaseByID;
    /**
     * Service for customers to get a case interaction by id
     *
     * @export
     * @class CustomerGetCaseInteraction
     * @implements {EvaService}
     */
    class CustomerGetCaseInteraction {
        name = 'Core:CustomerGetCaseInteraction';
        path = '/message/CustomerGetCaseInteraction';
        request;
        response;
    }
    Core.CustomerGetCaseInteraction = CustomerGetCaseInteraction;
    /**
     * Service for customers to list case interactions
     *
     * @export
     * @class CustomerListCaseInteractions
     * @implements {EvaService}
     */
    class CustomerListCaseInteractions {
        name = 'Core:CustomerListCaseInteractions';
        path = '/message/CustomerListCaseInteractions';
        request;
        response;
    }
    Core.CustomerListCaseInteractions = CustomerListCaseInteractions;
    /**
     * Service for customers to list cases. Returns a paged response.
     *
     * @export
     * @class CustomerListCases
     * @implements {EvaService}
     */
    class CustomerListCases {
        name = 'Core:CustomerListCases';
        path = '/message/CustomerListCases';
        request;
        response;
    }
    Core.CustomerListCases = CustomerListCases;
    /**
     * Service for customers to remove a blob from a case.
     *
     * @export
     * @class CustomerRemoveCaseBlob
     * @implements {EvaService}
     */
    class CustomerRemoveCaseBlob {
        name = 'Core:CustomerRemoveCaseBlob';
        path = '/message/CustomerRemoveCaseBlob';
        request;
        response;
    }
    Core.CustomerRemoveCaseBlob = CustomerRemoveCaseBlob;
    /**
     * Service for customers to remove a blob from a case interaction.
     *
     * @export
     * @class CustomerRemoveCaseInteractionBlob
     * @implements {EvaService}
     */
    class CustomerRemoveCaseInteractionBlob {
        name = 'Core:CustomerRemoveCaseInteractionBlob';
        path = '/message/CustomerRemoveCaseInteractionBlob';
        request;
        response;
    }
    Core.CustomerRemoveCaseInteractionBlob = CustomerRemoveCaseInteractionBlob;
    /**
     * Service for customers to update an existing case.
     *
     * @export
     * @class CustomerUpdateCase
     * @implements {EvaService}
     */
    class CustomerUpdateCase {
        name = 'Core:CustomerUpdateCase';
        path = '/message/CustomerUpdateCase';
        request;
        response;
    }
    Core.CustomerUpdateCase = CustomerUpdateCase;
    /**
     * Service for customers to update a case interaction
     *
     * @export
     * @class CustomerUpdateCaseInteraction
     * @implements {EvaService}
     */
    class CustomerUpdateCaseInteraction {
        name = 'Core:CustomerUpdateCaseInteraction';
        path = '/message/CustomerUpdateCaseInteraction';
        request;
        response;
    }
    Core.CustomerUpdateCaseInteraction = CustomerUpdateCaseInteraction;
    /**
     * Deactivates all active user tasks based on organization unit. Not supported on production environments!
     *
     * @export
     * @class DeactivateAllUserTasks
     * @implements {EvaService}
     */
    class DeactivateAllUserTasks {
        name = 'Core:DeactivateAllUserTasks';
        path = '/message/DeactivateAllUserTasks';
        request;
        response;
    }
    Core.DeactivateAllUserTasks = DeactivateAllUserTasks;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DeactivateUserTask
     * @implements {EvaService}
     */
    class DeactivateUserTask {
        name = 'Core:DeactivateUserTask';
        path = '/message/DeactivateUserTask';
        request;
        response;
    }
    Core.DeactivateUserTask = DeactivateUserTask;
    /**
     * Deactivate the given ZonedCycleCounts

Also deactivates linked PreCounts
     *
     * @export
     * @class DeactivateZonedCycleCount
     * @implements {EvaService}
     */
    class DeactivateZonedCycleCount {
        name = 'Core:DeactivateZonedCycleCount';
        path = '/message/DeactivateZonedCycleCount';
        request;
        response;
    }
    Core.DeactivateZonedCycleCount = DeactivateZonedCycleCount;
    /**
     * Delete an Address in the AddressBook of an User

It's not allowed to delete an address when it's the default and there are more than 1 remaining items in the address book
     *
     * @export
     * @class DeleteAddressBookItem
     * @implements {EvaService}
     */
    class DeleteAddressBookItem {
        name = 'Core:DeleteAddressBookItem';
        path = '/message/DeleteAddressBookItem';
        request;
        response;
    }
    Core.DeleteAddressBookItem = DeleteAddressBookItem;
    /**
     * Deletes an existing anonymous token.
     *
     * @export
     * @class DeleteAnonymousToken
     * @implements {EvaService}
     */
    class DeleteAnonymousToken {
        name = 'Core:DeleteAnonymousToken';
        path = '/message/DeleteAnonymousToken';
        request;
        response;
    }
    Core.DeleteAnonymousToken = DeleteAnonymousToken;
    /**
     * Deletes an anonymous wishlist.
     *
     * @export
     * @class DeleteAnonymousWishlist
     * @implements {EvaService}
     */
    class DeleteAnonymousWishlist {
        name = 'Core:DeleteAnonymousWishlist';
        path = '/message/DeleteAnonymousWishlist';
        request;
        response;
    }
    Core.DeleteAnonymousWishlist = DeleteAnonymousWishlist;
    /**
     * Deletes an API key
     *
     * @export
     * @class DeleteApiKey
     * @implements {EvaService}
     */
    class DeleteApiKey {
        name = 'Core:DeleteApiKey';
        path = '/message/DeleteApiKey';
        request;
        response;
    }
    Core.DeleteApiKey = DeleteApiKey;
    /**
     * Delete app rule
     *
     * @export
     * @class DeleteAppRule
     * @implements {EvaService}
     */
    class DeleteAppRule {
        name = 'Core:DeleteAppRule';
        path = '/message/DeleteAppRule';
        request;
        response;
    }
    Core.DeleteAppRule = DeleteAppRule;
    /**
     * Deletes an AuditChainConfiguration
     *
     * @export
     * @class DeleteAuditChainConfiguration
     * @implements {EvaService}
     */
    class DeleteAuditChainConfiguration {
        name = 'Core:DeleteAuditChainConfiguration';
        path = '/message/DeleteAuditChainConfiguration';
        request;
        response;
    }
    Core.DeleteAuditChainConfiguration = DeleteAuditChainConfiguration;
    /**
     * Delete a cash correction reason
     *
     * @export
     * @class DeleteCashCorrectionReason
     * @implements {EvaService}
     */
    class DeleteCashCorrectionReason {
        name = 'Core:DeleteCashCorrectionReason';
        path = '/message/DeleteCashCorrectionReason';
        request;
        response;
    }
    Core.DeleteCashCorrectionReason = DeleteCashCorrectionReason;
    /**
     * Deletes a deposit for the given `ID`.

Cash deposits in status Pending (`-1`) can always be removed, status Done (`0`) ("Dropped-off") requires the cash journal and the financial period to still be open.
     *
     * @export
     * @class DeleteCashDeposit
     * @implements {EvaService}
     */
    class DeleteCashDeposit {
        name = 'Core:DeleteCashDeposit';
        path = '/message/DeleteCashDeposit';
        request;
        response;
    }
    Core.DeleteCashDeposit = DeleteCashDeposit;
    /**
     * Deletes an expense for the given `ID`. This is only possible while the cash journal and the financial period are still open.
     *
     * @export
     * @class DeleteCashExpense
     * @implements {EvaService}
     */
    class DeleteCashExpense {
        name = 'Core:DeleteCashExpense';
        path = '/message/DeleteCashExpense';
        request;
        response;
    }
    Core.DeleteCashExpense = DeleteCashExpense;
    /**
     * Deletes a custom order status
     *
     * @export
     * @class DeleteCustomOrderStatus
     * @implements {EvaService}
     */
    class DeleteCustomOrderStatus {
        name = 'Core:DeleteCustomOrderStatus';
        path = '/message/DeleteCustomOrderStatus';
        request;
        response;
    }
    Core.DeleteCustomOrderStatus = DeleteCustomOrderStatus;
    /**
     * Deletes a specific custom usertask template
     *
     * @export
     * @class DeleteCustomUserTaskTemplate
     * @implements {EvaService}
     */
    class DeleteCustomUserTaskTemplate {
        name = 'Core:DeleteCustomUserTaskTemplate';
        path = '/message/DeleteCustomUserTaskTemplate';
        request;
        response;
    }
    Core.DeleteCustomUserTaskTemplate = DeleteCustomUserTaskTemplate;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DeleteCycleCountZone
     * @implements {EvaService}
     */
    class DeleteCycleCountZone {
        name = 'Core:DeleteCycleCountZone';
        path = '/message/DeleteCycleCountZone';
        request;
        response;
    }
    Core.DeleteCycleCountZone = DeleteCycleCountZone;
    /**
     * Deletes a CycleCountZoneGroup by its ID
     *
     * @export
     * @class DeleteCycleCountZoneGroup
     * @implements {EvaService}
     */
    class DeleteCycleCountZoneGroup {
        name = 'Core:DeleteCycleCountZoneGroup';
        path = '/message/DeleteCycleCountZoneGroup';
        request;
        response;
    }
    Core.DeleteCycleCountZoneGroup = DeleteCycleCountZoneGroup;
    /**
     * Service for deleting an existing `EntityTranslation`
     *
     * @export
     * @class DeleteEntityTranslation
     * @implements {EvaService}
     */
    class DeleteEntityTranslation {
        name = 'Core:DeleteEntityTranslation';
        path = '/message/DeleteEntityTranslation';
        request;
        response;
    }
    Core.DeleteEntityTranslation = DeleteEntityTranslation;
    /**
     * Service for deleting a existing `EventExportConfiguration`
     *
     * @export
     * @class DeleteEventExportConfiguration
     * @implements {EvaService}
     */
    class DeleteEventExportConfiguration {
        name = 'Core:DeleteEventExportConfiguration';
        path = '/message/DeleteEventExportConfiguration';
        request;
        response;
    }
    Core.DeleteEventExportConfiguration = DeleteEventExportConfiguration;
    /**
     * Delete an existing Flight
     *
     * @export
     * @class DeleteFlight
     * @implements {EvaService}
     */
    class DeleteFlight {
        name = 'Core:DeleteFlight';
        path = '/message/DeleteFlight';
        request;
        response;
    }
    Core.DeleteFlight = DeleteFlight;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DeleteInitialCycleCountResult
     * @implements {EvaService}
     */
    class DeleteInitialCycleCountResult {
        name = 'Core:DeleteInitialCycleCountResult';
        path = '/message/DeleteInitialCycleCountResult';
        request;
        response;
    }
    Core.DeleteInitialCycleCountResult = DeleteInitialCycleCountResult;
    /**
     * Deletes the given invoice. Note, can only delete invoices that have not been booked yet.
     *
     * @export
     * @class DeleteInvoice
     * @implements {EvaService}
     */
    class DeleteInvoice {
        name = 'Core:DeleteInvoice';
        path = '/message/DeleteInvoice';
        request;
        response;
    }
    Core.DeleteInvoice = DeleteInvoice;
    /**
     * Delete an InvoiceAdditionalAmount
     *
     * @export
     * @class DeleteInvoiceAdditionalAmount
     * @implements {EvaService}
     */
    class DeleteInvoiceAdditionalAmount {
        name = 'Core:DeleteInvoiceAdditionalAmount';
        path = '/message/DeleteInvoiceAdditionalAmount';
        request;
        response;
    }
    Core.DeleteInvoiceAdditionalAmount = DeleteInvoiceAdditionalAmount;
    /**
     * Delete a InvoiceAdditionalAmountType, this is only allowed if the type is never used
     *
     * @export
     * @class DeleteInvoiceAdditionalAmountType
     * @implements {EvaService}
     */
    class DeleteInvoiceAdditionalAmountType {
        name = 'Core:DeleteInvoiceAdditionalAmountType';
        path = '/message/DeleteInvoiceAdditionalAmountType';
        request;
        response;
    }
    Core.DeleteInvoiceAdditionalAmountType = DeleteInvoiceAdditionalAmountType;
    /**
     * Removes a blob from an invoice, either by `BlobID` or `BlobUrl`.
     *
     * @export
     * @class DeleteInvoiceBlob
     * @implements {EvaService}
     */
    class DeleteInvoiceBlob {
        name = 'Core:DeleteInvoiceBlob';
        path = '/message/DeleteInvoiceBlob';
        request;
        response;
    }
    Core.DeleteInvoiceBlob = DeleteInvoiceBlob;
    /**
     * Deletes an `InvoiceCompanyMapping`.
     *
     * @export
     * @class DeleteInvoiceCompanyMapping
     * @implements {EvaService}
     */
    class DeleteInvoiceCompanyMapping {
        name = 'Core:DeleteInvoiceCompanyMapping';
        path = '/message/DeleteInvoiceCompanyMapping';
        request;
        response;
    }
    Core.DeleteInvoiceCompanyMapping = DeleteInvoiceCompanyMapping;
    /**
     * Delete an InvoiceDispute
     *
     * @export
     * @class DeleteInvoiceDispute
     * @implements {EvaService}
     */
    class DeleteInvoiceDispute {
        name = 'Core:DeleteInvoiceDispute';
        path = '/message/DeleteInvoiceDispute';
        request;
        response;
    }
    Core.DeleteInvoiceDispute = DeleteInvoiceDispute;
    /**
     * Delete a InvoiceDisputeReason, this is only allowed if the reason is never used
     *
     * @export
     * @class DeleteInvoiceDisputeReason
     * @implements {EvaService}
     */
    class DeleteInvoiceDisputeReason {
        name = 'Core:DeleteInvoiceDisputeReason';
        path = '/message/DeleteInvoiceDisputeReason';
        request;
        response;
    }
    Core.DeleteInvoiceDisputeReason = DeleteInvoiceDisputeReason;
    /**
     * Delete an InvoiceDisputeResolveAction
     *
     * @export
     * @class DeleteInvoiceDisputeResolveAction
     * @implements {EvaService}
     */
    class DeleteInvoiceDisputeResolveAction {
        name = 'Core:DeleteInvoiceDisputeResolveAction';
        path = '/message/DeleteInvoiceDisputeResolveAction';
        request;
        response;
    }
    Core.DeleteInvoiceDisputeResolveAction = DeleteInvoiceDisputeResolveAction;
    /**
     * Delete a manual tax exemption reason.
     *
     * @export
     * @class DeleteManualTaxExemptionReason
     * @implements {EvaService}
     */
    class DeleteManualTaxExemptionReason {
        name = 'Core:DeleteManualTaxExemptionReason';
        path = '/message/DeleteManualTaxExemptionReason';
        request;
        response;
    }
    Core.DeleteManualTaxExemptionReason = DeleteManualTaxExemptionReason;
    /**
     * Delete a manual tax exemption reason line.
     *
     * @export
     * @class DeleteManualTaxExemptionReasonLine
     * @implements {EvaService}
     */
    class DeleteManualTaxExemptionReasonLine {
        name = 'Core:DeleteManualTaxExemptionReasonLine';
        path = '/message/DeleteManualTaxExemptionReasonLine';
        request;
        response;
    }
    Core.DeleteManualTaxExemptionReasonLine = DeleteManualTaxExemptionReasonLine;
    /**
     * Delete an OpeningHoursTemplate
     *
     * @export
     * @class DeleteOpeningHoursTemplate
     * @implements {EvaService}
     */
    class DeleteOpeningHoursTemplate {
        name = 'Core:DeleteOpeningHoursTemplate';
        path = '/message/DeleteOpeningHoursTemplate';
        request;
        response;
    }
    Core.DeleteOpeningHoursTemplate = DeleteOpeningHoursTemplate;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DeleteOrderCustomStatus
     * @implements {EvaService}
     */
    class DeleteOrderCustomStatus {
        name = 'Core:DeleteOrderCustomStatus';
        path = '/message/DeleteOrderCustomStatus';
        request;
        response;
    }
    Core.DeleteOrderCustomStatus = DeleteOrderCustomStatus;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DeleteOrderCustomType
     * @implements {EvaService}
     */
    class DeleteOrderCustomType {
        name = 'Core:DeleteOrderCustomType';
        path = '/message/DeleteOrderCustomType';
        request;
        response;
    }
    Core.DeleteOrderCustomType = DeleteOrderCustomType;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DeleteOrderLink
     * @implements {EvaService}
     */
    class DeleteOrderLink {
        name = 'Core:DeleteOrderLink';
        path = '/message/DeleteOrderLink';
        request;
        response;
    }
    Core.DeleteOrderLink = DeleteOrderLink;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DeleteOrderLinkType
     * @implements {EvaService}
     */
    class DeleteOrderLinkType {
        name = 'Core:DeleteOrderLinkType';
        path = '/message/DeleteOrderLinkType';
        request;
        response;
    }
    Core.DeleteOrderLinkType = DeleteOrderLinkType;
    /**
     * Delete an order verification reason
     *
     * @export
     * @class DeleteOrderVerificationReason
     * @implements {EvaService}
     */
    class DeleteOrderVerificationReason {
        name = 'Core:DeleteOrderVerificationReason';
        path = '/message/DeleteOrderVerificationReason';
        request;
        response;
    }
    Core.DeleteOrderVerificationReason = DeleteOrderVerificationReason;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DeleteOrganizationUnit
     * @implements {EvaService}
     */
    class DeleteOrganizationUnit {
        name = 'Core:DeleteOrganizationUnit';
        path = '/message/DeleteOrganizationUnit';
        request;
        response;
    }
    Core.DeleteOrganizationUnit = DeleteOrganizationUnit;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DeleteOrganizationUnitSupplier
     * @implements {EvaService}
     */
    class DeleteOrganizationUnitSupplier {
        name = 'Core:DeleteOrganizationUnitSupplier';
        path = '/message/DeleteOrganizationUnitSupplier';
        request;
        response;
    }
    Core.DeleteOrganizationUnitSupplier = DeleteOrganizationUnitSupplier;
    /**
     * Remove a passkey configuration for the current user.
     *
     * @export
     * @class DeletePasskey
     * @implements {EvaService}
     */
    class DeletePasskey {
        name = 'Core:DeletePasskey';
        path = '/message/DeletePasskey';
        request;
        response;
    }
    Core.DeletePasskey = DeletePasskey;
    /**
     * Remove all passkey configurations for the specified user, as employee management feature.
     *
     * @export
     * @class DeletePasskeyForUser
     * @implements {EvaService}
     */
    class DeletePasskeyForUser {
        name = 'Core:DeletePasskeyForUser';
        path = '/message/DeletePasskeyForUser';
        request;
        response;
    }
    Core.DeletePasskeyForUser = DeletePasskeyForUser;
    /**
     * Deletes a ProductBundle.
     *
     * @export
     * @class DeleteProductBundle
     * @implements {EvaService}
     */
    class DeleteProductBundle {
        name = 'Core:DeleteProductBundle';
        path = '/message/DeleteProductBundle';
        request;
        response;
    }
    Core.DeleteProductBundle = DeleteProductBundle;
    /**
     * Deletes an existing structure of products by `ID`.
     *
     * @export
     * @class DeleteProductStructure
     * @implements {EvaService}
     */
    class DeleteProductStructure {
        name = 'Core:DeleteProductStructure';
        path = '/message/DeleteProductStructure';
        request;
        response;
    }
    Core.DeleteProductStructure = DeleteProductStructure;
    /**
     * Deletes a ProductZone by its ID
     *
     * @export
     * @class DeleteProductZone
     * @implements {EvaService}
     */
    class DeleteProductZone {
        name = 'Core:DeleteProductZone';
        path = '/message/DeleteProductZone';
        request;
        response;
    }
    Core.DeleteProductZone = DeleteProductZone;
    /**
     * Deletes a ProductZoneGroup by its ID
     *
     * @export
     * @class DeleteProductZoneGroup
     * @implements {EvaService}
     */
    class DeleteProductZoneGroup {
        name = 'Core:DeleteProductZoneGroup';
        path = '/message/DeleteProductZoneGroup';
        request;
        response;
    }
    Core.DeleteProductZoneGroup = DeleteProductZoneGroup;
    /**
     * Service for deleting an existing `QuickBuy` by ID
     *
     * @export
     * @class DeleteQuickBuy
     * @implements {EvaService}
     */
    class DeleteQuickBuy {
        name = 'Core:DeleteQuickBuy';
        path = '/message/DeleteQuickBuy';
        request;
        response;
    }
    Core.DeleteQuickBuy = DeleteQuickBuy;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DeleteRecurringTask
     * @implements {EvaService}
     */
    class DeleteRecurringTask {
        name = 'Core:DeleteRecurringTask';
        path = '/message/DeleteRecurringTask';
        request;
        response;
    }
    Core.DeleteRecurringTask = DeleteRecurringTask;
    /**
     * Delete a ReturnToSupplierRequest

This is only allowed for Request in the state New or Error
     *
     * @export
     * @class DeleteReturnToSupplierRequest
     * @implements {EvaService}
     */
    class DeleteReturnToSupplierRequest {
        name = 'Core:DeleteReturnToSupplierRequest';
        path = '/message/DeleteReturnToSupplierRequest';
        request;
        response;
    }
    Core.DeleteReturnToSupplierRequest = DeleteReturnToSupplierRequest;
    /**
     * Deletes a script
     *
     * @export
     * @class DeleteScript
     * @implements {EvaService}
     */
    class DeleteScript {
        name = 'Core:DeleteScript';
        path = '/message/DeleteScript';
        request;
        response;
    }
    Core.DeleteScript = DeleteScript;
    /**
     * Deletes an existing Serial Number Configuration by it's `ID` if this is not linked to any existing Serial Number Product.
     *
     * @export
     * @class DeleteSerialNumberConfiguration
     * @implements {EvaService}
     */
    class DeleteSerialNumberConfiguration {
        name = 'Core:DeleteSerialNumberConfiguration';
        path = '/message/DeleteSerialNumberConfiguration';
        request;
        response;
    }
    Core.DeleteSerialNumberConfiguration = DeleteSerialNumberConfiguration;
    /**
     * Removes a product association with a Serial Number Configuration.
     *
     * @export
     * @class DeleteSerialNumberProduct
     * @implements {EvaService}
     */
    class DeleteSerialNumberProduct {
        name = 'Core:DeleteSerialNumberProduct';
        path = '/message/DeleteSerialNumberProduct';
        request;
        response;
    }
    Core.DeleteSerialNumberProduct = DeleteSerialNumberProduct;
    /**
     * Delete an existing shipment that has status Pending.

Works only for SalesOrders at this moment.
     *
     * @export
     * @class DeleteShipment
     * @implements {EvaService}
     */
    class DeleteShipment {
        name = 'Core:DeleteShipment';
        path = '/message/DeleteShipment';
        request;
        response;
    }
    Core.DeleteShipment = DeleteShipment;
    /**
     * Delete an existing shipment identifier.
     *
     * @export
     * @class DeleteShipmentIdentifier
     * @implements {EvaService}
     */
    class DeleteShipmentIdentifier {
        name = 'Core:DeleteShipmentIdentifier';
        path = '/message/DeleteShipmentIdentifier';
        request;
        response;
    }
    Core.DeleteShipmentIdentifier = DeleteShipmentIdentifier;
    /**
     * Deletes a StockNotification by ID. When it was created with an EmailAddress, repeat that in this request by means of authentication.
     *
     * @export
     * @class DeleteStockNotification
     * @implements {EvaService}
     */
    class DeleteStockNotification {
        name = 'Core:DeleteStockNotification';
        path = '/message/DeleteStockNotification';
        request;
        response;
    }
    Core.DeleteStockNotification = DeleteStockNotification;
    /**
     * Service for deleting an existing `StringTranslation`
     *
     * @export
     * @class DeleteStringTranslation
     * @implements {EvaService}
     */
    class DeleteStringTranslation {
        name = 'Core:DeleteStringTranslation';
        path = '/message/DeleteStringTranslation';
        request;
        response;
    }
    Core.DeleteStringTranslation = DeleteStringTranslation;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DeleteTaxCode
     * @implements {EvaService}
     */
    class DeleteTaxCode {
        name = 'Core:DeleteTaxCode';
        path = '/message/DeleteTaxCode';
        request;
        response;
    }
    Core.DeleteTaxCode = DeleteTaxCode;
    /**
     * Delete a tax mapping.
     *
     * @export
     * @class DeleteTaxCodeMapping
     * @implements {EvaService}
     */
    class DeleteTaxCodeMapping {
        name = 'Core:DeleteTaxCodeMapping';
        path = '/message/DeleteTaxCodeMapping';
        request;
        response;
    }
    Core.DeleteTaxCodeMapping = DeleteTaxCodeMapping;
    /**
     * Delete a TaxProvider
     *
     * @export
     * @class DeleteTaxProvider
     * @implements {EvaService}
     */
    class DeleteTaxProvider {
        name = 'Core:DeleteTaxProvider';
        path = '/message/DeleteTaxProvider';
        request;
        response;
    }
    Core.DeleteTaxProvider = DeleteTaxProvider;
    /**
     * Deletes a tax rate.
     *
     * @export
     * @class DeleteTaxRate
     * @implements {EvaService}
     */
    class DeleteTaxRate {
        name = 'Core:DeleteTaxRate';
        path = '/message/DeleteTaxRate';
        request;
        response;
    }
    Core.DeleteTaxRate = DeleteTaxRate;
    /**
     * Delete a User by it's ID.
     *
     * @export
     * @class DeleteUser
     * @implements {EvaService}
     */
    class DeleteUser {
        name = 'Core:DeleteUser';
        path = '/message/DeleteUser';
        request;
        response;
    }
    Core.DeleteUser = DeleteUser;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DeleteUserAssociation
     * @implements {EvaService}
     */
    class DeleteUserAssociation {
        name = 'Core:DeleteUserAssociation';
        path = '/message/DeleteUserAssociation';
        request;
        response;
    }
    Core.DeleteUserAssociation = DeleteUserAssociation;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DeleteUserAssociationType
     * @implements {EvaService}
     */
    class DeleteUserAssociationType {
        name = 'Core:DeleteUserAssociationType';
        path = '/message/DeleteUserAssociationType';
        request;
        response;
    }
    Core.DeleteUserAssociationType = DeleteUserAssociationType;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DeleteUserGroup
     * @implements {EvaService}
     */
    class DeleteUserGroup {
        name = 'Core:DeleteUserGroup';
        path = '/message/DeleteUserGroup';
        request;
        response;
    }
    Core.DeleteUserGroup = DeleteUserGroup;
    /**
     * Deletes a UserInteraction.
     *
     * @export
     * @class DeleteUserInteraction
     * @implements {EvaService}
     */
    class DeleteUserInteraction {
        name = 'Core:DeleteUserInteraction';
        path = '/message/DeleteUserInteraction';
        request;
        response;
    }
    Core.DeleteUserInteraction = DeleteUserInteraction;
    /**
     * Delete a user's phone number based on the provided ID. If you're trying to delete a user's primary phone number and that user has
more than two phone numbers currently, this service will return a `CannotDeletePrimaryPhoneNumber` error,
because it cannot determine what number should now become the user's primary phone number. If the user has two numbers, the other number
will become the primary.

This service only allows the number's own user or an employee to delete it.
     *
     * @export
     * @class DeleteUserPhoneNumber
     * @implements {EvaService}
     */
    class DeleteUserPhoneNumber {
        name = 'Core:DeleteUserPhoneNumber';
        path = '/message/DeleteUserPhoneNumber';
        request;
        response;
    }
    Core.DeleteUserPhoneNumber = DeleteUserPhoneNumber;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DeleteUserTaskNotCompletedReason
     * @implements {EvaService}
     */
    class DeleteUserTaskNotCompletedReason {
        name = 'Core:DeleteUserTaskNotCompletedReason';
        path = '/message/DeleteUserTaskNotCompletedReason';
        request;
        response;
    }
    Core.DeleteUserTaskNotCompletedReason = DeleteUserTaskNotCompletedReason;
    /**
     * Deletes a User Task Priority.
     *
     * @export
     * @class DeleteUserTaskPriority
     * @implements {EvaService}
     */
    class DeleteUserTaskPriority {
        name = 'Core:DeleteUserTaskPriority';
        path = '/message/DeleteUserTaskPriority';
        request;
        response;
    }
    Core.DeleteUserTaskPriority = DeleteUserTaskPriority;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DeleteUserTaskTypeOrganizationUnitSet
     * @implements {EvaService}
     */
    class DeleteUserTaskTypeOrganizationUnitSet {
        name = 'Core:DeleteUserTaskTypeOrganizationUnitSet';
        path = '/message/DeleteUserTaskTypeOrganizationUnitSet';
        request;
        response;
    }
    Core.DeleteUserTaskTypeOrganizationUnitSet = DeleteUserTaskTypeOrganizationUnitSet;
    /**
     * Deletes the user wishlist.
     *
     * @export
     * @class DeleteUserWishlist
     * @implements {EvaService}
     */
    class DeleteUserWishlist {
        name = 'Core:DeleteUserWishlist';
        path = '/message/DeleteUserWishlist';
        request;
        response;
    }
    Core.DeleteUserWishlist = DeleteUserWishlist;
    /**
     * Delete multiple users by ID's.
This service is async only and only accepts 1000 ID's per request
     *
     * @export
     * @class DeleteUsers
     * @implements {EvaService}
     */
    class DeleteUsers {
        name = 'Core:DeleteUsers';
        path = '/message/DeleteUsers';
        request;
        response;
    }
    Core.DeleteUsers = DeleteUsers;
    /**
     * Delete multiple users by ID's.
This service is async only and only accepts 1000 ID's per request
     *
     * @export
     * @class DeleteUsers_Async
     * @implements {EvaService}
     */
    class DeleteUsers_Async {
        name = 'Core:DeleteUsers_Async';
        path = '/async-message/DeleteUsers';
        request;
        response;
    }
    Core.DeleteUsers_Async = DeleteUsers_Async;
    /**
     * Delete multiple users by ID's.
This service is async only and only accepts 1000 ID's per request
     *
     * @export
     * @class DeleteUsers_AsyncResult
     * @implements {EvaService}
     */
    class DeleteUsers_AsyncResult {
        name = 'Core:DeleteUsers_AsyncResult';
        path = '/async-result/DeleteUsers';
        request;
        response;
    }
    Core.DeleteUsers_AsyncResult = DeleteUsers_AsyncResult;
    /**
     * Deletes a Zoned Cycle Count Schedule.
     *
     * @export
     * @class DeleteZonedCycleCountSchedule
     * @implements {EvaService}
     */
    class DeleteZonedCycleCountSchedule {
        name = 'Core:DeleteZonedCycleCountSchedule';
        path = '/message/DeleteZonedCycleCountSchedule';
        request;
        response;
    }
    Core.DeleteZonedCycleCountSchedule = DeleteZonedCycleCountSchedule;
    /**
     * Delivers an undelivered SalesOrder shipment. This will give both the shipment and the orderline the status that they have been delivered.
     *
     * @export
     * @class DeliverShipment
     * @implements {EvaService}
     */
    class DeliverShipment {
        name = 'Core:DeliverShipment';
        path = '/message/DeliverShipment';
        request;
        response;
    }
    Core.DeliverShipment = DeliverShipment;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DetachCompanyFromUser
     * @implements {EvaService}
     */
    class DetachCompanyFromUser {
        name = 'Core:DetachCompanyFromUser';
        path = '/message/DetachCompanyFromUser';
        request;
        response;
    }
    Core.DetachCompanyFromUser = DetachCompanyFromUser;
    /**
     * Detaches the consumer company from an order.
     *
     * @export
     * @class DetachConsumerCompanyFromOrder
     * @implements {EvaService}
     */
    class DetachConsumerCompanyFromOrder {
        name = 'Core:DetachConsumerCompanyFromOrder';
        path = '/message/DetachConsumerCompanyFromOrder';
        request;
        response;
    }
    Core.DetachConsumerCompanyFromOrder = DetachConsumerCompanyFromOrder;
    /**
     * Detach a Customer from an Order. The addresses on the Order will also be cleared.
     *
     * @export
     * @class DetachCustomerFromOrder
     * @implements {EvaService}
     */
    class DetachCustomerFromOrder {
        name = 'Core:DetachCustomerFromOrder';
        path = '/message/DetachCustomerFromOrder';
        request;
        response;
    }
    Core.DetachCustomerFromOrder = DetachCustomerFromOrder;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DetachFromRepairUserTask
     * @implements {EvaService}
     */
    class DetachFromRepairUserTask {
        name = 'Core:DetachFromRepairUserTask';
        path = '/message/DetachFromRepairUserTask';
        request;
        response;
    }
    Core.DetachFromRepairUserTask = DetachFromRepairUserTask;
    /**
     * Detach an identification document from an order. This will wipe the document and data.
     *
     * @export
     * @class DetachIdentificationFromOrder
     * @implements {EvaService}
     */
    class DetachIdentificationFromOrder {
        name = 'Core:DetachIdentificationFromOrder';
        path = '/message/DetachIdentificationFromOrder';
        request;
        response;
    }
    Core.DetachIdentificationFromOrder = DetachIdentificationFromOrder;
    /**
     * Attaches an OpeningHoursTemplate to the given OrganizationUnitSets.
     *
     * @export
     * @class DetachOpeningHoursTemplateToOrganizationUnitSets
     * @implements {EvaService}
     */
    class DetachOpeningHoursTemplateToOrganizationUnitSets {
        name = 'Core:DetachOpeningHoursTemplateToOrganizationUnitSets';
        path = '/message/DetachOpeningHoursTemplateToOrganizationUnitSets';
        request;
        response;
    }
    Core.DetachOpeningHoursTemplateToOrganizationUnitSets = DetachOpeningHoursTemplateToOrganizationUnitSets;
    /**
     * Detach the given Order from the attached customer and a session. A ReminderToken will be returned to be able to use the Order later with the `RecoverShoppingCartService`.

This service can be used to transfer an Order to a different User:
- DetachOrder
- Logout
- Login
- RecoverShoppingCart
     *
     * @export
     * @class DetachOrder
     * @implements {EvaService}
     */
    class DetachOrder {
        name = 'Core:DetachOrder';
        path = '/message/DetachOrder';
        request;
        response;
    }
    Core.DetachOrder = DetachOrder;
    /**
     * Detaches an user from a consumer company.
     *
     * @export
     * @class DetachUserFromConsumerCompany
     * @implements {EvaService}
     */
    class DetachUserFromConsumerCompany {
        name = 'Core:DetachUserFromConsumerCompany';
        path = '/message/DetachUserFromConsumerCompany';
        request;
        response;
    }
    Core.DetachUserFromConsumerCompany = DetachUserFromConsumerCompany;
    /**
     * Disables all two-factor authenticator for the given user
     *
     * @export
     * @class DisableAllTwoFactorAuthentication
     * @implements {EvaService}
     */
    class DisableAllTwoFactorAuthentication {
        name = 'Core:DisableAllTwoFactorAuthentication';
        path = '/message/DisableAllTwoFactorAuthentication';
        request;
        response;
    }
    Core.DisableAllTwoFactorAuthentication = DisableAllTwoFactorAuthentication;
    /**
     * Disable a specific Discount for an Order, if the discount is active it will be removed from the Order, if it not active, it will not be applied anymore.
     *
     * @export
     * @class DisableDiscountOnOrder
     * @implements {EvaService}
     */
    class DisableDiscountOnOrder {
        name = 'Core:DisableDiscountOnOrder';
        path = '/message/DisableDiscountOnOrder';
        request;
        response;
    }
    Core.DisableDiscountOnOrder = DisableDiscountOnOrder;
    /**
     * Disable all discounts of the given trigger(s) on the order.
     *
     * @export
     * @class DisableDiscountTriggersOnOrder
     * @implements {EvaService}
     */
    class DisableDiscountTriggersOnOrder {
        name = 'Core:DisableDiscountTriggersOnOrder';
        path = '/message/DisableDiscountTriggersOnOrder';
        request;
        response;
    }
    Core.DisableDiscountTriggersOnOrder = DisableDiscountTriggersOnOrder;
    /**
     * Disable a given two-factor authenticator for the current user
     *
     * @export
     * @class DisableTwoFactorAuthentication
     * @implements {EvaService}
     */
    class DisableTwoFactorAuthentication {
        name = 'Core:DisableTwoFactorAuthentication';
        path = '/message/DisableTwoFactorAuthentication';
        request;
        response;
    }
    Core.DisableTwoFactorAuthentication = DisableTwoFactorAuthentication;
    /**
     * Indicate that this was the current order, but has been dismissed.

This is purely a ledger and does not affect the order in any other way.
     *
     * @export
     * @class DismissOrder
     * @implements {EvaService}
     */
    class DismissOrder {
        name = 'Core:DismissOrder';
        path = '/message/DismissOrder';
        request;
        response;
    }
    Core.DismissOrder = DismissOrder;
    /**
     * Download an Excel sample which can be filled with cycle count info. The populated excel can be uploaded through the `UploadCycleCountExcel` service.
     *
     * @export
     * @class DownloadCycleCountSample
     * @implements {EvaService}
     */
    class DownloadCycleCountSample {
        name = 'Core:DownloadCycleCountSample';
        path = '/message/DownloadCycleCountSample';
        request;
        response;
    }
    Core.DownloadCycleCountSample = DownloadCycleCountSample;
    /**
     * Download the GiftCard data for a specific order, based on given `OrderID` and `GiftCardID`. This order needs to be visible for the current user. Requires
the order to be shipped (automatically when it is fully paid).

Additionally, this service can be called with an `AccessToken` and `GiftCardID` combination. In this case, no user validation is done - you know both
keys to the GiftCard, so you are allowed to get it's information.

If you want, you can specify a `LanguageID` to use for rendering the report - when omitted, the `LanguageID` of the current user.

See `GetDigitalGiftCardsForOrder` service for more details.
     *
     * @export
     * @class DownloadDigitalGiftCard
     * @implements {EvaService}
     */
    class DownloadDigitalGiftCard {
        name = 'Core:DownloadDigitalGiftCard';
        path = '/message/DownloadDigitalGiftCard';
        request;
        response;
    }
    Core.DownloadDigitalGiftCard = DownloadDigitalGiftCard;
    /**
     * Download a template format for the full stock count result to upload.
     *
     * @export
     * @class DownloadExternalFullStockCountResultTemplate
     * @implements {EvaService}
     */
    class DownloadExternalFullStockCountResultTemplate {
        name = 'Core:DownloadExternalFullStockCountResultTemplate';
        path = '/message/DownloadExternalFullStockCountResultTemplate';
        request;
        response;
    }
    Core.DownloadExternalFullStockCountResultTemplate = DownloadExternalFullStockCountResultTemplate;
    /**
     * Downloads all generated audit files from the selected period as a single zip file, with a separate folder for each organization unit.

When selecting a container organization unit, all underlying organization units will be included.
     *
     * @export
     * @class DownloadFinancialPeriodAudits
     * @implements {EvaService}
     */
    class DownloadFinancialPeriodAudits {
        name = 'Core:DownloadFinancialPeriodAudits';
        path = '/message/DownloadFinancialPeriodAudits';
        request;
        response;
    }
    Core.DownloadFinancialPeriodAudits = DownloadFinancialPeriodAudits;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DownloadFinancialPeriodDeposit
     * @implements {EvaService}
     */
    class DownloadFinancialPeriodDeposit {
        name = 'Core:DownloadFinancialPeriodDeposit';
        path = '/message/DownloadFinancialPeriodDeposit';
        request;
        response;
    }
    Core.DownloadFinancialPeriodDeposit = DownloadFinancialPeriodDeposit;
    /**
     * Download a template format for the flights file to upload.
     *
     * @export
     * @class DownloadFlightsFileTemplate
     * @implements {EvaService}
     */
    class DownloadFlightsFileTemplate {
        name = 'Core:DownloadFlightsFileTemplate';
        path = '/message/DownloadFlightsFileTemplate';
        request;
        response;
    }
    Core.DownloadFlightsFileTemplate = DownloadFlightsFileTemplate;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DownloadFullStockCountLabelUploadTemplate
     * @implements {EvaService}
     */
    class DownloadFullStockCountLabelUploadTemplate {
        name = 'Core:DownloadFullStockCountLabelUploadTemplate';
        path = '/message/DownloadFullStockCountLabelUploadTemplate';
        request;
        response;
    }
    Core.DownloadFullStockCountLabelUploadTemplate = DownloadFullStockCountLabelUploadTemplate;
    /**
     * Exports the summary of specified Full Stock Count to Excel.
     *
     * @export
     * @class DownloadFullStockCountSummaryExcel
     * @implements {EvaService}
     */
    class DownloadFullStockCountSummaryExcel {
        name = 'Core:DownloadFullStockCountSummaryExcel';
        path = '/message/DownloadFullStockCountSummaryExcel';
        request;
        response;
    }
    Core.DownloadFullStockCountSummaryExcel = DownloadFullStockCountSummaryExcel;
    /**
     * Exports the summary of specified Full Stock Count to Excel.
     *
     * @export
     * @class DownloadFullStockCountSummaryExcel_Async
     * @implements {EvaService}
     */
    class DownloadFullStockCountSummaryExcel_Async {
        name = 'Core:DownloadFullStockCountSummaryExcel_Async';
        path = '/async-message/DownloadFullStockCountSummaryExcel';
        request;
        response;
    }
    Core.DownloadFullStockCountSummaryExcel_Async = DownloadFullStockCountSummaryExcel_Async;
    /**
     * Exports the summary of specified Full Stock Count to Excel.
     *
     * @export
     * @class DownloadFullStockCountSummaryExcel_AsyncResult
     * @implements {EvaService}
     */
    class DownloadFullStockCountSummaryExcel_AsyncResult {
        name = 'Core:DownloadFullStockCountSummaryExcel_AsyncResult';
        path = '/async-result/DownloadFullStockCountSummaryExcel';
        request;
        response;
    }
    Core.DownloadFullStockCountSummaryExcel_AsyncResult = DownloadFullStockCountSummaryExcel_AsyncResult;
    /**
     * Exports the summary of specified Full Stock Count to PDF.
     *
     * @export
     * @class DownloadFullStockCountSummaryPDF
     * @implements {EvaService}
     */
    class DownloadFullStockCountSummaryPDF {
        name = 'Core:DownloadFullStockCountSummaryPDF';
        path = '/message/DownloadFullStockCountSummaryPDF';
        request;
        response;
    }
    Core.DownloadFullStockCountSummaryPDF = DownloadFullStockCountSummaryPDF;
    /**
     * This service is used only for downloading invoices.
     *
     * @export
     * @class DownloadInvoice
     * @implements {EvaService}
     */
    class DownloadInvoice {
        name = 'Core:DownloadInvoice';
        path = '/message/DownloadInvoice';
        request;
        response;
    }
    Core.DownloadInvoice = DownloadInvoice;
    /**
     * This service is used only for downloading offers.
     *
     * @export
     * @class DownloadOffer
     * @implements {EvaService}
     */
    class DownloadOffer {
        name = 'Core:DownloadOffer';
        path = '/message/DownloadOffer';
        request;
        response;
    }
    Core.DownloadOffer = DownloadOffer;
    /**
     * This service is used only for printing paper invoices.
     *
     * @export
     * @class DownloadOrderConfirmation
     * @implements {EvaService}
     */
    class DownloadOrderConfirmation {
        name = 'Core:DownloadOrderConfirmation';
        path = '/message/DownloadOrderConfirmation';
        request;
        response;
    }
    Core.DownloadOrderConfirmation = DownloadOrderConfirmation;
    /**
     * Download a sample Excel file which can be filled with special opening hours. The populated Excel file can be uploaded through the `ImportSpecialOpeningHours` service.
     *
     * @export
     * @class DownloadSpecialOpeningHoursExcelTemplate
     * @implements {EvaService}
     */
    class DownloadSpecialOpeningHoursExcelTemplate {
        name = 'Core:DownloadSpecialOpeningHoursExcelTemplate';
        path = '/message/DownloadSpecialOpeningHoursExcelTemplate';
        request;
        response;
    }
    Core.DownloadSpecialOpeningHoursExcelTemplate = DownloadSpecialOpeningHoursExcelTemplate;
    /**
     * Download a template format for the stock file to upload.
     *
     * @export
     * @class DownloadStockExcelFileTemplate
     * @implements {EvaService}
     */
    class DownloadStockExcelFileTemplate {
        name = 'Core:DownloadStockExcelFileTemplate';
        path = '/message/DownloadStockExcelFileTemplate';
        request;
        response;
    }
    Core.DownloadStockExcelFileTemplate = DownloadStockExcelFileTemplate;
    /**
     * Prepare an attachment of an UserInteraction to be downloaded, will return an url that is valid for 5min.
     *
     * @export
     * @class DownloadUserInteractionCommunicationAttachment
     * @implements {EvaService}
     */
    class DownloadUserInteractionCommunicationAttachment {
        name = 'Core:DownloadUserInteractionCommunicationAttachment';
        path = '/message/DownloadUserInteractionCommunicationAttachment';
        request;
        response;
    }
    Core.DownloadUserInteractionCommunicationAttachment = DownloadUserInteractionCommunicationAttachment;
    /**
     * Drops-off a cash deposit previously created and stored on a device (`CreateCashDeposit.DelayDropOff`).

Cash deposits created this way will remain in status Pending (`-1`) until it is either dropped-off (`DropOffCashDeposit`) or deleted (`DeleteCashDeposit`). Whilst
pending, it will not create any events, will not be attached to any `CashTransactionLedger` and therefor will not be attached to any `FinancialPeriod`. You can find
these pending cash deposits using `ListCashDeposits`, but then only when filtering for a `DeviceID` and/or `OrganizationUnitID` (and optionally `StatusID`).
     *
     * @export
     * @class DropOffCashDeposit
     * @implements {EvaService}
     */
    class DropOffCashDeposit {
        name = 'Core:DropOffCashDeposit';
        path = '/message/DropOffCashDeposit';
        request;
        response;
    }
    Core.DropOffCashDeposit = DropOffCashDeposit;
    /**
     * Make a new `Order` based on an existing one.

* Optionally you can provide some OrderLineIDs to duplicate only a subset of the order.
* When an `OrganizationUnitID` is set, the Order will be created Originating and SoldFrom the specified OrganizationUnit
* To include the orignal GiftWrapping the flag `IncludeGiftWrapping` should be set to true. When combining this with a subset of lines, this can generate an error when some wrapped lines are not duplicated.
* To ignore shipping costs, set `IgnoreShippingCosts` to true (defaults to false)
     *
     * @export
     * @class DuplicateOrder
     * @implements {EvaService}
     */
    class DuplicateOrder {
        name = 'Core:DuplicateOrder';
        path = '/message/DuplicateOrder';
        request;
        response;
    }
    Core.DuplicateOrder = DuplicateOrder;
    /**
     * Edits an existing structure of products by `ID`.
     *
     * @export
     * @class EditProductStructure
     * @implements {EvaService}
     */
    class EditProductStructure {
        name = 'Core:EditProductStructure';
        path = '/message/EditProductStructure';
        request;
        response;
    }
    Core.EditProductStructure = EditProductStructure;
    /**
     * This service is used only for emailing invoices.
     *
     * @export
     * @class EmailInvoice
     * @implements {EvaService}
     */
    class EmailInvoice {
        name = 'Core:EmailInvoice';
        path = '/message/EmailInvoice';
        request;
        response;
    }
    Core.EmailInvoice = EmailInvoice;
    /**
     * This service is used for emailing all invoices linked to an order ID.
     *
     * @export
     * @class EmailInvoices
     * @implements {EvaService}
     */
    class EmailInvoices {
        name = 'Core:EmailInvoices';
        path = '/message/EmailInvoices';
        request;
        response;
    }
    Core.EmailInvoices = EmailInvoices;
    /**
     * This service is used only for emailing offers.
     *
     * @export
     * @class EmailOffer
     * @implements {EvaService}
     */
    class EmailOffer {
        name = 'Core:EmailOffer';
        path = '/message/EmailOffer';
        request;
        response;
    }
    Core.EmailOffer = EmailOffer;
    /**
     * This service is used only for printing paper invoices.
     *
     * @export
     * @class EmailOrderConfirmation
     * @implements {EvaService}
     */
    class EmailOrderConfirmation {
        name = 'Core:EmailOrderConfirmation';
        path = '/message/EmailOrderConfirmation';
        request;
        response;
    }
    Core.EmailOrderConfirmation = EmailOrderConfirmation;
    /**
     * This service is used to retrieve the TaxFreeForms associated with an order & send them to the specified email address.
     *
     * @export
     * @class EmailOrderTaxFreeForm
     * @implements {EvaService}
     */
    class EmailOrderTaxFreeForm {
        name = 'Core:EmailOrderTaxFreeForm';
        path = '/message/EmailOrderTaxFreeForm';
        request;
        response;
    }
    Core.EmailOrderTaxFreeForm = EmailOrderTaxFreeForm;
    /**
     * This service is used only for emailing thermal invoices
     *
     * @export
     * @class EmailThermalInvoice
     * @implements {EvaService}
     */
    class EmailThermalInvoice {
        name = 'Core:EmailThermalInvoice';
        path = '/message/EmailThermalInvoice';
        request;
        response;
    }
    Core.EmailThermalInvoice = EmailThermalInvoice;
    /**
     * This service is used only for emailing thermal invoices based on an order ID.
     *
     * @export
     * @class EmailThermalInvoices
     * @implements {EvaService}
     */
    class EmailThermalInvoices {
        name = 'Core:EmailThermalInvoices';
        path = '/message/EmailThermalInvoices';
        request;
        response;
    }
    Core.EmailThermalInvoices = EmailThermalInvoices;
    /**
     * Empty the full amount of a giftcard into an empty order.
     *
     * @export
     * @class EmptyGiftCard
     * @implements {EvaService}
     */
    class EmptyGiftCard {
        name = 'Core:EmptyGiftCard';
        path = '/message/EmptyGiftCard';
        request;
        response;
    }
    Core.EmptyGiftCard = EmptyGiftCard;
    /**
     * Enable a previous disabled Discount for an Order. If the Discount wasn't disabled, no error will be given.
     *
     * @export
     * @class EnableDisabledDiscountOnOrder
     * @implements {EvaService}
     */
    class EnableDisabledDiscountOnOrder {
        name = 'Core:EnableDisabledDiscountOnOrder';
        path = '/message/EnableDisabledDiscountOnOrder';
        request;
        response;
    }
    Core.EnableDisabledDiscountOnOrder = EnableDisabledDiscountOnOrder;
    /**
     * Enable previously disabled discounts of the given trigger(s) on the order
     *
     * @export
     * @class EnableDiscountTriggersOnOrder
     * @implements {EvaService}
     */
    class EnableDiscountTriggersOnOrder {
        name = 'Core:EnableDiscountTriggersOnOrder';
        path = '/message/EnableDiscountTriggersOnOrder';
        request;
        response;
    }
    Core.EnableDiscountTriggersOnOrder = EnableDiscountTriggersOnOrder;
    /**
     * Enable a given two-factor authenticator for the current user
     *
     * @export
     * @class EnableTwoFactorAuthentication
     * @implements {EvaService}
     */
    class EnableTwoFactorAuthentication {
        name = 'Core:EnableTwoFactorAuthentication';
        path = '/message/EnableTwoFactorAuthentication';
        request;
        response;
    }
    Core.EnableTwoFactorAuthentication = EnableTwoFactorAuthentication;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class EnqueueTask
     * @implements {EvaService}
     */
    class EnqueueTask {
        name = 'Core:EnqueueTask';
        path = '/message/EnqueueTask';
        request;
        response;
    }
    Core.EnqueueTask = EnqueueTask;
    /**
     * Executes the given barcode with an available handler that can execute it. To know if a barcode is executable, run ParseBarcode and look for the IsExecutable in the response.
     *
     * @export
     * @class ExecuteBarcode
     * @implements {EvaService}
     */
    class ExecuteBarcode {
        name = 'Core:ExecuteBarcode';
        path = '/message/ExecuteBarcode';
        request;
        response;
    }
    Core.ExecuteBarcode = ExecuteBarcode;
    /**
     * Marks the provided Order or OrderLine as exempt from tax, with specified code and reason.

When exempting the Order, this also marks all current OrderLines of the Order that haven't been invoiced yet as tax-exempt. All future
OrderLines created on this Order will then also automatically be made tax-exempt.

Calling this service is irreversible; once the Order is marked as tax exempt, it cannot be undone and can only be worked around by creating a new Order.
     *
     * @export
     * @class ExemptOrderFromTax
     * @implements {EvaService}
     */
    class ExemptOrderFromTax {
        name = 'Core:ExemptOrderFromTax';
        path = '/message/ExemptOrderFromTax';
        request;
        response;
    }
    Core.ExemptOrderFromTax = ExemptOrderFromTax;
    /**
     * Returns a tree representation of how the price was derived for the given ProductIDs in the given PriceListID. NOTICE THAT you can provide a maximum of 100 products to explain.
     *
     * @export
     * @class ExplainProductPrices
     * @implements {EvaService}
     */
    class ExplainProductPrices {
        name = 'Core:ExplainProductPrices';
        path = '/message/ExplainProductPrices';
        request;
        response;
    }
    Core.ExplainProductPrices = ExplainProductPrices;
    /**
     * Attempts to explain the given script in plain English.
     *
     * @export
     * @class ExplainScript
     * @implements {EvaService}
     */
    class ExplainScript {
        name = 'Core:ExplainScript';
        path = '/message/ExplainScript';
        request;
        response;
    }
    Core.ExplainScript = ExplainScript;
    /**
     * Fetches the user by its BackendID from the configured external provider. This service is usually used in combination with a call to SearchUsers. This service will create a user in EVA based on the details returned by the external provider if we don't already have a user with the same BackendID. Passing in the OrderID will attach the (created) user to the given order directly as well.
     *
     * @export
     * @class FetchUserFromExternalProvider
     * @implements {EvaService}
     */
    class FetchUserFromExternalProvider {
        name = 'Core:FetchUserFromExternalProvider';
        path = '/message/FetchUserFromExternalProvider';
        request;
        response;
    }
    Core.FetchUserFromExternalProvider = FetchUserFromExternalProvider;
    /**
     * Validate all AML requirements and finalize the pending PaymentTransactions on the Order.
     *
     * @export
     * @class FinalizeAMLChecksOnOrder
     * @implements {EvaService}
     */
    class FinalizeAMLChecksOnOrder {
        name = 'Core:FinalizeAMLChecksOnOrder';
        path = '/message/FinalizeAMLChecksOnOrder';
        request;
        response;
    }
    Core.FinalizeAMLChecksOnOrder = FinalizeAMLChecksOnOrder;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class FinishRepair
     * @implements {EvaService}
     */
    class FinishRepair {
        name = 'Core:FinishRepair';
        path = '/message/FinishRepair';
        request;
        response;
    }
    Core.FinishRepair = FinishRepair;
    /**
     * Finish repair user task
     *
     * @export
     * @class FinishRepairUserTask
     * @implements {EvaService}
     */
    class FinishRepairUserTask {
        name = 'Core:FinishRepairUserTask';
        path = '/message/FinishRepairUserTask';
        request;
        response;
    }
    Core.FinishRepairUserTask = FinishRepairUserTask;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class FlushCache
     * @implements {EvaService}
     */
    class FlushCache {
        name = 'Core:FlushCache';
        path = '/message/FlushCache';
        request;
        response;
    }
    Core.FlushCache = FlushCache;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ForcePlaceOrder
     * @implements {EvaService}
     */
    class ForcePlaceOrder {
        name = 'Core:ForcePlaceOrder';
        path = '/message/ForcePlaceOrder';
        request;
        response;
    }
    Core.ForcePlaceOrder = ForcePlaceOrder;
    /**
     * Verify the customer of an order without QR code check.
     *
     * @export
     * @class ForceVerifyCustomer
     * @implements {EvaService}
     */
    class ForceVerifyCustomer {
        name = 'Core:ForceVerifyCustomer';
        path = '/message/ForceVerifyCustomer';
        request;
        response;
    }
    Core.ForceVerifyCustomer = ForceVerifyCustomer;
    /**
     * Receives a shipment completely as-is. Supply either `ID` or `BackendID`.
     *
     * @export
     * @class FullyReceiveShipment
     * @implements {EvaService}
     */
    class FullyReceiveShipment {
        name = 'Core:FullyReceiveShipment';
        path = '/message/FullyReceiveShipment';
        request;
        response;
    }
    Core.FullyReceiveShipment = FullyReceiveShipment;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class FullyShipPurchaseOrder
     * @implements {EvaService}
     */
    class FullyShipPurchaseOrder {
        name = 'Core:FullyShipPurchaseOrder';
        path = '/message/FullyShipPurchaseOrder';
        request;
        response;
    }
    Core.FullyShipPurchaseOrder = FullyShipPurchaseOrder;
    /**
     * Service for generating a new device hub barcode
     *
     * @export
     * @class GenerateDeviceHubBarcode
     * @implements {EvaService}
     */
    class GenerateDeviceHubBarcode {
        name = 'Core:GenerateDeviceHubBarcode';
        path = '/message/GenerateDeviceHubBarcode';
        request;
        response;
    }
    Core.GenerateDeviceHubBarcode = GenerateDeviceHubBarcode;
    /**
     * Generates an elevation barcode to elevate this user's rights, which can be scanned by a manager with sufficient rights to grant elevation.

Show the returned `Barcode` to a manager for scanning through the `ParseBarcode` service, preferably as QR code through our `/barcode` endpoint.

:shield: Requires `Security:ElevatedFunctionalityProvider` to contain "ElevationBarcode".

:point_right: Send the returned `RequestToken` as elevation header with your original call, but before you do, it needs to be confirmed first through a manager scan. You can use this
same token to subscribe to the `/elevationBarcode` SignalR hub to listen for this scan event.

:bulb: Optionally supply the `OrganizationUnitID`, `Functionality` and `Scope` of your original request, so we can check the manager rights directly from the scan
on their device. Omitting these here will fall back to the default security enforced from the user attempting to use the (confirmed) elevation token, which just gives
a nasty 403 on the employee's device.
     *
     * @export
     * @class GenerateElevationBarcode
     * @implements {EvaService}
     */
    class GenerateElevationBarcode {
        name = 'Core:GenerateElevationBarcode';
        path = '/message/GenerateElevationBarcode';
        request;
        response;
    }
    Core.GenerateElevationBarcode = GenerateElevationBarcode;
    /**
     * Service for generating a new scan mode barcode
     *
     * @export
     * @class GenerateScanModeBarcode
     * @implements {EvaService}
     */
    class GenerateScanModeBarcode {
        name = 'Core:GenerateScanModeBarcode';
        path = '/message/GenerateScanModeBarcode';
        request;
        response;
    }
    Core.GenerateScanModeBarcode = GenerateScanModeBarcode;
    /**
     * Service for generating a new session barcode
     *
     * @export
     * @class GenerateSessionBarcode
     * @implements {EvaService}
     */
    class GenerateSessionBarcode {
        name = 'Core:GenerateSessionBarcode';
        path = '/message/GenerateSessionBarcode';
        request;
        response;
    }
    Core.GenerateSessionBarcode = GenerateSessionBarcode;
    /**
     * Generates a temporary 5-digit code that can be used for elevation.

A manager generates this code on their own device, and can then manually copy this code on the user's device when requested.

:shield: Requires `Security:ElevatedFunctionalityProvider` to contain "TemporaryElevationCode".

:point_right: Send this temporary code as elevation header with your original call.

:bulb: Note it's only valid for a limited period of time (as per `Security:TemporaryElevationCode:ExpireInMinutes`) and is a /separate/ code from your login PIN!
     *
     * @export
     * @class GenerateTemporaryElevationCode
     * @implements {EvaService}
     */
    class GenerateTemporaryElevationCode {
        name = 'Core:GenerateTemporaryElevationCode';
        path = '/message/GenerateTemporaryElevationCode';
        request;
        response;
    }
    Core.GenerateTemporaryElevationCode = GenerateTemporaryElevationCode;
    /**
     * Creates a temporary, numeric password for specified user, overwriting his/her current password, intended for employees to be able to help resetting a user password.
     *
     * @export
     * @class GenerateTemporaryPasswordForUser
     * @implements {EvaService}
     */
    class GenerateTemporaryPasswordForUser {
        name = 'Core:GenerateTemporaryPasswordForUser';
        path = '/message/GenerateTemporaryPasswordForUser';
        request;
        response;
    }
    Core.GenerateTemporaryPasswordForUser = GenerateTemporaryPasswordForUser;
    /**
     * Returns all active discounts within an organization unit
     *
     * @export
     * @class GetActiveDiscounts
     * @implements {EvaService}
     */
    class GetActiveDiscounts {
        name = 'Core:GetActiveDiscounts';
        path = '/message/GetActiveDiscounts';
        request;
        response;
    }
    Core.GetActiveDiscounts = GetActiveDiscounts;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetActivePaymentTypes
     * @implements {EvaService}
     */
    class GetActivePaymentTypes {
        name = 'Core:GetActivePaymentTypes';
        path = '/message/GetActivePaymentTypes';
        request;
        response;
    }
    Core.GetActivePaymentTypes = GetActivePaymentTypes;
    /**
     * Returns the active shopping cart for the current user.
Works only for webshop OUs.
If there is no active shopping cart, no orderID will be returned.
     *
     * @export
     * @class GetActiveShoppingCart
     * @implements {EvaService}
     */
    class GetActiveShoppingCart {
        name = 'Core:GetActiveShoppingCart';
        path = '/message/GetActiveShoppingCart';
        request;
        response;
    }
    Core.GetActiveShoppingCart = GetActiveShoppingCart;
    /**
     * Service for retrieving a `Address` by specifying a Zip Code and House Number.

This only works for addresses in the Netherlands, for a more generic approach look a the AutocompleteAddress service
     *
     * @export
     * @class GetAddressForZipCode
     * @implements {EvaService}
     */
    class GetAddressForZipCode {
        name = 'Core:GetAddressForZipCode';
        path = '/message/GetAddressForZipCode';
        request;
        response;
    }
    Core.GetAddressForZipCode = GetAddressForZipCode;
    /**
     * Get all available address requirements.
     *
     * @export
     * @class GetAddressRequirements
     * @implements {EvaService}
     */
    class GetAddressRequirements {
        name = 'Core:GetAddressRequirements';
        path = '/message/GetAddressRequirements';
        request;
        response;
    }
    Core.GetAddressRequirements = GetAddressRequirements;
    /**
     * Get all User subscriptions for all OUs.
     *
     * @export
     * @class GetAllSubscriptionsByUserID
     * @implements {EvaService}
     */
    class GetAllSubscriptionsByUserID {
        name = 'Core:GetAllSubscriptionsByUserID';
        path = '/message/GetAllSubscriptionsByUserID';
        request;
        response;
    }
    Core.GetAllSubscriptionsByUserID = GetAllSubscriptionsByUserID;
    /**
     * Retrieve the anonymous token for specified `OrganizationUnitID` and `LanguageID`. The response is your token, or null when not present.
     *
     * @export
     * @class GetAnonymousToken
     * @implements {EvaService}
     */
    class GetAnonymousToken {
        name = 'Core:GetAnonymousToken';
        path = '/message/GetAnonymousToken';
        request;
        response;
    }
    Core.GetAnonymousToken = GetAnonymousToken;
    /**
     * Get an anonymous wishlist by token.
     *
     * @export
     * @class GetAnonymousWishlist
     * @implements {EvaService}
     */
    class GetAnonymousWishlist {
        name = 'Core:GetAnonymousWishlist';
        path = '/message/GetAnonymousWishlist';
        request;
        response;
    }
    Core.GetAnonymousWishlist = GetAnonymousWishlist;
    /**
     * Gets the description of the entire API
     *
     * @export
     * @class GetApiDefinition
     * @implements {EvaService}
     */
    class GetApiDefinition {
        name = 'Core:GetApiDefinition';
        path = '/message/GetApiDefinition';
        request;
        response;
    }
    Core.GetApiDefinition = GetApiDefinition;
    /**
     * Get all app rules
     *
     * @export
     * @class GetAppRules
     * @implements {EvaService}
     */
    class GetAppRules {
        name = 'Core:GetAppRules';
        path = '/message/GetAppRules';
        request;
        response;
    }
    Core.GetAppRules = GetAppRules;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetApplicationConfiguration
     * @implements {EvaService}
     */
    class GetApplicationConfiguration {
        name = 'Core:GetApplicationConfiguration';
        path = '/message/GetApplicationConfiguration';
        request;
        response;
    }
    Core.GetApplicationConfiguration = GetApplicationConfiguration;
    /**
     * Returns the available assembly names for the device types. Can optionally filter by device types.
     *
     * @export
     * @class GetAssemblyNamesForDeviceTypes
     * @implements {EvaService}
     */
    class GetAssemblyNamesForDeviceTypes {
        name = 'Core:GetAssemblyNamesForDeviceTypes';
        path = '/message/GetAssemblyNamesForDeviceTypes';
        request;
        response;
    }
    Core.GetAssemblyNamesForDeviceTypes = GetAssemblyNamesForDeviceTypes;
    /**
     * Returns a specific async request for your current user
     *
     * @export
     * @class GetAsyncRequestForUser
     * @implements {EvaService}
     */
    class GetAsyncRequestForUser {
        name = 'Core:GetAsyncRequestForUser';
        path = '/message/GetAsyncRequestForUser';
        request;
        response;
    }
    Core.GetAsyncRequestForUser = GetAsyncRequestForUser;
    /**
     * Returns all async requests for your current user
     *
     * @export
     * @class GetAsyncRequestsForUser
     * @implements {EvaService}
     */
    class GetAsyncRequestsForUser {
        name = 'Core:GetAsyncRequestsForUser';
        path = '/message/GetAsyncRequestsForUser';
        request;
        response;
    }
    Core.GetAsyncRequestsForUser = GetAsyncRequestsForUser;
    /**
     * Gets all current audit chain configurations.
     *
     * @export
     * @class GetAuditChainConfigurations
     * @implements {EvaService}
     */
    class GetAuditChainConfigurations {
        name = 'Core:GetAuditChainConfigurations';
        path = '/message/GetAuditChainConfigurations';
        request;
        response;
    }
    Core.GetAuditChainConfigurations = GetAuditChainConfigurations;
    /**
     * Returns the full authorizationstructure of the current user.

It is a list of all the roles the user has, with their functionalities and the OrganizationUnits where these are active.
     *
     * @export
     * @class GetAuthorizationStructure
     * @implements {EvaService}
     */
    class GetAuthorizationStructure {
        name = 'Core:GetAuthorizationStructure';
        path = '/message/GetAuthorizationStructure';
        request;
        response;
    }
    Core.GetAuthorizationStructure = GetAuthorizationStructure;
    /**
     * Service for retrieving address suggestion details by specifying a address suggestion retrieved from `AutocompleteAddress` service
     *
     * @export
     * @class GetAutocompleteAddressByReference
     * @implements {EvaService}
     */
    class GetAutocompleteAddressByReference {
        name = 'Core:GetAutocompleteAddressByReference';
        path = '/message/GetAutocompleteAddressByReference';
        request;
        response;
    }
    Core.GetAutocompleteAddressByReference = GetAutocompleteAddressByReference;
    /**
     * Returns the pickup and/or delivery availability of the given products
     *
     * @export
     * @class GetAvailabilityIndication
     * @implements {EvaService}
     */
    class GetAvailabilityIndication {
        name = 'Core:GetAvailabilityIndication';
        path = '/message/GetAvailabilityIndication';
        request;
        response;
    }
    Core.GetAvailabilityIndication = GetAvailabilityIndication;
    /**
     * Retrieves the current available cash amount of given device, to be able to e.g. validate user given amounts in `CreateCashDeposit` or `CreateCashExpense` services.

Supply a `CurrencyID` and `PaymentTypeID` to indicate the Cash Journal to be used.
     *
     * @export
     * @class GetAvailableCashAmountForDevice
     * @implements {EvaService}
     */
    class GetAvailableCashAmountForDevice {
        name = 'Core:GetAvailableCashAmountForDevice';
        path = '/message/GetAvailableCashAmountForDevice';
        request;
        response;
    }
    Core.GetAvailableCashAmountForDevice = GetAvailableCashAmountForDevice;
    /**
     * Returns all `CashHandlers` available to use on `OrganizationUnits`
     *
     * @export
     * @class GetAvailableCashHandlers
     * @implements {EvaService}
     */
    class GetAvailableCashHandlers {
        name = 'Core:GetAvailableCashHandlers';
        path = '/message/GetAvailableCashHandlers';
        request;
        response;
    }
    Core.GetAvailableCashHandlers = GetAvailableCashHandlers;
    /**
     * Services for retrieving a list of `Currency`
     *
     * @export
     * @class GetAvailableCurrencies
     * @implements {EvaService}
     */
    class GetAvailableCurrencies {
        name = 'Core:GetAvailableCurrencies';
        path = '/message/GetAvailableCurrencies';
        request;
        response;
    }
    Core.GetAvailableCurrencies = GetAvailableCurrencies;
    /**
     * Returns a list of available outputs for an order by taking an `OrderID`.
     *
     * @export
     * @class GetAvailableDocumentsForOrder
     * @implements {EvaService}
     */
    class GetAvailableDocumentsForOrder {
        name = 'Core:GetAvailableDocumentsForOrder';
        path = '/message/GetAvailableDocumentsForOrder';
        request;
        response;
    }
    Core.GetAvailableDocumentsForOrder = GetAvailableDocumentsForOrder;
    /**
     * Get the AvailableGiftCardConfigurations taking into account the OrganizationUnitID from ClientContext.

`GiftCardConfiguration`: an item that describes the giftcard properties of a product with type GiftCard
     *
     * @export
     * @class GetAvailableGiftCardConfigurations
     * @implements {EvaService}
     */
    class GetAvailableGiftCardConfigurations {
        name = 'Core:GetAvailableGiftCardConfigurations';
        path = '/message/GetAvailableGiftCardConfigurations';
        request;
        response;
    }
    Core.GetAvailableGiftCardConfigurations = GetAvailableGiftCardConfigurations;
    /**
     * Get the available GiftWrapping options for an Order.
     *
     * @export
     * @class GetAvailableGiftWrappingLinesForOrder
     * @implements {EvaService}
     */
    class GetAvailableGiftWrappingLinesForOrder {
        name = 'Core:GetAvailableGiftWrappingLinesForOrder';
        path = '/message/GetAvailableGiftWrappingLinesForOrder';
        request;
        response;
    }
    Core.GetAvailableGiftWrappingLinesForOrder = GetAvailableGiftWrappingLinesForOrder;
    /**
     * Retrieve all available payment methods, in general, or for a specific order.

When ReturnUnusablePaymentMethods is set to true, the system will also return unusable payment methods
     *
     * @export
     * @class GetAvailablePaymentMethods
     * @implements {EvaService}
     */
    class GetAvailablePaymentMethods {
        name = 'Core:GetAvailablePaymentMethods';
        path = '/message/GetAvailablePaymentMethods';
        request;
        response;
    }
    Core.GetAvailablePaymentMethods = GetAvailablePaymentMethods;
    /**
     * Get all available options for refunds on the given order

Refunds can be executed with the CreateRefund service
     *
     * @export
     * @class GetAvailableRefundPaymentMethodsForOrder
     * @implements {EvaService}
     */
    class GetAvailableRefundPaymentMethodsForOrder {
        name = 'Core:GetAvailableRefundPaymentMethodsForOrder';
        path = '/message/GetAvailableRefundPaymentMethodsForOrder';
        request;
        response;
    }
    Core.GetAvailableRefundPaymentMethodsForOrder = GetAvailableRefundPaymentMethodsForOrder;
    /**
     * Service for retrieving a list available service details
     *
     * @export
     * @class GetAvailableServiceDetails
     * @implements {EvaService}
     */
    class GetAvailableServiceDetails {
        name = 'Core:GetAvailableServiceDetails';
        path = '/message/GetAvailableServiceDetails';
        request;
        response;
    }
    Core.GetAvailableServiceDetails = GetAvailableServiceDetails;
    /**
     * Service for retrieving a list of available services
     *
     * @export
     * @class GetAvailableServices
     * @implements {EvaService}
     */
    class GetAvailableServices {
        name = 'Core:GetAvailableServices';
        path = '/message/GetAvailableServices';
        request;
        response;
    }
    Core.GetAvailableServices = GetAvailableServices;
    /**
     * Get all available subscriptions
     *
     * @export
     * @class GetAvailableSubscriptions
     * @implements {EvaService}
     */
    class GetAvailableSubscriptions {
        name = 'Core:GetAvailableSubscriptions';
        path = '/message/GetAvailableSubscriptions';
        request;
        response;
    }
    Core.GetAvailableSubscriptions = GetAvailableSubscriptions;
    /**
     * Gets the available two-factor authenticators for the current user
     *
     * @export
     * @class GetAvailableTwoFactorAuthenticators
     * @implements {EvaService}
     */
    class GetAvailableTwoFactorAuthenticators {
        name = 'Core:GetAvailableTwoFactorAuthenticators';
        path = '/message/GetAvailableTwoFactorAuthenticators';
        request;
        response;
    }
    Core.GetAvailableTwoFactorAuthenticators = GetAvailableTwoFactorAuthenticators;
    /**
     * Get all visibility groups that the current user can see.
     *
     * @export
     * @class GetAvailableVisibilityGroups
     * @implements {EvaService}
     */
    class GetAvailableVisibilityGroups {
        name = 'Core:GetAvailableVisibilityGroups';
        path = '/message/GetAvailableVisibilityGroups';
        request;
        response;
    }
    Core.GetAvailableVisibilityGroups = GetAvailableVisibilityGroups;
    /**
     * Gets boarding pass information set to given order.
     *
     * @export
     * @class GetBoardingPass
     * @implements {EvaService}
     */
    class GetBoardingPass {
        name = 'Core:GetBoardingPass';
        path = '/message/GetBoardingPass';
        request;
        response;
    }
    Core.GetBoardingPass = GetBoardingPass;
    /**
     * Gets the details of a bundle by its ProductID. The input to this service is `BundleProductID` which refers to the ID
of a `Product` that has `Type` = `BundleProduct`.

The details of a bundle is a structure containing the lines of the bundle, the available options for each line
of the bundle and, if it's a bundle of bundles or a bundle of configurable products, this structure is recursive; each option
can have lines of its own again. So the output of this service contains a tree of all the available products for the bundle.

The `IncludedFields` parameter is optional and allows you to specify which fields you wish to get back from this service.
     *
     * @export
     * @class GetBundleProductDetails
     * @implements {EvaService}
     */
    class GetBundleProductDetails {
        name = 'Core:GetBundleProductDetails';
        path = '/message/GetBundleProductDetails';
        request;
        response;
    }
    Core.GetBundleProductDetails = GetBundleProductDetails;
    /**
     * This service returns a list of bundle products that contain the `ProductID` in the request.
The service is meant to be used on a product detail page as a "this product is also available in these bundles" component.
The request allows you to specify what data you'd like to get back from the bundle product, through the `IncludedFields` field.
     *
     * @export
     * @class GetBundleProductsForProduct
     * @implements {EvaService}
     */
    class GetBundleProductsForProduct {
        name = 'Core:GetBundleProductsForProduct';
        path = '/message/GetBundleProductsForProduct';
        request;
        response;
    }
    Core.GetBundleProductsForProduct = GetBundleProductsForProduct;
    /**
     * Gets info about EVA caches, only accessible by New Black.
     *
     * @export
     * @class GetCacheInfo
     * @implements {EvaService}
     */
    class GetCacheInfo {
        name = 'Core:GetCacheInfo';
        path = '/message/GetCacheInfo';
        request;
        response;
    }
    Core.GetCacheInfo = GetCacheInfo;
    /**
     * Retrieves details of a cash correction
     *
     * @export
     * @class GetCashCorrection
     * @implements {EvaService}
     */
    class GetCashCorrection {
        name = 'Core:GetCashCorrection';
        path = '/message/GetCashCorrection';
        request;
        response;
    }
    Core.GetCashCorrection = GetCashCorrection;
    /**
     * Get cash correction reason by it's ID
     *
     * @export
     * @class GetCashCorrectionReason
     * @implements {EvaService}
     */
    class GetCashCorrectionReason {
        name = 'Core:GetCashCorrectionReason';
        path = '/message/GetCashCorrectionReason';
        request;
        response;
    }
    Core.GetCashCorrectionReason = GetCashCorrectionReason;
    /**
     * Get all cash correction reasons
     *
     * @export
     * @class GetCashCorrectionReasons
     * @implements {EvaService}
     */
    class GetCashCorrectionReasons {
        name = 'Core:GetCashCorrectionReasons';
        path = '/message/GetCashCorrectionReasons';
        request;
        response;
    }
    Core.GetCashCorrectionReasons = GetCashCorrectionReasons;
    /**
     * Retrieves details of a cash deposit
     *
     * @export
     * @class GetCashDeposit
     * @implements {EvaService}
     */
    class GetCashDeposit {
        name = 'Core:GetCashDeposit';
        path = '/message/GetCashDeposit';
        request;
        response;
    }
    Core.GetCashDeposit = GetCashDeposit;
    /**
     * Retrieves details of a cash expense
     *
     * @export
     * @class GetCashExpense
     * @implements {EvaService}
     */
    class GetCashExpense {
        name = 'Core:GetCashExpense';
        path = '/message/GetCashExpense';
        request;
        response;
    }
    Core.GetCashExpense = GetCashExpense;
    /**
     * Returns all cash expenses that are available for your current OrganizationUnit, or available to the provided OrganizationUnitID (optional).
     *
     * @export
     * @class GetCashExpenseTypes
     * @implements {EvaService}
     */
    class GetCashExpenseTypes {
        name = 'Core:GetCashExpenseTypes';
        path = '/message/GetCashExpenseTypes';
        request;
        response;
    }
    Core.GetCashExpenseTypes = GetCashExpenseTypes;
    /**
     * Gets the currency and a list of available coins and notes for the provided `DeviceID`.
     *
     * @export
     * @class GetCashJournalDenominations
     * @implements {EvaService}
     */
    class GetCashJournalDenominations {
        name = 'Core:GetCashJournalDenominations';
        path = '/message/GetCashJournalDenominations';
        request;
        response;
    }
    Core.GetCashJournalDenominations = GetCashJournalDenominations;
    /**
     * Retrieves details of a cash movement
     *
     * @export
     * @class GetCashMovement
     * @implements {EvaService}
     */
    class GetCashMovement {
        name = 'Core:GetCashMovement';
        path = '/message/GetCashMovement';
        request;
        response;
    }
    Core.GetCashMovement = GetCashMovement;
    /**
     * Get the CheckoutOptions
     *
     * @export
     * @class GetCheckoutOptions
     * @implements {EvaService}
     */
    class GetCheckoutOptions {
        name = 'Core:GetCheckoutOptions';
        path = '/message/GetCheckoutOptions';
        request;
        response;
    }
    Core.GetCheckoutOptions = GetCheckoutOptions;
    /**
     * Return the Company attached to the given User
     *
     * @export
     * @class GetCompanyForUser
     * @implements {EvaService}
     */
    class GetCompanyForUser {
        name = 'Core:GetCompanyForUser';
        path = '/message/GetCompanyForUser';
        request;
        response;
    }
    Core.GetCompanyForUser = GetCompanyForUser;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetConfigurableOrderView
     * @implements {EvaService}
     */
    class GetConfigurableOrderView {
        name = 'Core:GetConfigurableOrderView';
        path = '/message/GetConfigurableOrderView';
        request;
        response;
    }
    Core.GetConfigurableOrderView = GetConfigurableOrderView;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetConfigurableProductDetail
     * @implements {EvaService}
     */
    class GetConfigurableProductDetail {
        name = 'Core:GetConfigurableProductDetail';
        path = '/message/GetConfigurableProductDetail';
        request;
        response;
    }
    Core.GetConfigurableProductDetail = GetConfigurableProductDetail;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetConfigurableProductsDetail
     * @implements {EvaService}
     */
    class GetConfigurableProductsDetail {
        name = 'Core:GetConfigurableProductsDetail';
        path = '/message/GetConfigurableProductsDetail';
        request;
        response;
    }
    Core.GetConfigurableProductsDetail = GetConfigurableProductsDetail;
    /**
     * Returns a detailed view of a ConsolidatedPickTask by the ID of its UserTask.
     *
     * @export
     * @class GetConsolidatedPickTask
     * @implements {EvaService}
     */
    class GetConsolidatedPickTask {
        name = 'Core:GetConsolidatedPickTask';
        path = '/message/GetConsolidatedPickTask';
        request;
        response;
    }
    Core.GetConsolidatedPickTask = GetConsolidatedPickTask;
    /**
     * Retrieves the details of the consumer company corresponding to the specified ID.
     *
     * @export
     * @class GetConsumerCompany
     * @implements {EvaService}
     */
    class GetConsumerCompany {
        name = 'Core:GetConsumerCompany';
        path = '/message/GetConsumerCompany';
        request;
        response;
    }
    Core.GetConsumerCompany = GetConsumerCompany;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetContractNumber
     * @implements {EvaService}
     */
    class GetContractNumber {
        name = 'Core:GetContractNumber';
        path = '/message/GetContractNumber';
        request;
        response;
    }
    Core.GetContractNumber = GetContractNumber;
    /**
     * Get the CountrySubdivisions

Optionally the request can be filtered on countryid
     *
     * @export
     * @class GetCountrySubdivisions
     * @implements {EvaService}
     */
    class GetCountrySubdivisions {
        name = 'Core:GetCountrySubdivisions';
        path = '/message/GetCountrySubdivisions';
        request;
        response;
    }
    Core.GetCountrySubdivisions = GetCountrySubdivisions;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetCurrency
     * @implements {EvaService}
     */
    class GetCurrency {
        name = 'Core:GetCurrency';
        path = '/message/GetCurrency';
        request;
        response;
    }
    Core.GetCurrency = GetCurrency;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetCurrentApplication
     * @implements {EvaService}
     */
    class GetCurrentApplication {
        name = 'Core:GetCurrentApplication';
        path = '/message/GetCurrentApplication';
        request;
        response;
    }
    Core.GetCurrentApplication = GetCurrentApplication;
    /**
     * Returns information about the current cash journals for the given DeviceID.
     *
     * @export
     * @class GetCurrentCashJournals
     * @implements {EvaService}
     */
    class GetCurrentCashJournals {
        name = 'Core:GetCurrentCashJournals';
        path = '/message/GetCurrentCashJournals';
        request;
        response;
    }
    Core.GetCurrentCashJournals = GetCurrentCashJournals;
    /**
     * Returns a summary of the current financial period of the organization unit that the user is currently logged on to. The
result of this service can be used to retrieve more details of the financial period via the
`GetFinancialPeriodDetails` service.
     *
     * @export
     * @class GetCurrentFinancialPeriodSummary
     * @implements {EvaService}
     */
    class GetCurrentFinancialPeriodSummary {
        name = 'Core:GetCurrentFinancialPeriodSummary';
        path = '/message/GetCurrentFinancialPeriodSummary';
        request;
        response;
    }
    Core.GetCurrentFinancialPeriodSummary = GetCurrentFinancialPeriodSummary;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetCurrentInitialCycleCount
     * @implements {EvaService}
     */
    class GetCurrentInitialCycleCount {
        name = 'Core:GetCurrentInitialCycleCount';
        path = '/message/GetCurrentInitialCycleCount';
        request;
        response;
    }
    Core.GetCurrentInitialCycleCount = GetCurrentInitialCycleCount;
    /**
     * Return the current user for the given Authorization header
     *
     * @export
     * @class GetCurrentUser
     * @implements {EvaService}
     */
    class GetCurrentUser {
        name = 'Core:GetCurrentUser';
        path = '/message/GetCurrentUser';
        request;
        response;
    }
    Core.GetCurrentUser = GetCurrentUser;
    /**
     * Return identification info for the current employee.
     *
     * @export
     * @class GetCurrentUserIdentificationInfo
     * @implements {EvaService}
     */
    class GetCurrentUserIdentificationInfo {
        name = 'Core:GetCurrentUserIdentificationInfo';
        path = '/message/GetCurrentUserIdentificationInfo';
        request;
        response;
    }
    Core.GetCurrentUserIdentificationInfo = GetCurrentUserIdentificationInfo;
    /**
     * Get the version status of the client compared to the current version of the API. The header EVA-API-Version is required.
     *
     * @export
     * @class GetCurrentVersion
     * @implements {EvaService}
     */
    class GetCurrentVersion {
        name = 'Core:GetCurrentVersion';
        path = '/message/GetCurrentVersion';
        request;
        response;
    }
    Core.GetCurrentVersion = GetCurrentVersion;
    /**
     * Lists the available custom order types that exists which can be used in the order editing process.
     *
     * @export
     * @class GetCustomOrderTypes
     * @implements {EvaService}
     */
    class GetCustomOrderTypes {
        name = 'Core:GetCustomOrderTypes';
        path = '/message/GetCustomOrderTypes';
        request;
        response;
    }
    Core.GetCustomOrderTypes = GetCustomOrderTypes;
    /**
     * Retrieve the set values
     *
     * @export
     * @class GetCustomUserTaskData
     * @implements {EvaService}
     */
    class GetCustomUserTaskData {
        name = 'Core:GetCustomUserTaskData';
        path = '/message/GetCustomUserTaskData';
        request;
        response;
    }
    Core.GetCustomUserTaskData = GetCustomUserTaskData;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetCustomerOrderVerificationCode
     * @implements {EvaService}
     */
    class GetCustomerOrderVerificationCode {
        name = 'Core:GetCustomerOrderVerificationCode';
        path = '/message/GetCustomerOrderVerificationCode';
        request;
        response;
    }
    Core.GetCustomerOrderVerificationCode = GetCustomerOrderVerificationCode;
    /**
     * Return the customer order return details originally set via `CreateCustomerReturn` or `CreateCustomerReturnWithoutOrder
     *
     * @export
     * @class GetCustomerReturn
     * @implements {EvaService}
     */
    class GetCustomerReturn {
        name = 'Core:GetCustomerReturn';
        path = '/message/GetCustomerReturn';
        request;
        response;
    }
    Core.GetCustomerReturn = GetCustomerReturn;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetCycleCountOriginTypes
     * @implements {EvaService}
     */
    class GetCycleCountOriginTypes {
        name = 'Core:GetCycleCountOriginTypes';
        path = '/message/GetCycleCountOriginTypes';
        request;
        response;
    }
    Core.GetCycleCountOriginTypes = GetCycleCountOriginTypes;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetCycleCountSettings
     * @implements {EvaService}
     */
    class GetCycleCountSettings {
        name = 'Core:GetCycleCountSettings';
        path = '/message/GetCycleCountSettings';
        request;
        response;
    }
    Core.GetCycleCountSettings = GetCycleCountSettings;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetCycleCountZones
     * @implements {EvaService}
     */
    class GetCycleCountZones {
        name = 'Core:GetCycleCountZones';
        path = '/message/GetCycleCountZones';
        request;
        response;
    }
    Core.GetCycleCountZones = GetCycleCountZones;
    /**
     * Get additional order information intended for delivery data.
     *
     * @export
     * @class GetDeliveryOrderData
     * @implements {EvaService}
     */
    class GetDeliveryOrderData {
        name = 'Core:GetDeliveryOrderData';
        path = '/message/GetDeliveryOrderData';
        request;
        response;
    }
    Core.GetDeliveryOrderData = GetDeliveryOrderData;
    /**
     * Get detailed organization unit opening hours
     *
     * @export
     * @class GetDetailedOrganizationUnitOpeningHours
     * @implements {EvaService}
     */
    class GetDetailedOrganizationUnitOpeningHours {
        name = 'Core:GetDetailedOrganizationUnitOpeningHours';
        path = '/message/GetDetailedOrganizationUnitOpeningHours';
        request;
        response;
    }
    Core.GetDetailedOrganizationUnitOpeningHours = GetDetailedOrganizationUnitOpeningHours;
    /**
     * Service for retrieving a existing `Device`
     *
     * @export
     * @class GetDevice
     * @implements {EvaService}
     */
    class GetDevice {
        name = 'Core:GetDevice';
        path = '/message/GetDevice';
        request;
        response;
    }
    Core.GetDevice = GetDevice;
    /**
     * Service for retrieving a list of possible `Device` types
     *
     * @export
     * @class GetDeviceTypes
     * @implements {EvaService}
     */
    class GetDeviceTypes {
        name = 'Core:GetDeviceTypes';
        path = '/message/GetDeviceTypes';
        request;
        response;
    }
    Core.GetDeviceTypes = GetDeviceTypes;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetDigitalGiftCardMailOptions
     * @implements {EvaService}
     */
    class GetDigitalGiftCardMailOptions {
        name = 'Core:GetDigitalGiftCardMailOptions';
        path = '/message/GetDigitalGiftCardMailOptions';
        request;
        response;
    }
    Core.GetDigitalGiftCardMailOptions = GetDigitalGiftCardMailOptions;
    /**
     * Gets the GiftCard mail information identified by the `OrderID` and `GiftCardID`.
     *
     * @export
     * @class GetDigitalGiftCardOptions
     * @implements {EvaService}
     */
    class GetDigitalGiftCardOptions {
        name = 'Core:GetDigitalGiftCardOptions';
        path = '/message/GetDigitalGiftCardOptions';
        request;
        response;
    }
    Core.GetDigitalGiftCardOptions = GetDigitalGiftCardOptions;
    /**
     * Retrieve the GiftCard data for a specific order, based on given `OrderID`. This order needs to be visible for the current user.

Will return a list of `GiftCard` data, for every orderline with a GiftCard. Will return the same data supplied in the `AddGiftCardToOrder`
service. When the order was shipped (automatically when it is fully paid), the details `GiftCardNumber` and
`Pin` are also included. An additional property `IsAvailable` let's you check if it was indeed shipped and paid.

The `GiftCardID` returned on the GiftCard is it's unique identifier, to be used in conjunction with the `AccessToken` to make it globally
unique. Using the `AccessToken` and `GiftCardID`, we are pretty sure you are allowed to see the GiftCard data. Use this data to build the link
to share directly, or use the approperiate services to mail/text/print this.

Additionally, this service can be called with an `AccessToken` and `GiftCardID` combination, as explained above. In this case, no user validation
is done - you know both keys to the GiftCard, so you are allowed to get it's information.
     *
     * @export
     * @class GetDigitalGiftCardsForOrder
     * @implements {EvaService}
     */
    class GetDigitalGiftCardsForOrder {
        name = 'Core:GetDigitalGiftCardsForOrder';
        path = '/message/GetDigitalGiftCardsForOrder';
        request;
        response;
    }
    Core.GetDigitalGiftCardsForOrder = GetDigitalGiftCardsForOrder;
    /**
     * Get discount product options for order
     *
     * @export
     * @class GetDiscountProductOptionsForOrder
     * @implements {EvaService}
     */
    class GetDiscountProductOptionsForOrder {
        name = 'Core:GetDiscountProductOptionsForOrder';
        path = '/message/GetDiscountProductOptionsForOrder';
        request;
        response;
    }
    Core.GetDiscountProductOptionsForOrder = GetDiscountProductOptionsForOrder;
    /**
     * Get discount product options for a specific discount line
     *
     * @export
     * @class GetDiscountProductOptionsForOrderLine
     * @implements {EvaService}
     */
    class GetDiscountProductOptionsForOrderLine {
        name = 'Core:GetDiscountProductOptionsForOrderLine';
        path = '/message/GetDiscountProductOptionsForOrderLine';
        request;
        response;
    }
    Core.GetDiscountProductOptionsForOrderLine = GetDiscountProductOptionsForOrderLine;
    /**
     * Get a list of all document store categories.

:warning: For debugging and support purposes only.
     *
     * @export
     * @class GetDocumentStoreCategories
     * @implements {EvaService}
     */
    class GetDocumentStoreCategories {
        name = 'Core:GetDocumentStoreCategories';
        path = '/message/GetDocumentStoreCategories';
        request;
        response;
    }
    Core.GetDocumentStoreCategories = GetDocumentStoreCategories;
    /**
     * Get a specific document from the document store.

:warning: For debugging and support purposes only.
     *
     * @export
     * @class GetDocumentStoreDocument
     * @implements {EvaService}
     */
    class GetDocumentStoreDocument {
        name = 'Core:GetDocumentStoreDocument';
        path = '/message/GetDocumentStoreDocument';
        request;
        response;
    }
    Core.GetDocumentStoreDocument = GetDocumentStoreDocument;
    /**
     * Used to retrieve the e-invoicing data that was set before via `SetElectronicInvoiceData`
     *
     * @export
     * @class GetElectronicInvoiceData
     * @implements {EvaService}
     */
    class GetElectronicInvoiceData {
        name = 'Core:GetElectronicInvoiceData';
        path = '/message/GetElectronicInvoiceData';
        request;
        response;
    }
    Core.GetElectronicInvoiceData = GetElectronicInvoiceData;
    /**
     * This service returns a list of the most likely email address domains (so 'gmail.com', 'hotmail.com', etc) based on
your current context.
     *
     * @export
     * @class GetEmailAddressDomainSuggestions
     * @implements {EvaService}
     */
    class GetEmailAddressDomainSuggestions {
        name = 'Core:GetEmailAddressDomainSuggestions';
        path = '/message/GetEmailAddressDomainSuggestions';
        request;
        response;
    }
    Core.GetEmailAddressDomainSuggestions = GetEmailAddressDomainSuggestions;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetEmployeeOrderVerificationCode
     * @implements {EvaService}
     */
    class GetEmployeeOrderVerificationCode {
        name = 'Core:GetEmployeeOrderVerificationCode';
        path = '/message/GetEmployeeOrderVerificationCode';
        request;
        response;
    }
    Core.GetEmployeeOrderVerificationCode = GetEmployeeOrderVerificationCode;
    /**
     * Service for retrieving an existing `EntityTranslation`
     *
     * @export
     * @class GetEntityTranslation
     * @implements {EvaService}
     */
    class GetEntityTranslation {
        name = 'Core:GetEntityTranslation';
        path = '/message/GetEntityTranslation';
        request;
        response;
    }
    Core.GetEntityTranslation = GetEntityTranslation;
    /**
     * A generic service to return all possible values in specified list, e.g. `Currency`, `TaxCode` or `StockLabel`.

The `Name` of the enumeration is unique within EVA, and all of the `Values` returned are also unique and identifiable
by their respective `Name`. Services that consume a value of an enumeration will expect the numeric `Value` returned.

Some of these enumerations are static and are defined by code, meaning the `Values`' combination of `Name` and `Value`
is contant and will never change. It is important to know, though, that other enumerations may be dynamic and can be
altered per environment by their own respective services. When using these, keep in mind they can vary between
environments and new values could be added. It is guaranteed, however, that once a certain `Name`-`Value` pair is set,
it will never change in that particular environment and you are safe treat it as a constant.

:point_right: It is important to realize these dynamics, because at first sight, all of these values may seem contant between
environments - but that is the mere result of an initialization sequence that is usually identical, but definitely
not guaranteed!

:point_right: `IsFlags` will indicate if the values should be treated as bit fields (or, a set of flags). For example,
the enumeration `OrganizationUnitTypes` demonstrates that an organization unit can both be a Shop (`1`) and a Warehouse (`16`)
at the same time, indicated by value `17`. Always use bitwise operands on these fields!
     *
     * @export
     * @class GetEnumValues
     * @implements {EvaService}
     */
    class GetEnumValues {
        name = 'Core:GetEnumValues';
        path = '/message/GetEnumValues';
        request;
        response;
    }
    Core.GetEnumValues = GetEnumValues;
    /**
     * Service for retrieving an existing `EventExportConfiguration`.
     *
     * @export
     * @class GetEventExportConfiguration
     * @implements {EvaService}
     */
    class GetEventExportConfiguration {
        name = 'Core:GetEventExportConfiguration';
        path = '/message/GetEventExportConfiguration';
        request;
        response;
    }
    Core.GetEventExportConfiguration = GetEventExportConfiguration;
    /**
     * Service for retrieving a list of existing `EventExportConfiguration`'s
     *
     * @export
     * @class GetEventExportConfigurations
     * @implements {EvaService}
     */
    class GetEventExportConfigurations {
        name = 'Core:GetEventExportConfigurations';
        path = '/message/GetEventExportConfigurations';
        request;
        response;
    }
    Core.GetEventExportConfigurations = GetEventExportConfigurations;
    /**
     * Service for retrieving a list of possible event types by `EventExportTarget`. If no target is provided, all targets and their types are returned.
     *
     * @export
     * @class GetEventExportTargetTypes
     * @implements {EvaService}
     */
    class GetEventExportTargetTypes {
        name = 'Core:GetEventExportTargetTypes';
        path = '/message/GetEventExportTargetTypes';
        request;
        response;
    }
    Core.GetEventExportTargetTypes = GetEventExportTargetTypes;
    /**
     * List available event ledger types.
     *
     * @export
     * @class GetEventLedgerTypes
     * @implements {EvaService}
     */
    class GetEventLedgerTypes {
        name = 'Core:GetEventLedgerTypes';
        path = '/message/GetEventLedgerTypes';
        request;
        response;
    }
    Core.GetEventLedgerTypes = GetEventLedgerTypes;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetFinancialPeriodAccountsSummary
     * @implements {EvaService}
     */
    class GetFinancialPeriodAccountsSummary {
        name = 'Core:GetFinancialPeriodAccountsSummary';
        path = '/message/GetFinancialPeriodAccountsSummary';
        request;
        response;
    }
    Core.GetFinancialPeriodAccountsSummary = GetFinancialPeriodAccountsSummary;
    /**
     * Get status summary for the devices of a FinancialPeriod
     *
     * @export
     * @class GetFinancialPeriodCashJournalDeviceSummary
     * @implements {EvaService}
     */
    class GetFinancialPeriodCashJournalDeviceSummary {
        name = 'Core:GetFinancialPeriodCashJournalDeviceSummary';
        path = '/message/GetFinancialPeriodCashJournalDeviceSummary';
        request;
        response;
    }
    Core.GetFinancialPeriodCashJournalDeviceSummary = GetFinancialPeriodCashJournalDeviceSummary;
    /**
     * Gets a list of reasons (if any) why this period cannot be closed yet.

The current possible reasons are (which is available in the `Type` property of each item):

## CLOCKED_IN_USER

The user is still clocked in and must be clocked out.

### Data

The `Data` property will contain:

```json
{
  "UserID" : 1,
  "ClockedIn" : "2018-08-01 12:00",
  "FirstName" : "John",
  "LastName"  : "Doe"
}
```

## ACTIVE_USER_TASK

The user task hasn't been completed yet and it's either attached to this financial period, or its past its deadline.

### Data

The `Data` property will contain:

```json
{
    "UserTaskID" : 5546,
    "UserTaskTypeID" : 9,
    "UserID" : null,
    "UserFullName" : null,
    "IsActive" : true,
    "IsCompleted" : false,
    "Deadline" : null,
    "CreationTime" : "2018-08-01"
}
```

## OPEN_CASH_JOURNAL

There is still an open cash journal that needs to be closed before the period can be closed.

### Data

The `Data` property will contain:

```json
{
"CashJournalID" : 3,
"DeviceID" : 1,
"OpeningAmount" : 150.15
}
```

## PCI_QUESTION

The PCI compliancy question has not been answered yet, this is required to close the period if the OrganizationUnit has been configured to require it.

### Data

No Data.

## NEGATIVE_STOCK

There is negative stock that must be corrected (to at least zero) before the period can be closed.

### Data

The `Data` property will contain:

```json
{
  "ProductID" : 7684,
  "ProductBackendID" : "ABC123",
  "QuantityOnHand" : -10,
  "StockLabelID" : 1,
  "StockLabelName" : "Sellable",
  "OrganizationUnitID" : 182
}
```

This data can then be used to correct the stock through AdjustStock/MoveStock.
     *
     * @export
     * @class GetFinancialPeriodClosingImpediments
     * @implements {EvaService}
     */
    class GetFinancialPeriodClosingImpediments {
        name = 'Core:GetFinancialPeriodClosingImpediments';
        path = '/message/GetFinancialPeriodClosingImpediments';
        request;
        response;
    }
    Core.GetFinancialPeriodClosingImpediments = GetFinancialPeriodClosingImpediments;
    /**
     * Gets information regarding financial period stock
     *
     * @export
     * @class GetFinancialPeriodClosingStockInformation
     * @implements {EvaService}
     */
    class GetFinancialPeriodClosingStockInformation {
        name = 'Core:GetFinancialPeriodClosingStockInformation';
        path = '/message/GetFinancialPeriodClosingStockInformation';
        request;
        response;
    }
    Core.GetFinancialPeriodClosingStockInformation = GetFinancialPeriodClosingStockInformation;
    /**
     * Returns a `FinancialPeriodDetailsDto` that contains details about the given financial period (`FinancialPeriodID`).
     *
     * @export
     * @class GetFinancialPeriodDetails
     * @implements {EvaService}
     */
    class GetFinancialPeriodDetails {
        name = 'Core:GetFinancialPeriodDetails';
        path = '/message/GetFinancialPeriodDetails';
        request;
        response;
    }
    Core.GetFinancialPeriodDetails = GetFinancialPeriodDetails;
    /**
     * Get financial period export documents
     *
     * @export
     * @class GetFinancialPeriodExportDocuments
     * @implements {EvaService}
     */
    class GetFinancialPeriodExportDocuments {
        name = 'Core:GetFinancialPeriodExportDocuments';
        path = '/message/GetFinancialPeriodExportDocuments';
        request;
        response;
    }
    Core.GetFinancialPeriodExportDocuments = GetFinancialPeriodExportDocuments;
    /**
     * Gets a detailed overview of the provided `FinancialPeriodID`. If no `FinancialPeriodID` is provided, the current period for your user is used.
     *
     * @export
     * @class GetFinancialPeriodInformation
     * @implements {EvaService}
     */
    class GetFinancialPeriodInformation {
        name = 'Core:GetFinancialPeriodInformation';
        path = '/message/GetFinancialPeriodInformation';
        request;
        response;
    }
    Core.GetFinancialPeriodInformation = GetFinancialPeriodInformation;
    /**
     * Gets a list of reasons (if any) why this period cannot be opened yet.

The current possible reasons are (which is available in the `Type` property of each item):

## LINKED_EMPLOYEES

Employees should be linked to this financial periods (with an optional commission share).

### Data

No Data.

## LOYALTY_PROGRAM

A loyalty program should be linked to this financial period.

### Data

No Data.

## MOBILE_ORGANIZATION_UNIT_LOCATION

This organization unit should get an updated location before starting this financial period.

### Data

No Data.
     *
     * @export
     * @class GetFinancialPeriodOpeningImpediments
     * @implements {EvaService}
     */
    class GetFinancialPeriodOpeningImpediments {
        name = 'Core:GetFinancialPeriodOpeningImpediments';
        path = '/message/GetFinancialPeriodOpeningImpediments';
        request;
        response;
    }
    Core.GetFinancialPeriodOpeningImpediments = GetFinancialPeriodOpeningImpediments;
    /**
     * Get the fiscal properties of an Order.
     *
     * @export
     * @class GetFiscalOrderData
     * @implements {EvaService}
     */
    class GetFiscalOrderData {
        name = 'Core:GetFiscalOrderData';
        path = '/message/GetFiscalOrderData';
        request;
        response;
    }
    Core.GetFiscalOrderData = GetFiscalOrderData;
    /**
     * Retrieves an existing Flight
     *
     * @export
     * @class GetFlight
     * @implements {EvaService}
     */
    class GetFlight {
        name = 'Core:GetFlight';
        path = '/message/GetFlight';
        request;
        response;
    }
    Core.GetFlight = GetFlight;
    /**
     * Get a Full Stock count task with details.
     *
     * @export
     * @class GetFullStockCount
     * @implements {EvaService}
     */
    class GetFullStockCount {
        name = 'Core:GetFullStockCount';
        path = '/message/GetFullStockCount';
        request;
        response;
    }
    Core.GetFullStockCount = GetFullStockCount;
    /**
     * Returns the information of a single label product. Most notably, this also includes serialnumber information.
     *
     * @export
     * @class GetFullStockCountLabelProduct
     * @implements {EvaService}
     */
    class GetFullStockCountLabelProduct {
        name = 'Core:GetFullStockCountLabelProduct';
        path = '/message/GetFullStockCountLabelProduct';
        request;
        response;
    }
    Core.GetFullStockCountLabelProduct = GetFullStockCountLabelProduct;
    /**
     * Fetch the options for a giftcard to determine the value ranges, currency etc.
     *
     * @export
     * @class GetGiftCardOptions
     * @implements {EvaService}
     */
    class GetGiftCardOptions {
        name = 'Core:GetGiftCardOptions';
        path = '/message/GetGiftCardOptions';
        request;
        response;
    }
    Core.GetGiftCardOptions = GetGiftCardOptions;
    /**
     * Get the GiftWrapping options for an Order.
     *
     * @export
     * @class GetGiftWrappingOptionsForOrder
     * @implements {EvaService}
     */
    class GetGiftWrappingOptionsForOrder {
        name = 'Core:GetGiftWrappingOptionsForOrder';
        path = '/message/GetGiftWrappingOptionsForOrder';
        request;
        response;
    }
    Core.GetGiftWrappingOptionsForOrder = GetGiftWrappingOptionsForOrder;
    /**
     * Returns a list of greeting cards.
     *
     * @export
     * @class GetGreetingCards
     * @implements {EvaService}
     */
    class GetGreetingCards {
        name = 'Core:GetGreetingCards';
        path = '/message/GetGreetingCards';
        request;
        response;
    }
    Core.GetGreetingCards = GetGreetingCards;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetInitialCycleCountLabel
     * @implements {EvaService}
     */
    class GetInitialCycleCountLabel {
        name = 'Core:GetInitialCycleCountLabel';
        path = '/message/GetInitialCycleCountLabel';
        request;
        response;
    }
    Core.GetInitialCycleCountLabel = GetInitialCycleCountLabel;
    /**
     * Gets the initialization state for the EVA environment.
Can either way be Created or Initialized.
If Created, the environment is not configured and can not be used.
If Initialized, the environment is configured and ready to be used.
     *
     * @export
     * @class GetInitializationState
     * @implements {EvaService}
     */
    class GetInitializationState {
        name = 'Core:GetInitializationState';
        path = '/message/GetInitializationState';
        request;
        response;
    }
    Core.GetInitializationState = GetInitializationState;
    /**
     * Returns inquiry details
     *
     * @export
     * @class GetInquiry
     * @implements {EvaService}
     */
    class GetInquiry {
        name = 'Core:GetInquiry';
        path = '/message/GetInquiry';
        request;
        response;
    }
    Core.GetInquiry = GetInquiry;
    /**
     * Returns all the details of an invoice by its ID.
     *
     * @export
     * @class GetInvoice
     * @implements {EvaService}
     */
    class GetInvoice {
        name = 'Core:GetInvoice';
        path = '/message/GetInvoice';
        request;
        response;
    }
    Core.GetInvoice = GetInvoice;
    /**
     * Get a InvoiceAdditionalAmountType by ID
     *
     * @export
     * @class GetInvoiceAdditionalAmountTypeByID
     * @implements {EvaService}
     */
    class GetInvoiceAdditionalAmountTypeByID {
        name = 'Core:GetInvoiceAdditionalAmountTypeByID';
        path = '/message/GetInvoiceAdditionalAmountTypeByID';
        request;
        response;
    }
    Core.GetInvoiceAdditionalAmountTypeByID = GetInvoiceAdditionalAmountTypeByID;
    /**
     * Get all InvoiceAdditionalAmountTypes
     *
     * @export
     * @class GetInvoiceAdditionalAmountTypes
     * @implements {EvaService}
     */
    class GetInvoiceAdditionalAmountTypes {
        name = 'Core:GetInvoiceAdditionalAmountTypes';
        path = '/message/GetInvoiceAdditionalAmountTypes';
        request;
        response;
    }
    Core.GetInvoiceAdditionalAmountTypes = GetInvoiceAdditionalAmountTypes;
    /**
     * Get all AdditionalAmounts for an Invoice
     *
     * @export
     * @class GetInvoiceAdditionalAmountsForInvoice
     * @implements {EvaService}
     */
    class GetInvoiceAdditionalAmountsForInvoice {
        name = 'Core:GetInvoiceAdditionalAmountsForInvoice';
        path = '/message/GetInvoiceAdditionalAmountsForInvoice';
        request;
        response;
    }
    Core.GetInvoiceAdditionalAmountsForInvoice = GetInvoiceAdditionalAmountsForInvoice;
    /**
     * Get a InvoiceDisputeReason by ID
     *
     * @export
     * @class GetInvoiceDisputeReasonByID
     * @implements {EvaService}
     */
    class GetInvoiceDisputeReasonByID {
        name = 'Core:GetInvoiceDisputeReasonByID';
        path = '/message/GetInvoiceDisputeReasonByID';
        request;
        response;
    }
    Core.GetInvoiceDisputeReasonByID = GetInvoiceDisputeReasonByID;
    /**
     * Get all InvoiceDisputeReasons
     *
     * @export
     * @class GetInvoiceDisputeReasons
     * @implements {EvaService}
     */
    class GetInvoiceDisputeReasons {
        name = 'Core:GetInvoiceDisputeReasons';
        path = '/message/GetInvoiceDisputeReasons';
        request;
        response;
    }
    Core.GetInvoiceDisputeReasons = GetInvoiceDisputeReasons;
    /**
     * Get all Disputes for an Invoice
     *
     * @export
     * @class GetInvoiceDisputesForInvoice
     * @implements {EvaService}
     */
    class GetInvoiceDisputesForInvoice {
        name = 'Core:GetInvoiceDisputesForInvoice';
        path = '/message/GetInvoiceDisputesForInvoice';
        request;
        response;
    }
    Core.GetInvoiceDisputesForInvoice = GetInvoiceDisputesForInvoice;
    /**
     * Get the details of an InvoiceExport
     *
     * @export
     * @class GetInvoiceExport
     * @implements {EvaService}
     */
    class GetInvoiceExport {
        name = 'Core:GetInvoiceExport';
        path = '/message/GetInvoiceExport';
        request;
        response;
    }
    Core.GetInvoiceExport = GetInvoiceExport;
    /**
     * Get the documents for an export when available
     *
     * @export
     * @class GetInvoiceExportDocuments
     * @implements {EvaService}
     */
    class GetInvoiceExportDocuments {
        name = 'Core:GetInvoiceExportDocuments';
        path = '/message/GetInvoiceExportDocuments';
        request;
        response;
    }
    Core.GetInvoiceExportDocuments = GetInvoiceExportDocuments;
    /**
     * Service for retrieving a list of available `InvoiceOutputType`'s providing a `Invoice`
     *
     * @export
     * @class GetInvoiceOutputTypes
     * @implements {EvaService}
     */
    class GetInvoiceOutputTypes {
        name = 'Core:GetInvoiceOutputTypes';
        path = '/message/GetInvoiceOutputTypes';
        request;
        response;
    }
    Core.GetInvoiceOutputTypes = GetInvoiceOutputTypes;
    /**
     * Retrieves payments for an order, with context about allocated invoices, filtered on specified optional `InvoiceID`.
     *
     * @export
     * @class GetInvoicePayments
     * @implements {EvaService}
     */
    class GetInvoicePayments {
        name = 'Core:GetInvoicePayments';
        path = '/message/GetInvoicePayments';
        request;
        response;
    }
    Core.GetInvoicePayments = GetInvoicePayments;
    /**
     * Returns all organization units where this user can login
     *
     * @export
     * @class GetLoginOrganizationUnitsForUser
     * @implements {EvaService}
     */
    class GetLoginOrganizationUnitsForUser {
        name = 'Core:GetLoginOrganizationUnitsForUser';
        path = '/message/GetLoginOrganizationUnitsForUser';
        request;
        response;
    }
    Core.GetLoginOrganizationUnitsForUser = GetLoginOrganizationUnitsForUser;
    /**
     * Retrieves the lottery number for a given order
     *
     * @export
     * @class GetLotteryNumber
     * @implements {EvaService}
     */
    class GetLotteryNumber {
        name = 'Core:GetLotteryNumber';
        path = '/message/GetLotteryNumber';
        request;
        response;
    }
    Core.GetLotteryNumber = GetLotteryNumber;
    /**
     * Gets the possible valid reasons that have been defined for opening the cash drawer manually.
     *
     * @export
     * @class GetOpenCashDrawerReasons
     * @implements {EvaService}
     */
    class GetOpenCashDrawerReasons {
        name = 'Core:GetOpenCashDrawerReasons';
        path = '/message/GetOpenCashDrawerReasons';
        request;
        response;
    }
    Core.GetOpenCashDrawerReasons = GetOpenCashDrawerReasons;
    /**
     * Get OpeningHoursTemplate by ID
     *
     * @export
     * @class GetOpeningHoursTemplateByID
     * @implements {EvaService}
     */
    class GetOpeningHoursTemplateByID {
        name = 'Core:GetOpeningHoursTemplateByID';
        path = '/message/GetOpeningHoursTemplateByID';
        request;
        response;
    }
    Core.GetOpeningHoursTemplateByID = GetOpeningHoursTemplateByID;
    /**
     * Get a list of all OpeningHoursTemplates translation keys for description translation.
     *
     * @export
     * @class GetOpeningHoursTemplatesTranslationKeys
     * @implements {EvaService}
     */
    class GetOpeningHoursTemplatesTranslationKeys {
        name = 'Core:GetOpeningHoursTemplatesTranslationKeys';
        path = '/message/GetOpeningHoursTemplatesTranslationKeys';
        request;
        response;
    }
    Core.GetOpeningHoursTemplatesTranslationKeys = GetOpeningHoursTemplatesTranslationKeys;
    /**
     * Get an Order by ID.

This service is readonly, it will not update the order just by calling it like the `GetShoppingCart` service does.

To include the result of `GetRequiredDataForOrder`, the property `AdditionalOrderDataOptions.RequiredFor` can be set to the desired level of requirements.
To include the result of `GetProductRequirementValuesForOrder`, the property `AdditionalOrderDataOptions.IncludeProductRequirements` can be set to `true`.
To include the result of `GetGiftWrappingOptionsForOrder` and `GetAvailableGiftWrappingLinesForOrder`, the property `AdditionalOrderDataOptions.IncludeGiftWrapping` can be set to `true`.
To include the result of `PrefigureDiscounts` and `GetPotentialDiscountsForOrder`, the property `AdditionalOrderDataOptions.IncludePrefigureDiscounts` can be set to `true`.
To include the result of `GetPickProductDiscountOptionsForOrder`, the property `AdditionalOrderDataOptions.IncludePickProductOptions` can be set to `true`.
To include the result of `ListAvailableShippingMethods`, the property `AdditionalOrderDataOptions.IncludeAvailableShippingMethods` can be set to `true`.
To include the result of `GetAvailablePaymentMethods`, the property `AdditionalOrderDataOptions.IncludeAvailablePaymentMethods` can be set to `true`.
To include the result of `GetAvailableRefundPaymentMethodsForOrder`, the property `AdditionalOrderDataOptions.IncludeAvailableRefundPaymentMethods` can be set to `true`.
To include the result of `ValidateOrderShipment`, the property `AdditionalOrderDataOptions.IncludeValidateShipment` can be set to `true`.
To include the available actions for the PaymentTransactions, the property `AdditionalOrderDataOptions.IncludePaymentTransactionActions` can be set to `true`.
     *
     * @export
     * @class GetOrder
     * @implements {EvaService}
     */
    class GetOrder {
        name = 'Core:GetOrder';
        path = '/message/GetOrder';
        request;
        response;
    }
    Core.GetOrder = GetOrder;
    /**
     * This services returns info about the discounts on the given order
     *
     * @export
     * @class GetOrderDiscountInfo
     * @implements {EvaService}
     */
    class GetOrderDiscountInfo {
        name = 'Core:GetOrderDiscountInfo';
        path = '/message/GetOrderDiscountInfo';
        request;
        response;
    }
    Core.GetOrderDiscountInfo = GetOrderDiscountInfo;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetOrderExportByID
     * @implements {EvaService}
     */
    class GetOrderExportByID {
        name = 'Core:GetOrderExportByID';
        path = '/message/GetOrderExportByID';
        request;
        response;
    }
    Core.GetOrderExportByID = GetOrderExportByID;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetOrderExportDocuments
     * @implements {EvaService}
     */
    class GetOrderExportDocuments {
        name = 'Core:GetOrderExportDocuments';
        path = '/message/GetOrderExportDocuments';
        request;
        response;
    }
    Core.GetOrderExportDocuments = GetOrderExportDocuments;
    /**
     * Gets the details of an OrderFulfillment, except for its Lines which can be paged in through ListOrderFulfillmentLines with a filter on OrderFulfillmentID.
     *
     * @export
     * @class GetOrderFulfillment
     * @implements {EvaService}
     */
    class GetOrderFulfillment {
        name = 'Core:GetOrderFulfillment';
        path = '/message/GetOrderFulfillment';
        request;
        response;
    }
    Core.GetOrderFulfillment = GetOrderFulfillment;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetOrderFulfillmentOptions
     * @implements {EvaService}
     */
    class GetOrderFulfillmentOptions {
        name = 'Core:GetOrderFulfillmentOptions';
        path = '/message/GetOrderFulfillmentOptions';
        request;
        response;
    }
    Core.GetOrderFulfillmentOptions = GetOrderFulfillmentOptions;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetOrderFulfillmentSupplierPerformance
     * @implements {EvaService}
     */
    class GetOrderFulfillmentSupplierPerformance {
        name = 'Core:GetOrderFulfillmentSupplierPerformance';
        path = '/message/GetOrderFulfillmentSupplierPerformance';
        request;
        response;
    }
    Core.GetOrderFulfillmentSupplierPerformance = GetOrderFulfillmentSupplierPerformance;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetOrderLinkTypeByID
     * @implements {EvaService}
     */
    class GetOrderLinkTypeByID {
        name = 'Core:GetOrderLinkTypeByID';
        path = '/message/GetOrderLinkTypeByID';
        request;
        response;
    }
    Core.GetOrderLinkTypeByID = GetOrderLinkTypeByID;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetOrderLinkTypes
     * @implements {EvaService}
     */
    class GetOrderLinkTypes {
        name = 'Core:GetOrderLinkTypes';
        path = '/message/GetOrderLinkTypes';
        request;
        response;
    }
    Core.GetOrderLinkTypes = GetOrderLinkTypes;
    /**
     * Return the current order links for the given order
     *
     * @export
     * @class GetOrderLinks
     * @implements {EvaService}
     */
    class GetOrderLinks {
        name = 'Core:GetOrderLinks';
        path = '/message/GetOrderLinks';
        request;
        response;
    }
    Core.GetOrderLinks = GetOrderLinks;
    /**
     * Get the signature for an Order
     *
     * @export
     * @class GetOrderSignature
     * @implements {EvaService}
     */
    class GetOrderSignature {
        name = 'Core:GetOrderSignature';
        path = '/message/GetOrderSignature';
        request;
        response;
    }
    Core.GetOrderSignature = GetOrderSignature;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetOrderStatistics
     * @implements {EvaService}
     */
    class GetOrderStatistics {
        name = 'Core:GetOrderStatistics';
        path = '/message/GetOrderStatistics';
        request;
        response;
    }
    Core.GetOrderStatistics = GetOrderStatistics;
    /**
     * Returns a summarized version of the order with less details than `GetOrder`. This service should be used to expose
less data to the frontend, also this variant to retrieve the order can be used when authenticated via the `GetTemporaryTokenForOrder`
service. Where `GetOrder` is not accessible.
     *
     * @export
     * @class GetOrderSummary
     * @implements {EvaService}
     */
    class GetOrderSummary {
        name = 'Core:GetOrderSummary';
        path = '/message/GetOrderSummary';
        request;
        response;
    }
    Core.GetOrderSummary = GetOrderSummary;
    /**
     * Get a summary of an Order to be used when a shipment will be made.

Caution: the ProductID is nullable, all non-cancelled lines are returned
     *
     * @export
     * @class GetOrderSummaryForShipping
     * @implements {EvaService}
     */
    class GetOrderSummaryForShipping {
        name = 'Core:GetOrderSummaryForShipping';
        path = '/message/GetOrderSummaryForShipping';
        request;
        response;
    }
    Core.GetOrderSummaryForShipping = GetOrderSummaryForShipping;
    /**
     * Get tax details on the specified order.
     *
     * @export
     * @class GetOrderTaxDetails
     * @implements {EvaService}
     */
    class GetOrderTaxDetails {
        name = 'Core:GetOrderTaxDetails';
        path = '/message/GetOrderTaxDetails';
        request;
        response;
    }
    Core.GetOrderTaxDetails = GetOrderTaxDetails;
    /**
     * Get order verification reason.
     *
     * @export
     * @class GetOrderVerificationReason
     * @implements {EvaService}
     */
    class GetOrderVerificationReason {
        name = 'Core:GetOrderVerificationReason';
        path = '/message/GetOrderVerificationReason';
        request;
        response;
    }
    Core.GetOrderVerificationReason = GetOrderVerificationReason;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetOrdersForReturnOrder
     * @implements {EvaService}
     */
    class GetOrdersForReturnOrder {
        name = 'Core:GetOrdersForReturnOrder';
        path = '/message/GetOrdersForReturnOrder';
        request;
        response;
    }
    Core.GetOrdersForReturnOrder = GetOrdersForReturnOrder;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetOrganizationUnit
     * @implements {EvaService}
     */
    class GetOrganizationUnit {
        name = 'Core:GetOrganizationUnit';
        path = '/message/GetOrganizationUnit';
        request;
        response;
    }
    Core.GetOrganizationUnit = GetOrganizationUnit;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetOrganizationUnitCreditBalance
     * @implements {EvaService}
     */
    class GetOrganizationUnitCreditBalance {
        name = 'Core:GetOrganizationUnitCreditBalance';
        path = '/message/GetOrganizationUnitCreditBalance';
        request;
        response;
    }
    Core.GetOrganizationUnitCreditBalance = GetOrganizationUnitCreditBalance;
    /**
     * Retrieve detailed organization unit information.
     *
     * @export
     * @class GetOrganizationUnitDetailed
     * @implements {EvaService}
     */
    class GetOrganizationUnitDetailed {
        name = 'Core:GetOrganizationUnitDetailed';
        path = '/message/GetOrganizationUnitDetailed';
        request;
        response;
    }
    Core.GetOrganizationUnitDetailed = GetOrganizationUnitDetailed;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetOrganizationUnitNotes
     * @implements {EvaService}
     */
    class GetOrganizationUnitNotes {
        name = 'Core:GetOrganizationUnitNotes';
        path = '/message/GetOrganizationUnitNotes';
        request;
        response;
    }
    Core.GetOrganizationUnitNotes = GetOrganizationUnitNotes;
    /**
     * Get flattened organization unit opening hours
     *
     * @export
     * @class GetOrganizationUnitOpeningHours
     * @implements {EvaService}
     */
    class GetOrganizationUnitOpeningHours {
        name = 'Core:GetOrganizationUnitOpeningHours';
        path = '/message/GetOrganizationUnitOpeningHours';
        request;
        response;
    }
    Core.GetOrganizationUnitOpeningHours = GetOrganizationUnitOpeningHours;
    /**
     * Gets the organization unit visiting opening hours for the given period.
     *
     * @export
     * @class GetOrganizationUnitOpeningHoursForPeriod
     * @implements {EvaService}
     */
    class GetOrganizationUnitOpeningHoursForPeriod {
        name = 'Core:GetOrganizationUnitOpeningHoursForPeriod';
        path = '/message/GetOrganizationUnitOpeningHoursForPeriod';
        request;
        response;
    }
    Core.GetOrganizationUnitOpeningHoursForPeriod = GetOrganizationUnitOpeningHoursForPeriod;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetOrganizationUnitSettings
     * @implements {EvaService}
     */
    class GetOrganizationUnitSettings {
        name = 'Core:GetOrganizationUnitSettings';
        path = '/message/GetOrganizationUnitSettings';
        request;
        response;
    }
    Core.GetOrganizationUnitSettings = GetOrganizationUnitSettings;
    /**
     * Returns a summary of a specific organizationunit. Since this service is publicly available, this will return minimal information (aka a summary) about the OU.
Service can also be called for archived organization units to fetch minimal information.
     *
     * @export
     * @class GetOrganizationUnitSummary
     * @implements {EvaService}
     */
    class GetOrganizationUnitSummary {
        name = 'Core:GetOrganizationUnitSummary';
        path = '/message/GetOrganizationUnitSummary';
        request;
        response;
    }
    Core.GetOrganizationUnitSummary = GetOrganizationUnitSummary;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetOrganizationUnitsForUser
     * @implements {EvaService}
     */
    class GetOrganizationUnitsForUser {
        name = 'Core:GetOrganizationUnitsForUser';
        path = '/message/GetOrganizationUnitsForUser';
        request;
        response;
    }
    Core.GetOrganizationUnitsForUser = GetOrganizationUnitsForUser;
    /**
     * Returns the full hierarchy of organization units, starting from the root and then containing a nested list of child OU's.
     *
     * @export
     * @class GetOrganizationUnitsHierarchy
     * @implements {EvaService}
     */
    class GetOrganizationUnitsHierarchy {
        name = 'Core:GetOrganizationUnitsHierarchy';
        path = '/message/GetOrganizationUnitsHierarchy';
        request;
        response;
    }
    Core.GetOrganizationUnitsHierarchy = GetOrganizationUnitsHierarchy;
    /**
     * As a logged in user, you can create a passkey as additional login method, which is a totally awesome, passwordless, usernameless method to log in!

Before you can create a new passkey, use this `GetPasskeyChallenge` service to obtain a challenge and some information from the server, push that through WebAuthn using
`navigator.credentials.create` to create the credential, which you use to call `CreatePasskey`.

:point_right: See `CreatePasskey` for more details!
     *
     * @export
     * @class GetPasskeyChallenge
     * @implements {EvaService}
     */
    class GetPasskeyChallenge {
        name = 'Core:GetPasskeyChallenge';
        path = '/message/GetPasskeyChallenge';
        request;
        response;
    }
    Core.GetPasskeyChallenge = GetPasskeyChallenge;
    /**
     * Retrieves some basic information about the current user's passkeys.
     *
     * @export
     * @class GetPasskeyInfo
     * @implements {EvaService}
     */
    class GetPasskeyInfo {
        name = 'Core:GetPasskeyInfo';
        path = '/message/GetPasskeyInfo';
        request;
        response;
    }
    Core.GetPasskeyInfo = GetPasskeyInfo;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetPaymentTransaction
     * @implements {EvaService}
     */
    class GetPaymentTransaction {
        name = 'Core:GetPaymentTransaction';
        path = '/message/GetPaymentTransaction';
        request;
        response;
    }
    Core.GetPaymentTransaction = GetPaymentTransaction;
    /**
     * Get the PaymentTransactions attached to the given Invoice

The response also includes an object `AvailableActions`:
- Cancel: can the payment be cancelled
- Refund: can the payment be refunded
- Update: can an update for this payment be requested
- Approve: can the payment be approved
     *
     * @export
     * @class GetPaymentTransactionsForInvoice
     * @implements {EvaService}
     */
    class GetPaymentTransactionsForInvoice {
        name = 'Core:GetPaymentTransactionsForInvoice';
        path = '/message/GetPaymentTransactionsForInvoice';
        request;
        response;
    }
    Core.GetPaymentTransactionsForInvoice = GetPaymentTransactionsForInvoice;
    /**
     * Get the PaymentTransactions attached to the given Order

The response also includes an object `AvailableActions`:
- Cancel: can the payment be cancelled
- Refund: can the payment be refunded
- Update: can an update for this payment be requested
- Approve: can the payment be approved
     *
     * @export
     * @class GetPaymentTransactionsForOrder
     * @implements {EvaService}
     */
    class GetPaymentTransactionsForOrder {
        name = 'Core:GetPaymentTransactionsForOrder';
        path = '/message/GetPaymentTransactionsForOrder';
        request;
        response;
    }
    Core.GetPaymentTransactionsForOrder = GetPaymentTransactionsForOrder;
    /**
     * Returns the quantity that is to be shipped for order lines. Includes pending shipments.
     *
     * @export
     * @class GetPendingShipmentInformationForOrderLines
     * @implements {EvaService}
     */
    class GetPendingShipmentInformationForOrderLines {
        name = 'Core:GetPendingShipmentInformationForOrderLines';
        path = '/message/GetPendingShipmentInformationForOrderLines';
        request;
        response;
    }
    Core.GetPendingShipmentInformationForOrderLines = GetPendingShipmentInformationForOrderLines;
    /**
     * Get the PickProductDiscountOptions for an Order

For each line there is an object with the options:
- Options: the available products to choose from
- CurrentSelection: the currently selected product
- CurrentTier: the current tier of the discount
- BaseAmount: the amount used to determine the tiers
- Tiers:
 - ID
 - Description
 - From: The amount at which this tier is available
 - Difference: The amount that should be added to be eligable for this tier
 - DefaultProductID: The product that should be selected by default when hitting this tier
 - Prompt: Should the frontend show a prompt to pick a product?
 - ProductIDs: The avaialble products in this tier
 - IsCurrentTier: Is this tier the current one?
     *
     * @export
     * @class GetPickProductDiscountOptionsForOrder
     * @implements {EvaService}
     */
    class GetPickProductDiscountOptionsForOrder {
        name = 'Core:GetPickProductDiscountOptionsForOrder';
        path = '/message/GetPickProductDiscountOptionsForOrder';
        request;
        response;
    }
    Core.GetPickProductDiscountOptionsForOrder = GetPickProductDiscountOptionsForOrder;
    /**
     * Get the PickProductDiscountOptions for an OrderLine

See: `GetPickProductDiscountOptionsForOrder`
     *
     * @export
     * @class GetPickProductDiscountOptionsForOrderLine
     * @implements {EvaService}
     */
    class GetPickProductDiscountOptionsForOrderLine {
        name = 'Core:GetPickProductDiscountOptionsForOrderLine';
        path = '/message/GetPickProductDiscountOptionsForOrderLine';
        request;
        response;
    }
    Core.GetPickProductDiscountOptionsForOrderLine = GetPickProductDiscountOptionsForOrderLine;
    /**
     * This service returns the bundles for which you currently have at least one product in the provided order.
This can then be used to suggest bundles to the end-user that they're missing out on.

The IncludedFields field controls which product content you get back for each bundle product. By default, only the product's display value is returned.

Specifying the ProductIDs field means that only suggestions for the given products are returned.
If the Order does not contain the provided ProductIDs, nothing will be returned.
     *
     * @export
     * @class GetPotentialBundleProductsForOrder
     * @implements {EvaService}
     */
    class GetPotentialBundleProductsForOrder {
        name = 'Core:GetPotentialBundleProductsForOrder';
        path = '/message/GetPotentialBundleProductsForOrder';
        request;
        response;
    }
    Core.GetPotentialBundleProductsForOrder = GetPotentialBundleProductsForOrder;
    /**
     * List the discounts that potentially could be activated.
When an `Order` is given, identified by `OrderID`, the discounts will be based on the ordercontext. That will include possibly User specific discounts etc.
If a `ProductID` is set, also discounts that will be triggered when that Product is added to the current Order will be returned.

It is required to supply an Order a Product or both.
     *
     * @export
     * @class GetPotentialDiscountsForOrder
     * @implements {EvaService}
     */
    class GetPotentialDiscountsForOrder {
        name = 'Core:GetPotentialDiscountsForOrder';
        path = '/message/GetPotentialDiscountsForOrder';
        request;
        response;
    }
    Core.GetPotentialDiscountsForOrder = GetPotentialDiscountsForOrder;
    /**
     * List the discounts that potentially could be activated.
This service has the same behavior as the `GetPotentialDiscountsForOrder`, only in this service the discounts are not calculated based on one `ProductID`, but on the result of a `ProductSearch` request.
This creates the possibility to fire a `ProductSearch` and a `GetPotentialDiscountsForProductSearch` at the same time.
     *
     * @export
     * @class GetPotentialDiscountsForProductSearch
     * @implements {EvaService}
     */
    class GetPotentialDiscountsForProductSearch {
        name = 'Core:GetPotentialDiscountsForProductSearch';
        path = '/message/GetPotentialDiscountsForProductSearch';
        request;
        response;
    }
    Core.GetPotentialDiscountsForProductSearch = GetPotentialDiscountsForProductSearch;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetPotentialProductPricing
     * @implements {EvaService}
     */
    class GetPotentialProductPricing {
        name = 'Core:GetPotentialProductPricing';
        path = '/message/GetPotentialProductPricing';
        request;
        response;
    }
    Core.GetPotentialProductPricing = GetPotentialProductPricing;
    /**
     * Retrieves a pre-picked ShipFromStoreTask based on a product ID.
Optionally filters by a ConsolidatedPickTask ID or defaults to the latest done, stopped, or paused task.
     *
     * @export
     * @class GetPrePickedShipFromStoreTask
     * @implements {EvaService}
     */
    class GetPrePickedShipFromStoreTask {
        name = 'Core:GetPrePickedShipFromStoreTask';
        path = '/message/GetPrePickedShipFromStoreTask';
        request;
        response;
    }
    Core.GetPrePickedShipFromStoreTask = GetPrePickedShipFromStoreTask;
    /**
     * Get the selected preferred refund method to use when this order will be refunded.

See SetPreferredRefundMethod for more information.
     *
     * @export
     * @class GetPreferredRefundMethod
     * @implements {EvaService}
     */
    class GetPreferredRefundMethod {
        name = 'Core:GetPreferredRefundMethod';
        path = '/message/GetPreferredRefundMethod';
        request;
        response;
    }
    Core.GetPreferredRefundMethod = GetPreferredRefundMethod;
    /**
     * This service returns information about product availability.
     *
     * @export
     * @class GetProductAvailability
     * @implements {EvaService}
     */
    class GetProductAvailability {
        name = 'Core:GetProductAvailability';
        path = '/message/GetProductAvailability';
        request;
        response;
    }
    Core.GetProductAvailability = GetProductAvailability;
    /**
     * This service is used to fetch a `ProductBundle` by its ID. The requested bundle will be returned with its lines and for each line, its options.
     *
     * @export
     * @class GetProductBundle
     * @implements {EvaService}
     */
    class GetProductBundle {
        name = 'Core:GetProductBundle';
        path = '/message/GetProductBundle';
        request;
        response;
    }
    Core.GetProductBundle = GetProductBundle;
    /**
     * Get product details by id
     *
     * @export
     * @class GetProductDetail
     * @implements {EvaService}
     */
    class GetProductDetail {
        name = 'Core:GetProductDetail';
        path = '/message/GetProductDetail';
        request;
        response;
    }
    Core.GetProductDetail = GetProductDetail;
    /**
     * This service is used to list prices associated with the products determined by IDs.

Price - this value has TaxRate applied
PriceInTax - value without TaxRate

A product has more associated prices with different usage types, e.g. Cost, Sales..

Request e.g.:
{
  "ProductIDs": [
    "productId1",
    "productId2"
  ]
}
     *
     * @export
     * @class GetProductPrices
     * @implements {EvaService}
     */
    class GetProductPrices {
        name = 'Core:GetProductPrices';
        path = '/message/GetProductPrices';
        request;
        response;
    }
    Core.GetProductPrices = GetProductPrices;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetProductPricing
     * @implements {EvaService}
     */
    class GetProductPricing {
        name = 'Core:GetProductPricing';
        path = '/message/GetProductPricing';
        request;
        response;
    }
    Core.GetProductPricing = GetProductPricing;
    /**
     * Get product relations by product id
     *
     * @export
     * @class GetProductRelations
     * @implements {EvaService}
     */
    class GetProductRelations {
        name = 'Core:GetProductRelations';
        path = '/message/GetProductRelations';
        request;
        response;
    }
    Core.GetProductRelations = GetProductRelations;
    /**
     * List all ProductRequirement values for an Order
     *
     * @export
     * @class GetProductRequirementValuesForOrder
     * @implements {EvaService}
     */
    class GetProductRequirementValuesForOrder {
        name = 'Core:GetProductRequirementValuesForOrder';
        path = '/message/GetProductRequirementValuesForOrder';
        request;
        response;
    }
    Core.GetProductRequirementValuesForOrder = GetProductRequirementValuesForOrder;
    /**
     * List all ProductRequirement values for an OrderLine
     *
     * @export
     * @class GetProductRequirementValuesForOrderLine
     * @implements {EvaService}
     */
    class GetProductRequirementValuesForOrderLine {
        name = 'Core:GetProductRequirementValuesForOrderLine';
        path = '/message/GetProductRequirementValuesForOrderLine';
        request;
        response;
    }
    Core.GetProductRequirementValuesForOrderLine = GetProductRequirementValuesForOrderLine;
    /**
     * Calculates the run-rates for the provided products for the provided warehouse OrganizationUnit, based on a date (`Since`).

The run-rates are returned per SoldFromOrganizationUnit.
     *
     * @export
     * @class GetProductRunRates
     * @implements {EvaService}
     */
    class GetProductRunRates {
        name = 'Core:GetProductRunRates';
        path = '/message/GetProductRunRates';
        request;
        response;
    }
    Core.GetProductRunRates = GetProductRunRates;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetProductSearchSuggestions
     * @implements {EvaService}
     */
    class GetProductSearchSuggestions {
        name = 'Core:GetProductSearchSuggestions';
        path = '/message/GetProductSearchSuggestions';
        request;
        response;
    }
    Core.GetProductSearchSuggestions = GetProductSearchSuggestions;
    /**
     * Retrieve the structure of products by `Code` (and for given `LanguageID`/`CountryID`).
     *
     * @export
     * @class GetProductStructure
     * @implements {EvaService}
     */
    class GetProductStructure {
        name = 'Core:GetProductStructure';
        path = '/message/GetProductStructure';
        request;
        response;
    }
    Core.GetProductStructure = GetProductStructure;
    /**
     * Get the supplier product info for a set of product IDs (not supplier product IDs) and the optional supplier OU.
     *
     * @export
     * @class GetProductSupplierInfoForProducts
     * @implements {EvaService}
     */
    class GetProductSupplierInfoForProducts {
        name = 'Core:GetProductSupplierInfoForProducts';
        path = '/message/GetProductSupplierInfoForProducts';
        request;
        response;
    }
    Core.GetProductSupplierInfoForProducts = GetProductSupplierInfoForProducts;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetProductUnitOfMeasureQuantities
     * @implements {EvaService}
     */
    class GetProductUnitOfMeasureQuantities {
        name = 'Core:GetProductUnitOfMeasureQuantities';
        path = '/message/GetProductUnitOfMeasureQuantities';
        request;
        response;
    }
    Core.GetProductUnitOfMeasureQuantities = GetProductUnitOfMeasureQuantities;
    /**
     * Get product warranty information by making a request to an endpoint set with the 'Product:WarrantyEndpoint' setting.

If 'SerialNumber' is not set in the request, we'll try to get it using the 'OrderLineID', so at least one or the other must be present and valid.
     *
     * @export
     * @class GetProductWarranty
     * @implements {EvaService}
     */
    class GetProductWarranty {
        name = 'Core:GetProductWarranty';
        path = '/message/GetProductWarranty';
        request;
        response;
    }
    Core.GetProductWarranty = GetProductWarranty;
    /**
     * Retrieves a ProductZone by its ID
     *
     * @export
     * @class GetProductZone
     * @implements {EvaService}
     */
    class GetProductZone {
        name = 'Core:GetProductZone';
        path = '/message/GetProductZone';
        request;
        response;
    }
    Core.GetProductZone = GetProductZone;
    /**
     * Retrieves a ProductZoneGroup by its ID
     *
     * @export
     * @class GetProductZoneGroup
     * @implements {EvaService}
     */
    class GetProductZoneGroup {
        name = 'Core:GetProductZoneGroup';
        path = '/message/GetProductZoneGroup';
        request;
        response;
    }
    Core.GetProductZoneGroup = GetProductZoneGroup;
    /**
     * Fetch one or more products by ID.
     *
     * @export
     * @class GetProducts
     * @implements {EvaService}
     */
    class GetProducts {
        name = 'Core:GetProducts';
        path = '/message/GetProducts';
        request;
        response;
    }
    Core.GetProducts = GetProducts;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetPurchaseOrderShipment
     * @implements {EvaService}
     */
    class GetPurchaseOrderShipment {
        name = 'Core:GetPurchaseOrderShipment';
        path = '/message/GetPurchaseOrderShipment';
        request;
        response;
    }
    Core.GetPurchaseOrderShipment = GetPurchaseOrderShipment;
    /**
     * Calculate and return the current `QuantityOnHand` for supplied `ProductID`s on given organization unit.

Returns a dictionary with `ProductID` as key, and the `QuantityOnHand` as value.
     *
     * @export
     * @class GetQuantityOnHandForProducts
     * @implements {EvaService}
     */
    class GetQuantityOnHandForProducts {
        name = 'Core:GetQuantityOnHandForProducts';
        path = '/message/GetQuantityOnHandForProducts';
        request;
        response;
    }
    Core.GetQuantityOnHandForProducts = GetQuantityOnHandForProducts;
    /**
     * Service for retrieving an existing `QuickBuy` by ID
     *
     * @export
     * @class GetQuickBuy
     * @implements {EvaService}
     */
    class GetQuickBuy {
        name = 'Core:GetQuickBuy';
        path = '/message/GetQuickBuy';
        request;
        response;
    }
    Core.GetQuickBuy = GetQuickBuy;
    /**
     * Service for retrieving an list of `QuickBuy` options
     *
     * @export
     * @class GetQuickBuyOptions
     * @implements {EvaService}
     */
    class GetQuickBuyOptions {
        name = 'Core:GetQuickBuyOptions';
        path = '/message/GetQuickBuyOptions';
        request;
        response;
    }
    Core.GetQuickBuyOptions = GetQuickBuyOptions;
    /**
     * Service for retrieving an list of `QuickBuy`
     *
     * @export
     * @class GetQuickBuys
     * @implements {EvaService}
     */
    class GetQuickBuys {
        name = 'Core:GetQuickBuys';
        path = '/message/GetQuickBuys';
        request;
        response;
    }
    Core.GetQuickBuys = GetQuickBuys;
    /**
     * Get the logging of the run of a recurring task.
     *
     * @export
     * @class GetRecurringTaskLogging
     * @implements {EvaService}
     */
    class GetRecurringTaskLogging {
        name = 'Core:GetRecurringTaskLogging';
        path = '/message/GetRecurringTaskLogging';
        request;
        response;
    }
    Core.GetRecurringTaskLogging = GetRecurringTaskLogging;
    /**
     * Get the list of runs for a recurring task.
     *
     * @export
     * @class GetRecurringTaskRuns
     * @implements {EvaService}
     */
    class GetRecurringTaskRuns {
        name = 'Core:GetRecurringTaskRuns';
        path = '/message/GetRecurringTaskRuns';
        request;
        response;
    }
    Core.GetRecurringTaskRuns = GetRecurringTaskRuns;
    /**
     * Get all refund reasons available in the current context
     *
     * @export
     * @class GetRefundCorrectionReasons
     * @implements {EvaService}
     */
    class GetRefundCorrectionReasons {
        name = 'Core:GetRefundCorrectionReasons';
        path = '/message/GetRefundCorrectionReasons';
        request;
        response;
    }
    Core.GetRefundCorrectionReasons = GetRefundCorrectionReasons;
    /**
     * List all the related orderlines for the given OrderLineID.

The orderlines will be sorted by CreationTime.
     *
     * @export
     * @class GetRelatedOrderLines
     * @implements {EvaService}
     */
    class GetRelatedOrderLines {
        name = 'Core:GetRelatedOrderLines';
        path = '/message/GetRelatedOrderLines';
        request;
        response;
    }
    Core.GetRelatedOrderLines = GetRelatedOrderLines;
    /**
     * Get all the related orders for the given OrderID.

The orders will be sorted by CreationTime.
     *
     * @export
     * @class GetRelatedOrders
     * @implements {EvaService}
     */
    class GetRelatedOrders {
        name = 'Core:GetRelatedOrders';
        path = '/message/GetRelatedOrders';
        request;
        response;
    }
    Core.GetRelatedOrders = GetRelatedOrders;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetRepair
     * @implements {EvaService}
     */
    class GetRepair {
        name = 'Core:GetRepair';
        path = '/message/GetRepair';
        request;
        response;
    }
    Core.GetRepair = GetRepair;
    /**
     * Get the required data for the order
     *
     * @export
     * @class GetRequiredDataForOrder
     * @implements {EvaService}
     */
    class GetRequiredDataForOrder {
        name = 'Core:GetRequiredDataForOrder';
        path = '/message/GetRequiredDataForOrder';
        request;
        response;
    }
    Core.GetRequiredDataForOrder = GetRequiredDataForOrder;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetRequiredOrganizationUnitFields
     * @implements {EvaService}
     */
    class GetRequiredOrganizationUnitFields {
        name = 'Core:GetRequiredOrganizationUnitFields';
        path = '/message/GetRequiredOrganizationUnitFields';
        request;
        response;
    }
    Core.GetRequiredOrganizationUnitFields = GetRequiredOrganizationUnitFields;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetReturnOrdersForOrder
     * @implements {EvaService}
     */
    class GetReturnOrdersForOrder {
        name = 'Core:GetReturnOrdersForOrder';
        path = '/message/GetReturnOrdersForOrder';
        request;
        response;
    }
    Core.GetReturnOrdersForOrder = GetReturnOrdersForOrder;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetReturnToSupplierData
     * @implements {EvaService}
     */
    class GetReturnToSupplierData {
        name = 'Core:GetReturnToSupplierData';
        path = '/message/GetReturnToSupplierData';
        request;
        response;
    }
    Core.GetReturnToSupplierData = GetReturnToSupplierData;
    /**
     * Get a ReturnToSupplierRequest
     *
     * @export
     * @class GetReturnToSupplierRequestByID
     * @implements {EvaService}
     */
    class GetReturnToSupplierRequestByID {
        name = 'Core:GetReturnToSupplierRequestByID';
        path = '/message/GetReturnToSupplierRequestByID';
        request;
        response;
    }
    Core.GetReturnToSupplierRequestByID = GetReturnToSupplierRequestByID;
    /**
     * Gets whether or not an Order is currently returnable.

For each OrderLine on the Order you'll get back a result that specifies whether or not it can be returned,
how much can be returned and which (if any) other OrderLines must be returned before the line itself can be returned
(think of parent-child lines where you can't return a child OrderLine without also returning the parent OrderLine).

In addition, this service may return `ReturnSets` which specify that 'if you return these OrderLines (specified by `OrderLineIDs`) then
you must *also* return these lines (specified by `RequiredOrderLineIDsToReturn`). For example, if you return all normal OrderLines on an Order
then you must also return all the free products you have received.

Finally, specify the `ReturningQuantities` parameter as an object where the key is an `OrderLineID` with a (positive) `Quantity` you wish to be
returned. The `Result` can be affected in case rules have been configured to, for example, allow _returns without products_ only when the total
return order amount is below a certain amount.
     *
     * @export
     * @class GetReturnableStatusForOrder
     * @implements {EvaService}
     */
    class GetReturnableStatusForOrder {
        name = 'Core:GetReturnableStatusForOrder';
        path = '/message/GetReturnableStatusForOrder';
        request;
        response;
    }
    Core.GetReturnableStatusForOrder = GetReturnableStatusForOrder;
    /**
     * Will return the estimated tax for specified order, but does not persist through the order amounts retrieved elsewhere.
     *
     * @export
     * @class GetSalesTaxEstimateForOrder
     * @implements {EvaService}
     */
    class GetSalesTaxEstimateForOrder {
        name = 'Core:GetSalesTaxEstimateForOrder';
        path = '/message/GetSalesTaxEstimateForOrder';
        request;
        response;
    }
    Core.GetSalesTaxEstimateForOrder = GetSalesTaxEstimateForOrder;
    /**
     * Gets a script by ID
     *
     * @export
     * @class GetScript
     * @implements {EvaService}
     */
    class GetScript {
        name = 'Core:GetScript';
        path = '/message/GetScript';
        request;
        response;
    }
    Core.GetScript = GetScript;
    /**
     * Returns all available dialects
     *
     * @export
     * @class GetScriptDialects
     * @implements {EvaService}
     */
    class GetScriptDialects {
        name = 'Core:GetScriptDialects';
        path = '/message/GetScriptDialects';
        request;
        response;
    }
    Core.GetScriptDialects = GetScriptDialects;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetScriptExtensionPoints
     * @implements {EvaService}
     */
    class GetScriptExtensionPoints {
        name = 'Core:GetScriptExtensionPoints';
        path = '/message/GetScriptExtensionPoints';
        request;
        response;
    }
    Core.GetScriptExtensionPoints = GetScriptExtensionPoints;
    /**
     * Gets information about a serial number
     *
     * @export
     * @class GetSerialNumber
     * @implements {EvaService}
     */
    class GetSerialNumber {
        name = 'Core:GetSerialNumber';
        path = '/message/GetSerialNumber';
        request;
        response;
    }
    Core.GetSerialNumber = GetSerialNumber;
    /**
     * Get all Serial Number Configurations, without paging.
     *
     * @export
     * @class GetSerialNumberConfigurations
     * @implements {EvaService}
     */
    class GetSerialNumberConfigurations {
        name = 'Core:GetSerialNumberConfigurations';
        path = '/message/GetSerialNumberConfigurations';
        request;
        response;
    }
    Core.GetSerialNumberConfigurations = GetSerialNumberConfigurations;
    /**
     * Shows in which OU sets an OU is included.
     *
     * @export
     * @class GetSetsByOrganizationUnit
     * @implements {EvaService}
     */
    class GetSetsByOrganizationUnit {
        name = 'Core:GetSetsByOrganizationUnit';
        path = '/message/GetSetsByOrganizationUnit';
        request;
        response;
    }
    Core.GetSetsByOrganizationUnit = GetSetsByOrganizationUnit;
    /**
     * Gets an active ShipFromStore type User Task for your store, that contains a product with specified `Barcode`.

Use the optional `DeterminationType` to indicate if you prefer the `Oldest`, `Smallest` or `Largest` task that contains your product.
     *
     * @export
     * @class GetShipFromStoreTaskByBarcode
     * @implements {EvaService}
     */
    class GetShipFromStoreTaskByBarcode {
        name = 'Core:GetShipFromStoreTaskByBarcode';
        path = '/message/GetShipFromStoreTaskByBarcode';
        request;
        response;
    }
    Core.GetShipFromStoreTaskByBarcode = GetShipFromStoreTaskByBarcode;
    /**
     * Get a Shipment by its ID, returning information about where it came from, where it's shipped to, its shipping or delivery status and payment status
of the order(s) contained in the shipment.
     *
     * @export
     * @class GetShipment
     * @implements {EvaService}
     */
    class GetShipment {
        name = 'Core:GetShipment';
        path = '/message/GetShipment';
        request;
        response;
    }
    Core.GetShipment = GetShipment;
    /**
     * Get details of a shipment to receive, either by `ID` or by `BackendID`/`OrganizationUnitID` combination.
     *
     * @export
     * @class GetShipmentDetails
     * @implements {EvaService}
     */
    class GetShipmentDetails {
        name = 'Core:GetShipmentDetails';
        path = '/message/GetShipmentDetails';
        request;
        response;
    }
    Core.GetShipmentDetails = GetShipmentDetails;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetShipmentExportByID
     * @implements {EvaService}
     */
    class GetShipmentExportByID {
        name = 'Core:GetShipmentExportByID';
        path = '/message/GetShipmentExportByID';
        request;
        response;
    }
    Core.GetShipmentExportByID = GetShipmentExportByID;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetShipmentExportDocuments
     * @implements {EvaService}
     */
    class GetShipmentExportDocuments {
        name = 'Core:GetShipmentExportDocuments';
        path = '/message/GetShipmentExportDocuments';
        request;
        response;
    }
    Core.GetShipmentExportDocuments = GetShipmentExportDocuments;
    /**
     * Get a shipment identifier by ID.
     *
     * @export
     * @class GetShipmentIdentifier
     * @implements {EvaService}
     */
    class GetShipmentIdentifier {
        name = 'Core:GetShipmentIdentifier';
        path = '/message/GetShipmentIdentifier';
        request;
        response;
    }
    Core.GetShipmentIdentifier = GetShipmentIdentifier;
    /**
     * Get an existing ShipmentReceipt
     *
     * @export
     * @class GetShipmentReceipt
     * @implements {EvaService}
     */
    class GetShipmentReceipt {
        name = 'Core:GetShipmentReceipt';
        path = '/message/GetShipmentReceipt';
        request;
        response;
    }
    Core.GetShipmentReceipt = GetShipmentReceipt;
    /**
     * @see: SetShipmentSettings
     *
     * @export
     * @class GetShipmentSettings
     * @implements {EvaService}
     */
    class GetShipmentSettings {
        name = 'Core:GetShipmentSettings';
        path = '/message/GetShipmentSettings';
        request;
        response;
    }
    Core.GetShipmentSettings = GetShipmentSettings;
    /**
     * Returns all of the shipping methods that are being used on the order.
     *
     * @export
     * @class GetShippingMethodsForOrder
     * @implements {EvaService}
     */
    class GetShippingMethodsForOrder {
        name = 'Core:GetShippingMethodsForOrder';
        path = '/message/GetShippingMethodsForOrder';
        request;
        response;
    }
    Core.GetShippingMethodsForOrder = GetShippingMethodsForOrder;
    /**
     * This returns the requested order. The order is retreived based on the OrderID.

The order will be recalculated:
- Discounts
- ShippingCosts
- GiftWrappingCosts
- OrderLine prices

If no recalculation is needed, use the GetOrder service instead. In general the approach would be: use GetShoppingCart while building the order, after PrepareOrderForCheckout has been called, switch to GetOrder.

To include the result of `GetRequiredDataForOrder`, the property `AdditionalOrderDataOptions.RequiredFor` can be set to the desired level of requirements.
To include the result of `GetProductRequirementValuesForOrder`, the property `AdditionalOrderDataOptions.IncludeProductRequirements` can be set to `true`.
To include the result of `GetGiftWrappingOptionsForOrder` and `GetAvailableGiftWrappingLinesForOrder`, the property `AdditionalOrderDataOptions.IncludeGiftWrapping` can be set to `true`.
To include the result of `PrefigureDiscounts` and `GetPotentialDiscountsForOrder`, the property `AdditionalOrderDataOptions.IncludePrefigureDiscounts` can be set to `true`.
To include the result of `GetPickProductDiscountOptionsForOrder`, the property `AdditionalOrderDataOptions.IncludePickProductOptions` can be set to `true`.
To include the result of `ListAvailableShippingMethods`, the property `AdditionalOrderDataOptions.IncludeAvailableShippingMethods` can be set to `true`.
To include the result of `GetAvailablePaymentMethods`, the property `AdditionalOrderDataOptions.IncludeAvailablePaymentMethods` can be set to `true`.
To include the result of `GetAvailableRefundPaymentMethodsForOrder`, the property `AdditionalOrderDataOptions.IncludeAvailableRefundPaymentMethods` can be set to `true`.
To include the result of `ValidateOrderShipment`, the property `AdditionalOrderDataOptions.IncludeValidateShipment` can be set to `true`.
To include the available actions for the PaymentTransactions, the property `AdditionalOrderDataOptions.IncludePaymentTransactionActions` can be set to `true`.
     *
     * @export
     * @class GetShoppingCart
     * @implements {EvaService}
     */
    class GetShoppingCart {
        name = 'Core:GetShoppingCart';
        path = '/message/GetShoppingCart';
        request;
        response;
    }
    Core.GetShoppingCart = GetShoppingCart;
    /**
     * Fetch the summary of an Order. This summary contains:
- QuantityOrdered: the total count of products in the Order
- TotalAmount: the total amount of the Order
- ForeignTotalAmount: the total amount of the Order in the foreign currency
- CurrencyID: the currency of the Order

It is required to supply an OrderID
     *
     * @export
     * @class GetShoppingCartInfo
     * @implements {EvaService}
     */
    class GetShoppingCartInfo {
        name = 'Core:GetShoppingCartInfo';
        path = '/message/GetShoppingCartInfo';
        request;
        response;
    }
    Core.GetShoppingCartInfo = GetShoppingCartInfo;
    /**
     * Returns stores in proximity of a set of coordinates.

If `ProductID` and `HasStock` is set, only the stores with stock for that product will be returned.
     *
     * @export
     * @class GetShopsByProximity
     * @implements {EvaService}
     */
    class GetShopsByProximity {
        name = 'Core:GetShopsByProximity';
        path = '/message/GetShopsByProximity';
        request;
        response;
    }
    Core.GetShopsByProximity = GetShopsByProximity;
    /**
     * Service for retieving a existing `Station`
     *
     * @export
     * @class GetStation
     * @implements {EvaService}
     */
    class GetStation {
        name = 'Core:GetStation';
        path = '/message/GetStation';
        request;
        response;
    }
    Core.GetStation = GetStation;
    /**
     * Gets the status of the pre-counts of a cyclecount, if any. The input for this service is either the ID of the main count task (`ZonedCycleCountUserTaskID`)
or the ID of a pre-count task (`PreCountUserTaskID`). If `PreCountUserTaskID` is specified, it returns the status of the sibling pre-counts.
     *
     * @export
     * @class GetStatusForZonedCycleCountPreCounts
     * @implements {EvaService}
     */
    class GetStatusForZonedCycleCountPreCounts {
        name = 'Core:GetStatusForZonedCycleCountPreCounts';
        path = '/message/GetStatusForZonedCycleCountPreCounts';
        request;
        response;
    }
    Core.GetStatusForZonedCycleCountPreCounts = GetStatusForZonedCycleCountPreCounts;
    /**
     * Calculates the stock availability for the provided OrderLines that are part of the provided Order.

The return value of this service is a list that contains, per OrderLine, whether or not it can be fulfilled (`CanBeFulfilled`) on the `RequestedDate`.

When an OrderLine doesn't already have a RequestedDate, a RequestedDate of tomorrow is used.

Additionally, a list of AlternativeDates is returned per OrderLine with dates on which it is expected that the OrderLine can be fulfilled.

When OrderLineIDs is left empty, this service will return an estimate for all unshipped lines of the order.

Doesn't work for orders with more than 25 lines.
     *
     * @export
     * @class GetStockAvailabilityEstimateForOrder
     * @implements {EvaService}
     */
    class GetStockAvailabilityEstimateForOrder {
        name = 'Core:GetStockAvailabilityEstimateForOrder';
        path = '/message/GetStockAvailabilityEstimateForOrder';
        request;
        response;
    }
    Core.GetStockAvailabilityEstimateForOrder = GetStockAvailabilityEstimateForOrder;
    /**
     * Given a set of products this service returns a detailed estimate for each product when it's expected to be available.
     *
     * @export
     * @class GetStockAvailabilityEstimateForProducts
     * @implements {EvaService}
     */
    class GetStockAvailabilityEstimateForProducts {
        name = 'Core:GetStockAvailabilityEstimateForProducts';
        path = '/message/GetStockAvailabilityEstimateForProducts';
        request;
        response;
    }
    Core.GetStockAvailabilityEstimateForProducts = GetStockAvailabilityEstimateForProducts;
    /**
     * Returns the expected availability timeline for the provided `ProductIDs`, from the perspective of the provided `OrganizationUnitID` (optional, defaults to the user's current OrganizationUnitID).

The timeline is ordered chronologically and includes all events that are relevant to the availability of the requested products, including events that happen on the suppliers of the requested OrganizationUnit (such as PurchaseOrder receipts).

Additionally, a `FromDate` (inclusive) and `ToDate` (exclusive) can be used to filter the response by date and a `Type` can be provided to only return timeline items of a certain type.
     *
     * @export
     * @class GetStockAvailabilityTimeline
     * @implements {EvaService}
     */
    class GetStockAvailabilityTimeline {
        name = 'Core:GetStockAvailabilityTimeline';
        path = '/message/GetStockAvailabilityTimeline';
        request;
        response;
    }
    Core.GetStockAvailabilityTimeline = GetStockAvailabilityTimeline;
    /**
     * Requests the stock per stock label, per product for the given organization unit. If there is no stock at all for a product the product is not
returned in the response.
     *
     * @export
     * @class GetStockByStockLabelForProducts
     * @implements {EvaService}
     */
    class GetStockByStockLabelForProducts {
        name = 'Core:GetStockByStockLabelForProducts';
        path = '/message/GetStockByStockLabelForProducts';
        request;
        response;
    }
    Core.GetStockByStockLabelForProducts = GetStockByStockLabelForProducts;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetStockDetailsForProduct
     * @implements {EvaService}
     */
    class GetStockDetailsForProduct {
        name = 'Core:GetStockDetailsForProduct';
        path = '/message/GetStockDetailsForProduct';
        request;
        response;
    }
    Core.GetStockDetailsForProduct = GetStockDetailsForProduct;
    /**
     * Returns all organizationunits with the configured setting for a single stocklabel.

Every organizationunit that has any setting set for the stocklabel will be returned.
If an organizationunit has no setting for a specific feature, it will inherit the setting from it’s parent, this is indicated by the `IsInherited` property.
     *
     * @export
     * @class GetStockLabelSettingsForLabel
     * @implements {EvaService}
     */
    class GetStockLabelSettingsForLabel {
        name = 'Core:GetStockLabelSettingsForLabel';
        path = '/message/GetStockLabelSettingsForLabel';
        request;
        response;
    }
    Core.GetStockLabelSettingsForLabel = GetStockLabelSettingsForLabel;
    /**
     * Get stock labels
     *
     * @export
     * @class GetStockLabels
     * @implements {EvaService}
     */
    class GetStockLabels {
        name = 'Core:GetStockLabels';
        path = '/message/GetStockLabels';
        request;
        response;
    }
    Core.GetStockLabels = GetStockLabels;
    /**
     * Returns all stocklabels with the configured setting for a single organizationunit.
     *
     * @export
     * @class GetStockLabelsForFeature
     * @implements {EvaService}
     */
    class GetStockLabelsForFeature {
        name = 'Core:GetStockLabelsForFeature';
        path = '/message/GetStockLabelsForFeature';
        request;
        response;
    }
    Core.GetStockLabelsForFeature = GetStockLabelsForFeature;
    /**
     * Retrieve a StockNotification for a product and organization, for an EmailAddress - will return its ID, or null when it does not exist.
     *
     * @export
     * @class GetStockNotification
     * @implements {EvaService}
     */
    class GetStockNotification {
        name = 'Core:GetStockNotification';
        path = '/message/GetStockNotification';
        request;
        response;
    }
    Core.GetStockNotification = GetStockNotification;
    /**
     * Retrieve a StockNotification for a product and organization, for the current user - will return its ID, or null when it does not exist.
     *
     * @export
     * @class GetStockNotificationForCurrentUser
     * @implements {EvaService}
     */
    class GetStockNotificationForCurrentUser {
        name = 'Core:GetStockNotificationForCurrentUser';
        path = '/message/GetStockNotificationForCurrentUser';
        request;
        response;
    }
    Core.GetStockNotificationForCurrentUser = GetStockNotificationForCurrentUser;
    /**
     * Get the additional Stock Replenishment task data.
     *
     * @export
     * @class GetStockReplenishmentTaskData
     * @implements {EvaService}
     */
    class GetStockReplenishmentTaskData {
        name = 'Core:GetStockReplenishmentTaskData';
        path = '/message/GetStockReplenishmentTaskData';
        request;
        response;
    }
    Core.GetStockReplenishmentTaskData = GetStockReplenishmentTaskData;
    /**
     * Get the configured zones for your current organization unit.
     *
     * @export
     * @class GetStockReplenishmentTaskZones
     * @implements {EvaService}
     */
    class GetStockReplenishmentTaskZones {
        name = 'Core:GetStockReplenishmentTaskZones';
        path = '/message/GetStockReplenishmentTaskZones';
        request;
        response;
    }
    Core.GetStockReplenishmentTaskZones = GetStockReplenishmentTaskZones;
    /**
     * Retrieve details on a Stock Reservation Task based on an OrderID.
     *
     * @export
     * @class GetStockReservationTask
     * @implements {EvaService}
     */
    class GetStockReservationTask {
        name = 'Core:GetStockReservationTask';
        path = '/message/GetStockReservationTask';
        request;
        response;
    }
    Core.GetStockReservationTask = GetStockReservationTask;
    /**
     * Service for retrieving a `StringTranslation`
     *
     * @export
     * @class GetStringTranslation
     * @implements {EvaService}
     */
    class GetStringTranslation {
        name = 'Core:GetStringTranslation';
        path = '/message/GetStringTranslation';
        request;
        response;
    }
    Core.GetStringTranslation = GetStringTranslation;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetSupplierStockForProduct
     * @implements {EvaService}
     */
    class GetSupplierStockForProduct {
        name = 'Core:GetSupplierStockForProduct';
        path = '/message/GetSupplierStockForProduct';
        request;
        response;
    }
    Core.GetSupplierStockForProduct = GetSupplierStockForProduct;
    /**
     * Service for retrieving a list of `OrganizationUnitSupplier` by `OrganizationUnit`
     *
     * @export
     * @class GetSuppliersForOrganizationUnit
     * @implements {EvaService}
     */
    class GetSuppliersForOrganizationUnit {
        name = 'Core:GetSuppliersForOrganizationUnit';
        path = '/message/GetSuppliersForOrganizationUnit';
        request;
        response;
    }
    Core.GetSuppliersForOrganizationUnit = GetSuppliersForOrganizationUnit;
    /**
     * Gets the available reasons for tax exemption.
The `Code` property of each result can then be supplied to `ExemptOrderFromTax` as the `TaxExemptionCode`.
     *
     * @export
     * @class GetTaxExemptionReasons
     * @implements {EvaService}
     */
    class GetTaxExemptionReasons {
        name = 'Core:GetTaxExemptionReasons';
        path = '/message/GetTaxExemptionReasons';
        request;
        response;
    }
    Core.GetTaxExemptionReasons = GetTaxExemptionReasons;
    /**
     * Get a tax provider by ID.
     *
     * @export
     * @class GetTaxProvider
     * @implements {EvaService}
     */
    class GetTaxProvider {
        name = 'Core:GetTaxProvider';
        path = '/message/GetTaxProvider';
        request;
        response;
    }
    Core.GetTaxProvider = GetTaxProvider;
    /**
     * Get the available tax provider types.
     *
     * @export
     * @class GetTaxProviderTypes
     * @implements {EvaService}
     */
    class GetTaxProviderTypes {
        name = 'Core:GetTaxProviderTypes';
        path = '/message/GetTaxProviderTypes';
        request;
        response;
    }
    Core.GetTaxProviderTypes = GetTaxProviderTypes;
    /**
     * Gets a tax rate.

:point_right: See `CreateTaxRate` service for more info.
     *
     * @export
     * @class GetTaxRate
     * @implements {EvaService}
     */
    class GetTaxRate {
        name = 'Core:GetTaxRate';
        path = '/message/GetTaxRate';
        request;
        response;
    }
    Core.GetTaxRate = GetTaxRate;
    /**
     * Create a temporary token, based off of your current authentication token, which can be passed in query parameters for redirect requests. On the
receiving side, post this token in the `Login` service request body as `AuthenticationToken` to retrieve a new token, similar to the original
token, preserving user and context.

Note this token lifetime is only 30 seconds, and has no rights to do anything else.
     *
     * @export
     * @class GetTemporaryRedirectToken
     * @implements {EvaService}
     */
    class GetTemporaryRedirectToken {
        name = 'Core:GetTemporaryRedirectToken';
        path = '/message/GetTemporaryRedirectToken';
        request;
        response;
    }
    Core.GetTemporaryRedirectToken = GetTemporaryRedirectToken;
    /**
     * Allows customers to grab a token to be able to view their order for a limited amount of time. The token is
obtained through the user of either `OrderID` or both a `BackendSystemID` and a `BackendID` in combination
with the `EmailAddress` of the customer that is attached to the order.
     *
     * @export
     * @class GetTemporaryTokenForOrder
     * @implements {EvaService}
     */
    class GetTemporaryTokenForOrder {
        name = 'Core:GetTemporaryTokenForOrder';
        path = '/message/GetTemporaryTokenForOrder';
        request;
        response;
    }
    Core.GetTemporaryTokenForOrder = GetTemporaryTokenForOrder;
    /**
     * Retrieve information about a temporary access token from specified `Authorization` parameter.
     *
     * @export
     * @class GetTokenInfo
     * @implements {EvaService}
     */
    class GetTokenInfo {
        name = 'Core:GetTokenInfo';
        path = '/message/GetTokenInfo';
        request;
        response;
    }
    Core.GetTokenInfo = GetTokenInfo;
    /**
     * Get additional order line information intended for transport data.
     *
     * @export
     * @class GetTransportOrderLineData
     * @implements {EvaService}
     */
    class GetTransportOrderLineData {
        name = 'Core:GetTransportOrderLineData';
        path = '/message/GetTransportOrderLineData';
        request;
        response;
    }
    Core.GetTransportOrderLineData = GetTransportOrderLineData;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetTransputJobTypes
     * @implements {EvaService}
     */
    class GetTransputJobTypes {
        name = 'Core:GetTransputJobTypes';
        path = '/message/GetTransputJobTypes';
        request;
        response;
    }
    Core.GetTransputJobTypes = GetTransputJobTypes;
    /**
     * Get all unitPrice correction reasons
     *
     * @export
     * @class GetUnitPriceCorrectionReasons
     * @implements {EvaService}
     */
    class GetUnitPriceCorrectionReasons {
        name = 'Core:GetUnitPriceCorrectionReasons';
        path = '/message/GetUnitPriceCorrectionReasons';
        request;
        response;
    }
    Core.GetUnitPriceCorrectionReasons = GetUnitPriceCorrectionReasons;
    /**
     * Get the estimated amount of unprocessed financial events.
     *
     * @export
     * @class GetUnprocessedFinancialEventsCount
     * @implements {EvaService}
     */
    class GetUnprocessedFinancialEventsCount {
        name = 'Core:GetUnprocessedFinancialEventsCount';
        path = '/message/GetUnprocessedFinancialEventsCount';
        request;
        response;
    }
    Core.GetUnprocessedFinancialEventsCount = GetUnprocessedFinancialEventsCount;
    /**
     * Get a user by ID
     *
     * @export
     * @class GetUser
     * @implements {EvaService}
     */
    class GetUser {
        name = 'Core:GetUser';
        path = '/message/GetUser';
        request;
        response;
    }
    Core.GetUser = GetUser;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetUserAssociationTypeByID
     * @implements {EvaService}
     */
    class GetUserAssociationTypeByID {
        name = 'Core:GetUserAssociationTypeByID';
        path = '/message/GetUserAssociationTypeByID';
        request;
        response;
    }
    Core.GetUserAssociationTypeByID = GetUserAssociationTypeByID;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetUserAssociationTypes
     * @implements {EvaService}
     */
    class GetUserAssociationTypes {
        name = 'Core:GetUserAssociationTypes';
        path = '/message/GetUserAssociationTypes';
        request;
        response;
    }
    Core.GetUserAssociationTypes = GetUserAssociationTypes;
    /**
     * Return the current user associations for the given user
     *
     * @export
     * @class GetUserAssociations
     * @implements {EvaService}
     */
    class GetUserAssociations {
        name = 'Core:GetUserAssociations';
        path = '/message/GetUserAssociations';
        request;
        response;
    }
    Core.GetUserAssociations = GetUserAssociations;
    /**
     * Find an User by their SocialSecurityNumber. This service only returns an UserID.
When more info is needed, additional data can be fetched with the `GetUser` service.
     *
     * @export
     * @class GetUserBySocialSecurityNumber
     * @implements {EvaService}
     */
    class GetUserBySocialSecurityNumber {
        name = 'Core:GetUserBySocialSecurityNumber';
        path = '/message/GetUserBySocialSecurityNumber';
        request;
        response;
    }
    Core.GetUserBySocialSecurityNumber = GetUserBySocialSecurityNumber;
    /**
     * Get the user Consignment property.
     *
     * @export
     * @class GetUserConsignment
     * @implements {EvaService}
     */
    class GetUserConsignment {
        name = 'Core:GetUserConsignment';
        path = '/message/GetUserConsignment';
        request;
        response;
    }
    Core.GetUserConsignment = GetUserConsignment;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetUserDebtorData
     * @implements {EvaService}
     */
    class GetUserDebtorData {
        name = 'Core:GetUserDebtorData';
        path = '/message/GetUserDebtorData';
        request;
        response;
    }
    Core.GetUserDebtorData = GetUserDebtorData;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetUserGroupByID
     * @implements {EvaService}
     */
    class GetUserGroupByID {
        name = 'Core:GetUserGroupByID';
        path = '/message/GetUserGroupByID';
        request;
        response;
    }
    Core.GetUserGroupByID = GetUserGroupByID;
    /**
     * Fetch user information from an external API based on the phone number. This can be used to enrich the user in the frontend.
Depending on the phone number provider, this may require Customer or Employee rights.
     *
     * @export
     * @class GetUserInfoByPhoneNumber
     * @implements {EvaService}
     */
    class GetUserInfoByPhoneNumber {
        name = 'Core:GetUserInfoByPhoneNumber';
        path = '/message/GetUserInfoByPhoneNumber';
        request;
        response;
    }
    Core.GetUserInfoByPhoneNumber = GetUserInfoByPhoneNumber;
    /**
     * Fetch user information from an external API based on the social security number. This can be used to enrich the user in the frontend.
Depending on the SSN provider, this may require Customer or Employee rights.
     *
     * @export
     * @class GetUserInfoBySocialSecurityNumber
     * @implements {EvaService}
     */
    class GetUserInfoBySocialSecurityNumber {
        name = 'Core:GetUserInfoBySocialSecurityNumber';
        path = '/message/GetUserInfoBySocialSecurityNumber';
        request;
        response;
    }
    Core.GetUserInfoBySocialSecurityNumber = GetUserInfoBySocialSecurityNumber;
    /**
     * Returns user inquiries
     *
     * @export
     * @class GetUserInquiries
     * @implements {EvaService}
     */
    class GetUserInquiries {
        name = 'Core:GetUserInquiries';
        path = '/message/GetUserInquiries';
        request;
        response;
    }
    Core.GetUserInquiries = GetUserInquiries;
    /**
     * Returns a user inquiry with data
     *
     * @export
     * @class GetUserInquiry
     * @implements {EvaService}
     */
    class GetUserInquiry {
        name = 'Core:GetUserInquiry';
        path = '/message/GetUserInquiry';
        request;
        response;
    }
    Core.GetUserInquiry = GetUserInquiry;
    /**
     * Get a UserInteration by its ID. A UserInteraction logs an interaction between an employee and a customer, for example the fact the customer was called.
     *
     * @export
     * @class GetUserInteractionByID
     * @implements {EvaService}
     */
    class GetUserInteractionByID {
        name = 'Core:GetUserInteractionByID';
        path = '/message/GetUserInteractionByID';
        request;
        response;
    }
    Core.GetUserInteractionByID = GetUserInteractionByID;
    /**
     * Get the user loyalty balance.
     *
     * @export
     * @class GetUserLoyaltyBalance
     * @implements {EvaService}
     */
    class GetUserLoyaltyBalance {
        name = 'Core:GetUserLoyaltyBalance';
        path = '/message/GetUserLoyaltyBalance';
        request;
        response;
    }
    Core.GetUserLoyaltyBalance = GetUserLoyaltyBalance;
    /**
     * Get all user loyalty subscriptions, this takes into account the OU this request is done on and will only show subscriptions available in that OU.
     *
     * @export
     * @class GetUserLoyaltySubscriptions
     * @implements {EvaService}
     */
    class GetUserLoyaltySubscriptions {
        name = 'Core:GetUserLoyaltySubscriptions';
        path = '/message/GetUserLoyaltySubscriptions';
        request;
        response;
    }
    Core.GetUserLoyaltySubscriptions = GetUserLoyaltySubscriptions;
    /**
     * Get the requested user's phone numbers. If UserID is left null, this service will return the phone numbers for your current user.
Only employee users are allowed to access the phone numbers of other users.
     *
     * @export
     * @class GetUserPhoneNumbers
     * @implements {EvaService}
     */
    class GetUserPhoneNumbers {
        name = 'Core:GetUserPhoneNumbers';
        path = '/message/GetUserPhoneNumbers';
        request;
        response;
    }
    Core.GetUserPhoneNumbers = GetUserPhoneNumbers;
    /**
     * Get all User subscriptions, this takes into account the OU this request is done on and will only show subscriptions available in that OU.
     *
     * @export
     * @class GetUserSubscriptions
     * @implements {EvaService}
     */
    class GetUserSubscriptions {
        name = 'Core:GetUserSubscriptions';
        path = '/message/GetUserSubscriptions';
        request;
        response;
    }
    Core.GetUserSubscriptions = GetUserSubscriptions;
    /**
     * Return the total number of open tasks, and the count per task type.
     *
     * @export
     * @class GetUserTaskCounts
     * @implements {EvaService}
     */
    class GetUserTaskCounts {
        name = 'Core:GetUserTaskCounts';
        path = '/message/GetUserTaskCounts';
        request;
        response;
    }
    Core.GetUserTaskCounts = GetUserTaskCounts;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetUserTaskDetails
     * @implements {EvaService}
     */
    class GetUserTaskDetails {
        name = 'Core:GetUserTaskDetails';
        path = '/message/GetUserTaskDetails';
        request;
        response;
    }
    Core.GetUserTaskDetails = GetUserTaskDetails;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetUserTaskNotCompletedReasons
     * @implements {EvaService}
     */
    class GetUserTaskNotCompletedReasons {
        name = 'Core:GetUserTaskNotCompletedReasons';
        path = '/message/GetUserTaskNotCompletedReasons';
        request;
        response;
    }
    Core.GetUserTaskNotCompletedReasons = GetUserTaskNotCompletedReasons;
    /**
     * Return all of the configured User Task Priority configurations.

These are used at real-time on the User Task details whenever fetched, translating the User Task `Priority` into a `PriorityDescription`. The
`LanguageID` and `CountryID` filters are compared against the user context requesting this information, and the `UserTaskTypeID`, `UserTaskSubTypeID`
and `Priority` are taken from the User Task itself. The `Priority` from the User Task will be compared against the `From` and `To` ranges defined,
where the `From` priority is an *inclusive* lower bound, while `To` is the *exclusive* upper bound.

The `Description` will be used to describe the priority, but when left empty, will fall back to `Name`.

An example configuration could be as follows;

```
Language | From | To | Description
---------|------|----|------------
      NL |      |    | Standaard
      NL |   10 |    | Spoed
      DE |      | 10 | Unwichtig
         |      |    | Default
```

A User Task with priority 9 for a Dutch employee would be labelled "Standaard", while for a German colleague this would be called "Unwichtig". A
User Task of priority 10 would be called "Spoed" in Dutch, but "Default" in German.

:sunglasses: For added awesomeness, if you define overlapping priority ranges, we'll select the most narrow range for you.
     *
     * @export
     * @class GetUserTaskPriorities
     * @implements {EvaService}
     */
    class GetUserTaskPriorities {
        name = 'Core:GetUserTaskPriorities';
        path = '/message/GetUserTaskPriorities';
        request;
        response;
    }
    Core.GetUserTaskPriorities = GetUserTaskPriorities;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetUserTaskTypeOrganizationUnitSet
     * @implements {EvaService}
     */
    class GetUserTaskTypeOrganizationUnitSet {
        name = 'Core:GetUserTaskTypeOrganizationUnitSet';
        path = '/message/GetUserTaskTypeOrganizationUnitSet';
        request;
        response;
    }
    Core.GetUserTaskTypeOrganizationUnitSet = GetUserTaskTypeOrganizationUnitSet;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetUserTaskTypes
     * @implements {EvaService}
     */
    class GetUserTaskTypes {
        name = 'Core:GetUserTaskTypes';
        path = '/message/GetUserTaskTypes';
        request;
        response;
    }
    Core.GetUserTaskTypes = GetUserTaskTypes;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetUserWhoDeletedCycleCountZoneAndMakeItGreatAgain
     * @implements {EvaService}
     */
    class GetUserWhoDeletedCycleCountZoneAndMakeItGreatAgain {
        name = 'Core:GetUserWhoDeletedCycleCountZoneAndMakeItGreatAgain';
        path = '/message/GetUserWhoDeletedCycleCountZoneAndMakeItGreatAgain';
        request;
        response;
    }
    Core.GetUserWhoDeletedCycleCountZoneAndMakeItGreatAgain = GetUserWhoDeletedCycleCountZoneAndMakeItGreatAgain;
    /**
     * Get the user wishlist by ID.
     *
     * @export
     * @class GetUserWishlist
     * @implements {EvaService}
     */
    class GetUserWishlist {
        name = 'Core:GetUserWishlist';
        path = '/message/GetUserWishlist';
        request;
        response;
    }
    Core.GetUserWishlist = GetUserWishlist;
    /**
     * Get additional order information intended for warehouse data.
     *
     * @export
     * @class GetWarehouseOrderData
     * @implements {EvaService}
     */
    class GetWarehouseOrderData {
        name = 'Core:GetWarehouseOrderData';
        path = '/message/GetWarehouseOrderData';
        request;
        response;
    }
    Core.GetWarehouseOrderData = GetWarehouseOrderData;
    /**
     * This service return the available webshop OrganizationUnits
     *
     * @export
     * @class GetWebshops
     * @implements {EvaService}
     */
    class GetWebshops {
        name = 'Core:GetWebshops';
        path = '/message/GetWebshops';
        request;
        response;
    }
    Core.GetWebshops = GetWebshops;
    /**
     * Returns a detailed view of a ZonedCycleCount by the ID of its UserTask.

The response contains:

- Which StockLabels to count (`StockLabelsToCount`)
- The product that needs to be counted. This product contains all the fields in its `Content` object that were requested through the `IncludedFields` property on the request, or a default set of fields if not specified.
- Which StockMutations have been created since the first pre-count (if any) per StockLabel (`StockMutationsSincePreCount`)
- A list of all pre-counts, complete with the zone that needs to be counted, the user who did the count (if the count already happened) and a list of count results per StockLabel
- A list of pre-counted quantityies per StockLabel (`PreCountedQuantities`)
- A list of the total quantity of stock mutated per StockLabel (a summary of `StockMutationsSincePreCount`).
- The current stock per StockLabel
- ExpectedPreCountedQuantity: This is stored on the ZonedCyleCount the moment the last pre-count has been completed, and is a sum of the expected Stock at that moment.
- PreCountedQuantity: The quantity that was actually counted in all pre-counts over all StockLabels. This is recorded when all pre-counts have been completed.
     *
     * @export
     * @class GetZonedCycleCount
     * @implements {EvaService}
     */
    class GetZonedCycleCount {
        name = 'Core:GetZonedCycleCount';
        path = '/message/GetZonedCycleCount';
        request;
        response;
    }
    Core.GetZonedCycleCount = GetZonedCycleCount;
    /**
     * Returns a detailed view of a ZonedCycleCountPreCount by the ID of its UserTask.

The response contains:

- Which StockLabels to count (`StockLabelsToCount`)
- The product that needs to be counted (`Product`); this product contains all the fields in its `Content` object that were requested through the `IncludedFields` property on the request, or a default set of fields if not specified
- Zone that needs to be counted (`CycleCountZone`)
- List of stock labels to be counted (`StockLabelsToCount`)
- List of required resource types (`RequiredResourceTypes`)
     *
     * @export
     * @class GetZonedCycleCountPreCount
     * @implements {EvaService}
     */
    class GetZonedCycleCountPreCount {
        name = 'Core:GetZonedCycleCountPreCount';
        path = '/message/GetZonedCycleCountPreCount';
        request;
        response;
    }
    Core.GetZonedCycleCountPreCount = GetZonedCycleCountPreCount;
    /**
     * Returns a count of potential cycle counts that would be created for the combinations of (type Stock) Products and Organization Units that match specified filters. Use this service to preview results before actual creation.
     *
     * @export
     * @class GetZonedCycleCountsEstimateByQuery
     * @implements {EvaService}
     */
    class GetZonedCycleCountsEstimateByQuery {
        name = 'Core:GetZonedCycleCountsEstimateByQuery';
        path = '/message/GetZonedCycleCountsEstimateByQuery';
        request;
        response;
    }
    Core.GetZonedCycleCountsEstimateByQuery = GetZonedCycleCountsEstimateByQuery;
    /**
     * Returns a count of potential cycle counts that would be created for the combinations of (type Stock) Products and Organization Units that match specified filters. Use this service to preview results before actual creation.
     *
     * @export
     * @class GetZonedCycleCountsEstimateByQuery_Async
     * @implements {EvaService}
     */
    class GetZonedCycleCountsEstimateByQuery_Async {
        name = 'Core:GetZonedCycleCountsEstimateByQuery_Async';
        path = '/async-message/GetZonedCycleCountsEstimateByQuery';
        request;
        response;
    }
    Core.GetZonedCycleCountsEstimateByQuery_Async = GetZonedCycleCountsEstimateByQuery_Async;
    /**
     * Returns a count of potential cycle counts that would be created for the combinations of (type Stock) Products and Organization Units that match specified filters. Use this service to preview results before actual creation.
     *
     * @export
     * @class GetZonedCycleCountsEstimateByQuery_AsyncResult
     * @implements {EvaService}
     */
    class GetZonedCycleCountsEstimateByQuery_AsyncResult {
        name = 'Core:GetZonedCycleCountsEstimateByQuery_AsyncResult';
        path = '/async-result/GetZonedCycleCountsEstimateByQuery';
        request;
        response;
    }
    Core.GetZonedCycleCountsEstimateByQuery_AsyncResult = GetZonedCycleCountsEstimateByQuery_AsyncResult;
    /**
     * When a PaymentTransaction is disputed due to a Chargeback or a Reversal, the difference can be booked in a different PaymentTransaction to allow the order to be completed.

Calling this service will result in an additional PaymentTransaction of type `DISPUTE`.
     *
     * @export
     * @class HandlePaymentTransactionDispute
     * @implements {EvaService}
     */
    class HandlePaymentTransactionDispute {
        name = 'Core:HandlePaymentTransactionDispute';
        path = '/message/HandlePaymentTransactionDispute';
        request;
        response;
    }
    Core.HandlePaymentTransactionDispute = HandlePaymentTransactionDispute;
    /**
     * Creates multiple Flight objects for a specific Organization Unit.
    The flights are identified from a GRC type file containing the necessary information.
     *
     * @export
     * @class ImportFlights
     * @implements {EvaService}
     */
    class ImportFlights {
        name = 'Core:ImportFlights';
        path = '/message/ImportFlights';
        request;
        response;
    }
    Core.ImportFlights = ImportFlights;
    /**
     * Creates or updates specified `OrganizationUnits`, identified by your `ID` (that we map to our `BackendID`).

Omit any field you don't want altered, or send in null values of nullable fields to unset their current value.

- Does not apply to `Address` - if you specify a new or different one from the current, a new Address will be created with only the data specify!
- Does not apply to `OpeningHours` - every value you specify will either update or create a record for that day
     *
     * @export
     * @class ImportOrganizationUnits
     * @implements {EvaService}
     */
    class ImportOrganizationUnits {
        name = 'Core:ImportOrganizationUnits';
        path = '/message/ImportOrganizationUnits';
        request;
        response;
    }
    Core.ImportOrganizationUnits = ImportOrganizationUnits;
    /**
     * Set up a payment type
     *
     * @export
     * @class InitializePaymentType
     * @implements {EvaService}
     */
    class InitializePaymentType {
        name = 'Core:InitializePaymentType';
        path = '/message/InitializePaymentType';
        request;
        response;
    }
    Core.InitializePaymentType = InitializePaymentType;
    /**
     * Service for retrieving a list of `AddressBook`
     *
     * @export
     * @class ListAddressBook
     * @implements {EvaService}
     */
    class ListAddressBook {
        name = 'Core:ListAddressBook';
        path = '/message/ListAddressBook';
        request;
        response;
    }
    Core.ListAddressBook = ListAddressBook;
    /**
     * List API keys, optionally filtered.
     *
     * @export
     * @class ListApiKeys
     * @implements {EvaService}
     */
    class ListApiKeys {
        name = 'Core:ListApiKeys';
        path = '/message/ListApiKeys';
        request;
        response;
    }
    Core.ListApiKeys = ListApiKeys;
    /**
     * Get a list of all active Applications
     *
     * @export
     * @class ListApplications
     * @implements {EvaService}
     */
    class ListApplications {
        name = 'Core:ListApplications';
        path = '/message/ListApplications';
        request;
        response;
    }
    Core.ListApplications = ListApplications;
    /**
     * Lists all tasks that are able to be configured to run.
     *
     * @export
     * @class ListAvailableRecurringTasks
     * @implements {EvaService}
     */
    class ListAvailableRecurringTasks {
        name = 'Core:ListAvailableRecurringTasks';
        path = '/message/ListAvailableRecurringTasks';
        request;
        response;
    }
    Core.ListAvailableRecurringTasks = ListAvailableRecurringTasks;
    /**
     * Returns a set of all the shipping methods that can be used for the given order. Use `SetShippingMethod` to update the shipping method on the order.
     *
     * @export
     * @class ListAvailableShippingMethods
     * @implements {EvaService}
     */
    class ListAvailableShippingMethods {
        name = 'Core:ListAvailableShippingMethods';
        path = '/message/ListAvailableShippingMethods';
        request;
        response;
    }
    Core.ListAvailableShippingMethods = ListAvailableShippingMethods;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListAvailableTimeZones
     * @implements {EvaService}
     */
    class ListAvailableTimeZones {
        name = 'Core:ListAvailableTimeZones';
        path = '/message/ListAvailableTimeZones';
        request;
        response;
    }
    Core.ListAvailableTimeZones = ListAvailableTimeZones;
    /**
     * List the available UserTasks for the current user.

The response has a `Aggregations` property. This property contains the available filters for this set of UserTasks.
To apply such a filter it should added in the `Filters` property on the RequestMessage.

Example response:
```
{
...
,
  "Aggregations": {
      "ZonedCycleCountPreCount": {
        "CycleCountZoneID": [
          {
            "Name": "Shelves",
            "Value": 10,
            "Count": 1
          },
          {
            "Name": "Stockroom",
            "Value": 12,
            "Count": 6
          },
          {
            "Name": "Store",
            "Value": 13,
            "Count": 4
          }
        ]
      }
    }
  }
}
```

To apply a matching filter:
```
{
  "Filters": {
    "ZonedCycleCountPreCount": {
      "CycleCountZoneID": [10]
    }
  }
}
```
     *
     * @export
     * @class ListAvailableUserTasks
     * @implements {EvaService}
     */
    class ListAvailableUserTasks {
        name = 'Core:ListAvailableUserTasks';
        path = '/message/ListAvailableUserTasks';
        request;
        response;
    }
    Core.ListAvailableUserTasks = ListAvailableUserTasks;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListBlobsForFinancialPeriod
     * @implements {EvaService}
     */
    class ListBlobsForFinancialPeriod {
        name = 'Core:ListBlobsForFinancialPeriod';
        path = '/message/ListBlobsForFinancialPeriod';
        request;
        response;
    }
    Core.ListBlobsForFinancialPeriod = ListBlobsForFinancialPeriod;
    /**
     * List all the blobs that're attached to the given invoice (`InvoiceID`).
     *
     * @export
     * @class ListBlobsForInvoice
     * @implements {EvaService}
     */
    class ListBlobsForInvoice {
        name = 'Core:ListBlobsForInvoice';
        path = '/message/ListBlobsForInvoice';
        request;
        response;
    }
    Core.ListBlobsForInvoice = ListBlobsForInvoice;
    /**
     * Get the blobs that are attached to an Order

It's required to specify the order, optionally the blobs can also be filtered on `InvoiceID` of `ShipmentID`.
     *
     * @export
     * @class ListBlobsForOrder
     * @implements {EvaService}
     */
    class ListBlobsForOrder {
        name = 'Core:ListBlobsForOrder';
        path = '/message/ListBlobsForOrder';
        request;
        response;
    }
    Core.ListBlobsForOrder = ListBlobsForOrder;
    /**
     * Lists all of the bookings that've been made for the given financial period. Which you can retrieve
by setting the filter `FinancialPeriodID` on the `PageConfig`.
     *
     * @export
     * @class ListBookings
     * @implements {EvaService}
     */
    class ListBookings {
        name = 'Core:ListBookings';
        path = '/message/ListBookings';
        request;
        response;
    }
    Core.ListBookings = ListBookings;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListBrands
     * @implements {EvaService}
     */
    class ListBrands {
        name = 'Core:ListBrands';
        path = '/message/ListBrands';
        request;
        response;
    }
    Core.ListBrands = ListBrands;
    /**
     * Lists all cash deposits for your current financial period.
     *
     * @export
     * @class ListCashDeposits
     * @implements {EvaService}
     */
    class ListCashDeposits {
        name = 'Core:ListCashDeposits';
        path = '/message/ListCashDeposits';
        request;
        response;
    }
    Core.ListCashDeposits = ListCashDeposits;
    /**
     * Lists all cash expenses for your current financial period.
     *
     * @export
     * @class ListCashExpenses
     * @implements {EvaService}
     */
    class ListCashExpenses {
        name = 'Core:ListCashExpenses';
        path = '/message/ListCashExpenses';
        request;
        response;
    }
    Core.ListCashExpenses = ListCashExpenses;
    /**
     * This service allows you to view the cash transaction ledger, which underlies all cash transactions,
such as received payments, moves between devices and expenses.

By default, you only get access to the cash transaction ledger for your current financial period. If
you have the `ManageCashTransactionLedger` permission, you're also allowed to filter on another financial
period.
     *
     * @export
     * @class ListCashTransactionLedger
     * @implements {EvaService}
     */
    class ListCashTransactionLedger {
        name = 'Core:ListCashTransactionLedger';
        path = '/message/ListCashTransactionLedger';
        request;
        response;
    }
    Core.ListCashTransactionLedger = ListCashTransactionLedger;
    /**
     * This service allows you to get a grouped view of the cash transaction ledger, which underlies all cash
transactions, such as received payments, moves between devices and expenses.

By default, you only get access to the cash transaction ledger for your current financial period. If
you have the `ManageCashTransactionLedger` permission, you're also allowed to filter on another financial
period.
     *
     * @export
     * @class ListCashTransactionLedgerGroups
     * @implements {EvaService}
     */
    class ListCashTransactionLedgerGroups {
        name = 'Core:ListCashTransactionLedgerGroups';
        path = '/message/ListCashTransactionLedgerGroups';
        request;
        response;
    }
    Core.ListCashTransactionLedgerGroups = ListCashTransactionLedgerGroups;
    /**
     * This service lists the OrderLines for the given ProductID that currently have committed Stock.
     *
     * @export
     * @class ListCommittedOrderLines
     * @implements {EvaService}
     */
    class ListCommittedOrderLines {
        name = 'Core:ListCommittedOrderLines';
        path = '/message/ListCommittedOrderLines';
        request;
        response;
    }
    Core.ListCommittedOrderLines = ListCommittedOrderLines;
    /**
     * List the available ConsolidatedPickTask tasks for the current user.
     *
     * @export
     * @class ListConsolidatedPickTasks
     * @implements {EvaService}
     */
    class ListConsolidatedPickTasks {
        name = 'Core:ListConsolidatedPickTasks';
        path = '/message/ListConsolidatedPickTasks';
        request;
        response;
    }
    Core.ListConsolidatedPickTasks = ListConsolidatedPickTasks;
    /**
     * List the available ConsolidatedZonePickTask tasks for the current user.
     *
     * @export
     * @class ListConsolidatedZonePickTasks
     * @implements {EvaService}
     */
    class ListConsolidatedZonePickTasks {
        name = 'Core:ListConsolidatedZonePickTasks';
        path = '/message/ListConsolidatedZonePickTasks';
        request;
        response;
    }
    Core.ListConsolidatedZonePickTasks = ListConsolidatedZonePickTasks;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListControlDocuments
     * @implements {EvaService}
     */
    class ListControlDocuments {
        name = 'Core:ListControlDocuments';
        path = '/message/ListControlDocuments';
        request;
        response;
    }
    Core.ListControlDocuments = ListControlDocuments;
    /**
     * Gets the full list of countries. When `FetchAll` is set to true, all the `Country` entries are returned, rather than just the ones limited by the `OrganizationUnitCountry` constraint (`false` or `null`, default).
     *
     * @export
     * @class ListCountries
     * @implements {EvaService}
     */
    class ListCountries {
        name = 'Core:ListCountries';
        path = '/message/ListCountries';
        request;
        response;
    }
    Core.ListCountries = ListCountries;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListCurrencies
     * @implements {EvaService}
     */
    class ListCurrencies {
        name = 'Core:ListCurrencies';
        path = '/message/ListCurrencies';
        request;
        response;
    }
    Core.ListCurrencies = ListCurrencies;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListCustomOrderStatus
     * @implements {EvaService}
     */
    class ListCustomOrderStatus {
        name = 'Core:ListCustomOrderStatus';
        path = '/message/ListCustomOrderStatus';
        request;
        response;
    }
    Core.ListCustomOrderStatus = ListCustomOrderStatus;
    /**
     * Lists all of the custom usertask templates
     *
     * @export
     * @class ListCustomUserTaskTemplate
     * @implements {EvaService}
     */
    class ListCustomUserTaskTemplate {
        name = 'Core:ListCustomUserTaskTemplate';
        path = '/message/ListCustomUserTaskTemplate';
        request;
        response;
    }
    Core.ListCustomUserTaskTemplate = ListCustomUserTaskTemplate;
    /**
     * List all custom usertask types
     *
     * @export
     * @class ListCustomUserTaskTypes
     * @implements {EvaService}
     */
    class ListCustomUserTaskTypes {
        name = 'Core:ListCustomUserTaskTypes';
        path = '/message/ListCustomUserTaskTypes';
        request;
        response;
    }
    Core.ListCustomUserTaskTypes = ListCustomUserTaskTypes;
    /**
     * Gets all the CycleCountZoneGroups based on the given filter and returns a paged response.
     *
     * @export
     * @class ListCycleCountZoneGroups
     * @implements {EvaService}
     */
    class ListCycleCountZoneGroups {
        name = 'Core:ListCycleCountZoneGroups';
        path = '/message/ListCycleCountZoneGroups';
        request;
        response;
    }
    Core.ListCycleCountZoneGroups = ListCycleCountZoneGroups;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListCycleZonesForOrganizationUnits
     * @implements {EvaService}
     */
    class ListCycleZonesForOrganizationUnits {
        name = 'Core:ListCycleZonesForOrganizationUnits';
        path = '/message/ListCycleZonesForOrganizationUnits';
        request;
        response;
    }
    Core.ListCycleZonesForOrganizationUnits = ListCycleZonesForOrganizationUnits;
    /**
     * Service for retrieving a list of `Device`
     *
     * @export
     * @class ListDevices
     * @implements {EvaService}
     */
    class ListDevices {
        name = 'Core:ListDevices';
        path = '/message/ListDevices';
        request;
        response;
    }
    Core.ListDevices = ListDevices;
    /**
     * List blobs intended for app diagnostics.
     *
     * @export
     * @class ListDiagnosticsBlobs
     * @implements {EvaService}
     */
    class ListDiagnosticsBlobs {
        name = 'Core:ListDiagnosticsBlobs';
        path = '/message/ListDiagnosticsBlobs';
        request;
        response;
    }
    Core.ListDiagnosticsBlobs = ListDiagnosticsBlobs;
    /**
     * List disabled discounts triggers on order
     *
     * @export
     * @class ListDisabledDiscountTriggersOnOrder
     * @implements {EvaService}
     */
    class ListDisabledDiscountTriggersOnOrder {
        name = 'Core:ListDisabledDiscountTriggersOnOrder';
        path = '/message/ListDisabledDiscountTriggersOnOrder';
        request;
        response;
    }
    Core.ListDisabledDiscountTriggersOnOrder = ListDisabledDiscountTriggersOnOrder;
    /**
     * List disabled discounts on order
     *
     * @export
     * @class ListDisabledDiscountsOnOrder
     * @implements {EvaService}
     */
    class ListDisabledDiscountsOnOrder {
        name = 'Core:ListDisabledDiscountsOnOrder';
        path = '/message/ListDisabledDiscountsOnOrder';
        request;
        response;
    }
    Core.ListDisabledDiscountsOnOrder = ListDisabledDiscountsOnOrder;
    /**
     * This services returns a list of discount coupon handlers
     *
     * @export
     * @class ListDiscountCouponHandlers
     * @implements {EvaService}
     */
    class ListDiscountCouponHandlers {
        name = 'Core:ListDiscountCouponHandlers';
        path = '/message/ListDiscountCouponHandlers';
        request;
        response;
    }
    Core.ListDiscountCouponHandlers = ListDiscountCouponHandlers;
    /**
     * Service for retrieving a list of `EntityTranslation`
     *
     * @export
     * @class ListEntityTranslations
     * @implements {EvaService}
     */
    class ListEntityTranslations {
        name = 'Core:ListEntityTranslations';
        path = '/message/ListEntityTranslations';
        request;
        response;
    }
    Core.ListEntityTranslations = ListEntityTranslations;
    /**
     * This service lets you query the EventLedger for auditing purposes.

The request provides a PageConfig (of type ScrollablePageConfig) that lets you filter on the given properties in the EventLedger.
Paging is done by providing the request with the `NextResultToken` that you got back from the previous request.
As this method of paging is forward-only, you can't go back to a previous page unless you store the token or the results,
and the total number of results is unknown, only whether or not there are more results (determined by if the NextResultToken is null).

The response contains the whole EventLedger document.

Possible filters:

- Types: A list of strings that refer to the `Type` field that is in every document.
- OrderID: Only return documents that contain a reference to the given OrderID
- OrganizationUnitID: Only return documents that were created by someone logged into the given OrganizationUnitID. It's recommended that this filter is always used, due to performance reasons.
- DeviceID: Filters on documents that have a reference to the given device, usually associated with a payment or a print command.
- FromDate: Only return documents newer than this date. It's recommended that this filter is always used, due to performance reasons.
- ToDate: Only return documents older than this date. It's recommended that this filter is always used, due to performance reasons.
- UserIDs: Only return documents created by these users. The IDs for this can be gotten by first doing a user search.
- FirstName: Filter on documents created by users whose first name starts with this. Achieves the same as filtering on UserIDs, but with one step less. However, due to privacy reasons, this information isn't stored for customers.
- FullName: Filter on documents created by users whose full name starts with this. Achieves the same as filtering on UserIDs, but with one step less. However, due to privacy reasons, this information isn't stored for customers.
- EmailAddress: Filter on documents created by users whose email starts with this. Achieves the same as filtering on UserIDs, but with one step less. However, due to privacy reasons, this information isn't stored for customers.
     *
     * @export
     * @class ListEventLedger
     * @implements {EvaService}
     */
    class ListEventLedger {
        name = 'Core:ListEventLedger';
        path = '/message/ListEventLedger';
        request;
        response;
    }
    Core.ListEventLedger = ListEventLedger;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListExternalOrderStatusForOrder
     * @implements {EvaService}
     */
    class ListExternalOrderStatusForOrder {
        name = 'Core:ListExternalOrderStatusForOrder';
        path = '/message/ListExternalOrderStatusForOrder';
        request;
        response;
    }
    Core.ListExternalOrderStatusForOrder = ListExternalOrderStatusForOrder;
    /**
     * List the active feed subscriptions for the current user's `ApplicationID`.
     *
     * @export
     * @class ListFeedSubscriptions
     * @implements {EvaService}
     */
    class ListFeedSubscriptions {
        name = 'Core:ListFeedSubscriptions';
        path = '/message/ListFeedSubscriptions';
        request;
        response;
    }
    Core.ListFeedSubscriptions = ListFeedSubscriptions;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListFinancialEvents
     * @implements {EvaService}
     */
    class ListFinancialEvents {
        name = 'Core:ListFinancialEvents';
        path = '/message/ListFinancialEvents';
        request;
        response;
    }
    Core.ListFinancialEvents = ListFinancialEvents;
    /**
     * Lists all `Financial Period Audit` with their possible BlobID's for audition purposes.
     *
     * @export
     * @class ListFinancialPeriodAudits
     * @implements {EvaService}
     */
    class ListFinancialPeriodAudits {
        name = 'Core:ListFinancialPeriodAudits';
        path = '/message/ListFinancialPeriodAudits';
        request;
        response;
    }
    Core.ListFinancialPeriodAudits = ListFinancialPeriodAudits;
    /**
     * List financial period exports
     *
     * @export
     * @class ListFinancialPeriodExports2
     * @implements {EvaService}
     */
    class ListFinancialPeriodExports2 {
        name = 'Core:ListFinancialPeriodExports2';
        path = '/message/ListFinancialPeriodExports2';
        request;
        response;
    }
    Core.ListFinancialPeriodExports2 = ListFinancialPeriodExports2;
    /**
     * List financialperiods for an OrganizationUnit
     *
     * @export
     * @class ListFinancialPeriods
     * @implements {EvaService}
     */
    class ListFinancialPeriods {
        name = 'Core:ListFinancialPeriods';
        path = '/message/ListFinancialPeriods';
        request;
        response;
    }
    Core.ListFinancialPeriods = ListFinancialPeriods;
    /**
     * List all the existing Flights mathing the specified filter
     *
     * @export
     * @class ListFlights
     * @implements {EvaService}
     */
    class ListFlights {
        name = 'Core:ListFlights';
        path = '/message/ListFlights';
        request;
        response;
    }
    Core.ListFlights = ListFlights;
    /**
     * Lists the products of specified full stock count label.
     *
     * @export
     * @class ListFullStockCountLabelProducts
     * @implements {EvaService}
     */
    class ListFullStockCountLabelProducts {
        name = 'Core:ListFullStockCountLabelProducts';
        path = '/message/ListFullStockCountLabelProducts';
        request;
        response;
    }
    Core.ListFullStockCountLabelProducts = ListFullStockCountLabelProducts;
    /**
     * Lists the summary of specified Full Stock Count.
     *
     * @export
     * @class ListFullStockCountLabelSummary
     * @implements {EvaService}
     */
    class ListFullStockCountLabelSummary {
        name = 'Core:ListFullStockCountLabelSummary';
        path = '/message/ListFullStockCountLabelSummary';
        request;
        response;
    }
    Core.ListFullStockCountLabelSummary = ListFullStockCountLabelSummary;
    /**
     * List the available FullStockCountLabel tasks for the current user.
     *
     * @export
     * @class ListFullStockCountLabelTasks
     * @implements {EvaService}
     */
    class ListFullStockCountLabelTasks {
        name = 'Core:ListFullStockCountLabelTasks';
        path = '/message/ListFullStockCountLabelTasks';
        request;
        response;
    }
    Core.ListFullStockCountLabelTasks = ListFullStockCountLabelTasks;
    /**
     * Lists the Full Stock Count labels.
     *
     * @export
     * @class ListFullStockCountLabels
     * @implements {EvaService}
     */
    class ListFullStockCountLabels {
        name = 'Core:ListFullStockCountLabels';
        path = '/message/ListFullStockCountLabels';
        request;
        response;
    }
    Core.ListFullStockCountLabels = ListFullStockCountLabels;
    /**
     * Lists the result of specified Full Stock Count.
     *
     * @export
     * @class ListFullStockCountResult
     * @implements {EvaService}
     */
    class ListFullStockCountResult {
        name = 'Core:ListFullStockCountResult';
        path = '/message/ListFullStockCountResult';
        request;
        response;
    }
    Core.ListFullStockCountResult = ListFullStockCountResult;
    /**
     * Retrieves the status of serial numbers for a specific product and stock label within a Full Stock Count.
     *
     * @export
     * @class ListFullStockCountSerialNumbersStatus
     * @implements {EvaService}
     */
    class ListFullStockCountSerialNumbersStatus {
        name = 'Core:ListFullStockCountSerialNumbersStatus';
        path = '/message/ListFullStockCountSerialNumbersStatus';
        request;
        response;
    }
    Core.ListFullStockCountSerialNumbersStatus = ListFullStockCountSerialNumbersStatus;
    /**
     * Lists the summary of specified Full Stock Count.
     *
     * @export
     * @class ListFullStockCountSummary
     * @implements {EvaService}
     */
    class ListFullStockCountSummary {
        name = 'Core:ListFullStockCountSummary';
        path = '/message/ListFullStockCountSummary';
        request;
        response;
    }
    Core.ListFullStockCountSummary = ListFullStockCountSummary;
    /**
     * List the available FullStockCount tasks for the current user.
     *
     * @export
     * @class ListFullStockCountTasks
     * @implements {EvaService}
     */
    class ListFullStockCountTasks {
        name = 'Core:ListFullStockCountTasks';
        path = '/message/ListFullStockCountTasks';
        request;
        response;
    }
    Core.ListFullStockCountTasks = ListFullStockCountTasks;
    /**
     * Lists the full stock counts.
     *
     * @export
     * @class ListFullStockCounts
     * @implements {EvaService}
     */
    class ListFullStockCounts {
        name = 'Core:ListFullStockCounts';
        path = '/message/ListFullStockCounts';
        request;
        response;
    }
    Core.ListFullStockCounts = ListFullStockCounts;
    /**
     * Returns a paged view of all the general ledgers.

The page size `Limit` has a maximum value of `1.000` for this service.
     *
     * @export
     * @class ListGeneralLedgers
     * @implements {EvaService}
     */
    class ListGeneralLedgers {
        name = 'Core:ListGeneralLedgers';
        path = '/message/ListGeneralLedgers';
        request;
        response;
    }
    Core.ListGeneralLedgers = ListGeneralLedgers;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListInitialCycleCountLabels
     * @implements {EvaService}
     */
    class ListInitialCycleCountLabels {
        name = 'Core:ListInitialCycleCountLabels';
        path = '/message/ListInitialCycleCountLabels';
        request;
        response;
    }
    Core.ListInitialCycleCountLabels = ListInitialCycleCountLabels;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListInitialCycleCountResults
     * @implements {EvaService}
     */
    class ListInitialCycleCountResults {
        name = 'Core:ListInitialCycleCountResults';
        path = '/message/ListInitialCycleCountResults';
        request;
        response;
    }
    Core.ListInitialCycleCountResults = ListInitialCycleCountResults;
    /**
     * Lists the OrganizationUnits that are available for the given OrderID to be used as the target for an interbranch order.
     *
     * @export
     * @class ListInterbranchOrganizationUnitForOrder
     * @implements {EvaService}
     */
    class ListInterbranchOrganizationUnitForOrder {
        name = 'Core:ListInterbranchOrganizationUnitForOrder';
        path = '/message/ListInterbranchOrganizationUnitForOrder';
        request;
        response;
    }
    Core.ListInterbranchOrganizationUnitForOrder = ListInterbranchOrganizationUnitForOrder;
    /**
     * Lists the `InvoiceCompanyMapping` items.
     *
     * @export
     * @class ListInvoiceCompanyMapping
     * @implements {EvaService}
     */
    class ListInvoiceCompanyMapping {
        name = 'Core:ListInvoiceCompanyMapping';
        path = '/message/ListInvoiceCompanyMapping';
        request;
        response;
    }
    Core.ListInvoiceCompanyMapping = ListInvoiceCompanyMapping;
    /**
     * List invoice exports
     *
     * @export
     * @class ListInvoiceExports
     * @implements {EvaService}
     */
    class ListInvoiceExports {
        name = 'Core:ListInvoiceExports';
        path = '/message/ListInvoiceExports';
        request;
        response;
    }
    Core.ListInvoiceExports = ListInvoiceExports;
    /**
     * List the exports for the given Invoice
     *
     * @export
     * @class ListInvoiceExportsForInvoice
     * @implements {EvaService}
     */
    class ListInvoiceExportsForInvoice {
        name = 'Core:ListInvoiceExportsForInvoice';
        path = '/message/ListInvoiceExportsForInvoice';
        request;
        response;
    }
    Core.ListInvoiceExportsForInvoice = ListInvoiceExportsForInvoice;
    /**
     * List ledgers for invoices

Available filters:
- InvoiceID
- InvoiceLineID
- InvoiceDisputeID
- Type
     *
     * @export
     * @class ListInvoiceLedger
     * @implements {EvaService}
     */
    class ListInvoiceLedger {
        name = 'Core:ListInvoiceLedger';
        path = '/message/ListInvoiceLedger';
        request;
        response;
    }
    Core.ListInvoiceLedger = ListInvoiceLedger;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListInvoices
     * @implements {EvaService}
     */
    class ListInvoices {
        name = 'Core:ListInvoices';
        path = '/message/ListInvoices';
        request;
        response;
    }
    Core.ListInvoices = ListInvoices;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListInvoicesForOrder
     * @implements {EvaService}
     */
    class ListInvoicesForOrder {
        name = 'Core:ListInvoicesForOrder';
        path = '/message/ListInvoicesForOrder';
        request;
        response;
    }
    Core.ListInvoicesForOrder = ListInvoicesForOrder;
    /**
     * List the available manual discounts. Optionally, the OrderType or DiscountAppliesTo filter can be given.
     *
     * @export
     * @class ListManualDiscounts
     * @implements {EvaService}
     */
    class ListManualDiscounts {
        name = 'Core:ListManualDiscounts';
        path = '/message/ListManualDiscounts';
        request;
        response;
    }
    Core.ListManualDiscounts = ListManualDiscounts;
    /**
     * List manually created invoices. These invoices are created via the `CreateManualInvoice` service and are used as a worst-case scenario when everything has gone offline and the retailer has to make invoices on actual paper. These services are then used to enter the paper invoices back in to EVA.
     *
     * @export
     * @class ListManualInvoices
     * @implements {EvaService}
     */
    class ListManualInvoices {
        name = 'Core:ListManualInvoices';
        path = '/message/ListManualInvoices';
        request;
        response;
    }
    Core.ListManualInvoices = ListManualInvoices;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListManualTaxExemptionReasons
     * @implements {EvaService}
     */
    class ListManualTaxExemptionReasons {
        name = 'Core:ListManualTaxExemptionReasons';
        path = '/message/ListManualTaxExemptionReasons';
        request;
        response;
    }
    Core.ListManualTaxExemptionReasons = ListManualTaxExemptionReasons;
    /**
     * Lists the errors from the message queue.
     *
     * @export
     * @class ListMessageQueueErrors
     * @implements {EvaService}
     */
    class ListMessageQueueErrors {
        name = 'Core:ListMessageQueueErrors';
        path = '/message/ListMessageQueueErrors';
        request;
        response;
    }
    Core.ListMessageQueueErrors = ListMessageQueueErrors;
    /**
     * List the UserTasks for the current user.
     *
     * @export
     * @class ListMyUserTasks
     * @implements {EvaService}
     */
    class ListMyUserTasks {
        name = 'Core:ListMyUserTasks';
        path = '/message/ListMyUserTasks';
        request;
        response;
    }
    Core.ListMyUserTasks = ListMyUserTasks;
    /**
     * List OpeningHoursTemplates
     *
     * @export
     * @class ListOpeningHoursTemplates
     * @implements {EvaService}
     */
    class ListOpeningHoursTemplates {
        name = 'Core:ListOpeningHoursTemplates';
        path = '/message/ListOpeningHoursTemplates';
        request;
        response;
    }
    Core.ListOpeningHoursTemplates = ListOpeningHoursTemplates;
    /**
     * List all the attached OrganizationUnitSets for OpeningHoursTemplates
     *
     * @export
     * @class ListOpeningHoursTemplatesOrganizationUnitSets
     * @implements {EvaService}
     */
    class ListOpeningHoursTemplatesOrganizationUnitSets {
        name = 'Core:ListOpeningHoursTemplatesOrganizationUnitSets';
        path = '/message/ListOpeningHoursTemplatesOrganizationUnitSets';
        request;
        response;
    }
    Core.ListOpeningHoursTemplatesOrganizationUnitSets = ListOpeningHoursTemplatesOrganizationUnitSets;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListOrderCustomStatus
     * @implements {EvaService}
     */
    class ListOrderCustomStatus {
        name = 'Core:ListOrderCustomStatus';
        path = '/message/ListOrderCustomStatus';
        request;
        response;
    }
    Core.ListOrderCustomStatus = ListOrderCustomStatus;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListOrderCustomTypes
     * @implements {EvaService}
     */
    class ListOrderCustomTypes {
        name = 'Core:ListOrderCustomTypes';
        path = '/message/ListOrderCustomTypes';
        request;
        response;
    }
    Core.ListOrderCustomTypes = ListOrderCustomTypes;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListOrderExportsForOrder
     * @implements {EvaService}
     */
    class ListOrderExportsForOrder {
        name = 'Core:ListOrderExportsForOrder';
        path = '/message/ListOrderExportsForOrder';
        request;
        response;
    }
    Core.ListOrderExportsForOrder = ListOrderExportsForOrder;
    /**
     * Lists the OrderFulfillmentLines for a given OrderID or OrderFulfillmentID.
     *
     * @export
     * @class ListOrderFulfillmentLines
     * @implements {EvaService}
     */
    class ListOrderFulfillmentLines {
        name = 'Core:ListOrderFulfillmentLines';
        path = '/message/ListOrderFulfillmentLines';
        request;
        response;
    }
    Core.ListOrderFulfillmentLines = ListOrderFulfillmentLines;
    /**
     * List fulfillment rejections for one order.
Filter on: OrderID, SupplierOrganizationUnitID, OrderLineID, Reason, FulfillmentMethod
     *
     * @export
     * @class ListOrderFulfillmentRejections
     * @implements {EvaService}
     */
    class ListOrderFulfillmentRejections {
        name = 'Core:ListOrderFulfillmentRejections';
        path = '/message/ListOrderFulfillmentRejections';
        request;
        response;
    }
    Core.ListOrderFulfillmentRejections = ListOrderFulfillmentRejections;
    /**
     * Lists OrderFulfillments, optionally filtered.
     *
     * @export
     * @class ListOrderFulfillments
     * @implements {EvaService}
     */
    class ListOrderFulfillments {
        name = 'Core:ListOrderFulfillments';
        path = '/message/ListOrderFulfillments';
        request;
        response;
    }
    Core.ListOrderFulfillments = ListOrderFulfillments;
    /**
     * Retrieves a paged list of Order Ledgers for specified OrderID.
     *
     * @export
     * @class ListOrderLedgerForOrder
     * @implements {EvaService}
     */
    class ListOrderLedgerForOrder {
        name = 'Core:ListOrderLedgerForOrder';
        path = '/message/ListOrderLedgerForOrder';
        request;
        response;
    }
    Core.ListOrderLedgerForOrder = ListOrderLedgerForOrder;
    /**
     * List the OrderLines of an Order in a paginated fashion, allowing you to filter with a `PageConfig` and include product properties using `ProductProperties`.
   * Use this service when an Order contains a lot of lines, and the `GetOrder` service doesn't cut it - it will tell you it's time to switch using a property called `HasMoreLines`.
     *
     * @export
     * @class ListOrderLines
     * @implements {EvaService}
     */
    class ListOrderLines {
        name = 'Core:ListOrderLines';
        path = '/message/ListOrderLines';
        request;
        response;
    }
    Core.ListOrderLines = ListOrderLines;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListOrderLinesInvoiceSummary
     * @implements {EvaService}
     */
    class ListOrderLinesInvoiceSummary {
        name = 'Core:ListOrderLinesInvoiceSummary';
        path = '/message/ListOrderLinesInvoiceSummary';
        request;
        response;
    }
    Core.ListOrderLinesInvoiceSummary = ListOrderLinesInvoiceSummary;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListOrderShipments
     * @implements {EvaService}
     */
    class ListOrderShipments {
        name = 'Core:ListOrderShipments';
        path = '/message/ListOrderShipments';
        request;
        response;
    }
    Core.ListOrderShipments = ListOrderShipments;
    /**
     * Lists order verification reasons.
     *
     * @export
     * @class ListOrderVerificationReasons
     * @implements {EvaService}
     */
    class ListOrderVerificationReasons {
        name = 'Core:ListOrderVerificationReasons';
        path = '/message/ListOrderVerificationReasons';
        request;
        response;
    }
    Core.ListOrderVerificationReasons = ListOrderVerificationReasons;
    /**
     * List orders for specific customer.
     *
     * @export
     * @class ListOrdersForCustomer
     * @implements {EvaService}
     */
    class ListOrdersForCustomer {
        name = 'Core:ListOrdersForCustomer';
        path = '/message/ListOrdersForCustomer';
        request;
        response;
    }
    Core.ListOrdersForCustomer = ListOrdersForCustomer;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListOrdersWithCustomerReferences
     * @implements {EvaService}
     */
    class ListOrdersWithCustomerReferences {
        name = 'Core:ListOrdersWithCustomerReferences';
        path = '/message/ListOrdersWithCustomerReferences';
        request;
        response;
    }
    Core.ListOrdersWithCustomerReferences = ListOrdersWithCustomerReferences;
    /**
     * Returns summaries of a list of organizationunits. Since this service is publicly available, this will return minimal information (aka a summary) about the OUs.
     *
     * @export
     * @class ListOrganizationUnitSummaries
     * @implements {EvaService}
     */
    class ListOrganizationUnitSummaries {
        name = 'Core:ListOrganizationUnitSummaries';
        path = '/message/ListOrganizationUnitSummaries';
        request;
        response;
    }
    Core.ListOrganizationUnitSummaries = ListOrganizationUnitSummaries;
    /**
     * Service for retrieving a list of `OrganizationUnitSupplier`
     *
     * @export
     * @class ListOrganizationUnitSuppliers
     * @implements {EvaService}
     */
    class ListOrganizationUnitSuppliers {
        name = 'Core:ListOrganizationUnitSuppliers';
        path = '/message/ListOrganizationUnitSuppliers';
        request;
        response;
    }
    Core.ListOrganizationUnitSuppliers = ListOrganizationUnitSuppliers;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListOrganizationUnits
     * @implements {EvaService}
     */
    class ListOrganizationUnits {
        name = 'Core:ListOrganizationUnits';
        path = '/message/ListOrganizationUnits';
        request;
        response;
    }
    Core.ListOrganizationUnits = ListOrganizationUnits;
    /**
     * Returns all data of a list of organizationunits. Since this service is not publicly available, this will return all information about the OUs.
     *
     * @export
     * @class ListOrganizationUnitsDetailed
     * @implements {EvaService}
     */
    class ListOrganizationUnitsDetailed {
        name = 'Core:ListOrganizationUnitsDetailed';
        path = '/message/ListOrganizationUnitsDetailed';
        request;
        response;
    }
    Core.ListOrganizationUnitsDetailed = ListOrganizationUnitsDetailed;
    /**
     * List PaymentTransactionLedger

All available filters are typed in the PageConfig.Filter property.
     *
     * @export
     * @class ListPaymentTransactionLedger
     * @implements {EvaService}
     */
    class ListPaymentTransactionLedger {
        name = 'Core:ListPaymentTransactionLedger';
        path = '/message/ListPaymentTransactionLedger';
        request;
        response;
    }
    Core.ListPaymentTransactionLedger = ListPaymentTransactionLedger;
    /**
     * List the available PrintPriceLabel tasks for the current user.
     *
     * @export
     * @class ListPrintPriceLabelTasks
     * @implements {EvaService}
     */
    class ListPrintPriceLabelTasks {
        name = 'Core:ListPrintPriceLabelTasks';
        path = '/message/ListPrintPriceLabelTasks';
        request;
        response;
    }
    Core.ListPrintPriceLabelTasks = ListPrintPriceLabelTasks;
    /**
     * List the available Print tasks for the current user.
     *
     * @export
     * @class ListPrintTasks
     * @implements {EvaService}
     */
    class ListPrintTasks {
        name = 'Core:ListPrintTasks';
        path = '/message/ListPrintTasks';
        request;
        response;
    }
    Core.ListPrintTasks = ListPrintTasks;
    /**
     * This service returns a paged summary of `ProductBundles`, for each bundle it contains the `BundleProduct` and the pricing information for the bundle.
     *
     * @export
     * @class ListProductBundles
     * @implements {EvaService}
     */
    class ListProductBundles {
        name = 'Core:ListProductBundles';
        path = '/message/ListProductBundles';
        request;
        response;
    }
    Core.ListProductBundles = ListProductBundles;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListProductPrices
     * @implements {EvaService}
     */
    class ListProductPrices {
        name = 'Core:ListProductPrices';
        path = '/message/ListProductPrices';
        request;
        response;
    }
    Core.ListProductPrices = ListProductPrices;
    /**
     * List product structures.
     *
     * @export
     * @class ListProductStructures
     * @implements {EvaService}
     */
    class ListProductStructures {
        name = 'Core:ListProductStructures';
        path = '/message/ListProductStructures';
        request;
        response;
    }
    Core.ListProductStructures = ListProductStructures;
    /**
     * Gets all the ProductZoneGroups based on the given filter and returns a paged response.
     *
     * @export
     * @class ListProductZoneGroups
     * @implements {EvaService}
     */
    class ListProductZoneGroups {
        name = 'Core:ListProductZoneGroups';
        path = '/message/ListProductZoneGroups';
        request;
        response;
    }
    Core.ListProductZoneGroups = ListProductZoneGroups;
    /**
     * Gets all the ProductZones based on the given filter and returns a paged response.
     *
     * @export
     * @class ListProductZones
     * @implements {EvaService}
     */
    class ListProductZones {
        name = 'Core:ListProductZones';
        path = '/message/ListProductZones';
        request;
        response;
    }
    Core.ListProductZones = ListProductZones;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListPurchaseOrderShipments
     * @implements {EvaService}
     */
    class ListPurchaseOrderShipments {
        name = 'Core:ListPurchaseOrderShipments';
        path = '/message/ListPurchaseOrderShipments';
        request;
        response;
    }
    Core.ListPurchaseOrderShipments = ListPurchaseOrderShipments;
    /**
     * List the available ReceiveShipment tasks for the current user.
     *
     * @export
     * @class ListReceiveShipmentTasks
     * @implements {EvaService}
     */
    class ListReceiveShipmentTasks {
        name = 'Core:ListReceiveShipmentTasks';
        path = '/message/ListReceiveShipmentTasks';
        request;
        response;
    }
    Core.ListReceiveShipmentTasks = ListReceiveShipmentTasks;
    /**
     * Lists all tasks that are scheduled recurringly.
     *
     * @export
     * @class ListRecurringScheduledTasks
     * @implements {EvaService}
     */
    class ListRecurringScheduledTasks {
        name = 'Core:ListRecurringScheduledTasks';
        path = '/message/ListRecurringScheduledTasks';
        request;
        response;
    }
    Core.ListRecurringScheduledTasks = ListRecurringScheduledTasks;
    /**
     * Lists all tasks that are configured to run recurringly.
     *
     * @export
     * @class ListRecurringTasks
     * @implements {EvaService}
     */
    class ListRecurringTasks {
        name = 'Core:ListRecurringTasks';
        path = '/message/ListRecurringTasks';
        request;
        response;
    }
    Core.ListRecurringTasks = ListRecurringTasks;
    /**
     * Lists all tasks that are configured to run recurringly.
     *
     * @export
     * @class ListRecurringTasks2
     * @implements {EvaService}
     */
    class ListRecurringTasks2 {
        name = 'Core:ListRecurringTasks2';
        path = '/message/ListRecurringTasks2';
        request;
        response;
    }
    Core.ListRecurringTasks2 = ListRecurringTasks2;
    /**
     * List the repair interactions
     *
     * @export
     * @class ListRepairInteractions
     * @implements {EvaService}
     */
    class ListRepairInteractions {
        name = 'Core:ListRepairInteractions';
        path = '/message/ListRepairInteractions';
        request;
        response;
    }
    Core.ListRepairInteractions = ListRepairInteractions;
    /**
     * List the available Repair tasks for the current user.
     *
     * @export
     * @class ListRepairTasks
     * @implements {EvaService}
     */
    class ListRepairTasks {
        name = 'Core:ListRepairTasks';
        path = '/message/ListRepairTasks';
        request;
        response;
    }
    Core.ListRepairTasks = ListRepairTasks;
    /**
     * List Repairs, optionally filtered.
     *
     * @export
     * @class ListRepairs
     * @implements {EvaService}
     */
    class ListRepairs {
        name = 'Core:ListRepairs';
        path = '/message/ListRepairs';
        request;
        response;
    }
    Core.ListRepairs = ListRepairs;
    /**
     * List the available ReservationCleanup tasks for the current user.
     *
     * @export
     * @class ListReservationCleanupTasks
     * @implements {EvaService}
     */
    class ListReservationCleanupTasks {
        name = 'Core:ListReservationCleanupTasks';
        path = '/message/ListReservationCleanupTasks';
        request;
        response;
    }
    Core.ListReservationCleanupTasks = ListReservationCleanupTasks;
    /**
     * List the available ReservationDeviation tasks for the current user.
     *
     * @export
     * @class ListReservationDeviationTasks
     * @implements {EvaService}
     */
    class ListReservationDeviationTasks {
        name = 'Core:ListReservationDeviationTasks';
        path = '/message/ListReservationDeviationTasks';
        request;
        response;
    }
    Core.ListReservationDeviationTasks = ListReservationDeviationTasks;
    /**
     * List the available ReservationPickup tasks for the current user.
     *
     * @export
     * @class ListReservationPickupTasks
     * @implements {EvaService}
     */
    class ListReservationPickupTasks {
        name = 'Core:ListReservationPickupTasks';
        path = '/message/ListReservationPickupTasks';
        request;
        response;
    }
    Core.ListReservationPickupTasks = ListReservationPickupTasks;
    /**
     * List ReturnToSupplierRequests

Available filters:
- Name
- Status
     *
     * @export
     * @class ListReturnToSupplierRequests
     * @implements {EvaService}
     */
    class ListReturnToSupplierRequests {
        name = 'Core:ListReturnToSupplierRequests';
        path = '/message/ListReturnToSupplierRequests';
        request;
        response;
    }
    Core.ListReturnToSupplierRequests = ListReturnToSupplierRequests;
    /**
     * List available ReturnToSupplier order lines with quantities.
     *
     * @export
     * @class ListReturnToSupplierTaskOrderLines
     * @implements {EvaService}
     */
    class ListReturnToSupplierTaskOrderLines {
        name = 'Core:ListReturnToSupplierTaskOrderLines';
        path = '/message/ListReturnToSupplierTaskOrderLines';
        request;
        response;
    }
    Core.ListReturnToSupplierTaskOrderLines = ListReturnToSupplierTaskOrderLines;
    /**
     * List lines for the tasks shipment with quantities.
     *
     * @export
     * @class ListReturnToSupplierTaskShipmentLines
     * @implements {EvaService}
     */
    class ListReturnToSupplierTaskShipmentLines {
        name = 'Core:ListReturnToSupplierTaskShipmentLines';
        path = '/message/ListReturnToSupplierTaskShipmentLines';
        request;
        response;
    }
    Core.ListReturnToSupplierTaskShipmentLines = ListReturnToSupplierTaskShipmentLines;
    /**
     * List the available ReturnToSupplier tasks for the current user.
     *
     * @export
     * @class ListReturnToSupplierTasks
     * @implements {EvaService}
     */
    class ListReturnToSupplierTasks {
        name = 'Core:ListReturnToSupplierTasks';
        path = '/message/ListReturnToSupplierTasks';
        request;
        response;
    }
    Core.ListReturnToSupplierTasks = ListReturnToSupplierTasks;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListReturnableSuppliersForOrder
     * @implements {EvaService}
     */
    class ListReturnableSuppliersForOrder {
        name = 'Core:ListReturnableSuppliersForOrder';
        path = '/message/ListReturnableSuppliersForOrder';
        request;
        response;
    }
    Core.ListReturnableSuppliersForOrder = ListReturnableSuppliersForOrder;
    /**
     * Returns a list of revisions for a specific script.
     *
     * @export
     * @class ListScriptHistory
     * @implements {EvaService}
     */
    class ListScriptHistory {
        name = 'Core:ListScriptHistory';
        path = '/message/ListScriptHistory';
        request;
        response;
    }
    Core.ListScriptHistory = ListScriptHistory;
    /**
     * Lists scripts, optionally filtered.
     *
     * @export
     * @class ListScripts
     * @implements {EvaService}
     */
    class ListScripts {
        name = 'Core:ListScripts';
        path = '/message/ListScripts';
        request;
        response;
    }
    Core.ListScripts = ListScripts;
    /**
     * List the available SecondChanceProductRegistration tasks for the current user.
     *
     * @export
     * @class ListSecondChanceProductRegistrationTasks
     * @implements {EvaService}
     */
    class ListSecondChanceProductRegistrationTasks {
        name = 'Core:ListSecondChanceProductRegistrationTasks';
        path = '/message/ListSecondChanceProductRegistrationTasks';
        request;
        response;
    }
    Core.ListSecondChanceProductRegistrationTasks = ListSecondChanceProductRegistrationTasks;
    /**
     * Lists all products associated with a Serial Number Configuration.
     *
     * @export
     * @class ListSerialNumberProducts
     * @implements {EvaService}
     */
    class ListSerialNumberProducts {
        name = 'Core:ListSerialNumberProducts';
        path = '/message/ListSerialNumberProducts';
        request;
        response;
    }
    Core.ListSerialNumberProducts = ListSerialNumberProducts;
    /**
     * List serial number registrations for a serial number.
     *
     * @export
     * @class ListSerialNumberRegistrations
     * @implements {EvaService}
     */
    class ListSerialNumberRegistrations {
        name = 'Core:ListSerialNumberRegistrations';
        path = '/message/ListSerialNumberRegistrations';
        request;
        response;
    }
    Core.ListSerialNumberRegistrations = ListSerialNumberRegistrations;
    /**
     * Lists Serial Numbers
     *
     * @export
     * @class ListSerialNumbers
     * @implements {EvaService}
     */
    class ListSerialNumbers {
        name = 'Core:ListSerialNumbers';
        path = '/message/ListSerialNumbers';
        request;
        response;
    }
    Core.ListSerialNumbers = ListSerialNumbers;
    /**
     * List the available ShipFromStore tasks for the current user.
     *
     * @export
     * @class ListShipFromStoreTasks
     * @implements {EvaService}
     */
    class ListShipFromStoreTasks {
        name = 'Core:ListShipFromStoreTasks';
        path = '/message/ListShipFromStoreTasks';
        request;
        response;
    }
    Core.ListShipFromStoreTasks = ListShipFromStoreTasks;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListShipmentExportsForShipment
     * @implements {EvaService}
     */
    class ListShipmentExportsForShipment {
        name = 'Core:ListShipmentExportsForShipment';
        path = '/message/ListShipmentExportsForShipment';
        request;
        response;
    }
    Core.ListShipmentExportsForShipment = ListShipmentExportsForShipment;
    /**
     * List shipment identifiers.
     *
     * @export
     * @class ListShipmentIdentifiers
     * @implements {EvaService}
     */
    class ListShipmentIdentifiers {
        name = 'Core:ListShipmentIdentifiers';
        path = '/message/ListShipmentIdentifiers';
        request;
        response;
    }
    Core.ListShipmentIdentifiers = ListShipmentIdentifiers;
    /**
     * Retrieves a paged list of Shipment Ledgers for specified ShipmentID.
     *
     * @export
     * @class ListShipmentLedgerForShipment
     * @implements {EvaService}
     */
    class ListShipmentLedgerForShipment {
        name = 'Core:ListShipmentLedgerForShipment';
        path = '/message/ListShipmentLedgerForShipment';
        request;
        response;
    }
    Core.ListShipmentLedgerForShipment = ListShipmentLedgerForShipment;
    /**
     * Returns serial numbers on a shipment line with pagination and filtering capabilities.
     *
     * @export
     * @class ListShipmentLineSerialNumbers
     * @implements {EvaService}
     */
    class ListShipmentLineSerialNumbers {
        name = 'Core:ListShipmentLineSerialNumbers';
        path = '/message/ListShipmentLineSerialNumbers';
        request;
        response;
    }
    Core.ListShipmentLineSerialNumbers = ListShipmentLineSerialNumbers;
    /**
     * List shipmentlines of a shipment, this service replaces the GetShipmentLines and the ListPurchaseOrderShipmentLines services.

The page size `Limit` has a maximum value of `10.000` for this service.
     *
     * @export
     * @class ListShipmentLines
     * @implements {EvaService}
     */
    class ListShipmentLines {
        name = 'Core:ListShipmentLines';
        path = '/message/ListShipmentLines';
        request;
        response;
    }
    Core.ListShipmentLines = ListShipmentLines;
    /**
     * List all of the lines of a shipment that have not been completely invoiced.
     *
     * @export
     * @class ListShipmentLinesToInvoice
     * @implements {EvaService}
     */
    class ListShipmentLinesToInvoice {
        name = 'Core:ListShipmentLinesToInvoice';
        path = '/message/ListShipmentLinesToInvoice';
        request;
        response;
    }
    Core.ListShipmentLinesToInvoice = ListShipmentLinesToInvoice;
    /**
     * Lists shipment packages for a specified shipment
     *
     * @export
     * @class ListShipmentPackages
     * @implements {EvaService}
     */
    class ListShipmentPackages {
        name = 'Core:ListShipmentPackages';
        path = '/message/ListShipmentPackages';
        request;
        response;
    }
    Core.ListShipmentPackages = ListShipmentPackages;
    /**
     * List all of the shipments that have not been completely invoiced.
     *
     * @export
     * @class ListShipmentsToInvoice
     * @implements {EvaService}
     */
    class ListShipmentsToInvoice {
        name = 'Core:ListShipmentsToInvoice';
        path = '/message/ListShipmentsToInvoice';
        request;
        response;
    }
    Core.ListShipmentsToInvoice = ListShipmentsToInvoice;
    /**
     * Service that returns OrganizationUnitDtos that are approximately in range of the given latitude and longitude. The result are returned in ascending order.

This service is useful for displaying a list of the nearest shops (eg: checkout and choosing a pick-up shop).

The page size `Limit` has a maximum value of `100` for this service.
     *
     * @export
     * @class ListShopsByProximity
     * @implements {EvaService}
     */
    class ListShopsByProximity {
        name = 'Core:ListShopsByProximity';
        path = '/message/ListShopsByProximity';
        request;
        response;
    }
    Core.ListShopsByProximity = ListShopsByProximity;
    /**
     * List the Shop OrganizationUnits in a certain area

Included are the OpeningHours in the next 7 days, and the Regular OpeningHours.

This service is useful for showing all shops in a map, where you want to search in a given rectangle.
     *
     * @export
     * @class ListShopsInArea
     * @implements {EvaService}
     */
    class ListShopsInArea {
        name = 'Core:ListShopsInArea';
        path = '/message/ListShopsInArea';
        request;
        response;
    }
    Core.ListShopsInArea = ListShopsInArea;
    /**
     * List stations

This service is meant for management purposes, will return all stations you're allowed to view.
     *
     * @export
     * @class ListStations
     * @implements {EvaService}
     */
    class ListStations {
        name = 'Core:ListStations';
        path = '/message/ListStations';
        request;
        response;
    }
    Core.ListStations = ListStations;
    /**
     * List stations for specified organization unit.
     *
     * @export
     * @class ListStationsForOrganizationUnit
     * @implements {EvaService}
     */
    class ListStationsForOrganizationUnit {
        name = 'Core:ListStationsForOrganizationUnit';
        path = '/message/ListStationsForOrganizationUnit';
        request;
        response;
    }
    Core.ListStationsForOrganizationUnit = ListStationsForOrganizationUnit;
    /**
     * Returns a paginated list of all stock, optionally filtered.
     *
     * @export
     * @class ListStock
     * @implements {EvaService}
     */
    class ListStock {
        name = 'Core:ListStock';
        path = '/message/ListStock';
        request;
        response;
    }
    Core.ListStock = ListStock;
    /**
     * List the available StockMovementFollowUp tasks for the current user.
     *
     * @export
     * @class ListStockMovementFollowUpTasks
     * @implements {EvaService}
     */
    class ListStockMovementFollowUpTasks {
        name = 'Core:ListStockMovementFollowUpTasks';
        path = '/message/ListStockMovementFollowUpTasks';
        request;
        response;
    }
    Core.ListStockMovementFollowUpTasks = ListStockMovementFollowUpTasks;
    /**
     * The page size `Limit` has a maximum value of `1.000` for this service.
     *
     * @export
     * @class ListStockMutations
     * @implements {EvaService}
     */
    class ListStockMutations {
        name = 'Core:ListStockMutations';
        path = '/message/ListStockMutations';
        request;
        response;
    }
    Core.ListStockMutations = ListStockMutations;
    /**
     * Lists the additional Stock Replenishment task data.
     *
     * @export
     * @class ListStockReplenishmentTaskData
     * @implements {EvaService}
     */
    class ListStockReplenishmentTaskData {
        name = 'Core:ListStockReplenishmentTaskData';
        path = '/message/ListStockReplenishmentTaskData';
        request;
        response;
    }
    Core.ListStockReplenishmentTaskData = ListStockReplenishmentTaskData;
    /**
     * List the available StockReplenishment tasks for the current user.
     *
     * @export
     * @class ListStockReplenishmentTasks
     * @implements {EvaService}
     */
    class ListStockReplenishmentTasks {
        name = 'Core:ListStockReplenishmentTasks';
        path = '/message/ListStockReplenishmentTasks';
        request;
        response;
    }
    Core.ListStockReplenishmentTasks = ListStockReplenishmentTasks;
    /**
     * List the available StockReservation tasks for the current user.
     *
     * @export
     * @class ListStockReservationTasks
     * @implements {EvaService}
     */
    class ListStockReservationTasks {
        name = 'Core:ListStockReservationTasks';
        path = '/message/ListStockReservationTasks';
        request;
        response;
    }
    Core.ListStockReservationTasks = ListStockReservationTasks;
    /**
     * Service for retrieving a list of `StringTranslation`
     *
     * @export
     * @class ListStringTranslations
     * @implements {EvaService}
     */
    class ListStringTranslations {
        name = 'Core:ListStringTranslations';
        path = '/message/ListStringTranslations';
        request;
        response;
    }
    Core.ListStringTranslations = ListStringTranslations;
    /**
     * To continue with a suspended order, use the `ResumeSuspendedOrder` service.
     *
     * @export
     * @class ListSuspendedOrders
     * @implements {EvaService}
     */
    class ListSuspendedOrders {
        name = 'Core:ListSuspendedOrders';
        path = '/message/ListSuspendedOrders';
        request;
        response;
    }
    Core.ListSuspendedOrders = ListSuspendedOrders;
    /**
     * Returns the current tasks that prevent the current organization units' financial period from closing.
     *
     * @export
     * @class ListTasksThatBlockPeriodClosing
     * @implements {EvaService}
     */
    class ListTasksThatBlockPeriodClosing {
        name = 'Core:ListTasksThatBlockPeriodClosing';
        path = '/message/ListTasksThatBlockPeriodClosing';
        request;
        response;
    }
    Core.ListTasksThatBlockPeriodClosing = ListTasksThatBlockPeriodClosing;
    /**
     * Lists tax code mappings.
     *
     * @export
     * @class ListTaxCodeMappings
     * @implements {EvaService}
     */
    class ListTaxCodeMappings {
        name = 'Core:ListTaxCodeMappings';
        path = '/message/ListTaxCodeMappings';
        request;
        response;
    }
    Core.ListTaxCodeMappings = ListTaxCodeMappings;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListTaxCodes
     * @implements {EvaService}
     */
    class ListTaxCodes {
        name = 'Core:ListTaxCodes';
        path = '/message/ListTaxCodes';
        request;
        response;
    }
    Core.ListTaxCodes = ListTaxCodes;
    /**
     * Lists tax providers.
     *
     * @export
     * @class ListTaxProviders
     * @implements {EvaService}
     */
    class ListTaxProviders {
        name = 'Core:ListTaxProviders';
        path = '/message/ListTaxProviders';
        request;
        response;
    }
    Core.ListTaxProviders = ListTaxProviders;
    /**
     * Lists all tax rates.

Supports the filter `OnlyActive`, and when specified, will filter out all tax rates that have a `StartDate` or `EndDate` out of bounds for
'today'. The actual value of the filter is irrelevant.

:point_right: See `CreateTaxRate` service for more info.
     *
     * @export
     * @class ListTaxRates
     * @implements {EvaService}
     */
    class ListTaxRates {
        name = 'Core:ListTaxRates';
        path = '/message/ListTaxRates';
        request;
        response;
    }
    Core.ListTaxRates = ListTaxRates;
    /**
     * Service for listing transput jobs
     *
     * @export
     * @class ListTransputJobs
     * @implements {EvaService}
     */
    class ListTransputJobs {
        name = 'Core:ListTransputJobs';
        path = '/message/ListTransputJobs';
        request;
        response;
    }
    Core.ListTransputJobs = ListTransputJobs;
    /**
     * List the UserTasks for the current user.
     *
     * @export
     * @class ListUrgentTasks
     * @implements {EvaService}
     */
    class ListUrgentTasks {
        name = 'Core:ListUrgentTasks';
        path = '/message/ListUrgentTasks';
        request;
        response;
    }
    Core.ListUrgentTasks = ListUrgentTasks;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListUserApiKeys
     * @implements {EvaService}
     */
    class ListUserApiKeys {
        name = 'Core:ListUserApiKeys';
        path = '/message/ListUserApiKeys';
        request;
        response;
    }
    Core.ListUserApiKeys = ListUserApiKeys;
    /**
     * List borrowed products based on the given filter
     *
     * @export
     * @class ListUserBorrowedProducts
     * @implements {EvaService}
     */
    class ListUserBorrowedProducts {
        name = 'Core:ListUserBorrowedProducts';
        path = '/message/ListUserBorrowedProducts';
        request;
        response;
    }
    Core.ListUserBorrowedProducts = ListUserBorrowedProducts;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListUserGroups
     * @implements {EvaService}
     */
    class ListUserGroups {
        name = 'Core:ListUserGroups';
        path = '/message/ListUserGroups';
        request;
        response;
    }
    Core.ListUserGroups = ListUserGroups;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListUserInteractions
     * @implements {EvaService}
     */
    class ListUserInteractions {
        name = 'Core:ListUserInteractions';
        path = '/message/ListUserInteractions';
        request;
        response;
    }
    Core.ListUserInteractions = ListUserInteractions;
    /**
     * List the user loyalty transactions.
     *
     * @export
     * @class ListUserLoyaltyTransactions
     * @implements {EvaService}
     */
    class ListUserLoyaltyTransactions {
        name = 'Core:ListUserLoyaltyTransactions';
        path = '/message/ListUserLoyaltyTransactions';
        request;
        response;
    }
    Core.ListUserLoyaltyTransactions = ListUserLoyaltyTransactions;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListUserTaskTypeOrganizationUnitSets
     * @implements {EvaService}
     */
    class ListUserTaskTypeOrganizationUnitSets {
        name = 'Core:ListUserTaskTypeOrganizationUnitSets';
        path = '/message/ListUserTaskTypeOrganizationUnitSets';
        request;
        response;
    }
    Core.ListUserTaskTypeOrganizationUnitSets = ListUserTaskTypeOrganizationUnitSets;
    /**
     * Returns a paged list of UserTasks.
     *
     * @export
     * @class ListUserTasks
     * @implements {EvaService}
     */
    class ListUserTasks {
        name = 'Core:ListUserTasks';
        path = '/message/ListUserTasks';
        request;
        response;
    }
    Core.ListUserTasks = ListUserTasks;
    /**
     * List the users wishlists.
     *
     * @export
     * @class ListUserWishlists
     * @implements {EvaService}
     */
    class ListUserWishlists {
        name = 'Core:ListUserWishlists';
        path = '/message/ListUserWishlists';
        request;
        response;
    }
    Core.ListUserWishlists = ListUserWishlists;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListUsersForUserGroup
     * @implements {EvaService}
     */
    class ListUsersForUserGroup {
        name = 'Core:ListUsersForUserGroup';
        path = '/message/ListUsersForUserGroup';
        request;
        response;
    }
    Core.ListUsersForUserGroup = ListUsersForUserGroup;
    /**
     * Lists results associated with a Zoned Cycle Count PreCount
     *
     * @export
     * @class ListZonedCycleCountPreCountResult
     * @implements {EvaService}
     */
    class ListZonedCycleCountPreCountResult {
        name = 'Core:ListZonedCycleCountPreCountResult';
        path = '/message/ListZonedCycleCountPreCountResult';
        request;
        response;
    }
    Core.ListZonedCycleCountPreCountResult = ListZonedCycleCountPreCountResult;
    /**
     * List the available ZonedCycleCountPreCount tasks for the current user.
     *
     * @export
     * @class ListZonedCycleCountPreCountTasks
     * @implements {EvaService}
     */
    class ListZonedCycleCountPreCountTasks {
        name = 'Core:ListZonedCycleCountPreCountTasks';
        path = '/message/ListZonedCycleCountPreCountTasks';
        request;
        response;
    }
    Core.ListZonedCycleCountPreCountTasks = ListZonedCycleCountPreCountTasks;
    /**
     * Lists the Zoned Cycle Count Schedules.
     *
     * @export
     * @class ListZonedCycleCountSchedules
     * @implements {EvaService}
     */
    class ListZonedCycleCountSchedules {
        name = 'Core:ListZonedCycleCountSchedules';
        path = '/message/ListZonedCycleCountSchedules';
        request;
        response;
    }
    Core.ListZonedCycleCountSchedules = ListZonedCycleCountSchedules;
    /**
     * Retrieves the status of serial numbers for a specific product and stock label within a Zoned Cycle Count.
     *
     * @export
     * @class ListZonedCycleCountSerialNumbersStatus
     * @implements {EvaService}
     */
    class ListZonedCycleCountSerialNumbersStatus {
        name = 'Core:ListZonedCycleCountSerialNumbersStatus';
        path = '/message/ListZonedCycleCountSerialNumbersStatus';
        request;
        response;
    }
    Core.ListZonedCycleCountSerialNumbersStatus = ListZonedCycleCountSerialNumbersStatus;
    /**
     * List the available ZonedCycleCount tasks for the current user.
     *
     * @export
     * @class ListZonedCycleCountTasks
     * @implements {EvaService}
     */
    class ListZonedCycleCountTasks {
        name = 'Core:ListZonedCycleCountTasks';
        path = '/message/ListZonedCycleCountTasks';
        request;
        response;
    }
    Core.ListZonedCycleCountTasks = ListZonedCycleCountTasks;
    /**
     * The page size `Limit` has a maximum value of `250` for this service.
     *
     * @export
     * @class ListZonedCycleCounts
     * @implements {EvaService}
     */
    class ListZonedCycleCounts {
        name = 'Core:ListZonedCycleCounts';
        path = '/message/ListZonedCycleCounts';
        request;
        response;
    }
    Core.ListZonedCycleCounts = ListZonedCycleCounts;
    /**
     * Lock the Order in order to prevent some editing functionalities on it.
     *
     * @export
     * @class LockOrder
     * @implements {EvaService}
     */
    class LockOrder {
        name = 'Core:LockOrder';
        path = '/message/LockOrder';
        request;
        response;
    }
    Core.LockOrder = LockOrder;
    /**
     * Authenticates a user
     *
     * @export
     * @class Login
     * @implements {EvaService}
     */
    class Login {
        name = 'Core:Login';
        path = '/message/Login';
        request;
        response;
    }
    Core.Login = Login;
    /**
     * Ends the current session of the user and invalidates the used AuthenticationToken

Optionally the ExpireAllSessions property can be set to terminate all current sessions for the User.

The Clockout property can be used the register a clock out event for time tracking.
     *
     * @export
     * @class Logout
     * @implements {EvaService}
     */
    class Logout {
        name = 'Core:Logout';
        path = '/message/Logout';
        request;
        response;
    }
    Core.Logout = Logout;
    /**
     * This service marks the provided phone number as the user's primary phone number,
which will be used for communication with the user.

This service only allows the number's own user or an employee to mark it as the primary number.
     *
     * @export
     * @class MakeUserPhoneNumberPrimary
     * @implements {EvaService}
     */
    class MakeUserPhoneNumberPrimary {
        name = 'Core:MakeUserPhoneNumberPrimary';
        path = '/message/MakeUserPhoneNumberPrimary';
        request;
        response;
    }
    Core.MakeUserPhoneNumberPrimary = MakeUserPhoneNumberPrimary;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class MigrateOrdersToUnified
     * @implements {EvaService}
     */
    class MigrateOrdersToUnified {
        name = 'Core:MigrateOrdersToUnified';
        path = '/message/MigrateOrdersToUnified';
        request;
        response;
    }
    Core.MigrateOrdersToUnified = MigrateOrdersToUnified;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class MissingProductForInitialCycleCount
     * @implements {EvaService}
     */
    class MissingProductForInitialCycleCount {
        name = 'Core:MissingProductForInitialCycleCount';
        path = '/message/MissingProductForInitialCycleCount';
        request;
        response;
    }
    Core.MissingProductForInitialCycleCount = MissingProductForInitialCycleCount;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ModifyOrderLinePrice
     * @implements {EvaService}
     */
    class ModifyOrderLinePrice {
        name = 'Core:ModifyOrderLinePrice';
        path = '/message/ModifyOrderLinePrice';
        request;
        response;
    }
    Core.ModifyOrderLinePrice = ModifyOrderLinePrice;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ModifyPurchaseOrderLine
     * @implements {EvaService}
     */
    class ModifyPurchaseOrderLine {
        name = 'Core:ModifyPurchaseOrderLine';
        path = '/message/ModifyPurchaseOrderLine';
        request;
        response;
    }
    Core.ModifyPurchaseOrderLine = ModifyPurchaseOrderLine;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ModifyQuantityOrdered
     * @implements {EvaService}
     */
    class ModifyQuantityOrdered {
        name = 'Core:ModifyQuantityOrdered';
        path = '/message/ModifyQuantityOrdered';
        request;
        response;
    }
    Core.ModifyQuantityOrdered = ModifyQuantityOrdered;
    /**
     * Modify the QuantityShipped on one or more ShipmentLines of a Shipment.

When the new QuantityShipped is 0 it will be cancelled.
     *
     * @export
     * @class ModifyQuantityShipped
     * @implements {EvaService}
     */
    class ModifyQuantityShipped {
        name = 'Core:ModifyQuantityShipped';
        path = '/message/ModifyQuantityShipped';
        request;
        response;
    }
    Core.ModifyQuantityShipped = ModifyQuantityShipped;
    /**
     * Moves cash!
     *
     * @export
     * @class MoveCash
     * @implements {EvaService}
     */
    class MoveCash {
        name = 'Core:MoveCash';
        path = '/message/MoveCash';
        request;
        response;
    }
    Core.MoveCash = MoveCash;
    /**
     * This service allows you to move stock commitments from one OrderLine (`SourceOrderLineID`) to another OrderLine (`DestinationOrderLineID`).

- If the Source and Destination do not share the same ProductID, a `CannotMoveCommitment` error is returned.
- If the Source does not have a commitment, a `CannotMoveCommitment` error is returned.
     *
     * @export
     * @class MoveCommitments
     * @implements {EvaService}
     */
    class MoveCommitments {
        name = 'Core:MoveCommitments';
        path = '/message/MoveCommitments';
        request;
        response;
    }
    Core.MoveCommitments = MoveCommitments;
    /**
     * Books a set of Movements.

A Movement should have a `ProductID` to identify the product, an `OrganizationUnitID` to identify the stock keeping
organization, a `SourceStockLabelID` and `DestinationStockLabelID` (see `GetEnumValues` with type `StockLabel`) and (of course) a `Quantity`
to actually book.

Supply a `BackendSystemID` on the request and `BackendID`'s on the Movements to make the request idempotent.

Optionally supports a `StockMutationReasonID` and `Remark` for each Movement.
     *
     * @export
     * @class MoveStock
     * @implements {EvaService}
     */
    class MoveStock {
        name = 'Core:MoveStock';
        path = '/message/MoveStock';
        request;
        response;
    }
    Core.MoveStock = MoveStock;
    /**
     * Opens a financial period for your current OrganizationUnit.
     *
     * @export
     * @class OpenFinancialPeriod
     * @implements {EvaService}
     */
    class OpenFinancialPeriod {
        name = 'Core:OpenFinancialPeriod';
        path = '/message/OpenFinancialPeriod';
        request;
        response;
    }
    Core.OpenFinancialPeriod = OpenFinancialPeriod;
    /**
     * Parses the given barcode with an available handler that can process it.
     *
     * @export
     * @class ParseBarcode
     * @implements {EvaService}
     */
    class ParseBarcode {
        name = 'Core:ParseBarcode';
        path = '/message/ParseBarcode';
        request;
        response;
    }
    Core.ParseBarcode = ParseBarcode;
    /**
     * Parses a script for validation and auto-completion.

Can be used as the user types their script, for that purpose use these parameters:
- Type: Fast, doing Full performs a full compilation of the script which can take longer. Using Full can be done before the user hits the Save button, or for example every 10th keystroke or so.

Use IncludeCompletionSuggestions if you want to display auto-completion suggestions to the user.

You can verify the entire script and get completion results by passing in the full script as the Source and only the text until the user's cursor in the CompletionSource.

A list of the available dialects can be retrieved by calling GetScriptDialects.
     *
     * @export
     * @class ParseScript
     * @implements {EvaService}
     */
    class ParseScript {
        name = 'Core:ParseScript';
        path = '/message/ParseScript';
        request;
        response;
    }
    Core.ParseScript = ParseScript;
    /**
     * Pauses a ConsolidatedPickTask task.
     *
     * @export
     * @class PauseConsolidatedPickTask
     * @implements {EvaService}
     */
    class PauseConsolidatedPickTask {
        name = 'Core:PauseConsolidatedPickTask';
        path = '/message/PauseConsolidatedPickTask';
        request;
        response;
    }
    Core.PauseConsolidatedPickTask = PauseConsolidatedPickTask;
    /**
     * Stub service to validate the current token for employees
     *
     * @export
     * @class Ping
     * @implements {EvaService}
     */
    class Ping {
        name = 'Core:Ping';
        path = '/message/Ping';
        request;
        response;
    }
    Core.Ping = Ping;
    /**
     * Placing an order means it is final for all parties; both agree on the exchange in goods, services and/or money that this order implies.

Will set the `Order`.`IsPlaced` flag.

This service can be used to place a single order, or to place a batch at once.
     *
     * @export
     * @class PlaceOrder
     * @implements {EvaService}
     */
    class PlaceOrder {
        name = 'Core:PlaceOrder';
        path = '/message/PlaceOrder';
        request;
        response;
    }
    Core.PlaceOrder = PlaceOrder;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class PollExternalOrderStatus
     * @implements {EvaService}
     */
    class PollExternalOrderStatus {
        name = 'Core:PollExternalOrderStatus';
        path = '/message/PollExternalOrderStatus';
        request;
        response;
    }
    Core.PollExternalOrderStatus = PollExternalOrderStatus;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class PreCountInitialCycleCountLabel
     * @implements {EvaService}
     */
    class PreCountInitialCycleCountLabel {
        name = 'Core:PreCountInitialCycleCountLabel';
        path = '/message/PreCountInitialCycleCountLabel';
        request;
        response;
    }
    Core.PreCountInitialCycleCountLabel = PreCountInitialCycleCountLabel;
    /**
     * List the discounts that potentially could be activated.

A order or user can be given to look at the context of the order or user. When order is given the user will be ignored and the customer of the order will be used (if present)

If a `ProductIDs`, `ProductSearchID` or `ProductSearch` is set, the service will check if the resulting products are a eligible to one or more discounts. If an `OrderID` is provided, the context of the given order is taken into account, that can include user specific discounts, order OU specific discount, etc.

Be aware that:
- If `ProductIDs` is given, `ProductSearchID` and `ProductSearch` are ignored
- If `ProductSearchID` is given, `ProductIDs` and `ProductSearch` are ignored
- If `ProductSearch` is given, `ProductIDs` and `ProductSearchID` are ignored
     *
     * @export
     * @class PrefigureDiscounts
     * @implements {EvaService}
     */
    class PrefigureDiscounts {
        name = 'Core:PrefigureDiscounts';
        path = '/message/PrefigureDiscounts';
        request;
        response;
    }
    Core.PrefigureDiscounts = PrefigureDiscounts;
    /**
     * Prepare the order to go into the checkout

If the order still has status ShoppingCart, update it to Order and:
 - Validate lineactiontypes (customer are not allowed to use ShipLine p/a)
 - Set the SoldBy on the lines to the current user
 - Set the addresses of the customer on the order, if not already set
 - (Re)calculate the taxes
 - Recalculate the order: discounts, shippingcosts, giftwrappingcosts etc.
     *
     * @export
     * @class PrepareOrderForCheckout
     * @implements {EvaService}
     */
    class PrepareOrderForCheckout {
        name = 'Core:PrepareOrderForCheckout';
        path = '/message/PrepareOrderForCheckout';
        request;
        response;
    }
    Core.PrepareOrderForCheckout = PrepareOrderForCheckout;
    /**
     * Render a UserInteraction of Type Communication in something that can be displayed.

This can be used to view the send emails in a webview/iframe.
     *
     * @export
     * @class PreviewUserInteractionCommunication
     * @implements {EvaService}
     */
    class PreviewUserInteractionCommunication {
        name = 'Core:PreviewUserInteractionCommunication';
        path = '/message/PreviewUserInteractionCommunication';
        request;
        response;
    }
    Core.PreviewUserInteractionCommunication = PreviewUserInteractionCommunication;
    /**
     * Pushes a blob (by `BlobID` or `BlobUrl`) to a device of specified `Type` on given `StationID`.
     *
     * @export
     * @class Print
     * @implements {EvaService}
     */
    class Print {
        name = 'Core:Print';
        path = '/message/Print';
        request;
        response;
    }
    Core.Print = Print;
    /**
     * This is service is used only for printing couopons.
     *
     * @export
     * @class PrintCouponsForOrder
     * @implements {EvaService}
     */
    class PrintCouponsForOrder {
        name = 'Core:PrintCouponsForOrder';
        path = '/message/PrintCouponsForOrder';
        request;
        response;
    }
    Core.PrintCouponsForOrder = PrintCouponsForOrder;
    /**
     * Prints label(s) for specified Full Stock Count to specified station.
     *
     * @export
     * @class PrintFullStockCountLabels
     * @implements {EvaService}
     */
    class PrintFullStockCountLabels {
        name = 'Core:PrintFullStockCountLabels';
        path = '/message/PrintFullStockCountLabels';
        request;
        response;
    }
    Core.PrintFullStockCountLabels = PrintFullStockCountLabels;
    /**
     * Print the InterbranchOrder receipt.
     *
     * @export
     * @class PrintInterbranchOrderReceipt
     * @implements {EvaService}
     */
    class PrintInterbranchOrderReceipt {
        name = 'Core:PrintInterbranchOrderReceipt';
        path = '/message/PrintInterbranchOrderReceipt';
        request;
        response;
    }
    Core.PrintInterbranchOrderReceipt = PrintInterbranchOrderReceipt;
    /**
     * This service is used only for printing paper invoices.
     *
     * @export
     * @class PrintPaperInvoice
     * @implements {EvaService}
     */
    class PrintPaperInvoice {
        name = 'Core:PrintPaperInvoice';
        path = '/message/PrintPaperInvoice';
        request;
        response;
    }
    Core.PrintPaperInvoice = PrintPaperInvoice;
    /**
     * This is service is used for printing sales paper invoices for one order.
     *
     * @export
     * @class PrintPaperInvoices
     * @implements {EvaService}
     */
    class PrintPaperInvoices {
        name = 'Core:PrintPaperInvoices';
        path = '/message/PrintPaperInvoices';
        request;
        response;
    }
    Core.PrintPaperInvoices = PrintPaperInvoices;
    /**
     * This service is used only for printing offers.
     *
     * @export
     * @class PrintPaperOffer
     * @implements {EvaService}
     */
    class PrintPaperOffer {
        name = 'Core:PrintPaperOffer';
        path = '/message/PrintPaperOffer';
        request;
        response;
    }
    Core.PrintPaperOffer = PrintPaperOffer;
    /**
     * This service is used only for printing paper invoices.
     *
     * @export
     * @class PrintPaperOrderConfirmation
     * @implements {EvaService}
     */
    class PrintPaperOrderConfirmation {
        name = 'Core:PrintPaperOrderConfirmation';
        path = '/message/PrintPaperOrderConfirmation';
        request;
        response;
    }
    Core.PrintPaperOrderConfirmation = PrintPaperOrderConfirmation;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class PrintPriceLabel
     * @implements {EvaService}
     */
    class PrintPriceLabel {
        name = 'Core:PrintPriceLabel';
        path = '/message/PrintPriceLabel';
        request;
        response;
    }
    Core.PrintPriceLabel = PrintPriceLabel;
    /**
     * This service is used to print labels containing the price details of one product
     *
     * @export
     * @class PrintProductPriceLabel
     * @implements {EvaService}
     */
    class PrintProductPriceLabel {
        name = 'Core:PrintProductPriceLabel';
        path = '/message/PrintProductPriceLabel';
        request;
        response;
    }
    Core.PrintProductPriceLabel = PrintProductPriceLabel;
    /**
     * Print repair thermal receipt
     *
     * @export
     * @class PrintRepairThermalReceipt
     * @implements {EvaService}
     */
    class PrintRepairThermalReceipt {
        name = 'Core:PrintRepairThermalReceipt';
        path = '/message/PrintRepairThermalReceipt';
        request;
        response;
    }
    Core.PrintRepairThermalReceipt = PrintRepairThermalReceipt;
    /**
     * Print the return to supplier order label.
     *
     * @export
     * @class PrintReturnToSupplierOrderTicket
     * @implements {EvaService}
     */
    class PrintReturnToSupplierOrderTicket {
        name = 'Core:PrintReturnToSupplierOrderTicket';
        path = '/message/PrintReturnToSupplierOrderTicket';
        request;
        response;
    }
    Core.PrintReturnToSupplierOrderTicket = PrintReturnToSupplierOrderTicket;
    /**
     * Print the return to supplier order receipt.
     *
     * @export
     * @class PrintReturnToSupplierReceipt
     * @implements {EvaService}
     */
    class PrintReturnToSupplierReceipt {
        name = 'Core:PrintReturnToSupplierReceipt';
        path = '/message/PrintReturnToSupplierReceipt';
        request;
        response;
    }
    Core.PrintReturnToSupplierReceipt = PrintReturnToSupplierReceipt;
    /**
     * Print the tasks shipment label.
     *
     * @export
     * @class PrintReturnToSupplierTaskShipment
     * @implements {EvaService}
     */
    class PrintReturnToSupplierTaskShipment {
        name = 'Core:PrintReturnToSupplierTaskShipment';
        path = '/message/PrintReturnToSupplierTaskShipment';
        request;
        response;
    }
    Core.PrintReturnToSupplierTaskShipment = PrintReturnToSupplierTaskShipment;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class PrintSecondChanceProductPriceLabel
     * @implements {EvaService}
     */
    class PrintSecondChanceProductPriceLabel {
        name = 'Core:PrintSecondChanceProductPriceLabel';
        path = '/message/PrintSecondChanceProductPriceLabel';
        request;
        response;
    }
    Core.PrintSecondChanceProductPriceLabel = PrintSecondChanceProductPriceLabel;
    /**
     * Generates a combined pick list for given Ship From Store tasks, starting and assigning them all to the current user.

These tasks need to be ShipFromStore type with subtype Pick, or a CompositeUserTask type with such a task as first child.
     *
     * @export
     * @class PrintShipFromStoreTasks
     * @implements {EvaService}
     */
    class PrintShipFromStoreTasks {
        name = 'Core:PrintShipFromStoreTasks';
        path = '/message/PrintShipFromStoreTasks';
        request;
        response;
    }
    Core.PrintShipFromStoreTasks = PrintShipFromStoreTasks;
    /**
     * Print the Reservation receipt for the given Order
     *
     * @export
     * @class PrintStockReservationReceipt
     * @implements {EvaService}
     */
    class PrintStockReservationReceipt {
        name = 'Core:PrintStockReservationReceipt';
        path = '/message/PrintStockReservationReceipt';
        request;
        response;
    }
    Core.PrintStockReservationReceipt = PrintStockReservationReceipt;
    /**
     * Print a *gift* receipt; a regular receipt, but without any price- or payment details. This document is intended to accompany the purchase when gifted, so the recipient can return or exchange it without (direct) knowledge of the price.
    The `Lines` property is optional, when omitted the entire order (from `OrderID`) will be printed. Also, `Name` and `Remark` are optional and intended for the gift recipient, only.
     *
     * @export
     * @class PrintThermalGiftReceipt
     * @implements {EvaService}
     */
    class PrintThermalGiftReceipt {
        name = 'Core:PrintThermalGiftReceipt';
        path = '/message/PrintThermalGiftReceipt';
        request;
        response;
    }
    Core.PrintThermalGiftReceipt = PrintThermalGiftReceipt;
    /**
     * This is service is used only for printing thermal invoices.
     *
     * @export
     * @class PrintThermalInvoice
     * @implements {EvaService}
     */
    class PrintThermalInvoice {
        name = 'Core:PrintThermalInvoice';
        path = '/message/PrintThermalInvoice';
        request;
        response;
    }
    Core.PrintThermalInvoice = PrintThermalInvoice;
    /**
     * This is service is used for printing sales thermal invoices for one order.
     *
     * @export
     * @class PrintThermalInvoices
     * @implements {EvaService}
     */
    class PrintThermalInvoices {
        name = 'Core:PrintThermalInvoices';
        path = '/message/PrintThermalInvoices';
        request;
        response;
    }
    Core.PrintThermalInvoices = PrintThermalInvoices;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class PrintThermalOrderConfirmation
     * @implements {EvaService}
     */
    class PrintThermalOrderConfirmation {
        name = 'Core:PrintThermalOrderConfirmation';
        path = '/message/PrintThermalOrderConfirmation';
        request;
        response;
    }
    Core.PrintThermalOrderConfirmation = PrintThermalOrderConfirmation;
    /**
     * Print an order summary as a thermal non-fiscal receipt.
It can be used when a payment is refunded or canceled during the sale process, the cashier needs to hand a proof to the customer with the current state of the order.
     *
     * @export
     * @class PrintThermalOrderSummary
     * @implements {EvaService}
     */
    class PrintThermalOrderSummary {
        name = 'Core:PrintThermalOrderSummary';
        path = '/message/PrintThermalOrderSummary';
        request;
        response;
    }
    Core.PrintThermalOrderSummary = PrintThermalOrderSummary;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ProcessInitialCycleCountResults
     * @implements {EvaService}
     */
    class ProcessInitialCycleCountResults {
        name = 'Core:ProcessInitialCycleCountResults';
        path = '/message/ProcessInitialCycleCountResults';
        request;
        response;
    }
    Core.ProcessInitialCycleCountResults = ProcessInitialCycleCountResults;
    /**
     * Processes the print tasks for each required ID.

This service does not throws an expeption in the case of mulptiple user task ids, but the output will be a dictionary containing
an Error (EVA.Framework.Error) for every print task that encounters an issue. The UserTaskID will be the key in that specific Dictionary.

In the case of a single user task id, the service will behave exactly as the depracated ProcessPrintTask service did, throwing the encountered exception.
     *
     * @export
     * @class ProcessPrintTasks
     * @implements {EvaService}
     */
    class ProcessPrintTasks {
        name = 'Core:ProcessPrintTasks';
        path = '/message/ProcessPrintTasks';
        request;
        response;
    }
    Core.ProcessPrintTasks = ProcessPrintTasks;
    /**
     * Start the processing of a ReturnToSupplierRequest

This will put the request in a processing state and will generate the orders based on the set options.
     *
     * @export
     * @class ProcessReturnToSupplierRequest
     * @implements {EvaService}
     */
    class ProcessReturnToSupplierRequest {
        name = 'Core:ProcessReturnToSupplierRequest';
        path = '/message/ProcessReturnToSupplierRequest';
        request;
        response;
    }
    Core.ProcessReturnToSupplierRequest = ProcessReturnToSupplierRequest;
    /**
     * Processes a (delta)stock mutation file.

Expected format of the file is JSON with the following markup:

```
[
  {
    "ProductID": [Optional, int],
    "ProductBackendID": [Optional, string],
    "QuantityOnHand": [Required, int, value >= 0],
    "StockMutationReasonID": [Optional, int],
    "Remark": [Optional, string]
  },
  ...
]
```

Mutation will only be processed for valid ProductIDs or ProductBackendIDs. In case ProductID and ProductBackendID are provided,
ProductBackendID will be selected as the search parameter.
     *
     * @export
     * @class ProcessStockMutationFile
     * @implements {EvaService}
     */
    class ProcessStockMutationFile {
        name = 'Core:ProcessStockMutationFile';
        path = '/message/ProcessStockMutationFile';
        request;
        response;
    }
    Core.ProcessStockMutationFile = ProcessStockMutationFile;
    /**
     * Process unprocessed financial events.
     *
     * @export
     * @class ProcessUnprocessedFinancialEvents
     * @implements {EvaService}
     */
    class ProcessUnprocessedFinancialEvents {
        name = 'Core:ProcessUnprocessedFinancialEvents';
        path = '/message/ProcessUnprocessedFinancialEvents';
        request;
        response;
    }
    Core.ProcessUnprocessedFinancialEvents = ProcessUnprocessedFinancialEvents;
    /**
     * Service for producing a cash deposit document
     *
     * @export
     * @class ProduceCashDepositDocument
     * @implements {EvaService}
     */
    class ProduceCashDepositDocument {
        name = 'Core:ProduceCashDepositDocument';
        path = '/message/ProduceCashDepositDocument';
        request;
        response;
    }
    Core.ProduceCashDepositDocument = ProduceCashDepositDocument;
    /**
     * Service for producing a cash expense document
     *
     * @export
     * @class ProduceCashExpenseDocument
     * @implements {EvaService}
     */
    class ProduceCashExpenseDocument {
        name = 'Core:ProduceCashExpenseDocument';
        path = '/message/ProduceCashExpenseDocument';
        request;
        response;
    }
    Core.ProduceCashExpenseDocument = ProduceCashExpenseDocument;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ProduceDocuments
     * @implements {EvaService}
     */
    class ProduceDocuments {
        name = 'Core:ProduceDocuments';
        path = '/message/ProduceDocuments';
        request;
        response;
    }
    Core.ProduceDocuments = ProduceDocuments;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ProduceInitialCycleCountLabels
     * @implements {EvaService}
     */
    class ProduceInitialCycleCountLabels {
        name = 'Core:ProduceInitialCycleCountLabels';
        path = '/message/ProduceInitialCycleCountLabels';
        request;
        response;
    }
    Core.ProduceInitialCycleCountLabels = ProduceInitialCycleCountLabels;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ProduceInvoice
     * @implements {EvaService}
     */
    class ProduceInvoice {
        name = 'Core:ProduceInvoice';
        path = '/message/ProduceInvoice';
        request;
        response;
    }
    Core.ProduceInvoice = ProduceInvoice;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ProducePackingSlip
     * @implements {EvaService}
     */
    class ProducePackingSlip {
        name = 'Core:ProducePackingSlip';
        path = '/message/ProducePackingSlip';
        request;
        response;
    }
    Core.ProducePackingSlip = ProducePackingSlip;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ProducePickSlip
     * @implements {EvaService}
     */
    class ProducePickSlip {
        name = 'Core:ProducePickSlip';
        path = '/message/ProducePickSlip';
        request;
        response;
    }
    Core.ProducePickSlip = ProducePickSlip;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ProducePurchaseOrderDocument
     * @implements {EvaService}
     */
    class ProducePurchaseOrderDocument {
        name = 'Core:ProducePurchaseOrderDocument';
        path = '/message/ProducePurchaseOrderDocument';
        request;
        response;
    }
    Core.ProducePurchaseOrderDocument = ProducePurchaseOrderDocument;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ProduceReceipt
     * @implements {EvaService}
     */
    class ProduceReceipt {
        name = 'Core:ProduceReceipt';
        path = '/message/ProduceReceipt';
        request;
        response;
    }
    Core.ProduceReceipt = ProduceReceipt;
    /**
     * Generate shipment document for an order or shipment.

It is required to supply an `OrderID` or a `ShipmentID`.

When using an `OrderID` it is also required to set the `LinesToShip`.

When a `StationID` is supplied the documents will be printed, if not, the service will return urls for downloading the documents.
     *
     * @export
     * @class ProduceShipmentDocuments
     * @implements {EvaService}
     */
    class ProduceShipmentDocuments {
        name = 'Core:ProduceShipmentDocuments';
        path = '/message/ProduceShipmentDocuments';
        request;
        response;
    }
    Core.ProduceShipmentDocuments = ProduceShipmentDocuments;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ProduceTrackingInformation
     * @implements {EvaService}
     */
    class ProduceTrackingInformation {
        name = 'Core:ProduceTrackingInformation';
        path = '/message/ProduceTrackingInformation';
        request;
        response;
    }
    Core.ProduceTrackingInformation = ProduceTrackingInformation;
    /**
     *
     *
     * @export
     * @class ProduceZonedCycleCountHandout
     * @implements {EvaService}
     */
    class ProduceZonedCycleCountHandout {
        name = 'Core:ProduceZonedCycleCountHandout';
        path = '/message/ProduceZonedCycleCountHandout';
        request;
        response;
    }
    Core.ProduceZonedCycleCountHandout = ProduceZonedCycleCountHandout;
    /**
     * A service that allows to manage the entirety of a price list.
     *
     * @export
     * @class PushPriceList
     * @implements {EvaService}
     */
    class PushPriceList {
        name = 'Core:PushPriceList';
        path = '/message/PushPriceList';
        request;
        response;
    }
    Core.PushPriceList = PushPriceList;
    /**
     * A service that allows to manage the entirety of a price list.
     *
     * @export
     * @class PushPriceList_Async
     * @implements {EvaService}
     */
    class PushPriceList_Async {
        name = 'Core:PushPriceList_Async';
        path = '/async-message/PushPriceList';
        request;
        response;
    }
    Core.PushPriceList_Async = PushPriceList_Async;
    /**
     * A service that allows to manage the entirety of a price list.
     *
     * @export
     * @class PushPriceList_AsyncResult
     * @implements {EvaService}
     */
    class PushPriceList_AsyncResult {
        name = 'Core:PushPriceList_AsyncResult';
        path = '/async-result/PushPriceList';
        request;
        response;
    }
    Core.PushPriceList_AsyncResult = PushPriceList_AsyncResult;
    /**
     * Creates a returnorder with all specified data

It is required to send the identifier for the ReturnOrder of the external system by providing a BackendSystemID and a BackendID.

A return is based of an OriginalOrder. This order can be identifier by the OriginalBackendID or the OriginalOrderID. One of those is required.

If the stock is already received, set the `AlreadyReceived` to true. This will ship the order immediately.

If the stock is already received and the open amount should be refunded directly, set `AutoRefund` to true.

The Lines have to be identified by the original line, this should be done by providing the OriginalBackendID or the OriginalOrderLineID.
If those are not available the CustomID of the product can be set, but matching based on that is not advised.
     *
     * @export
     * @class PushReturnOrder
     * @implements {EvaService}
     */
    class PushReturnOrder {
        name = 'Core:PushReturnOrder';
        path = '/message/PushReturnOrder';
        request;
        response;
    }
    Core.PushReturnOrder = PushReturnOrder;
    /**
     * Creates an order with all specified data, places it, and raises all follow-up events.

Whenever the order already exists with the same BackendSystemID/BackendID combination, nothing will be modified.
     *
     * @export
     * @class PushSalesOrder
     * @implements {EvaService}
     */
    class PushSalesOrder {
        name = 'Core:PushSalesOrder';
        path = '/message/PushSalesOrder';
        request;
        response;
    }
    Core.PushSalesOrder = PushSalesOrder;
    /**
     * Push multiple serial numbers into EVA.

- The `ProductID` is required
- You must either specify *both*, or *neither* of `StockLabelID` and `OrganizationUnitID`

:bulb: Our recommended JSON request size limit is 10 MB
:muscle: So when calling this service with just a `SerialNumber` and a `ProductID`, that should be somewhere between 100.000 and 200.000 serials per call
:warning: When a product belongs to a Serial Number Configuration that is configured with a validation regex, serial numbers pushed for that product must match this regex

This service is built for speeeeeeeeeeeed :rocket:, and so has a slightly different idempotency from other services;

- Skips over errors and attempts to persist as many serial numbers as possible
- Gathers any error encountered and returns (up to 1.000 of) them, so you can fix & retry
- Ignores serial numbers that already exist in EVA
- Ignores duplicates within the same call (but it's undefined which serial number is used)
- Ignores duplicates within multiple simultaneous calls (but it's undefined which serial number is used)
- Skips over serial number validation for second chance products
     *
     * @export
     * @class PushSerialNumbers
     * @implements {EvaService}
     */
    class PushSerialNumbers {
        name = 'Core:PushSerialNumbers';
        path = '/message/PushSerialNumbers';
        request;
        response;
    }
    Core.PushSerialNumbers = PushSerialNumbers;
    /**
     * Push multiple serial numbers into EVA.

- The `ProductID` is required
- You must either specify *both*, or *neither* of `StockLabelID` and `OrganizationUnitID`

:bulb: Our recommended JSON request size limit is 10 MB
:muscle: So when calling this service with just a `SerialNumber` and a `ProductID`, that should be somewhere between 100.000 and 200.000 serials per call
:warning: When a product belongs to a Serial Number Configuration that is configured with a validation regex, serial numbers pushed for that product must match this regex

This service is built for speeeeeeeeeeeed :rocket:, and so has a slightly different idempotency from other services;

- Skips over errors and attempts to persist as many serial numbers as possible
- Gathers any error encountered and returns (up to 1.000 of) them, so you can fix & retry
- Ignores serial numbers that already exist in EVA
- Ignores duplicates within the same call (but it's undefined which serial number is used)
- Ignores duplicates within multiple simultaneous calls (but it's undefined which serial number is used)
- Skips over serial number validation for second chance products
     *
     * @export
     * @class PushSerialNumbers_Async
     * @implements {EvaService}
     */
    class PushSerialNumbers_Async {
        name = 'Core:PushSerialNumbers_Async';
        path = '/async-message/PushSerialNumbers';
        request;
        response;
    }
    Core.PushSerialNumbers_Async = PushSerialNumbers_Async;
    /**
     * Push multiple serial numbers into EVA.

- The `ProductID` is required
- You must either specify *both*, or *neither* of `StockLabelID` and `OrganizationUnitID`

:bulb: Our recommended JSON request size limit is 10 MB
:muscle: So when calling this service with just a `SerialNumber` and a `ProductID`, that should be somewhere between 100.000 and 200.000 serials per call
:warning: When a product belongs to a Serial Number Configuration that is configured with a validation regex, serial numbers pushed for that product must match this regex

This service is built for speeeeeeeeeeeed :rocket:, and so has a slightly different idempotency from other services;

- Skips over errors and attempts to persist as many serial numbers as possible
- Gathers any error encountered and returns (up to 1.000 of) them, so you can fix & retry
- Ignores serial numbers that already exist in EVA
- Ignores duplicates within the same call (but it's undefined which serial number is used)
- Ignores duplicates within multiple simultaneous calls (but it's undefined which serial number is used)
- Skips over serial number validation for second chance products
     *
     * @export
     * @class PushSerialNumbers_AsyncResult
     * @implements {EvaService}
     */
    class PushSerialNumbers_AsyncResult {
        name = 'Core:PushSerialNumbers_AsyncResult';
        path = '/async-result/PushSerialNumbers';
        request;
        response;
    }
    Core.PushSerialNumbers_AsyncResult = PushSerialNumbers_AsyncResult;
    /**
     * Used to create or update a user from 3rd party system.
     *
     * @export
     * @class PushUser
     * @implements {EvaService}
     */
    class PushUser {
        name = 'Core:PushUser';
        path = '/message/PushUser';
        request;
        response;
    }
    Core.PushUser = PushUser;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class PushUserInteractionContent
     * @implements {EvaService}
     */
    class PushUserInteractionContent {
        name = 'Core:PushUserInteractionContent';
        path = '/message/PushUserInteractionContent';
        request;
        response;
    }
    Core.PushUserInteractionContent = PushUserInteractionContent;
    /**
     * Use this to push multiple users at once. This is more efficient than pushing them one by one. Please get in touch with your contact at New Black if you plan on pushing a lot of users. This service follows the "all-or-nothing" approach, either everything is imported, or nothing is imported. There is a limit (100) on the number of users that can be pushed at once.
     *
     * @export
     * @class PushUsers
     * @implements {EvaService}
     */
    class PushUsers {
        name = 'Core:PushUsers';
        path = '/message/PushUsers';
        request;
        response;
    }
    Core.PushUsers = PushUsers;
    /**
     * Use this to push multiple users at once. This is more efficient than pushing them one by one. Please get in touch with your contact at New Black if you plan on pushing a lot of users. This service follows the "all-or-nothing" approach, either everything is imported, or nothing is imported. There is a limit (100) on the number of users that can be pushed at once.
     *
     * @export
     * @class PushUsers_Async
     * @implements {EvaService}
     */
    class PushUsers_Async {
        name = 'Core:PushUsers_Async';
        path = '/async-message/PushUsers';
        request;
        response;
    }
    Core.PushUsers_Async = PushUsers_Async;
    /**
     * Use this to push multiple users at once. This is more efficient than pushing them one by one. Please get in touch with your contact at New Black if you plan on pushing a lot of users. This service follows the "all-or-nothing" approach, either everything is imported, or nothing is imported. There is a limit (100) on the number of users that can be pushed at once.
     *
     * @export
     * @class PushUsers_AsyncResult
     * @implements {EvaService}
     */
    class PushUsers_AsyncResult {
        name = 'Core:PushUsers_AsyncResult';
        path = '/async-result/PushUsers';
        request;
        response;
    }
    Core.PushUsers_AsyncResult = PushUsers_AsyncResult;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class RaisePurchaseOrderImportedEvent
     * @implements {EvaService}
     */
    class RaisePurchaseOrderImportedEvent {
        name = 'Core:RaisePurchaseOrderImportedEvent';
        path = '/message/RaisePurchaseOrderImportedEvent';
        request;
        response;
    }
    Core.RaisePurchaseOrderImportedEvent = RaisePurchaseOrderImportedEvent;
    /**
     * Reactivates an User that was deactivated due to no login
     *
     * @export
     * @class ReactivateUser
     * @implements {EvaService}
     */
    class ReactivateUser {
        name = 'Core:ReactivateUser';
        path = '/message/ReactivateUser';
        request;
        response;
    }
    Core.ReactivateUser = ReactivateUser;
    /**
     * Receive (part of) a Shipment for a PurchaseOrder.

A ShipmentID is required.

When doing partial receipts it is strongly advised to supply a BackendSystemID and BackendID to make sure Receipts are not created twice.

To do partial receipts the FinalShipment property should be set to false, otherwise the shipment will be close afterwards and the remaining lines will be booked as missing.

When available it is preferred to identify the ShipmentLines with the ShipmentLineID and not with the ProductID.
     *
     * @export
     * @class ReceivePurchaseOrderShipment
     * @implements {EvaService}
     */
    class ReceivePurchaseOrderShipment {
        name = 'Core:ReceivePurchaseOrderShipment';
        path = '/message/ReceivePurchaseOrderShipment';
        request;
        response;
    }
    Core.ReceivePurchaseOrderShipment = ReceivePurchaseOrderShipment;
    /**
     * Receive a customer return order
     *
     * @export
     * @class ReceiveReturnOrder
     * @implements {EvaService}
     */
    class ReceiveReturnOrder {
        name = 'Core:ReceiveReturnOrder';
        path = '/message/ReceiveReturnOrder';
        request;
        response;
    }
    Core.ReceiveReturnOrder = ReceiveReturnOrder;
    /**
     * Receive a shipment.
     *
     * @export
     * @class ReceiveShipment
     * @implements {EvaService}
     */
    class ReceiveShipment {
        name = 'Core:ReceiveShipment';
        path = '/message/ReceiveShipment';
        request;
        response;
    }
    Core.ReceiveShipment = ReceiveShipment;
    /**
     * Initiates a recount of the given FullStockCountLabel. FullStockCount will not be completed.
     *
     * @export
     * @class RecountFullStockCountLabel
     * @implements {EvaService}
     */
    class RecountFullStockCountLabel {
        name = 'Core:RecountFullStockCountLabel';
        path = '/message/RecountFullStockCountLabel';
        request;
        response;
    }
    Core.RecountFullStockCountLabel = RecountFullStockCountLabel;
    /**
     * Initiates a recount of the given FullStockCountProduct for the given FullStockCount. FullStockCount will not be completed.
     *
     * @export
     * @class RecountFullStockCountProduct
     * @implements {EvaService}
     */
    class RecountFullStockCountProduct {
        name = 'Core:RecountFullStockCountProduct';
        path = '/message/RecountFullStockCountProduct';
        request;
        response;
    }
    Core.RecountFullStockCountProduct = RecountFullStockCountProduct;
    /**
     * Recovers an employee account by changing the email address and optionally generating a temporary password.
  This is intended as last resort for when an employee has lost access to their emailaddress.
     *
     * @export
     * @class RecoverEmployeeAccount
     * @implements {EvaService}
     */
    class RecoverEmployeeAccount {
        name = 'Core:RecoverEmployeeAccount';
        path = '/message/RecoverEmployeeAccount';
        request;
        response;
    }
    Core.RecoverEmployeeAccount = RecoverEmployeeAccount;
    /**
     * Refresh a JWT token
     *
     * @export
     * @class RefreshToken
     * @implements {EvaService}
     */
    class RefreshToken {
        name = 'Core:RefreshToken';
        path = '/message/RefreshToken';
        request;
        response;
    }
    Core.RefreshToken = RefreshToken;
    /**
     * Triggers a refund request for the given Order.

The amount to refund is optional, if not specified it will be the amount available to refund on the order.
     *
     * @export
     * @class RefundOrder
     * @implements {EvaService}
     */
    class RefundOrder {
        name = 'Core:RefundOrder';
        path = '/message/RefundOrder';
        request;
        response;
    }
    Core.RefundOrder = RefundOrder;
    /**
     * Register an app for push notifications. This will register the device token for the given application identifier so the app can receive PushNotifications for the current User/OrganizationUnit.
     *
     * @export
     * @class RegisterAppForNotifications
     * @implements {EvaService}
     */
    class RegisterAppForNotifications {
        name = 'Core:RegisterAppForNotifications';
        path = '/message/RegisterAppForNotifications';
        request;
        response;
    }
    Core.RegisterAppForNotifications = RegisterAppForNotifications;
    /**
     * Register user borrowed products
     *
     * @export
     * @class RegisterUserBorrowedProducts
     * @implements {EvaService}
     */
    class RegisterUserBorrowedProducts {
        name = 'Core:RegisterUserBorrowedProducts';
        path = '/message/RegisterUserBorrowedProducts';
        request;
        response;
    }
    Core.RegisterUserBorrowedProducts = RegisterUserBorrowedProducts;
    /**
     * Remove offer expiration date for an order specified by `OrderID`.
     *
     * @export
     * @class RemoveOfferStatusFromOrder
     * @implements {EvaService}
     */
    class RemoveOfferStatusFromOrder {
        name = 'Core:RemoveOfferStatusFromOrder';
        path = '/message/RemoveOfferStatusFromOrder';
        request;
        response;
    }
    Core.RemoveOfferStatusFromOrder = RemoveOfferStatusFromOrder;
    /**
     * Reset the unitprice on an OrderLine with a price correction.
     *
     * @export
     * @class RemoveOrderLineUnitPriceCorrection
     * @implements {EvaService}
     */
    class RemoveOrderLineUnitPriceCorrection {
        name = 'Core:RemoveOrderLineUnitPriceCorrection';
        path = '/message/RemoveOrderLineUnitPriceCorrection';
        request;
        response;
    }
    Core.RemoveOrderLineUnitPriceCorrection = RemoveOrderLineUnitPriceCorrection;
    /**
     * Remove an Organization's openinghours exception. When neither a DayOfWeek or Date is given, all openinghours exception for the given type will be removed and all openinghours will revert to the template value (if present).
     *
     * @export
     * @class RemoveOrganizationUnitOpeningHoursException
     * @implements {EvaService}
     */
    class RemoveOrganizationUnitOpeningHoursException {
        name = 'Core:RemoveOrganizationUnitOpeningHoursException';
        path = '/message/RemoveOrganizationUnitOpeningHoursException';
        request;
        response;
    }
    Core.RemoveOrganizationUnitOpeningHoursException = RemoveOrganizationUnitOpeningHoursException;
    /**
     * Removes product(s) from an anonymous wishlist.
     *
     * @export
     * @class RemoveProductsFromAnonymousWishlist
     * @implements {EvaService}
     */
    class RemoveProductsFromAnonymousWishlist {
        name = 'Core:RemoveProductsFromAnonymousWishlist';
        path = '/message/RemoveProductsFromAnonymousWishlist';
        request;
        response;
    }
    Core.RemoveProductsFromAnonymousWishlist = RemoveProductsFromAnonymousWishlist;
    /**
     * Removes product(s) from the user wishlist.
     *
     * @export
     * @class RemoveProductsFromUserWishlist
     * @implements {EvaService}
     */
    class RemoveProductsFromUserWishlist {
        name = 'Core:RemoveProductsFromUserWishlist';
        path = '/message/RemoveProductsFromUserWishlist';
        request;
        response;
    }
    Core.RemoveProductsFromUserWishlist = RemoveProductsFromUserWishlist;
    /**
     * Remove a special date from an OpeningHoursTemplate
     *
     * @export
     * @class RemoveSpecialDateFromOpeningHoursTemplate
     * @implements {EvaService}
     */
    class RemoveSpecialDateFromOpeningHoursTemplate {
        name = 'Core:RemoveSpecialDateFromOpeningHoursTemplate';
        path = '/message/RemoveSpecialDateFromOpeningHoursTemplate';
        request;
        response;
    }
    Core.RemoveSpecialDateFromOpeningHoursTemplate = RemoveSpecialDateFromOpeningHoursTemplate;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class RemoveUserFromGroup
     * @implements {EvaService}
     */
    class RemoveUserFromGroup {
        name = 'Core:RemoveUserFromGroup';
        path = '/message/RemoveUserFromGroup';
        request;
        response;
    }
    Core.RemoveUserFromGroup = RemoveUserFromGroup;
    /**
     * Renders the result of a previous thermal print job to HTML and/or PDF. Supply either a `BlobID` or `BlobUrl`.
     *
     * @export
     * @class RenderThermalPrintResult
     * @implements {EvaService}
     */
    class RenderThermalPrintResult {
        name = 'Core:RenderThermalPrintResult';
        path = '/message/RenderThermalPrintResult';
        request;
        response;
    }
    Core.RenderThermalPrintResult = RenderThermalPrintResult;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ReplaceCycleCountZonesForOrganizationUnit
     * @implements {EvaService}
     */
    class ReplaceCycleCountZonesForOrganizationUnit {
        name = 'Core:ReplaceCycleCountZonesForOrganizationUnit';
        path = '/message/ReplaceCycleCountZonesForOrganizationUnit';
        request;
        response;
    }
    Core.ReplaceCycleCountZonesForOrganizationUnit = ReplaceCycleCountZonesForOrganizationUnit;
    /**
     * Creates an EntityTranslation if one does not exist yet, otherwise it replaces the current one.
     *
     * @export
     * @class ReplaceEntityTranslation
     * @implements {EvaService}
     */
    class ReplaceEntityTranslation {
        name = 'Core:ReplaceEntityTranslation';
        path = '/message/ReplaceEntityTranslation';
        request;
        response;
    }
    Core.ReplaceEntityTranslation = ReplaceEntityTranslation;
    /**
     * Creates an StringTranslation if one does not exist yet, otherwise it replaces the current one.
     *
     * @export
     * @class ReplaceStringTranslation
     * @implements {EvaService}
     */
    class ReplaceStringTranslation {
        name = 'Core:ReplaceStringTranslation';
        path = '/message/ReplaceStringTranslation';
        request;
        response;
    }
    Core.ReplaceStringTranslation = ReplaceStringTranslation;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ReplayEvents
     * @implements {EvaService}
     */
    class ReplayEvents {
        name = 'Core:ReplayEvents';
        path = '/message/ReplayEvents';
        request;
        response;
    }
    Core.ReplayEvents = ReplayEvents;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class RepostFinancialPeriod
     * @implements {EvaService}
     */
    class RepostFinancialPeriod {
        name = 'Core:RepostFinancialPeriod';
        path = '/message/RepostFinancialPeriod';
        request;
        response;
    }
    Core.RepostFinancialPeriod = RepostFinancialPeriod;
    /**
     * Reprints the results of a previous thermal print job to a specified station. Supply either a `BlobID` or `BlobUrl`.
     *
     * @export
     * @class ReprintThermalPrintResult
     * @implements {EvaService}
     */
    class ReprintThermalPrintResult {
        name = 'Core:ReprintThermalPrintResult';
        path = '/message/ReprintThermalPrintResult';
        request;
        response;
    }
    Core.ReprintThermalPrintResult = ReprintThermalPrintResult;
    /**
     * Service for retrieving a device authentication token
     *
     * @export
     * @class RequestDeviceAuthenticationToken
     * @implements {EvaService}
     */
    class RequestDeviceAuthenticationToken {
        name = 'Core:RequestDeviceAuthenticationToken';
        path = '/message/RequestDeviceAuthenticationToken';
        request;
        response;
    }
    Core.RequestDeviceAuthenticationToken = RequestDeviceAuthenticationToken;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class RequestPasswordResetToken
     * @implements {EvaService}
     */
    class RequestPasswordResetToken {
        name = 'Core:RequestPasswordResetToken';
        path = '/message/RequestPasswordResetToken';
        request;
        response;
    }
    Core.RequestPasswordResetToken = RequestPasswordResetToken;
    /**
     * Certain payment methods support retrieving the current status. Given a PaymentTransactionID this service will attempt to poll thestatus for that particular payment and directly update its status.
     *
     * @export
     * @class RequestPaymentUpdate
     * @implements {EvaService}
     */
    class RequestPaymentUpdate {
        name = 'Core:RequestPaymentUpdate';
        path = '/message/RequestPaymentUpdate';
        request;
        response;
    }
    Core.RequestPaymentUpdate = RequestPaymentUpdate;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class RequestReindexOrderSearchData
     * @implements {EvaService}
     */
    class RequestReindexOrderSearchData {
        name = 'Core:RequestReindexOrderSearchData';
        path = '/message/RequestReindexOrderSearchData';
        request;
        response;
    }
    Core.RequestReindexOrderSearchData = RequestReindexOrderSearchData;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class RequestReindexUserSearchData
     * @implements {EvaService}
     */
    class RequestReindexUserSearchData {
        name = 'Core:RequestReindexUserSearchData';
        path = '/message/RequestReindexUserSearchData';
        request;
        response;
    }
    Core.RequestReindexUserSearchData = RequestReindexUserSearchData;
    /**
     * Requeues specified error message(s).
     *
     * @export
     * @class RequeueErrorMessage
     * @implements {EvaService}
     */
    class RequeueErrorMessage {
        name = 'Core:RequeueErrorMessage';
        path = '/message/RequeueErrorMessage';
        request;
        response;
    }
    Core.RequeueErrorMessage = RequeueErrorMessage;
    /**
     * Resend a UserInteraction of Type Communication

When no EmailAddress is supplied, the original recipient will be used.
     *
     * @export
     * @class ResendUserInteractionCommunication
     * @implements {EvaService}
     */
    class ResendUserInteractionCommunication {
        name = 'Core:ResendUserInteractionCommunication';
        path = '/message/ResendUserInteractionCommunication';
        request;
        response;
    }
    Core.ResendUserInteractionCommunication = ResendUserInteractionCommunication;
    /**
     * Reserve an Order.

The Lines on the Order with LineActionType ReserveLine will be reserved:
- The Stock will be moved from Sellable to Reserved
- A receipt will be printed
     *
     * @export
     * @class ReserveOrder
     * @implements {EvaService}
     */
    class ReserveOrder {
        name = 'Core:ReserveOrder';
        path = '/message/ReserveOrder';
        request;
        response;
    }
    Core.ReserveOrder = ReserveOrder;
    /**
     * This service resets processed financial events back to unprocessed,
which means all associated financial ledgers are deleted.

Only financial events of periods that have not been fully processed (for example exported to an external ERP system)
can be reset.

As this can be a time consuming service, the request is handled in the background and upon completion a mail
is sent to the caller of this service with the results.

The scope of which events to reset can be limited by specifying a `Filter` in the request. Only the events
that match the filter will be reset.
     *
     * @export
     * @class ResetFinancialEvents
     * @implements {EvaService}
     */
    class ResetFinancialEvents {
        name = 'Core:ResetFinancialEvents';
        path = '/message/ResetFinancialEvents';
        request;
        response;
    }
    Core.ResetFinancialEvents = ResetFinancialEvents;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ResetUserPassword
     * @implements {EvaService}
     */
    class ResetUserPassword {
        name = 'Core:ResetUserPassword';
        path = '/message/ResetUserPassword';
        request;
        response;
    }
    Core.ResetUserPassword = ResetUserPassword;
    /**
     * Resolve product backend IDs
     *
     * @export
     * @class ResolveProductBackendIDs
     * @implements {EvaService}
     */
    class ResolveProductBackendIDs {
        name = 'Core:ResolveProductBackendIDs';
        path = '/message/ResolveProductBackendIDs';
        request;
        response;
    }
    Core.ResolveProductBackendIDs = ResolveProductBackendIDs;
    /**
     * When you would like to resume a suspended order, you can use `ResumeSuspendedOrder` to do so. This will remove the suspended state from the order.
     *
     * @export
     * @class ResumeSuspendedOrder
     * @implements {EvaService}
     */
    class ResumeSuspendedOrder {
        name = 'Core:ResumeSuspendedOrder';
        path = '/message/ResumeSuspendedOrder';
        request;
        response;
    }
    Core.ResumeSuspendedOrder = ResumeSuspendedOrder;
    /**
     * Retry financial period export. Use `Force` to retry eventhough the status is `Finished`
     *
     * @export
     * @class RetryFinancialPeriodExport
     * @implements {EvaService}
     */
    class RetryFinancialPeriodExport {
        name = 'Core:RetryFinancialPeriodExport';
        path = '/message/RetryFinancialPeriodExport';
        request;
        response;
    }
    Core.RetryFinancialPeriodExport = RetryFinancialPeriodExport;
    /**
     * Retry financial period exports.
     *
     * @export
     * @class RetryFinancialPeriodExports
     * @implements {EvaService}
     */
    class RetryFinancialPeriodExports {
        name = 'Core:RetryFinancialPeriodExports';
        path = '/message/RetryFinancialPeriodExports';
        request;
        response;
    }
    Core.RetryFinancialPeriodExports = RetryFinancialPeriodExports;
    /**
     * Retry the given InvoiceExports
     *
     * @export
     * @class RetryInvoiceExport
     * @implements {EvaService}
     */
    class RetryInvoiceExport {
        name = 'Core:RetryInvoiceExport';
        path = '/message/RetryInvoiceExport';
        request;
        response;
    }
    Core.RetryInvoiceExport = RetryInvoiceExport;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class RetryOrderExport
     * @implements {EvaService}
     */
    class RetryOrderExport {
        name = 'Core:RetryOrderExport';
        path = '/message/RetryOrderExport';
        request;
        response;
    }
    Core.RetryOrderExport = RetryOrderExport;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class RetryShipmentExport
     * @implements {EvaService}
     */
    class RetryShipmentExport {
        name = 'Core:RetryShipmentExport';
        path = '/message/RetryShipmentExport';
        request;
        response;
    }
    Core.RetryShipmentExport = RetryShipmentExport;
    /**
     * Supports the creation of return orders and return reversal orders. Unreferenced reversals will always be treated as normal returns.
     *
     * @export
     * @class ReturnOrderLines
     * @implements {EvaService}
     */
    class ReturnOrderLines {
        name = 'Core:ReturnOrderLines';
        path = '/message/ReturnOrderLines';
        request;
        response;
    }
    Core.ReturnOrderLines = ReturnOrderLines;
    /**
     * Return user borrowed products. When IsDamaged is set to true, the stock will be moved to Damaged. Otherwise, the stock will be moved to Sellable.
     *
     * @export
     * @class ReturnUserBorrowedProducts
     * @implements {EvaService}
     */
    class ReturnUserBorrowedProducts {
        name = 'Core:ReturnUserBorrowedProducts';
        path = '/message/ReturnUserBorrowedProducts';
        request;
        response;
    }
    Core.ReturnUserBorrowedProducts = ReturnUserBorrowedProducts;
    /**
     * Service for updating a existing `EventExportConfiguration`.

- Make sure to catch & store the `SecretKey1` or `SecretKey2`, as there will be no other way of retrieving them after this service call!
     *
     * @export
     * @class RotateEventExportConfigurationKey
     * @implements {EvaService}
     */
    class RotateEventExportConfigurationKey {
        name = 'Core:RotateEventExportConfigurationKey';
        path = '/message/RotateEventExportConfigurationKey';
        request;
        response;
    }
    Core.RotateEventExportConfigurationKey = RotateEventExportConfigurationKey;
    /**
     * Searches for consumer companies based on the provided query and filter criteria.
     *
     * @export
     * @class SearchConsumerCompany
     * @implements {EvaService}
     */
    class SearchConsumerCompany {
        name = 'Core:SearchConsumerCompany';
        path = '/message/SearchConsumerCompany';
        request;
        response;
    }
    Core.SearchConsumerCompany = SearchConsumerCompany;
    /**
     * Search for documents in a specified category. This will return a maximum of 100 records.

:warning: For debugging and support purposes only.
     *
     * @export
     * @class SearchDocumentStore
     * @implements {EvaService}
     */
    class SearchDocumentStore {
        name = 'Core:SearchDocumentStore';
        path = '/message/SearchDocumentStore';
        request;
        response;
    }
    Core.SearchDocumentStore = SearchDocumentStore;
    /**
     * Search for any type of orders by providing the filter details properties
Important search criterias are: OrganizationUnitID, CurrentOrganizationUnitType, OrderIDs, CustomerID(ClientContext.Type), PaymentStatus.

When no StartTime is provided this will be defaulted to 3 months ago. The only exception is when specific OrderIDs are provided, then it's allowed to not specify a Date.

To include the custom fields of the customer, the property `AdditionalOrderDataOptions.CustomerCustomFields` can be set to `true`.

E.g. request:
{
  "OrderIDs": [
    "orderID1",
    "orderID2"
  ],
  "PaymentStatus": "PaymentStatus",
  "IsShipped": "isShipped"
}


Payment status options:
    NotPaid = 0,
    Paid = 1,
    Partial = 2
     *
     * @export
     * @class SearchOrders
     * @implements {EvaService}
     */
    class SearchOrders {
        name = 'Core:SearchOrders';
        path = '/message/SearchOrders';
        request;
        response;
    }
    Core.SearchOrders = SearchOrders;
    /**
     * Performs a search for products, given a `Query` string.
     *
     * @export
     * @class SearchProducts
     * @implements {EvaService}
     */
    class SearchProducts {
        name = 'Core:SearchProducts';
        path = '/message/SearchProducts';
        request;
        response;
    }
    Core.SearchProducts = SearchProducts;
    /**
     * Execute a search through the users

Filtering is possible on all kinds of properties. By default the search results will be restricted to users in the current country.
     *
     * @export
     * @class SearchUsers
     * @implements {EvaService}
     */
    class SearchUsers {
        name = 'Core:SearchUsers';
        path = '/message/SearchUsers';
        request;
        response;
    }
    Core.SearchUsers = SearchUsers;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class SendConfigurationPage
     * @implements {EvaService}
     */
    class SendConfigurationPage {
        name = 'Core:SendConfigurationPage';
        path = '/message/SendConfigurationPage';
        request;
        response;
    }
    Core.SendConfigurationPage = SendConfigurationPage;
    /**
     * Service for sending a contact form to the email set in settings called `ContactForm:MailTo`
     *
     * @export
     * @class SendContactForm
     * @implements {EvaService}
     */
    class SendContactForm {
        name = 'Core:SendContactForm';
        path = '/message/SendContactForm';
        request;
        response;
    }
    Core.SendContactForm = SendContactForm;
    /**
     * Requests a magic login link, which will send an email to the user (if found).

- Setting `MagicLink:Enabled` must be enabled explicitly
- When using a `RedirectUrl`, configure setting `MagicLink:RedirectDomains` to whitelist supported redirect hosts (recommended!)

Using the returned `RequestToken`, you can either subscribe to the `/magicLink` SignalR hub, or poll the `CheckMagicLink` service. As soon as the emailed magic link is clicked, that hub and service
will return either a `TemporaryToken` you can call `Login` with for this user, or an `APIKey` that's already valid and ready to proceed with.

- The email sent contains a link that will work for 10 minutes
- When clicked, this will generate either a `TemporaryToken` that can be used to `Login` with for 3 minutes, or an `ApiKey` that can be used for 1 hour
- This data is additionally exposed through `CheckMagicLink` for 1 minute after clicking
- When using a `TemporaryToken` to log in with, the resulting `AuthenticationToken` is valid for 1 week (or `SessionDuration:MagicLink`) and will refresh every time when used

Finally, when specifying `IncludeManualCode`, the email sent will also contain a short code for the user to _manually_ input into your application - call `ConfirmMagicLink` with both the `RequestToken`
and that `ManualCode` to obtain either the `TemporaryToken` or `ApiKey` like above, when valid.
     *
     * @export
     * @class SendMagicLink
     * @implements {EvaService}
     */
    class SendMagicLink {
        name = 'Core:SendMagicLink';
        path = '/message/SendMagicLink';
        request;
        response;
    }
    Core.SendMagicLink = SendMagicLink;
    /**
     * Sends a `ReturnMail` stencil to the customer of given return order, attaching order blobs of type `ReturnLabel` (3) and `ReturnForm` (4) if present.
     *
     * @export
     * @class SendReturnMail
     * @implements {EvaService}
     */
    class SendReturnMail {
        name = 'Core:SendReturnMail';
        path = '/message/SendReturnMail';
        request;
        response;
    }
    Core.SendReturnMail = SendReturnMail;
    /**
     * Update user custom data
     *
     * @export
     * @class SetCustomUserData
     * @implements {EvaService}
     */
    class SetCustomUserData {
        name = 'Core:SetCustomUserData';
        path = '/message/SetCustomUserData';
        request;
        response;
    }
    Core.SetCustomUserData = SetCustomUserData;
    /**
     * This service can be used when in local mode to set some UserIdentifiers on an Order

If ParseBarcode responds with ParsedButNotFound, this service can be used to set the UserIdentifiers on the Order.
Or an EmailAddress can be manually set.

When the order is exported to the cloud, the UserIdentifiers will be used to match the order to the correct user.
     *
     * @export
     * @class SetCustomerIdentifiersOnOrder
     * @implements {EvaService}
     */
    class SetCustomerIdentifiersOnOrder {
        name = 'Core:SetCustomerIdentifiersOnOrder';
        path = '/message/SetCustomerIdentifiersOnOrder';
        request;
        response;
    }
    Core.SetCustomerIdentifiersOnOrder = SetCustomerIdentifiersOnOrder;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class SetCustomerReferencesOnOrder
     * @implements {EvaService}
     */
    class SetCustomerReferencesOnOrder {
        name = 'Core:SetCustomerReferencesOnOrder';
        path = '/message/SetCustomerReferencesOnOrder';
        request;
        response;
    }
    Core.SetCustomerReferencesOnOrder = SetCustomerReferencesOnOrder;
    /**
     * Set the given Address Book Item as default BillingAddress for the User of the Address Book
     *
     * @export
     * @class SetDefaultBillingAddress
     * @implements {EvaService}
     */
    class SetDefaultBillingAddress {
        name = 'Core:SetDefaultBillingAddress';
        path = '/message/SetDefaultBillingAddress';
        request;
        response;
    }
    Core.SetDefaultBillingAddress = SetDefaultBillingAddress;
    /**
     * Set the given Address Book Item as default PickupAddress for the User of the Address Book
     *
     * @export
     * @class SetDefaultPickupAddress
     * @implements {EvaService}
     */
    class SetDefaultPickupAddress {
        name = 'Core:SetDefaultPickupAddress';
        path = '/message/SetDefaultPickupAddress';
        request;
        response;
    }
    Core.SetDefaultPickupAddress = SetDefaultPickupAddress;
    /**
     * Set the given Address Book Item as default ShippingAddress for the User of the Address Book
     *
     * @export
     * @class SetDefaultShippingAddress
     * @implements {EvaService}
     */
    class SetDefaultShippingAddress {
        name = 'Core:SetDefaultShippingAddress';
        path = '/message/SetDefaultShippingAddress';
        request;
        response;
    }
    Core.SetDefaultShippingAddress = SetDefaultShippingAddress;
    /**
     * Set additional order information intended for delivery data.
     *
     * @export
     * @class SetDeliveryOrderData
     * @implements {EvaService}
     */
    class SetDeliveryOrderData {
        name = 'Core:SetDeliveryOrderData';
        path = '/message/SetDeliveryOrderData';
        request;
        response;
    }
    Core.SetDeliveryOrderData = SetDeliveryOrderData;
    /**
     * Set the product selection for a specific discount line
     *
     * @export
     * @class SetDiscountProductOption
     * @implements {EvaService}
     */
    class SetDiscountProductOption {
        name = 'Core:SetDiscountProductOption';
        path = '/message/SetDiscountProductOption';
        request;
        response;
    }
    Core.SetDiscountProductOption = SetDiscountProductOption;
    /**
     * Sets the additional e-invoicing data on the given order. To retrieve the information that has been set use: `GetElectronicInvoiceData`
     *
     * @export
     * @class SetElectronicInvoiceData
     * @implements {EvaService}
     */
    class SetElectronicInvoiceData {
        name = 'Core:SetElectronicInvoiceData';
        path = '/message/SetElectronicInvoiceData';
        request;
        response;
    }
    Core.SetElectronicInvoiceData = SetElectronicInvoiceData;
    /**
     * Set the employees for the financial period. This only works for pending financial periods.
     *
     * @export
     * @class SetEmployeesForFinancialPeriod
     * @implements {EvaService}
     */
    class SetEmployeesForFinancialPeriod {
        name = 'Core:SetEmployeesForFinancialPeriod';
        path = '/message/SetEmployeesForFinancialPeriod';
        request;
        response;
    }
    Core.SetEmployeesForFinancialPeriod = SetEmployeesForFinancialPeriod;
    /**
     * Set the external full stock count result.
The service accepts partial or full result lists.
The service requires a ActualCompletionTime. There can only be one completion time. The value will be updated with every service call.

CountResults must either have ProductID (preferred) or ProductBarcode.
     *
     * @export
     * @class SetExternalFullStockCountResult
     * @implements {EvaService}
     */
    class SetExternalFullStockCountResult {
        name = 'Core:SetExternalFullStockCountResult';
        path = '/message/SetExternalFullStockCountResult';
        request;
        response;
    }
    Core.SetExternalFullStockCountResult = SetExternalFullStockCountResult;
    /**
     * Update the fiscal properties on an Order.
     *
     * @export
     * @class SetFiscalOrderData
     * @implements {EvaService}
     */
    class SetFiscalOrderData {
        name = 'Core:SetFiscalOrderData';
        path = '/message/SetFiscalOrderData';
        request;
        response;
    }
    Core.SetFiscalOrderData = SetFiscalOrderData;
    /**
     * Set the GiftWrapping options on an Order.

There are 4 options:

 - Wrap the complete order: set `WrapOrder` to `true`
 - Wrap the complete order individually: set `WrapIndividually` to `true`
 - Wrap parts of the order: set `GiftWraps` with a set of wraps
 - Wrap nothing: set everything to `null`

A `GiftWrap` consists out of an optional `Message` (could be printed on a card), an optional `GreetingCardProductID` and a set of `WrapLines`. A
`WrapLine` has an `OrderLineID` and a `Quantity`.

If a `GreetingCardProductID` and/or `Message` is desired when the order should be completely wrapped, or without any giftwrapping at all, set these
properties on root level. In all other cases they should be set on the `GiftWraps`.
     *
     * @export
     * @class SetGiftWrappingOptionsOnOrder
     * @implements {EvaService}
     */
    class SetGiftWrappingOptionsOnOrder {
        name = 'Core:SetGiftWrappingOptionsOnOrder';
        path = '/message/SetGiftWrappingOptionsOnOrder';
        request;
        response;
    }
    Core.SetGiftWrappingOptionsOnOrder = SetGiftWrappingOptionsOnOrder;
    /**
     * Adds or removes a lines to/from the ReturnToSupplier tasks shipment.

When 'Exclude' is enabled, all lines matching the given ProductID will be removed from the task shipment with a maximum of the given Quantity.
When 'Exclude' is disabled, all lines from the ReturnToSupplier order matching the given ProductID will be added to the tasks shipment to the maximum of the given Quantity.

Overshipment is not allowed.
     *
     * @export
     * @class SetLineForReturnToSupplierShipment
     * @implements {EvaService}
     */
    class SetLineForReturnToSupplierShipment {
        name = 'Core:SetLineForReturnToSupplierShipment';
        path = '/message/SetLineForReturnToSupplierShipment';
        request;
        response;
    }
    Core.SetLineForReturnToSupplierShipment = SetLineForReturnToSupplierShipment;
    /**
     * Sets the lottery number for a given order
     *
     * @export
     * @class SetLotteryNumber
     * @implements {EvaService}
     */
    class SetLotteryNumber {
        name = 'Core:SetLotteryNumber';
        path = '/message/SetLotteryNumber';
        request;
        response;
    }
    Core.SetLotteryNumber = SetLotteryNumber;
    /**
     * Set the loyalty program for the financial period. This only works for pending financial periods.
     *
     * @export
     * @class SetLoyaltyProgramForFinancialPeriod
     * @implements {EvaService}
     */
    class SetLoyaltyProgramForFinancialPeriod {
        name = 'Core:SetLoyaltyProgramForFinancialPeriod';
        path = '/message/SetLoyaltyProgramForFinancialPeriod';
        request;
        response;
    }
    Core.SetLoyaltyProgramForFinancialPeriod = SetLoyaltyProgramForFinancialPeriod;
    /**
     * Sets `BackendID`/`BackendSystemID` on specified `OrderID`.

This combination may not already exist, and the targeted order may not be completed, or  already have a `BackendID`/`BackendSystemID` set.

:warning: Careful! Use at your own risk!

An order may already have any of the following things, which will not automatically be regenerated/resent because of this identifier change, and could
result in mapping issues on any external system listening in on these. Any of these would also apply to return orders referencing this order, or stock
mutations that have been caused by this order.

* Order exports to third parties
* Event exports (order created, order updated, ...)
* Data Lake exports
* Shipment labels with third party carriers
* Financial exports (Cookbook)
* Created documents (receipts, invoices, ...)
     *
     * @export
     * @class SetOrderBackendIdentifier
     * @implements {EvaService}
     */
    class SetOrderBackendIdentifier {
        name = 'Core:SetOrderBackendIdentifier';
        path = '/message/SetOrderBackendIdentifier';
        request;
        response;
    }
    Core.SetOrderBackendIdentifier = SetOrderBackendIdentifier;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class SetOrderFulfillmentOptions
     * @implements {EvaService}
     */
    class SetOrderFulfillmentOptions {
        name = 'Core:SetOrderFulfillmentOptions';
        path = '/message/SetOrderFulfillmentOptions';
        request;
        response;
    }
    Core.SetOrderFulfillmentOptions = SetOrderFulfillmentOptions;
    /**
     * Sets the `SoldBy` of the specified sales order to the provided `UserID`.

- The user must have type `Employee`
- This service can only be called on orders that have not been invoiced yet
- As `SoldBy` is a line-level property this service will update all lines on the order that have not been invoiced yet
     *
     * @export
     * @class SetOrderSoldBy
     * @implements {EvaService}
     */
    class SetOrderSoldBy {
        name = 'Core:SetOrderSoldBy';
        path = '/message/SetOrderSoldBy';
        request;
        response;
    }
    Core.SetOrderSoldBy = SetOrderSoldBy;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class SetOrganizationUnitNotes
     * @implements {EvaService}
     */
    class SetOrganizationUnitNotes {
        name = 'Core:SetOrganizationUnitNotes';
        path = '/message/SetOrganizationUnitNotes';
        request;
        response;
    }
    Core.SetOrganizationUnitNotes = SetOrganizationUnitNotes;
    /**
     * Add or update an Organization's openinghours exception
     *
     * @export
     * @class SetOrganizationUnitOpeningHoursException
     * @implements {EvaService}
     */
    class SetOrganizationUnitOpeningHoursException {
        name = 'Core:SetOrganizationUnitOpeningHoursException';
        path = '/message/SetOrganizationUnitOpeningHoursException';
        request;
        response;
    }
    Core.SetOrganizationUnitOpeningHoursException = SetOrganizationUnitOpeningHoursException;
    /**
     * Set the answer to the PCI question for the provided `FinancialPeriodID`.
     *
     * @export
     * @class SetPCIQuestionAnswerForFinancialPeriod
     * @implements {EvaService}
     */
    class SetPCIQuestionAnswerForFinancialPeriod {
        name = 'Core:SetPCIQuestionAnswerForFinancialPeriod';
        path = '/message/SetPCIQuestionAnswerForFinancialPeriod';
        request;
        response;
    }
    Core.SetPCIQuestionAnswerForFinancialPeriod = SetPCIQuestionAnswerForFinancialPeriod;
    /**
     * Pick a product for a PickProductAction for an OrderLine
     *
     * @export
     * @class SetPickProductDiscountOptionsForOrderLine
     * @implements {EvaService}
     */
    class SetPickProductDiscountOptionsForOrderLine {
        name = 'Core:SetPickProductDiscountOptionsForOrderLine';
        path = '/message/SetPickProductDiscountOptionsForOrderLine';
        request;
        response;
    }
    Core.SetPickProductDiscountOptionsForOrderLine = SetPickProductDiscountOptionsForOrderLine;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class SetPickupOrganizationUnit
     * @implements {EvaService}
     */
    class SetPickupOrganizationUnit {
        name = 'Core:SetPickupOrganizationUnit';
        path = '/message/SetPickupOrganizationUnit';
        request;
        response;
    }
    Core.SetPickupOrganizationUnit = SetPickupOrganizationUnit;
    /**
     * Set a preferred method to use when this order will be refunded.
Can be used on ReturnOrders to indicate how the money should be transferred back to the customer.

Available methods can be listed with the GetAvailableRefundPaymentMethodsForOrder service.
     *
     * @export
     * @class SetPreferredRefundMethod
     * @implements {EvaService}
     */
    class SetPreferredRefundMethod {
        name = 'Core:SetPreferredRefundMethod';
        path = '/message/SetPreferredRefundMethod';
        request;
        response;
    }
    Core.SetPreferredRefundMethod = SetPreferredRefundMethod;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class SetRemarkOnOrder
     * @implements {EvaService}
     */
    class SetRemarkOnOrder {
        name = 'Core:SetRemarkOnOrder';
        path = '/message/SetRemarkOnOrder';
        request;
        response;
    }
    Core.SetRemarkOnOrder = SetRemarkOnOrder;
    /**
     * Set the `RequestedDate` on OrderLines.
The RequestedDate is the date on which the OrderLine should be ready for shipping/pickup/etc.

It is required to provide an `OrderID`.
If the RequestedDate is null, it will be removed from the lines.
     *
     * @export
     * @class SetRequestedDate
     * @implements {EvaService}
     */
    class SetRequestedDate {
        name = 'Core:SetRequestedDate';
        path = '/message/SetRequestedDate';
        request;
        response;
    }
    Core.SetRequestedDate = SetRequestedDate;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class SetReturnOrderRefundCorrection
     * @implements {EvaService}
     */
    class SetReturnOrderRefundCorrection {
        name = 'Core:SetReturnOrderRefundCorrection';
        path = '/message/SetReturnOrderRefundCorrection';
        request;
        response;
    }
    Core.SetReturnOrderRefundCorrection = SetReturnOrderRefundCorrection;
    /**
     * Sets the first serial number on given order line, and splits off new order lines for each additional serial number given.
     *
     * @export
     * @class SetSerialNumbers
     * @implements {EvaService}
     */
    class SetSerialNumbers {
        name = 'Core:SetSerialNumbers';
        path = '/message/SetSerialNumbers';
        request;
        response;
    }
    Core.SetSerialNumbers = SetSerialNumbers;
    /**
     * This service is used in combination with the `GetShipmentSettings` to manage OrganizationUnit settings for Shipments.
Optionally an OrganizationUnitID can be provided, but by default the settings are updated for the current OrganizationUnit.

- DefaultReceiveMethod: How shipments should be received if no custom implementation is available
     *
     * @export
     * @class SetShipmentSettings
     * @implements {EvaService}
     */
    class SetShipmentSettings {
        name = 'Core:SetShipmentSettings';
        path = '/message/SetShipmentSettings';
        request;
        response;
    }
    Core.SetShipmentSettings = SetShipmentSettings;
    /**
     * Sets the shipping method for the given order(lines). Use `ListAvailableShippingMethods` to request the shipping methods that can be used as input to this service.
     *
     * @export
     * @class SetShippingMethod
     * @implements {EvaService}
     */
    class SetShippingMethod {
        name = 'Core:SetShippingMethod';
        path = '/message/SetShippingMethod';
        request;
        response;
    }
    Core.SetShippingMethod = SetShippingMethod;
    /**
     * Add or update a special date on an OpeningHoursTemplate
     *
     * @export
     * @class SetSpecialDateOnOpeningHoursTemplate
     * @implements {EvaService}
     */
    class SetSpecialDateOnOpeningHoursTemplate {
        name = 'Core:SetSpecialDateOnOpeningHoursTemplate';
        path = '/message/SetSpecialDateOnOpeningHoursTemplate';
        request;
        response;
    }
    Core.SetSpecialDateOnOpeningHoursTemplate = SetSpecialDateOnOpeningHoursTemplate;
    /**
     * Change the settings for a specific OU/StockLabel combination. Use a value of null to make it inherit from it’s parent.
     *
     * @export
     * @class SetStockLabelSettings
     * @implements {EvaService}
     */
    class SetStockLabelSettings {
        name = 'Core:SetStockLabelSettings';
        path = '/message/SetStockLabelSettings';
        request;
        response;
    }
    Core.SetStockLabelSettings = SetStockLabelSettings;
    /**
     * Set the suppliers for OrganizationUnit where this could not be automatically determined

To view the available suppliers, sue the ValidateReturnToSupplierRequest service.

The SupplierOrganizationUnitID is nullable, if it is set to `null`, the OrganizationUnit will be skipped when generating the orders.
     *
     * @export
     * @class SetSuppliersForReturnToSupplierRequest
     * @implements {EvaService}
     */
    class SetSuppliersForReturnToSupplierRequest {
        name = 'Core:SetSuppliersForReturnToSupplierRequest';
        path = '/message/SetSuppliersForReturnToSupplierRequest';
        request;
        response;
    }
    Core.SetSuppliersForReturnToSupplierRequest = SetSuppliersForReturnToSupplierRequest;
    /**
     * Set additional order line information intended for transport data. Supports a single `OrderLineID`, or a list of `OrderLineIDs`.
     *
     * @export
     * @class SetTransportOrderLineData
     * @implements {EvaService}
     */
    class SetTransportOrderLineData {
        name = 'Core:SetTransportOrderLineData';
        path = '/message/SetTransportOrderLineData';
        request;
        response;
    }
    Core.SetTransportOrderLineData = SetTransportOrderLineData;
    /**
     * Set the user Consignment property.
     *
     * @export
     * @class SetUserConsignment
     * @implements {EvaService}
     */
    class SetUserConsignment {
        name = 'Core:SetUserConsignment';
        path = '/message/SetUserConsignment';
        request;
        response;
    }
    Core.SetUserConsignment = SetUserConsignment;
    /**
     * Update a user login to single sign on only
     *
     * @export
     * @class SetUserToSingleSignOnOnly
     * @implements {EvaService}
     */
    class SetUserToSingleSignOnOnly {
        name = 'Core:SetUserToSingleSignOnOnly';
        path = '/message/SetUserToSingleSignOnOnly';
        request;
        response;
    }
    Core.SetUserToSingleSignOnOnly = SetUserToSingleSignOnOnly;
    /**
     * Set additional order information intended for warehouse data.
     *
     * @export
     * @class SetWarehouseOrderData
     * @implements {EvaService}
     */
    class SetWarehouseOrderData {
        name = 'Core:SetWarehouseOrderData';
        path = '/message/SetWarehouseOrderData';
        request;
        response;
    }
    Core.SetWarehouseOrderData = SetWarehouseOrderData;
    /**
     * Ships an order that has been exported to an external system by another proces
     *
     * @export
     * @class ShipExternalOrder
     * @implements {EvaService}
     */
    class ShipExternalOrder {
        name = 'Core:ShipExternalOrder';
        path = '/message/ShipExternalOrder';
        request;
        response;
    }
    Core.ShipExternalOrder = ShipExternalOrder;
    /**
     * Ships the specified order. When Lines are specified, only those lines will be shipped.

Shipping of Lines includes:
- Activating giftcards
- Mutating the stock of the products
- Potentially invoicing of the lines
- Validating requirements
     *
     * @export
     * @class ShipOrder
     * @implements {EvaService}
     */
    class ShipOrder {
        name = 'Core:ShipOrder';
        path = '/message/ShipOrder';
        request;
        response;
    }
    Core.ShipOrder = ShipOrder;
    /**
     * Ships an OrderFulfillment, thereby creating one or more Shipments for the underlying Order.
     *
     * @export
     * @class ShipOrderFulfillment
     * @implements {EvaService}
     */
    class ShipOrderFulfillment {
        name = 'Core:ShipOrderFulfillment';
        path = '/message/ShipOrderFulfillment';
        request;
        response;
    }
    Core.ShipOrderFulfillment = ShipOrderFulfillment;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ShipOrderLines
     * @implements {EvaService}
     */
    class ShipOrderLines {
        name = 'Core:ShipOrderLines';
        path = '/message/ShipOrderLines';
        request;
        response;
    }
    Core.ShipOrderLines = ShipOrderLines;
    /**
     * Creates a shipment for given purchase order lines and ships it!
     *
     * @export
     * @class ShipPurchaseOrder
     * @implements {EvaService}
     */
    class ShipPurchaseOrder {
        name = 'Core:ShipPurchaseOrder';
        path = '/message/ShipPurchaseOrder';
        request;
        response;
    }
    Core.ShipPurchaseOrder = ShipPurchaseOrder;
    /**
     * Ship an existing shipment that has status Pending.

Works only for SalesOrders at this moment.
     *
     * @export
     * @class ShipShipment
     * @implements {EvaService}
     */
    class ShipShipment {
        name = 'Core:ShipShipment';
        path = '/message/ShipShipment';
        request;
        response;
    }
    Core.ShipShipment = ShipShipment;
    /**
     * Add a signature to an Order.
     *
     * @export
     * @class SignOrder
     * @implements {EvaService}
     */
    class SignOrder {
        name = 'Core:SignOrder';
        path = '/message/SignOrder';
        request;
        response;
    }
    Core.SignOrder = SignOrder;
    /**
     * Split an OrderLine in two lines.

The new line will have a QuantityOrdered of QuantityToSplit and on the existing line there will be QuantityToShip items cancelled.
If the OrderLine has a negative QuantityToShip, the QuantityOrdered of the new line will be -QuantityToSplit.

The QuantityToSplit should always be greather than 0 and smaller than the absolute value of the QuantityToShip of the OrderLine.
     *
     * @export
     * @class SplitOrderLine
     * @implements {EvaService}
     */
    class SplitOrderLine {
        name = 'Core:SplitOrderLine';
        path = '/message/SplitOrderLine';
        request;
        response;
    }
    Core.SplitOrderLine = SplitOrderLine;
    /**
     * Initiates the closing of a cash journal. This does not yet mutate anything, but returns all the details you need about a cash journal to be able to close it.

This consists of:

- The information about the device and station
- Which expenses and deposits were made from this device.
- What payments were made.
- What the `ExpectedClosingAmount` is, which is a summary of the previous journal's closing amount plus all transactions.
- Possible pending cash deposits on this device
     *
     * @export
     * @class StartCloseCashJournal
     * @implements {EvaService}
     */
    class StartCloseCashJournal {
        name = 'Core:StartCloseCashJournal';
        path = '/message/StartCloseCashJournal';
        request;
        response;
    }
    Core.StartCloseCashJournal = StartCloseCashJournal;
    /**
     * Starts a Composite User Task, returning child meta data.
     *
     * @export
     * @class StartCompositeUserTask
     * @implements {EvaService}
     */
    class StartCompositeUserTask {
        name = 'Core:StartCompositeUserTask';
        path = '/message/StartCompositeUserTask';
        request;
        response;
    }
    Core.StartCompositeUserTask = StartCompositeUserTask;
    /**
     * Starts a ConsolidatedZonePickTask
     *
     * @export
     * @class StartConsolidatedZonePickTask
     * @implements {EvaService}
     */
    class StartConsolidatedZonePickTask {
        name = 'Core:StartConsolidatedZonePickTask';
        path = '/message/StartConsolidatedZonePickTask';
        request;
        response;
    }
    Core.StartConsolidatedZonePickTask = StartConsolidatedZonePickTask;
    /**
     * Starts a new custom usertask
     *
     * @export
     * @class StartCustomUserTask
     * @implements {EvaService}
     */
    class StartCustomUserTask {
        name = 'Core:StartCustomUserTask';
        path = '/message/StartCustomUserTask';
        request;
        response;
    }
    Core.StartCustomUserTask = StartCustomUserTask;
    /**
     * Starts a full stock count task. Requires it to be ready.
     *
     * @export
     * @class StartFullStockCount
     * @implements {EvaService}
     */
    class StartFullStockCount {
        name = 'Core:StartFullStockCount';
        path = '/message/StartFullStockCount';
        request;
        response;
    }
    Core.StartFullStockCount = StartFullStockCount;
    /**
     * Starts a Full Stock Count label task.
     *
     * @export
     * @class StartFullStockCountLabel
     * @implements {EvaService}
     */
    class StartFullStockCountLabel {
        name = 'Core:StartFullStockCountLabel';
        path = '/message/StartFullStockCountLabel';
        request;
        response;
    }
    Core.StartFullStockCountLabel = StartFullStockCountLabel;
    /**
     * Starts the opening of a cash journal for the given DeviceID.

It's only possible to open a cash journal when an open financial period exists and when the device is a cash device. Retrieving a list of valid devices
can be accomplished through the `ListDevices` service.

Calling this service does not yet do anything, except return the data you need to open a cash journal:

- The available denominations (coins and notes)
- The details about the previous cash journal's closing amounts (if it exists), which can be used as an extra check
- Possible pending cash deposits on this device
     *
     * @export
     * @class StartOpenCashJournal
     * @implements {EvaService}
     */
    class StartOpenCashJournal {
        name = 'Core:StartOpenCashJournal';
        path = '/message/StartOpenCashJournal';
        request;
        response;
    }
    Core.StartOpenCashJournal = StartOpenCashJournal;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class StartPrintPriceLabelTask
     * @implements {EvaService}
     */
    class StartPrintPriceLabelTask {
        name = 'Core:StartPrintPriceLabelTask';
        path = '/message/StartPrintPriceLabelTask';
        request;
        response;
    }
    Core.StartPrintPriceLabelTask = StartPrintPriceLabelTask;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class StartPrintTask
     * @implements {EvaService}
     */
    class StartPrintTask {
        name = 'Core:StartPrintTask';
        path = '/message/StartPrintTask';
        request;
        response;
    }
    Core.StartPrintTask = StartPrintTask;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class StartReceiveShipment
     * @implements {EvaService}
     */
    class StartReceiveShipment {
        name = 'Core:StartReceiveShipment';
        path = '/message/StartReceiveShipment';
        request;
        response;
    }
    Core.StartReceiveShipment = StartReceiveShipment;
    /**
     * Start repair user task
     *
     * @export
     * @class StartRepairUserTask
     * @implements {EvaService}
     */
    class StartRepairUserTask {
        name = 'Core:StartRepairUserTask';
        path = '/message/StartRepairUserTask';
        request;
        response;
    }
    Core.StartRepairUserTask = StartRepairUserTask;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class StartReservationCleanup
     * @implements {EvaService}
     */
    class StartReservationCleanup {
        name = 'Core:StartReservationCleanup';
        path = '/message/StartReservationCleanup';
        request;
        response;
    }
    Core.StartReservationCleanup = StartReservationCleanup;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class StartReservationPickupTask
     * @implements {EvaService}
     */
    class StartReservationPickupTask {
        name = 'Core:StartReservationPickupTask';
        path = '/message/StartReservationPickupTask';
        request;
        response;
    }
    Core.StartReservationPickupTask = StartReservationPickupTask;
    /**
     * Starts ReturnToSupplier task.
     *
     * @export
     * @class StartReturnToSupplierTask
     * @implements {EvaService}
     */
    class StartReturnToSupplierTask {
        name = 'Core:StartReturnToSupplierTask';
        path = '/message/StartReturnToSupplierTask';
        request;
        response;
    }
    Core.StartReturnToSupplierTask = StartReturnToSupplierTask;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class StartSecondChanceProductRegistration
     * @implements {EvaService}
     */
    class StartSecondChanceProductRegistration {
        name = 'Core:StartSecondChanceProductRegistration';
        path = '/message/StartSecondChanceProductRegistration';
        request;
        response;
    }
    Core.StartSecondChanceProductRegistration = StartSecondChanceProductRegistration;
    /**
     * Starts a ShipFromStore task, identified by its UserTaskID.

The service returns the order that should be shipped from the user's current store as well as the OrderLines
that should be part of the shipment. Not necessarily all orderlines of the order should be shipped, so the
OrderLineIDs returned by this service should be respected.
     *
     * @export
     * @class StartShipFromStoreTask
     * @implements {EvaService}
     */
    class StartShipFromStoreTask {
        name = 'Core:StartShipFromStoreTask';
        path = '/message/StartShipFromStoreTask';
        request;
        response;
    }
    Core.StartShipFromStoreTask = StartShipFromStoreTask;
    /**
     * Starts a Stock Movement Follow Up task. Proceed with the `CompleteStockMovementFollowUp` service when finished.
     *
     * @export
     * @class StartStockMovementFollowUp
     * @implements {EvaService}
     */
    class StartStockMovementFollowUp {
        name = 'Core:StartStockMovementFollowUp';
        path = '/message/StartStockMovementFollowUp';
        request;
        response;
    }
    Core.StartStockMovementFollowUp = StartStockMovementFollowUp;
    /**
     * Starts one or more Stock Replenishment tasks, returning a workset. Pass this workset to the `CompleteStockReplenishment` service when all tasks are complete.
     *
     * @export
     * @class StartStockReplenishment
     * @implements {EvaService}
     */
    class StartStockReplenishment {
        name = 'Core:StartStockReplenishment';
        path = '/message/StartStockReplenishment';
        request;
        response;
    }
    Core.StartStockReplenishment = StartStockReplenishment;
    /**
     * Starts a user task of type Stock Reservation.

- The task will return all required data for display purposes
- When no lines are returned, the task is already completed or in progress by someone else
- To complete the StockReservation task, use the `CompleteStockReservationTask` service
     *
     * @export
     * @class StartStockReservation2
     * @implements {EvaService}
     */
    class StartStockReservation2 {
        name = 'Core:StartStockReservation2';
        path = '/message/StartStockReservation2';
        request;
        response;
    }
    Core.StartStockReservation2 = StartStockReservation2;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class StartZonedCycleCount
     * @implements {EvaService}
     */
    class StartZonedCycleCount {
        name = 'Core:StartZonedCycleCount';
        path = '/message/StartZonedCycleCount';
        request;
        response;
    }
    Core.StartZonedCycleCount = StartZonedCycleCount;
    /**
     * Starts a ZonedCycleCountPreCount by the ID of its UserTask.

The response contains:

- Which StockLabels to count (`StockLabelsToCount`)
- The product that needs to be counted (`Product`); this product contains all the fields in its `Content` object that were requested through the `IncludedFields` property on the request, or a default set of fields if not specified
- Zone that needs to be counted (`CycleCountZone`)
- List of stock labels to be counted (`StockLabelsToCount`)
     *
     * @export
     * @class StartZonedCycleCountPreCount
     * @implements {EvaService}
     */
    class StartZonedCycleCountPreCount {
        name = 'Core:StartZonedCycleCountPreCount';
        path = '/message/StartZonedCycleCountPreCount';
        request;
        response;
    }
    Core.StartZonedCycleCountPreCount = StartZonedCycleCountPreCount;
    /**
     * Service combining StoreBlob and AttachBlobToOrder.
     *
     * @export
     * @class StoreAndAttachBlobToOrder
     * @implements {EvaService}
     */
    class StoreAndAttachBlobToOrder {
        name = 'Core:StoreAndAttachBlobToOrder';
        path = '/message/StoreAndAttachBlobToOrder';
        request;
        response;
    }
    Core.StoreAndAttachBlobToOrder = StoreAndAttachBlobToOrder;
    /**
     * Submit an inquiry
     *
     * @export
     * @class SubmitInquiry
     * @implements {EvaService}
     */
    class SubmitInquiry {
        name = 'Core:SubmitInquiry';
        path = '/message/SubmitInquiry';
        request;
        response;
    }
    Core.SubmitInquiry = SubmitInquiry;
    /**
     * Subscribe to the specified feed for the current User's `ApplicationID`.

`Name` is the name of the file you wish to watch. The `WebhookUrl` is called with a JSON POST request, in which the Feed's `name` and `applicationID` are specified. This request does not contain the data
itself, your application will have to fetch the data using your current approaches to download this feed. This may seem verbose, but we have no guarantee the endpoint is secure, and we can't just send
possibly sensitive information there!

To unsubscribe, call the `UnsubscribeFromFeed` service with the returned `ID` value.
     *
     * @export
     * @class SubscribeToFeed
     * @implements {EvaService}
     */
    class SubscribeToFeed {
        name = 'Core:SubscribeToFeed';
        path = '/message/SubscribeToFeed';
        request;
        response;
    }
    Core.SubscribeToFeed = SubscribeToFeed;
    /**
     * Subscribe an User to a Subscription

The service returns the status of the subscription
     *
     * @export
     * @class SubscribeUser
     * @implements {EvaService}
     */
    class SubscribeUser {
        name = 'Core:SubscribeUser';
        path = '/message/SubscribeUser';
        request;
        response;
    }
    Core.SubscribeUser = SubscribeUser;
    /**
     * Creates a purchase order (or updates it if it already exists).

When the order already exists, only the lines can be updated (see `SupplierUpdatePurchaseOrder`) - other properties will be ignored.

:lightbulb: Using `SupplierCreateOrder` and `SupplierUpdatePurchaseOrder` is preferred.
     *
     * @export
     * @class SupplierCreateOrUpdatePurchaseOrder
     * @implements {EvaService}
     */
    class SupplierCreateOrUpdatePurchaseOrder {
        name = 'Core:SupplierCreateOrUpdatePurchaseOrder';
        path = '/message/SupplierCreateOrUpdatePurchaseOrder';
        request;
        response;
    }
    Core.SupplierCreateOrUpdatePurchaseOrder = SupplierCreateOrUpdatePurchaseOrder;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class SupplierCreatePurchaseOrder
     * @implements {EvaService}
     */
    class SupplierCreatePurchaseOrder {
        name = 'Core:SupplierCreatePurchaseOrder';
        path = '/message/SupplierCreatePurchaseOrder';
        request;
        response;
    }
    Core.SupplierCreatePurchaseOrder = SupplierCreatePurchaseOrder;
    /**
     * Ships a Purchase Order with specified lines. Supply either `ID` or a `BackendID`/`BackendSystemID` combination to
identify the order.

If you wish to receive on behalf of a different organization, identify that organization by specifying a
`ShipToOrganizationUnitBackendID`. Should this organization reside in a different cluster, this call will be proxied
to that cluster for you.
     *
     * @export
     * @class SupplierShipPurchaseOrder
     * @implements {EvaService}
     */
    class SupplierShipPurchaseOrder {
        name = 'Core:SupplierShipPurchaseOrder';
        path = '/message/SupplierShipPurchaseOrder';
        request;
        response;
    }
    Core.SupplierShipPurchaseOrder = SupplierShipPurchaseOrder;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class SupplierUpdatePurchaseOrder
     * @implements {EvaService}
     */
    class SupplierUpdatePurchaseOrder {
        name = 'Core:SupplierUpdatePurchaseOrder';
        path = '/message/SupplierUpdatePurchaseOrder';
        request;
        response;
    }
    Core.SupplierUpdatePurchaseOrder = SupplierUpdatePurchaseOrder;
    /**
     * When you would like to temporarily suspend an order, you can use `SuspendOrder` to do so.

- To identify your suspended order it is possible to supply a `Description`
- To print a receipt of the suspended order, to make it easier to continue later on, supply `PrintReceipt` (and optionally a `StationID`)
- To retreive the suspended orders, see the `ListSuspendedOrders` service
     *
     * @export
     * @class SuspendOrder
     * @implements {EvaService}
     */
    class SuspendOrder {
        name = 'Core:SuspendOrder';
        path = '/message/SuspendOrder';
        request;
        response;
    }
    Core.SuspendOrder = SuspendOrder;
    /**
     * *WARNING* NewBlack only service

Toggle on/off some core features of this environment
     *
     * @export
     * @class ToggleFeatures
     * @implements {EvaService}
     */
    class ToggleFeatures {
        name = 'Core:ToggleFeatures';
        path = '/message/ToggleFeatures';
        request;
        response;
    }
    Core.ToggleFeatures = ToggleFeatures;
    /**
     * Transfers the provided Order to the OrganizationUnit of the currently logged in user, updating both the SoldFromOrganizationUnit and PickupOrganizationUnit.

If this is already the case, calling this service has no effect. In case the order cannot be transferred, this service will return an error.
     *
     * @export
     * @class TransferOrderToOrganizationUnit
     * @implements {EvaService}
     */
    class TransferOrderToOrganizationUnit {
        name = 'Core:TransferOrderToOrganizationUnit';
        path = '/message/TransferOrderToOrganizationUnit';
        request;
        response;
    }
    Core.TransferOrderToOrganizationUnit = TransferOrderToOrganizationUnit;
    /**
     * Flag this order to trigger manual AML checks.
     *
     * @export
     * @class TriggerAMLChecksOnOrder
     * @implements {EvaService}
     */
    class TriggerAMLChecksOnOrder {
        name = 'Core:TriggerAMLChecksOnOrder';
        path = '/message/TriggerAMLChecksOnOrder';
        request;
        response;
    }
    Core.TriggerAMLChecksOnOrder = TriggerAMLChecksOnOrder;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class TriggerRecurringTask
     * @implements {EvaService}
     */
    class TriggerRecurringTask {
        name = 'Core:TriggerRecurringTask';
        path = '/message/TriggerRecurringTask';
        request;
        response;
    }
    Core.TriggerRecurringTask = TriggerRecurringTask;
    /**
     * Restore an archived organization unit.
     *
     * @export
     * @class UnarchiveOrganizationUnit
     * @implements {EvaService}
     */
    class UnarchiveOrganizationUnit {
        name = 'Core:UnarchiveOrganizationUnit';
        path = '/message/UnarchiveOrganizationUnit';
        request;
        response;
    }
    Core.UnarchiveOrganizationUnit = UnarchiveOrganizationUnit;
    /**
     * This service allows you to undo a commitment on the given OrderLineIDs, making the committed stock available to other orders again.
     *
     * @export
     * @class UncommitOrderLines
     * @implements {EvaService}
     */
    class UncommitOrderLines {
        name = 'Core:UncommitOrderLines';
        path = '/message/UncommitOrderLines';
        request;
        response;
    }
    Core.UncommitOrderLines = UncommitOrderLines;
    /**
     * Removes stock from transit for an unreceived shipment
     *
     * @export
     * @class UndoShipment
     * @implements {EvaService}
     */
    class UndoShipment {
        name = 'Core:UndoShipment';
        path = '/message/UndoShipment';
        request;
        response;
    }
    Core.UndoShipment = UndoShipment;
    /**
     * Removes stock for a received shipment
     *
     * @export
     * @class UndoShipmentReceipt
     * @implements {EvaService}
     */
    class UndoShipmentReceipt {
        name = 'Core:UndoShipmentReceipt';
        path = '/message/UndoShipmentReceipt';
        request;
        response;
    }
    Core.UndoShipmentReceipt = UndoShipmentReceipt;
    /**
     * Unlock the Order, allowing future editing on it.
     *
     * @export
     * @class UnlockOrder
     * @implements {EvaService}
     */
    class UnlockOrder {
        name = 'Core:UnlockOrder';
        path = '/message/UnlockOrder';
        request;
        response;
    }
    Core.UnlockOrder = UnlockOrder;
    /**
     * Unsubscribe from the specified feed.
     *
     * @export
     * @class UnsubscribeFromFeed
     * @implements {EvaService}
     */
    class UnsubscribeFromFeed {
        name = 'Core:UnsubscribeFromFeed';
        path = '/message/UnsubscribeFromFeed';
        request;
        response;
    }
    Core.UnsubscribeFromFeed = UnsubscribeFromFeed;
    /**
     * Unsubscribes an User from a Subscription

The service returns the status of the subscription
     *
     * @export
     * @class UnsubscribeUser
     * @implements {EvaService}
     */
    class UnsubscribeUser {
        name = 'Core:UnsubscribeUser';
        path = '/message/UnsubscribeUser';
        request;
        response;
    }
    Core.UnsubscribeUser = UnsubscribeUser;
    /**
     * Update the addresses on a User

This is deprecated in favour of using the AddressBook services
     *
     * @export
     * @class UpdateAddress
     * @implements {EvaService}
     */
    class UpdateAddress {
        name = 'Core:UpdateAddress';
        path = '/message/UpdateAddress';
        request;
        response;
    }
    Core.UpdateAddress = UpdateAddress;
    /**
     * Update an existing Address in the AddressBook of an User
     *
     * @export
     * @class UpdateAddressBookItem
     * @implements {EvaService}
     */
    class UpdateAddressBookItem {
        name = 'Core:UpdateAddressBookItem';
        path = '/message/UpdateAddressBookItem';
        request;
        response;
    }
    Core.UpdateAddressBookItem = UpdateAddressBookItem;
    /**
     * Update an existing Address Requirement object.

This service is using the ID or a PropertyType-CountryID par as input for the finding of the
correct address requirement we want to update.
If the address requirement is found the visibility and validation of this will be updated.
     *
     * @export
     * @class UpdateAddressRequirement
     * @implements {EvaService}
     */
    class UpdateAddressRequirement {
        name = 'Core:UpdateAddressRequirement';
        path = '/message/UpdateAddressRequirement';
        request;
        response;
    }
    Core.UpdateAddressRequirement = UpdateAddressRequirement;
    /**
     * Update an anonymous wishlist.
     *
     * @export
     * @class UpdateAnonymousWishlist
     * @implements {EvaService}
     */
    class UpdateAnonymousWishlist {
        name = 'Core:UpdateAnonymousWishlist';
        path = '/message/UpdateAnonymousWishlist';
        request;
        response;
    }
    Core.UpdateAnonymousWishlist = UpdateAnonymousWishlist;
    /**
     * Update an exisiting API key

All other properties need a new key to be created as these would influence the token authorization.
     *
     * @export
     * @class UpdateApiKey
     * @implements {EvaService}
     */
    class UpdateApiKey {
        name = 'Core:UpdateApiKey';
        path = '/message/UpdateApiKey';
        request;
        response;
    }
    Core.UpdateApiKey = UpdateApiKey;
    /**
     * Update an app rule
     *
     * @export
     * @class UpdateAppRule
     * @implements {EvaService}
     */
    class UpdateAppRule {
        name = 'Core:UpdateAppRule';
        path = '/message/UpdateAppRule';
        request;
        response;
    }
    Core.UpdateAppRule = UpdateAppRule;
    /**
     * Updates an existing AuditChainConfiguration, which allows you to configure the starting number of a sequence and its prefix.
Updating a configuration for an audit chain that already exists does not apply this updated configuration. A new chain would need to be created by incrementing the Auditing:Version setting.
     *
     * @export
     * @class UpdateAuditChainConfiguration
     * @implements {EvaService}
     */
    class UpdateAuditChainConfiguration {
        name = 'Core:UpdateAuditChainConfiguration';
        path = '/message/UpdateAuditChainConfiguration';
        request;
        response;
    }
    Core.UpdateAuditChainConfiguration = UpdateAuditChainConfiguration;
    /**
     * Update a cash correction reason
     *
     * @export
     * @class UpdateCashCorrectionReason
     * @implements {EvaService}
     */
    class UpdateCashCorrectionReason {
        name = 'Core:UpdateCashCorrectionReason';
        path = '/message/UpdateCashCorrectionReason';
        request;
        response;
    }
    Core.UpdateCashCorrectionReason = UpdateCashCorrectionReason;
    /**
     * Updates the current Company on specified `UserID`, or the current user when omitted.

:no_entry: Requires employee rights when using a `UserID` different than the current user.
:warning: Will overwrite *all* company fields, those fields omitted in your request will be removed! Except for FiscalID, that will be kept if not provided.
     *
     * @export
     * @class UpdateCompanyForUser
     * @implements {EvaService}
     */
    class UpdateCompanyForUser {
        name = 'Core:UpdateCompanyForUser';
        path = '/message/UpdateCompanyForUser';
        request;
        response;
    }
    Core.UpdateCompanyForUser = UpdateCompanyForUser;
    /**
     * Updates the details of companies associated with the consumer type.
     *
     * @export
     * @class UpdateConsumerCompany
     * @implements {EvaService}
     */
    class UpdateConsumerCompany {
        name = 'Core:UpdateConsumerCompany';
        path = '/message/UpdateConsumerCompany';
        request;
        response;
    }
    Core.UpdateConsumerCompany = UpdateConsumerCompany;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateContractNumber
     * @implements {EvaService}
     */
    class UpdateContractNumber {
        name = 'Core:UpdateContractNumber';
        path = '/message/UpdateContractNumber';
        request;
        response;
    }
    Core.UpdateContractNumber = UpdateContractNumber;
    /**
     * Update custom fields for multiple organization units at once.
     *
     * @export
     * @class UpdateCustomFieldsForOrganizationUnits
     * @implements {EvaService}
     */
    class UpdateCustomFieldsForOrganizationUnits {
        name = 'Core:UpdateCustomFieldsForOrganizationUnits';
        path = '/message/UpdateCustomFieldsForOrganizationUnits';
        request;
        response;
    }
    Core.UpdateCustomFieldsForOrganizationUnits = UpdateCustomFieldsForOrganizationUnits;
    /**
     * Updates a template for custom user tasks. If a property is not provided, it will be set to null.
     *
     * @export
     * @class UpdateCustomUserTaskTemplate
     * @implements {EvaService}
     */
    class UpdateCustomUserTaskTemplate {
        name = 'Core:UpdateCustomUserTaskTemplate';
        path = '/message/UpdateCustomUserTaskTemplate';
        request;
        response;
    }
    Core.UpdateCustomUserTaskTemplate = UpdateCustomUserTaskTemplate;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateCycleCountOriginType
     * @implements {EvaService}
     */
    class UpdateCycleCountOriginType {
        name = 'Core:UpdateCycleCountOriginType';
        path = '/message/UpdateCycleCountOriginType';
        request;
        response;
    }
    Core.UpdateCycleCountOriginType = UpdateCycleCountOriginType;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateCycleCountZone
     * @implements {EvaService}
     */
    class UpdateCycleCountZone {
        name = 'Core:UpdateCycleCountZone';
        path = '/message/UpdateCycleCountZone';
        request;
        response;
    }
    Core.UpdateCycleCountZone = UpdateCycleCountZone;
    /**
     * Updates an existing CycleCountZoneGroup.
     *
     * @export
     * @class UpdateCycleCountZoneGroup
     * @implements {EvaService}
     */
    class UpdateCycleCountZoneGroup {
        name = 'Core:UpdateCycleCountZoneGroup';
        path = '/message/UpdateCycleCountZoneGroup';
        request;
        response;
    }
    Core.UpdateCycleCountZoneGroup = UpdateCycleCountZoneGroup;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateDigitalGiftCardMailOptions
     * @implements {EvaService}
     */
    class UpdateDigitalGiftCardMailOptions {
        name = 'Core:UpdateDigitalGiftCardMailOptions';
        path = '/message/UpdateDigitalGiftCardMailOptions';
        request;
        response;
    }
    Core.UpdateDigitalGiftCardMailOptions = UpdateDigitalGiftCardMailOptions;
    /**
     * Sets the new mail values for the GiftCard identified by the `OrderID` and `GiftCardID`.

Omitting the `FromEmailAddress` parameter will default to the email address of the customer attached to the order.
     *
     * @export
     * @class UpdateDigitalGiftCardOptions
     * @implements {EvaService}
     */
    class UpdateDigitalGiftCardOptions {
        name = 'Core:UpdateDigitalGiftCardOptions';
        path = '/message/UpdateDigitalGiftCardOptions';
        request;
        response;
    }
    Core.UpdateDigitalGiftCardOptions = UpdateDigitalGiftCardOptions;
    /**
     * This service allows updating giftcard lines created with the `AddGiftCardToOrder` service.
 * `Data` will overwrite all the gift card data.
 * `ImageWidth` and `ImageHeight` describe the image used
     *
     * @export
     * @class UpdateDigitalGiftCardOrderLine
     * @implements {EvaService}
     */
    class UpdateDigitalGiftCardOrderLine {
        name = 'Core:UpdateDigitalGiftCardOrderLine';
        path = '/message/UpdateDigitalGiftCardOrderLine';
        request;
        response;
    }
    Core.UpdateDigitalGiftCardOrderLine = UpdateDigitalGiftCardOrderLine;
    /**
     * Service for updating a existing `EventExportConfiguration`
     *
     * @export
     * @class UpdateEventExportConfiguration
     * @implements {EvaService}
     */
    class UpdateEventExportConfiguration {
        name = 'Core:UpdateEventExportConfiguration';
        path = '/message/UpdateEventExportConfiguration';
        request;
        response;
    }
    Core.UpdateEventExportConfiguration = UpdateEventExportConfiguration;
    /**
     * Update an existing Flight
     *
     * @export
     * @class UpdateFlight
     * @implements {EvaService}
     */
    class UpdateFlight {
        name = 'Core:UpdateFlight';
        path = '/message/UpdateFlight';
        request;
        response;
    }
    Core.UpdateFlight = UpdateFlight;
    /**
     * Mutate Interbranch properties on the given `Order`.
     *
     * @export
     * @class UpdateInterbranchOrder
     * @implements {EvaService}
     */
    class UpdateInterbranchOrder {
        name = 'Core:UpdateInterbranchOrder';
        path = '/message/UpdateInterbranchOrder';
        request;
        response;
    }
    Core.UpdateInterbranchOrder = UpdateInterbranchOrder;
    /**
     * Updates an existing invoice. See the `CreateInvoice` service for more details about the request.
     *
     * @export
     * @class UpdateInvoice
     * @implements {EvaService}
     */
    class UpdateInvoice {
        name = 'Core:UpdateInvoice';
        path = '/message/UpdateInvoice';
        request;
        response;
    }
    Core.UpdateInvoice = UpdateInvoice;
    /**
     * Update an InvoiceAdditionalAmount
     *
     * @export
     * @class UpdateInvoiceAdditionalAmount
     * @implements {EvaService}
     */
    class UpdateInvoiceAdditionalAmount {
        name = 'Core:UpdateInvoiceAdditionalAmount';
        path = '/message/UpdateInvoiceAdditionalAmount';
        request;
        response;
    }
    Core.UpdateInvoiceAdditionalAmount = UpdateInvoiceAdditionalAmount;
    /**
     * Update the Description and LedgerClassID of a InvoiceAdditionalAmountType
     *
     * @export
     * @class UpdateInvoiceAdditionalAmountType
     * @implements {EvaService}
     */
    class UpdateInvoiceAdditionalAmountType {
        name = 'Core:UpdateInvoiceAdditionalAmountType';
        path = '/message/UpdateInvoiceAdditionalAmountType';
        request;
        response;
    }
    Core.UpdateInvoiceAdditionalAmountType = UpdateInvoiceAdditionalAmountType;
    /**
     * Update an InvoiceDispute
     *
     * @export
     * @class UpdateInvoiceDispute
     * @implements {EvaService}
     */
    class UpdateInvoiceDispute {
        name = 'Core:UpdateInvoiceDispute';
        path = '/message/UpdateInvoiceDispute';
        request;
        response;
    }
    Core.UpdateInvoiceDispute = UpdateInvoiceDispute;
    /**
     * Update the Description and LedgerClassID of a InvoiceDisputeReason
     *
     * @export
     * @class UpdateInvoiceDisputeReason
     * @implements {EvaService}
     */
    class UpdateInvoiceDisputeReason {
        name = 'Core:UpdateInvoiceDisputeReason';
        path = '/message/UpdateInvoiceDisputeReason';
        request;
        response;
    }
    Core.UpdateInvoiceDisputeReason = UpdateInvoiceDisputeReason;
    /**
     * Update an InvoiceDisputeResolveAction
     *
     * @export
     * @class UpdateInvoiceDisputeResolveAction
     * @implements {EvaService}
     */
    class UpdateInvoiceDisputeResolveAction {
        name = 'Core:UpdateInvoiceDisputeResolveAction';
        path = '/message/UpdateInvoiceDisputeResolveAction';
        request;
        response;
    }
    Core.UpdateInvoiceDisputeResolveAction = UpdateInvoiceDisputeResolveAction;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateInvoiceHoldStatus
     * @implements {EvaService}
     */
    class UpdateInvoiceHoldStatus {
        name = 'Core:UpdateInvoiceHoldStatus';
        path = '/message/UpdateInvoiceHoldStatus';
        request;
        response;
    }
    Core.UpdateInvoiceHoldStatus = UpdateInvoiceHoldStatus;
    /**
     * Updates lines on the given invoice (`InvoiceID`).

When the Quantity is 0 and the ExpectedQuantity is `null`, the line will be deleted.
     *
     * @export
     * @class UpdateInvoiceLines
     * @implements {EvaService}
     */
    class UpdateInvoiceLines {
        name = 'Core:UpdateInvoiceLines';
        path = '/message/UpdateInvoiceLines';
        request;
        response;
    }
    Core.UpdateInvoiceLines = UpdateInvoiceLines;
    /**
     * Updates the invoice user data. To retrieve the information that has been set use: `GetInvoice`
     *
     * @export
     * @class UpdateInvoiceUserData
     * @implements {EvaService}
     */
    class UpdateInvoiceUserData {
        name = 'Core:UpdateInvoiceUserData';
        path = '/message/UpdateInvoiceUserData';
        request;
        response;
    }
    Core.UpdateInvoiceUserData = UpdateInvoiceUserData;
    /**
     * Update a manual tax exemption reason.
     *
     * @export
     * @class UpdateManualTaxExemptionReason
     * @implements {EvaService}
     */
    class UpdateManualTaxExemptionReason {
        name = 'Core:UpdateManualTaxExemptionReason';
        path = '/message/UpdateManualTaxExemptionReason';
        request;
        response;
    }
    Core.UpdateManualTaxExemptionReason = UpdateManualTaxExemptionReason;
    /**
     * Update an existing OpeningHoursTemplate
     *
     * @export
     * @class UpdateOpeningHoursTemplate
     * @implements {EvaService}
     */
    class UpdateOpeningHoursTemplate {
        name = 'Core:UpdateOpeningHoursTemplate';
        path = '/message/UpdateOpeningHoursTemplate';
        request;
        response;
    }
    Core.UpdateOpeningHoursTemplate = UpdateOpeningHoursTemplate;
    /**
     * Update various fields on an Order.
     *
     * @export
     * @class UpdateOrder
     * @implements {EvaService}
     */
    class UpdateOrder {
        name = 'Core:UpdateOrder';
        path = '/message/UpdateOrder';
        request;
        response;
    }
    Core.UpdateOrder = UpdateOrder;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateOrderAddresses
     * @implements {EvaService}
     */
    class UpdateOrderAddresses {
        name = 'Core:UpdateOrderAddresses';
        path = '/message/UpdateOrderAddresses';
        request;
        response;
    }
    Core.UpdateOrderAddresses = UpdateOrderAddresses;
    /**
     * Update the BillingAddress on an Order.

This can be done by providing a full Address in the Address property, or by referencing an Address in an AddressBook in the AddressBookID property.
     *
     * @export
     * @class UpdateOrderBillingAddress
     * @implements {EvaService}
     */
    class UpdateOrderBillingAddress {
        name = 'Core:UpdateOrderBillingAddress';
        path = '/message/UpdateOrderBillingAddress';
        request;
        response;
    }
    Core.UpdateOrderBillingAddress = UpdateOrderBillingAddress;
    /**
     * Update the data for the checkout options returned in the `AdditionalData` of a `GetOrder` or `GetShoppingCart` call
     *
     * @export
     * @class UpdateOrderCheckoutOptions
     * @implements {EvaService}
     */
    class UpdateOrderCheckoutOptions {
        name = 'Core:UpdateOrderCheckoutOptions';
        path = '/message/UpdateOrderCheckoutOptions';
        request;
        response;
    }
    Core.UpdateOrderCheckoutOptions = UpdateOrderCheckoutOptions;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateOrderCurrency
     * @implements {EvaService}
     */
    class UpdateOrderCurrency {
        name = 'Core:UpdateOrderCurrency';
        path = '/message/UpdateOrderCurrency';
        request;
        response;
    }
    Core.UpdateOrderCurrency = UpdateOrderCurrency;
    /**
     * Create or update existing custom field on order
     *
     * @export
     * @class UpdateOrderCustomFields
     * @implements {EvaService}
     */
    class UpdateOrderCustomFields {
        name = 'Core:UpdateOrderCustomFields';
        path = '/message/UpdateOrderCustomFields';
        request;
        response;
    }
    Core.UpdateOrderCustomFields = UpdateOrderCustomFields;
    /**
     * Set order custom status
     *
     * @export
     * @class UpdateOrderCustomOrderStatus
     * @implements {EvaService}
     */
    class UpdateOrderCustomOrderStatus {
        name = 'Core:UpdateOrderCustomOrderStatus';
        path = '/message/UpdateOrderCustomOrderStatus';
        request;
        response;
    }
    Core.UpdateOrderCustomOrderStatus = UpdateOrderCustomOrderStatus;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateOrderCustomStatus
     * @implements {EvaService}
     */
    class UpdateOrderCustomStatus {
        name = 'Core:UpdateOrderCustomStatus';
        path = '/message/UpdateOrderCustomStatus';
        request;
        response;
    }
    Core.UpdateOrderCustomStatus = UpdateOrderCustomStatus;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateOrderCustomType
     * @implements {EvaService}
     */
    class UpdateOrderCustomType {
        name = 'Core:UpdateOrderCustomType';
        path = '/message/UpdateOrderCustomType';
        request;
        response;
    }
    Core.UpdateOrderCustomType = UpdateOrderCustomType;
    /**
     * Updates the price and/or quantity of a fulfillment line based on its ID.

When modifying the quantity, it's not possible currently to increase the quantity, only to decrease it. The modification must also happen on the physical fulfillment line,
that is a fulfillment line with Type = Physical.
     *
     * @export
     * @class UpdateOrderFulfillmentLine
     * @implements {EvaService}
     */
    class UpdateOrderFulfillmentLine {
        name = 'Core:UpdateOrderFulfillmentLine';
        path = '/message/UpdateOrderFulfillmentLine';
        request;
        response;
    }
    Core.UpdateOrderFulfillmentLine = UpdateOrderFulfillmentLine;
    /**
     * Create or update existing custom field on order line level by ID
     *
     * @export
     * @class UpdateOrderLineCustomFields
     * @implements {EvaService}
     */
    class UpdateOrderLineCustomFields {
        name = 'Core:UpdateOrderLineCustomFields';
        path = '/message/UpdateOrderLineCustomFields';
        request;
        response;
    }
    Core.UpdateOrderLineCustomFields = UpdateOrderLineCustomFields;
    /**
     * Update the StockLabel for a single `OrderLine` or for the complete `Order`. It is required to supply an `OrderID` or an `OrderLineID`.
If one of the lines cannot be updated, it will be skipped.

Only unshipped orderlines with LineActionType Ship can be updated.
     *
     * @export
     * @class UpdateOrderLineStockLabel
     * @implements {EvaService}
     */
    class UpdateOrderLineStockLabel {
        name = 'Core:UpdateOrderLineStockLabel';
        path = '/message/UpdateOrderLineStockLabel';
        request;
        response;
    }
    Core.UpdateOrderLineStockLabel = UpdateOrderLineStockLabel;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateOrderLink
     * @implements {EvaService}
     */
    class UpdateOrderLink {
        name = 'Core:UpdateOrderLink';
        path = '/message/UpdateOrderLink';
        request;
        response;
    }
    Core.UpdateOrderLink = UpdateOrderLink;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateOrderLinkType
     * @implements {EvaService}
     */
    class UpdateOrderLinkType {
        name = 'Core:UpdateOrderLinkType';
        path = '/message/UpdateOrderLinkType';
        request;
        response;
    }
    Core.UpdateOrderLinkType = UpdateOrderLinkType;
    /**
     * This services can be used to toggle some of the OrderOptions.

- IgnoreDiscounts: Discounts will not be added/removed/recalculated
- IgnoreShippingCosts: ShippingCosts will not be added/removed/recalculated
- IgnoreGiftWrappingCosts: GiftWrappingCosts will not be added/removed/recalculated
- AllowPartialFulfillment: The order will potentially be fulfilled in multiple batches
     *
     * @export
     * @class UpdateOrderOptions
     * @implements {EvaService}
     */
    class UpdateOrderOptions {
        name = 'Core:UpdateOrderOptions';
        path = '/message/UpdateOrderOptions';
        request;
        response;
    }
    Core.UpdateOrderOptions = UpdateOrderOptions;
    /**
     * Update the PickupAddress on an Order.

This can be done by providing a full Address in the Address property, or by referencing an Address in an AddressBook in the AddressBookID property.
     *
     * @export
     * @class UpdateOrderPickupAddress
     * @implements {EvaService}
     */
    class UpdateOrderPickupAddress {
        name = 'Core:UpdateOrderPickupAddress';
        path = '/message/UpdateOrderPickupAddress';
        request;
        response;
    }
    Core.UpdateOrderPickupAddress = UpdateOrderPickupAddress;
    /**
     * Update the ShippingAddress on an Order.

This can be done by providing a full Address in the Address property, or by referencing an Address in an AddressBook in the AddressBookID property.
     *
     * @export
     * @class UpdateOrderShippingAddress
     * @implements {EvaService}
     */
    class UpdateOrderShippingAddress {
        name = 'Core:UpdateOrderShippingAddress';
        path = '/message/UpdateOrderShippingAddress';
        request;
        response;
    }
    Core.UpdateOrderShippingAddress = UpdateOrderShippingAddress;
    /**
     * Updates the order shipping status, creating ledger entries on order level.

Will be processed as a whole; a single failing line in `Lines` will prevent all other updates in a single call from persisting.
     *
     * @export
     * @class UpdateOrderShippingStatus
     * @implements {EvaService}
     */
    class UpdateOrderShippingStatus {
        name = 'Core:UpdateOrderShippingStatus';
        path = '/message/UpdateOrderShippingStatus';
        request;
        response;
    }
    Core.UpdateOrderShippingStatus = UpdateOrderShippingStatus;
    /**
     * Update an order verification reason
     *
     * @export
     * @class UpdateOrderVerificationReason
     * @implements {EvaService}
     */
    class UpdateOrderVerificationReason {
        name = 'Core:UpdateOrderVerificationReason';
        path = '/message/UpdateOrderVerificationReason';
        request;
        response;
    }
    Core.UpdateOrderVerificationReason = UpdateOrderVerificationReason;
    /**
     * Updates the basic information associated with an OrganizationUnit. This service can be used to only update a subset of the settings of the OrganizationUnit by providing only the fields you want to update.

If a field is not part of the request message (or has value `undefined`) then the setting is not updated. If the field is present but has a value of `null` then it's assumed you want to unset the setting.
     *
     * @export
     * @class UpdateOrganizationUnit
     * @implements {EvaService}
     */
    class UpdateOrganizationUnit {
        name = 'Core:UpdateOrganizationUnit';
        path = '/message/UpdateOrganizationUnit';
        request;
        response;
    }
    Core.UpdateOrganizationUnit = UpdateOrganizationUnit;
    /**
     * Updates the OrganizationUnit's settings. This service can be used to only update a subset of the settings of the OrganizationUnit by providing only the fields you want to update.
If a field is not part of the request message (or has value `undefined`) then the setting is not updated. If the field is present but has a value of `null` then it's assumed you want to unset the setting.
     *
     * @export
     * @class UpdateOrganizationUnitSettings
     * @implements {EvaService}
     */
    class UpdateOrganizationUnitSettings {
        name = 'Core:UpdateOrganizationUnitSettings';
        path = '/message/UpdateOrganizationUnitSettings';
        request;
        response;
    }
    Core.UpdateOrganizationUnitSettings = UpdateOrganizationUnitSettings;
    /**
     * Service for updating a existing `OrganizationUnitSupplier`
     *
     * @export
     * @class UpdateOrganizationUnitSupplier
     * @implements {EvaService}
     */
    class UpdateOrganizationUnitSupplier {
        name = 'Core:UpdateOrganizationUnitSupplier';
        path = '/message/UpdateOrganizationUnitSupplier';
        request;
        response;
    }
    Core.UpdateOrganizationUnitSupplier = UpdateOrganizationUnitSupplier;
    /**
     * This service is largely the same as CreateProductBundle.
The model passed into the request body is considered to be the entire bundle configuration.
Any lines that are currently present but not present in the update model are removed from the bundle.
The only parameter that is different is that the model requires an ID to be set for the root object and its lines, which you get back from the `GetProductBundle` and `ListProductBundles` services.
     *
     * @export
     * @class UpdateProductBundle
     * @implements {EvaService}
     */
    class UpdateProductBundle {
        name = 'Core:UpdateProductBundle';
        path = '/message/UpdateProductBundle';
        request;
        response;
    }
    Core.UpdateProductBundle = UpdateProductBundle;
    /**
     * Replace the given ProductRequirement values for an OrderLine with new values
     *
     * @export
     * @class UpdateProductRequirementValuesForOrderLine
     * @implements {EvaService}
     */
    class UpdateProductRequirementValuesForOrderLine {
        name = 'Core:UpdateProductRequirementValuesForOrderLine';
        path = '/message/UpdateProductRequirementValuesForOrderLine';
        request;
        response;
    }
    Core.UpdateProductRequirementValuesForOrderLine = UpdateProductRequirementValuesForOrderLine;
    /**
     * Updates an existing ProductZone.
     *
     * @export
     * @class UpdateProductZone
     * @implements {EvaService}
     */
    class UpdateProductZone {
        name = 'Core:UpdateProductZone';
        path = '/message/UpdateProductZone';
        request;
        response;
    }
    Core.UpdateProductZone = UpdateProductZone;
    /**
     * Updates an existing ProductZoneGroup.
     *
     * @export
     * @class UpdateProductZoneGroup
     * @implements {EvaService}
     */
    class UpdateProductZoneGroup {
        name = 'Core:UpdateProductZoneGroup';
        path = '/message/UpdateProductZoneGroup';
        request;
        response;
    }
    Core.UpdateProductZoneGroup = UpdateProductZoneGroup;
    /**
     * Service for updating an existing `QuickBuy` by ID
     *
     * @export
     * @class UpdateQuickBuy
     * @implements {EvaService}
     */
    class UpdateQuickBuy {
        name = 'Core:UpdateQuickBuy';
        path = '/message/UpdateQuickBuy';
        request;
        response;
    }
    Core.UpdateQuickBuy = UpdateQuickBuy;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateRecurringTask
     * @implements {EvaService}
     */
    class UpdateRecurringTask {
        name = 'Core:UpdateRecurringTask';
        path = '/message/UpdateRecurringTask';
        request;
        response;
    }
    Core.UpdateRecurringTask = UpdateRecurringTask;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateRepair
     * @implements {EvaService}
     */
    class UpdateRepair {
        name = 'Core:UpdateRepair';
        path = '/message/UpdateRepair';
        request;
        response;
    }
    Core.UpdateRepair = UpdateRepair;
    /**
     * Updates the deadline of a pending ReservationPickup task.
     *
     * @export
     * @class UpdateReservationPickupTaskDeadline
     * @implements {EvaService}
     */
    class UpdateReservationPickupTaskDeadline {
        name = 'Core:UpdateReservationPickupTaskDeadline';
        path = '/message/UpdateReservationPickupTaskDeadline';
        request;
        response;
    }
    Core.UpdateReservationPickupTaskDeadline = UpdateReservationPickupTaskDeadline;
    /**
     * Update the return to supplier order with Reason, ShipFrom- and ShipTo organization unit
     *
     * @export
     * @class UpdateReturnToSupplierOrder
     * @implements {EvaService}
     */
    class UpdateReturnToSupplierOrder {
        name = 'Core:UpdateReturnToSupplierOrder';
        path = '/message/UpdateReturnToSupplierOrder';
        request;
        response;
    }
    Core.UpdateReturnToSupplierOrder = UpdateReturnToSupplierOrder;
    /**
     * Update a ReturnToSupplierRequest

This is only allowed for requests in the state New

Properties that are not provided in the request, will not be updated.
     *
     * @export
     * @class UpdateReturnToSupplierRequest
     * @implements {EvaService}
     */
    class UpdateReturnToSupplierRequest {
        name = 'Core:UpdateReturnToSupplierRequest';
        path = '/message/UpdateReturnToSupplierRequest';
        request;
        response;
    }
    Core.UpdateReturnToSupplierRequest = UpdateReturnToSupplierRequest;
    /**
     * Updates a script
     *
     * @export
     * @class UpdateScript
     * @implements {EvaService}
     */
    class UpdateScript {
        name = 'Core:UpdateScript';
        path = '/message/UpdateScript';
        request;
        response;
    }
    Core.UpdateScript = UpdateScript;
    /**
     * Update the serial number on an order line - when no serialnumber is provided, it will be removed.
     *
     * @export
     * @class UpdateSerialNumber
     * @implements {EvaService}
     */
    class UpdateSerialNumber {
        name = 'Core:UpdateSerialNumber';
        path = '/message/UpdateSerialNumber';
        request;
        response;
    }
    Core.UpdateSerialNumber = UpdateSerialNumber;
    /**
     * Updates an existing Serial Number Configuration by it's `ID`.
     *
     * @export
     * @class UpdateSerialNumberConfiguration
     * @implements {EvaService}
     */
    class UpdateSerialNumberConfiguration {
        name = 'Core:UpdateSerialNumberConfiguration';
        path = '/message/UpdateSerialNumberConfiguration';
        request;
        response;
    }
    Core.UpdateSerialNumberConfiguration = UpdateSerialNumberConfiguration;
    /**
     * Update a Shipment. For shipments with status > Pending, only `ReceiveMethod`, `ShipmentDate` and `ExpectedDeliveryDate` can be updated.
Updating a shipment creates the new necessary shipping lines and packages.
Using the RemoveOtherPackagesAndLines property removes the existing ones.
     *
     * @export
     * @class UpdateShipment
     * @implements {EvaService}
     */
    class UpdateShipment {
        name = 'Core:UpdateShipment';
        path = '/message/UpdateShipment';
        request;
        response;
    }
    Core.UpdateShipment = UpdateShipment;
    /**
     * Update an existing shipment identifier.
     *
     * @export
     * @class UpdateShipmentIdentifier
     * @implements {EvaService}
     */
    class UpdateShipmentIdentifier {
        name = 'Core:UpdateShipmentIdentifier';
        path = '/message/UpdateShipmentIdentifier';
        request;
        response;
    }
    Core.UpdateShipmentIdentifier = UpdateShipmentIdentifier;
    /**
     * Updates the shipment status, creating ledger entries on shipment level.

Will be processed as a whole; a single failing line in `Lines` will prevent all other updates in a single call from persisting.
     *
     * @export
     * @class UpdateShipmentStatus
     * @implements {EvaService}
     */
    class UpdateShipmentStatus {
        name = 'Core:UpdateShipmentStatus';
        path = '/message/UpdateShipmentStatus';
        request;
        response;
    }
    Core.UpdateShipmentStatus = UpdateShipmentStatus;
    /**
     * Update the prices in the pricelist specified.

This service takes a simplified approach of the pricing tools EVA offers, but that limits the options you have available. The price list to update may
only have a single active adjustment, and that has to be of type `MANUAL_INPUT`.

* The pricelist is identified by the `PriceListID` or the `BackendSystemID` and `BackendID`.
* Products can be identified by their (EVA) `ID`.
* Updates from this service are persisted in the background, which could take up to 15 minutes to process (unless you set `ForcePriceListRecalculation` to `true`)
     *
     * @export
     * @class UpdateSimplePrices
     * @implements {EvaService}
     */
    class UpdateSimplePrices {
        name = 'Core:UpdateSimplePrices';
        path = '/message/UpdateSimplePrices';
        request;
        response;
    }
    Core.UpdateSimplePrices = UpdateSimplePrices;
    /**
     * Updates the Sellable stock of the given products for specified `OrganizationUnitID`, or when omitted, your current organization unit.

Specify the new, absolute quantities as values in the `Products` list. Products that are not mentioned will not be modified.
     *
     * @export
     * @class UpdateStock
     * @implements {EvaService}
     */
    class UpdateStock {
        name = 'Core:UpdateStock';
        path = '/message/UpdateStock';
        request;
        response;
    }
    Core.UpdateStock = UpdateStock;
    /**
     * Updates Stock Replenishment task data.
     *
     * @export
     * @class UpdateStockReplenishmentTaskData
     * @implements {EvaService}
     */
    class UpdateStockReplenishmentTaskData {
        name = 'Core:UpdateStockReplenishmentTaskData';
        path = '/message/UpdateStockReplenishmentTaskData';
        request;
        response;
    }
    Core.UpdateStockReplenishmentTaskData = UpdateStockReplenishmentTaskData;
    /**
     * Update the user identifier on a user subscription
     *
     * @export
     * @class UpdateSubscriptionUserIdentifier
     * @implements {EvaService}
     */
    class UpdateSubscriptionUserIdentifier {
        name = 'Core:UpdateSubscriptionUserIdentifier';
        path = '/message/UpdateSubscriptionUserIdentifier';
        request;
        response;
    }
    Core.UpdateSubscriptionUserIdentifier = UpdateSubscriptionUserIdentifier;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateTaxCode
     * @implements {EvaService}
     */
    class UpdateTaxCode {
        name = 'Core:UpdateTaxCode';
        path = '/message/UpdateTaxCode';
        request;
        response;
    }
    Core.UpdateTaxCode = UpdateTaxCode;
    /**
     * Update an existing TaxCodeMapping. Only one mapping per TaxCode & TaxProvider is allowed.
     *
     * @export
     * @class UpdateTaxCodeMapping
     * @implements {EvaService}
     */
    class UpdateTaxCodeMapping {
        name = 'Core:UpdateTaxCodeMapping';
        path = '/message/UpdateTaxCodeMapping';
        request;
        response;
    }
    Core.UpdateTaxCodeMapping = UpdateTaxCodeMapping;
    /**
     * Update an existing TaxProvider
     *
     * @export
     * @class UpdateTaxProvider
     * @implements {EvaService}
     */
    class UpdateTaxProvider {
        name = 'Core:UpdateTaxProvider';
        path = '/message/UpdateTaxProvider';
        request;
        response;
    }
    Core.UpdateTaxProvider = UpdateTaxProvider;
    /**
     * Modifies a tax rate.

:point_right: See `CreateTaxRate` service for more info.
     *
     * @export
     * @class UpdateTaxRate
     * @implements {EvaService}
     */
    class UpdateTaxRate {
        name = 'Core:UpdateTaxRate';
        path = '/message/UpdateTaxRate';
        request;
        response;
    }
    Core.UpdateTaxRate = UpdateTaxRate;
    /**
     * Update properties on an existing User. Will throw an exception if one of the properties are invalid.

Properties not specified in the request will be ignored.
     *
     * @export
     * @class UpdateUser
     * @implements {EvaService}
     */
    class UpdateUser {
        name = 'Core:UpdateUser';
        path = '/message/UpdateUser';
        request;
        response;
    }
    Core.UpdateUser = UpdateUser;
    /**
     * This service is used to change the AccountType of a Customer.

When changing the AccountType from Standard to Incognito or Basic, all credentials and roles are removed.

When changing the AccountType from Incognito or Basic to Standard:
- Uniqueness checks are done for the EmailAddress and Nickname
- Default customer roles are generated
- When no password is provided, one is generated and returned in the response
- If configured, the user will receive an `welcome to EVA` email. If no valid password is provided, the email will also contain a generated password.
     *
     * @export
     * @class UpdateUserAccountType
     * @implements {EvaService}
     */
    class UpdateUserAccountType {
        name = 'Core:UpdateUserAccountType';
        path = '/message/UpdateUserAccountType';
        request;
        response;
    }
    Core.UpdateUserAccountType = UpdateUserAccountType;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateUserAssociation
     * @implements {EvaService}
     */
    class UpdateUserAssociation {
        name = 'Core:UpdateUserAssociation';
        path = '/message/UpdateUserAssociation';
        request;
        response;
    }
    Core.UpdateUserAssociation = UpdateUserAssociation;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateUserAssociationType
     * @implements {EvaService}
     */
    class UpdateUserAssociationType {
        name = 'Core:UpdateUserAssociationType';
        path = '/message/UpdateUserAssociationType';
        request;
        response;
    }
    Core.UpdateUserAssociationType = UpdateUserAssociationType;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateUserDebtorData
     * @implements {EvaService}
     */
    class UpdateUserDebtorData {
        name = 'Core:UpdateUserDebtorData';
        path = '/message/UpdateUserDebtorData';
        request;
        response;
    }
    Core.UpdateUserDebtorData = UpdateUserDebtorData;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateUserGroup
     * @implements {EvaService}
     */
    class UpdateUserGroup {
        name = 'Core:UpdateUserGroup';
        path = '/message/UpdateUserGroup';
        request;
        response;
    }
    Core.UpdateUserGroup = UpdateUserGroup;
    /**
     * Updates a UserInteraction. A UserInteraction logs an interaction between an employee and a customer, for example the fact the customer was called.

UserID is optional but only if OrderID is also provided and the given Order is attached to a customer. If so then the UserInteraction is attached to the Order.Customer.
     *
     * @export
     * @class UpdateUserInteraction
     * @implements {EvaService}
     */
    class UpdateUserInteraction {
        name = 'Core:UpdateUserInteraction';
        path = '/message/UpdateUserInteraction';
        request;
        response;
    }
    Core.UpdateUserInteraction = UpdateUserInteraction;
    /**
     * Updates a UserPhoneNumber based on its ID. This service allows you to change the PhoneNumber (required), Type, Description.
    If you want to change what number is the primary number, use the `MakeUserPhoneNumberPrimary` service.

This service only allows the number's own user or an employee to update it.
     *
     * @export
     * @class UpdateUserPhoneNumber
     * @implements {EvaService}
     */
    class UpdateUserPhoneNumber {
        name = 'Core:UpdateUserPhoneNumber';
        path = '/message/UpdateUserPhoneNumber';
        request;
        response;
    }
    Core.UpdateUserPhoneNumber = UpdateUserPhoneNumber;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateUserTaskNotCompletedReason
     * @implements {EvaService}
     */
    class UpdateUserTaskNotCompletedReason {
        name = 'Core:UpdateUserTaskNotCompletedReason';
        path = '/message/UpdateUserTaskNotCompletedReason';
        request;
        response;
    }
    Core.UpdateUserTaskNotCompletedReason = UpdateUserTaskNotCompletedReason;
    /**
     * Updates an existing User Task Priority.
     *
     * @export
     * @class UpdateUserTaskPriority
     * @implements {EvaService}
     */
    class UpdateUserTaskPriority {
        name = 'Core:UpdateUserTaskPriority';
        path = '/message/UpdateUserTaskPriority';
        request;
        response;
    }
    Core.UpdateUserTaskPriority = UpdateUserTaskPriority;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateUserTaskType
     * @implements {EvaService}
     */
    class UpdateUserTaskType {
        name = 'Core:UpdateUserTaskType';
        path = '/message/UpdateUserTaskType';
        request;
        response;
    }
    Core.UpdateUserTaskType = UpdateUserTaskType;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateUserTaskTypeOrganizationUnitSet
     * @implements {EvaService}
     */
    class UpdateUserTaskTypeOrganizationUnitSet {
        name = 'Core:UpdateUserTaskTypeOrganizationUnitSet';
        path = '/message/UpdateUserTaskTypeOrganizationUnitSet';
        request;
        response;
    }
    Core.UpdateUserTaskTypeOrganizationUnitSet = UpdateUserTaskTypeOrganizationUnitSet;
    /**
     * This service is used to change the VisibilityGroup of a User.

To change the VisibilityGroup of a User, the following conditions must be met:
- The User must be visable and editable by the current User
- The VisibilityGroup must be visible for Users by the current User, the service GetUsersVisibilityGroups can be used to get a list of all available VisibilityGroups for the current User.
- If the User is a standard account, there must be no duplicate standard account in the new VisibilityGroup.
     *
     * @export
     * @class UpdateUserVisibilityGroup
     * @implements {EvaService}
     */
    class UpdateUserVisibilityGroup {
        name = 'Core:UpdateUserVisibilityGroup';
        path = '/message/UpdateUserVisibilityGroup';
        request;
        response;
    }
    Core.UpdateUserVisibilityGroup = UpdateUserVisibilityGroup;
    /**
     * Update the user wishlist.
     *
     * @export
     * @class UpdateUserWishlist
     * @implements {EvaService}
     */
    class UpdateUserWishlist {
        name = 'Core:UpdateUserWishlist';
        path = '/message/UpdateUserWishlist';
        request;
        response;
    }
    Core.UpdateUserWishlist = UpdateUserWishlist;
    /**
     * Updates a Zoned Cycle Count Schedule.
     *
     * @export
     * @class UpdateZonedCycleCountSchedule
     * @implements {EvaService}
     */
    class UpdateZonedCycleCountSchedule {
        name = 'Core:UpdateZonedCycleCountSchedule';
        path = '/message/UpdateZonedCycleCountSchedule';
        request;
        response;
    }
    Core.UpdateZonedCycleCountSchedule = UpdateZonedCycleCountSchedule;
    /**
     * Service to validate and upgrade tickets to invoices based on order details.
     *
     * @export
     * @class UpgradeInvoice
     * @implements {EvaService}
     */
    class UpgradeInvoice {
        name = 'Core:UpgradeInvoice';
        path = '/message/UpgradeInvoice';
        request;
        response;
    }
    Core.UpgradeInvoice = UpgradeInvoice;
    /**
     * Upload stock Excel (delta)file. The service processes the data async. This service is intended for small files (up to 5MB). Please view the documentation for processing larger files.
     *
     * @export
     * @class UploadAndProcessStockExcelFile
     * @implements {EvaService}
     */
    class UploadAndProcessStockExcelFile {
        name = 'Core:UploadAndProcessStockExcelFile';
        path = '/message/UploadAndProcessStockExcelFile';
        request;
        response;
    }
    Core.UploadAndProcessStockExcelFile = UploadAndProcessStockExcelFile;
    /**
     * Upload stock JSON (delta)file. The service processes the data async.This service is intended for small files (up to 5MB). Please view the documentation for processing larger files.
     *
     * @export
     * @class UploadAndProcessStockJSONFile
     * @implements {EvaService}
     */
    class UploadAndProcessStockJSONFile {
        name = 'Core:UploadAndProcessStockJSONFile';
        path = '/message/UploadAndProcessStockJSONFile';
        request;
        response;
    }
    Core.UploadAndProcessStockJSONFile = UploadAndProcessStockJSONFile;
    /**
     * Uploads an Excel retrieved from `DownloadCycleCountSample`.
     *
     * @export
     * @class UploadCycleCountExcel
     * @implements {EvaService}
     */
    class UploadCycleCountExcel {
        name = 'Core:UploadCycleCountExcel';
        path = '/message/UploadCycleCountExcel';
        request;
        response;
    }
    Core.UploadCycleCountExcel = UploadCycleCountExcel;
    /**
     * Uploads an Excel retrieved from `DownloadCycleCountSample`.
     *
     * @export
     * @class UploadCycleCountExcel_Async
     * @implements {EvaService}
     */
    class UploadCycleCountExcel_Async {
        name = 'Core:UploadCycleCountExcel_Async';
        path = '/async-message/UploadCycleCountExcel';
        request;
        response;
    }
    Core.UploadCycleCountExcel_Async = UploadCycleCountExcel_Async;
    /**
     * Uploads an Excel retrieved from `DownloadCycleCountSample`.
     *
     * @export
     * @class UploadCycleCountExcel_AsyncResult
     * @implements {EvaService}
     */
    class UploadCycleCountExcel_AsyncResult {
        name = 'Core:UploadCycleCountExcel_AsyncResult';
        path = '/async-result/UploadCycleCountExcel';
        request;
        response;
    }
    Core.UploadCycleCountExcel_AsyncResult = UploadCycleCountExcel_AsyncResult;
    /**
     * Upload full stock count result. Previous uploads will be overwritten. The service processes the data async.
     *
     * @export
     * @class UploadExternalFullStockCountResult
     * @implements {EvaService}
     */
    class UploadExternalFullStockCountResult {
        name = 'Core:UploadExternalFullStockCountResult';
        path = '/message/UploadExternalFullStockCountResult';
        request;
        response;
    }
    Core.UploadExternalFullStockCountResult = UploadExternalFullStockCountResult;
    /**
     * Upload an excel with labels to the specified full stock count.
Caution! The Name column can only be max 50 chars. Names larger then that will be rejected.
Caution! This service will not change existing labels, but only add new ones. Duplicate detection is done on case insensitve Name in combination with StockLabel.
     *
     * @export
     * @class UploadFullStockCountLabels
     * @implements {EvaService}
     */
    class UploadFullStockCountLabels {
        name = 'Core:UploadFullStockCountLabels';
        path = '/message/UploadFullStockCountLabels';
        request;
        response;
    }
    Core.UploadFullStockCountLabels = UploadFullStockCountLabels;
    /**
     * Upload a filled Excel file with special opening hours for an opening hour template. The template Excel file should be downloaded from the `DownloadSpecialOpeningHoursSample` service.
     *
     * @export
     * @class UploadSpecialOpeningHoursExcel
     * @implements {EvaService}
     */
    class UploadSpecialOpeningHoursExcel {
        name = 'Core:UploadSpecialOpeningHoursExcel';
        path = '/message/UploadSpecialOpeningHoursExcel';
        request;
        response;
    }
    Core.UploadSpecialOpeningHoursExcel = UploadSpecialOpeningHoursExcel;
    /**
     * Before calling Create/UpdateCycleCountZone group you can call this service to perform some checks on the validity of the new zone group.
Currently it only returns warnings and calling it is not required before creating or updating the group, but it is recommended as it prevents confusing situations such as the same OrganizationUnit being part
of multiple groups at the same time.
     *
     * @export
     * @class ValidateCycleCountZoneGroup
     * @implements {EvaService}
     */
    class ValidateCycleCountZoneGroup {
        name = 'Core:ValidateCycleCountZoneGroup';
        path = '/message/ValidateCycleCountZoneGroup';
        request;
        response;
    }
    Core.ValidateCycleCountZoneGroup = ValidateCycleCountZoneGroup;
    /**
     * Validate if all conditions are met to schedule the (specified lines of) specified order.

_Will check the default ExportValidator and check OrderRequirements for all actions._
     *
     * @export
     * @class ValidateExportSchedule
     * @implements {EvaService}
     */
    class ValidateExportSchedule {
        name = 'Core:ValidateExportSchedule';
        path = '/message/ValidateExportSchedule';
        request;
        response;
    }
    Core.ValidateExportSchedule = ValidateExportSchedule;
    /**
     * Validates if the given PIN is valid for the current user/ou.
     *
     * @export
     * @class ValidateIdentificationPin
     * @implements {EvaService}
     */
    class ValidateIdentificationPin {
        name = 'Core:ValidateIdentificationPin';
        path = '/message/ValidateIdentificationPin';
        request;
        response;
    }
    Core.ValidateIdentificationPin = ValidateIdentificationPin;
    /**
     * Check if given `InvoiceNumber` is valid (eg. does not already exist & passes other validations).
     *
     * @export
     * @class ValidateInvoiceNumber
     * @implements {EvaService}
     */
    class ValidateInvoiceNumber {
        name = 'Core:ValidateInvoiceNumber';
        path = '/message/ValidateInvoiceNumber';
        request;
        response;
    }
    Core.ValidateInvoiceNumber = ValidateInvoiceNumber;
    /**
     * Validate an OpeningHoursTemplate
     *
     * @export
     * @class ValidateOpeningHoursTemplate
     * @implements {EvaService}
     */
    class ValidateOpeningHoursTemplate {
        name = 'Core:ValidateOpeningHoursTemplate';
        path = '/message/ValidateOpeningHoursTemplate';
        request;
        response;
    }
    Core.ValidateOpeningHoursTemplate = ValidateOpeningHoursTemplate;
    /**
     * Validates if a (part of an) Order can be shipped in the current state.

Returns if it is valid (`IsValid`) and if not, how much still needs to be paid (`OpenAmountForShipment`).
     *
     * @export
     * @class ValidateOrderShipment
     * @implements {EvaService}
     */
    class ValidateOrderShipment {
        name = 'Core:ValidateOrderShipment';
        path = '/message/ValidateOrderShipment';
        request;
        response;
    }
    Core.ValidateOrderShipment = ValidateOrderShipment;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ValidatePreCount
     * @implements {EvaService}
     */
    class ValidatePreCount {
        name = 'Core:ValidatePreCount';
        path = '/message/ValidatePreCount';
        request;
        response;
    }
    Core.ValidatePreCount = ValidatePreCount;
    /**
     * Validate the required data for the order
     *
     * @export
     * @class ValidateRequiredDataForOrder
     * @implements {EvaService}
     */
    class ValidateRequiredDataForOrder {
        name = 'Core:ValidateRequiredDataForOrder';
        path = '/message/ValidateRequiredDataForOrder';
        request;
        response;
    }
    Core.ValidateRequiredDataForOrder = ValidateRequiredDataForOrder;
    /**
     * Validate a ReturnToSupplierRequest

This will check if for all OrganizationUnits in the set a Supplier could be determined.

The service will return all available suppliers for each OrganizationUnit and will pick it when a single one is available.
When no Suppliers are available, no Order can be generated.
If more than one Supplier is available, the correct one should be picked with the SetSuppliersForReturnToSupplierRequest service.
     *
     * @export
     * @class ValidateReturnToSupplierRequest
     * @implements {EvaService}
     */
    class ValidateReturnToSupplierRequest {
        name = 'Core:ValidateReturnToSupplierRequest';
        path = '/message/ValidateReturnToSupplierRequest';
        request;
        response;
    }
    Core.ValidateReturnToSupplierRequest = ValidateReturnToSupplierRequest;
    /**
     * Validates if a Shipment can be shipped in the current state.

Returns if it is valid (`IsValid`) and if not, how much still needs to be paid (`OpenAmountForShipment`).
     *
     * @export
     * @class ValidateShipment
     * @implements {EvaService}
     */
    class ValidateShipment {
        name = 'Core:ValidateShipment';
        path = '/message/ValidateShipment';
        request;
        response;
    }
    Core.ValidateShipment = ValidateShipment;
    /**
     * Stub service to validate the current token
     *
     * @export
     * @class ValidateToken
     * @implements {EvaService}
     */
    class ValidateToken {
        name = 'Core:ValidateToken';
        path = '/message/ValidateToken';
        request;
        response;
    }
    Core.ValidateToken = ValidateToken;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ValidateUser
     * @implements {EvaService}
     */
    class ValidateUser {
        name = 'Core:ValidateUser';
        path = '/message/ValidateUser';
        request;
        response;
    }
    Core.ValidateUser = ValidateUser;
    /**
     * Sends an email validation code to your current user's email address.
     *
     * @export
     * @class ValidateUserEmailAddress
     * @implements {EvaService}
     */
    class ValidateUserEmailAddress {
        name = 'Core:ValidateUserEmailAddress';
        path = '/message/ValidateUserEmailAddress';
        request;
        response;
    }
    Core.ValidateUserEmailAddress = ValidateUserEmailAddress;
    /**
     * Validates the given VAT number by the current organization unit auditing provider or by providing a country in the request
     *
     * @export
     * @class ValidateVatNumber
     * @implements {EvaService}
     */
    class ValidateVatNumber {
        name = 'Core:ValidateVatNumber';
        path = '/message/ValidateVatNumber';
        request;
        response;
    }
    Core.ValidateVatNumber = ValidateVatNumber;
    /**
     * Verify the customer of an order by a QR code check. This process is used to validate that the person that picks up an order is really the person that ordered it.
     *
     * @export
     * @class VerifyCustomer
     * @implements {EvaService}
     */
    class VerifyCustomer {
        name = 'Core:VerifyCustomer';
        path = '/message/VerifyCustomer';
        request;
        response;
    }
    Core.VerifyCustomer = VerifyCustomer;
    /**
     * Flag the Order that the customer has been verified for AML purposes.
     *
     * @export
     * @class VerifyCustomerOnOrder
     * @implements {EvaService}
     */
    class VerifyCustomerOnOrder {
        name = 'Core:VerifyCustomerOnOrder';
        path = '/message/VerifyCustomerOnOrder';
        request;
        response;
    }
    Core.VerifyCustomerOnOrder = VerifyCustomerOnOrder;
    /**
     * Verify an Order that has been flagged with a CustomOrderStatus `NeedsEmployeeVerification`. Will try to place the order after the verification.
     *
     * @export
     * @class VerifyOrder
     * @implements {EvaService}
     */
    class VerifyOrder {
        name = 'Core:VerifyOrder';
        path = '/message/VerifyOrder';
        request;
        response;
    }
    Core.VerifyOrder = VerifyOrder;
})(Core || (Core = {}));
//# sourceMappingURL=EVA.Core.Services.js.map